window.__npEmb2Build = 'b0821-etch-flip';
/* ═══════════════════════════════════════════════════════════════════
   Embroidery 2.0 builder (product.embroidery-2-0 template only).
   Pre-upload: untouched legacy flow. When body.image-uploaded appears,
   this hides the legacy post-upload UI and runs the 3-step builder.

   Integration contract (nothing here re-implements pricing):
   - width/height/qty proxy into the legacy inputs (width__value /
     height__value / .customQtyFile__qty + keyup) so variant selection,
     discount properties (_discount_input/_discount_name) and validation
     all run exactly as production today.
   - Variant is ALSO set directly on the form (no BCPO dependency).
   - Committed options write properties[_Select Shape] / [Patch
     Background Color] / [Border Thread Color] / [_Select Your Backing].
   - AI proof = client-canvas composite of the actual uploaded render,
     hosted via the theme's own getPresignedUploadUrl, stored in
     properties[_AI Proof] and set as _cartImg (cart thumbnail).
   ═══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var root = document.getElementById('np-e2');
  if (!root) return; // not the embroidery-2-0 template

  var cfgEl = document.getElementById('np-e2-config');
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { console.error('np-emb2 config parse', e); return; }
  var S = CFG.settings || {};
  var QTY_MIN = parseInt(S.qtyMin, 10) || 10, QTY_STEP = S.qtyStep || 5, QTY_MAX = 999;
  var SIZE_STEP = S.sizeStep || 0.25;
  var SIZE_MIN = Math.max(S.sizeMin || 0.5, parseFloat(S.sizeMinMeta) || 0.5);
  var SIZE_MAX = parseFloat(S.sizeMaxMeta) || 15;
  function sizeError(msg) {
    var el = document.getElementById('np-e2-size-err');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(el.__t);
    el.__t = setTimeout(function () { el.hidden = true; }, 2000);
  }
  function clampSize(v, silent) {
    if (v < SIZE_MIN) { if (!silent) sizeError('Minimum size for this patch is ' + SIZE_MIN + '"'); return SIZE_MIN; }
    if (v > SIZE_MAX) { if (!silent) sizeError('Maximum size for this patch is ' + SIZE_MAX + '"'); return SIZE_MAX; }
    return v;
  }
  var REGEN_LIMIT = S.regenLimit || 4;

  /* ---- state ---- */
  var st = {
    shape: null, border: null, bg: null, thread: null, backing: null,
    step: null, draft: null,
    removeBg: false, crop: true, /* remove-background defaults OFF on upload */ /* crop+trim is ALWAYS on — the fill slider owns spacing */
    expanded: false, isAI: true, artZoom: 1, corners: null,
    w: 2.00, h: 2.19, ratio: 2.19 / 2.00, sizeSeeded: false, qty: QTY_MIN,
    versions: [], selected: 0, proofPhase: null, proofApproved: false,
    cart: 0
  };
  /* order mandate: the surface TEXTURE follows the background COLOR it sits on,
     and border STYLE comes after the border COLOR (thread).
     WZ_TITLES/WZ_LABELS are positional — they must be permuted in lockstep with
     WZ_STEPS, and the accordion rows in np-emb2-builder.liquid carry the same
     index in data-e2-acc/acchead/accbody. */
  /* 'font' is APPENDED, never inserted: WZ_TITLES/WZ_LABELS and the liquid
     accordion rows are keyed to these indices, so renumbering would silently
     repoint every other patch type's rows. The customer-facing ORDER comes
     from the accordion's DOM order instead — see stepSeq(). */
  /* 'opt1'/'opt2'/'opt3' are APPENDED for the same reason 'font' was: they are
     the NATIVE SHOPIFY VARIANT OPTIONS of a product whose customer choices are
     not theme-editor blocks at all (Custom Tackle Twill Letters: Size / Layers
     / Lines of Text). Their title and label are written at render time from
     product.options, so the placeholders below are never shown. */
  var WZ_STEPS = ['shape', 'bg', 'texture', 'border', 'thread', 'backing', 'font', 'opt1', 'opt2', 'opt3', 'text', 'ttext'];
  var WZ_TITLES = ['Select Shape', 'Patch Background Color', 'Background Texture', 'Select Border Style', 'Border Thread Color', 'Select Your Backing', 'Select Font Style', 'Select Option', 'Select Option', 'Select Option'];
  var WZ_LABELS = ['Shape', 'Background', 'Texture', 'Border', 'Thread', 'Backing', 'Font', 'Option', 'Option', 'Option'];

  /* ═══ PATCH TYPE PROFILES — each 2-0 template carries the option set the
     type ACTUALLY offers (mirrors the mockup lab / legacy product pages) ═══ */
  var PATCH_TYPES = {
    'embroidery-2-0':       { name: 'Embroidered', shape: 1, bg: 1, thread: 1, border: 1, fdGate: 1, stitchout: 1 },
    'print-and-stitch-2-0': { name: 'Print & Stitch', shape: 1, bg: 1, thread: 1, border: 1 },
    'fullcolor-2-0':        { name: 'Printed', photoBtn: 1, shape: 1, bg: 1, thread: 1, border: 1, borders: /merrow/i, threadLabel: 'Border Color (Merrow only)', threadProp: '_Border Color', noBorderOpt: 1, stitchout: 1 },
    'rubber-pvc-2-0':       { name: 'PVC / Rubber', shape: 1, bg: 1, thread: 1, border: 0, fdGate: 1, borderThick: 1, lbDefault: 5, lbZeroMax2: 1, threadLabel: 'Border Color', threadProp: '_Border Color', backings: ['heat', 'hook'] },
    'woven-2-0':            { name: 'Woven', shape: 1, bg: 1, thread: 1, border: 1, noBorderOpt: 1 },
    /* molded PVC keychain: rubber-pvc options (shape / background / border
       color), but the physical size IS the Shopify variant option and the
       keyring means there is no backing to choose */
    /* C08 (2026-08-25, Justin): "keychains should be setup just like rubber pvc
       without the backing option but everything else should be the same". So it
       now carries PVC's fdGate / borderThick / lbDefault / lbZeroMax2 — the
       molded-PVC option set, keeping only `backing: 0` — a keyring has no
       backing to choose.
       C09 (same day): the Shopify-variant sizing keys (optVariant /
       sizeFromOpt / fixedSize) were REMOVED too — Justin: "size needs to get
       away from shopify variants and be sized exactly like you do with rubber
       pvc". Keychains now measures freely like PVC; nearestVariant() still maps
       the measurement onto the closest size variant for price, which is exactly
       how PVC resolves its own per-size variants. */
    'keychains-2-0':        { name: 'Keychain', shape: 1, bg: 1, thread: 1, border: 0, fdGate: 1, borderThick: 1, lbDefault: 5, lbZeroMax2: 1, threadLabel: 'Border Color', threadProp: '_Border Color', backing: 0 },
    'leather-2-0':          { name: 'Leather', shape: 1, bg: 1, thread: 0, border: 1, stitchout: 1, bgLabel: 'Leather Color', bgProp: '_Background Color', backings: ['heat', 'peel'], mats: [{ label: 'Sand', hex: '#DCA05F', img: 'https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiAiYmNwbyIsICJrZXkiOiAibmluamFwb2RkZC5teXNob3BpZnkuY29tLzg3MzM4ODgyNTAxNzUtTmF0dXJhbF9IaWdoX0NvbnRyYXN0Mi5wbmciLCAiZWRpdHMiOiB7InJlc2l6ZSI6IHsid2lkdGgiOiAyMjAsICJmaXQiOiAiY29udGFpbiJ9fX0=' }, { label: 'Brown', hex: '#834822', img: 'https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiAiYmNwbyIsICJrZXkiOiAibmluamFwb2RkZC5teXNob3BpZnkuY29tLzg3MzM4ODgyNTAxNzUtQ2FyYW1lbF9IaWdoX0NvbnRyYXN0Mi5wbmciLCAiZWRpdHMiOiB7InJlc2l6ZSI6IHsid2lkdGgiOiAyMjAsICJmaXQiOiAiY29udGFpbiJ9fX0=' }, { label: 'Dark Brown', hex: '#716151', img: 'https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiAiYmNwbyIsICJrZXkiOiAibmluamFwb2RkZC5teXNob3BpZnkuY29tLzg3MzM4ODgyNTAxNzUtVGF1cGVfTG93X0NvbnRyYXN0Mi5wbmciLCAiZWRpdHMiOiB7InJlc2l6ZSI6IHsid2lkdGgiOiAyMjAsICJmaXQiOiAiY29udGFpbiJ9fX0=' }] },
    'fauxleather-2-0':      { name: 'Faux Leather', shape: 1, bg: 1, thread: 0, border: 1, stitchout: 1, bgLabel: 'Faux Leather Color', bgProp: '_Background Color', backings: ['heat', 'peel'], mats: [{ label: 'Black & Silver', hex: '#131313', img: 'https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiAiYmNwbyIsICJrZXkiOiAibmluamFwb2RkZC5teXNob3BpZnkuY29tLzg3MzM4ODc5MjI0OTUtc2xvd19uaW5qYS5wbmciLCAiZWRpdHMiOiB7InJlc2l6ZSI6IHsid2lkdGgiOiAyMjAsICJmaXQiOiAiY29udGFpbiJ9fX0=' }, { label: 'Light Brown w/ Black Imprint', hex: '#8A3D18', img: 'https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiAiYmNwbyIsICJrZXkiOiAibmluamFwb2RkZC5teXNob3BpZnkuY29tLzg3MzM4ODc5MjI0OTUtTGlnaHQtQnJvd24ucG5nIiwgImVkaXRzIjogeyJyZXNpemUiOiB7IndpZHRoIjogMjIwLCAiZml0IjogImNvbnRhaW4ifX19' }, { label: 'Dark Brown w/ Black Imprint', hex: '#482818', img: 'https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiAiYmNwbyIsICJrZXkiOiAibmluamFwb2RkZC5teXNob3BpZnkuY29tLzg3MzM4ODc5MjI0OTUtY2hvYy1hbmQtYmxhY2sucG5nIiwgImVkaXRzIjogeyJyZXNpemUiOiB7IndpZHRoIjogMjIwLCAiZml0IjogImNvbnRhaW4ifX19' }, { label: 'Tan w/ Black Imprint', hex: '#987868', img: 'https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiAiYmNwbyIsICJrZXkiOiAibmluamFwb2RkZC5teXNob3BpZnkuY29tLzg3MzM4ODc5MjI0OTUtU2FuZHN0b25lX2FuZF9ibGFjazIucG5nIiwgImVkaXRzIjogeyJyZXNpemUiOiB7IndpZHRoIjogMjIwLCAiZml0IjogImNvbnRhaW4ifX19' }] },
    'silicone-2-0':         { name: 'Silicone', shape: 1, bg: 1, thread: 1, border: 0, threadLabel: 'Border Color', threadProp: '_Border Color', backings: ['heat', 'hook'] },
    '3demb-2-0':            { name: '3D Embroidered', shape: 1, bg: 1, thread: 1, border: 1, borders: /hot/i },
    'chenille-2-0':         { name: 'Chenille', shape: 1, bg: 1, thread: 1, border: 1, borders: /hot/i, fdGate: 1 },
    'metallic-flex-2-0': { name: 'Metallic Flex', shape: 1, bg: 1, thread: 1, border: 0, backings: ['heat', 'peel'], threadLabel: 'Border Color', threadProp: '_Border Color', threadHelp: 'The molded border around the edge of your patch.', borderThick: 1, bgHelp: 'The base color of the molded patch behind your design.', fixedBg: { label: 'Metallic Silver', hex: '#C3C7CD' }, texPre: 1, texture: (window.NP_PATCH_TEXTURES || {})['metallic-flex-2-0'] },
    'fullcolor-flex-2-0': { name: 'Full Color Flex', shape: 1, bg: 1, thread: 1, border: 0, backings: ['heat', 'peel'], threadLabel: 'Border Color', threadProp: '_Border Color', threadHelp: 'The molded border around the edge of your patch.', borderThick: 1, bgHelp: 'The base color of the molded patch behind your design.', fixedBg: { label: 'White', hex: '#FFFFFF' }, texPre: 1, texture: (window.NP_PATCH_TEXTURES || {})['fullcolor-flex-2-0'] },
    'matte-black-flex-2-0': { name: 'Matte Black Flex', monoTone: { dark: '#0E0E10', light: '#46464B' }, shape: 1, bg: 0, thread: 0, border: 0, backings: ['heat', 'peel'], fixedBg: { label: 'Matte Black', hex: '#1A1A1C' }, texPre: 0, texture: (window.NP_PATCH_TEXTURES || {})['matte-black-flex-2-0'] },
    'matte-white-flex-2-0': { name: 'Matte White Flex', monoTone: { dark: '#CFCEC7', light: '#FFFFFF' }, shape: 1, bg: 0, thread: 0, border: 0, backings: ['heat', 'peel'], fixedBg: { label: 'Matte White', hex: '#F5F5F3' }, texPre: 0, texture: (window.NP_PATCH_TEXTURES || {})['matte-white-flex-2-0'] },
    'chrome-flex-2-0': { name: 'Chrome Flex', monoTone: { dark: '#8C929B', light: '#FFFFFF' }, shape: 1, bg: 0, thread: 0, border: 0, backings: ['heat', 'peel'], fixedBg: { label: 'Chrome', hex: '#D9DDE3' }, texPre: 0, texture: (window.NP_PATCH_TEXTURES || {})['chrome-flex-2-0'] }
    ,
    /* Custom Tackle Twill Letters. The ONLY type whose customer choices are
       NATIVE SHOPIFY VARIANT OPTIONS rather than theme-editor blocks: Size,
       Layers and Lines of Text are real product options and the PRICE rides on
       the variant, so the three steps together must resolve ONE variant (see
       optVariant / nearestVariant). The live PDP carries no BCPO option set and
       asks for no shape, colour, border or backing, so every block-driven step
       sits out. Artwork upload + AI proof run exactly as on every other type. */
    'tackle-twill-2-0': {
      name: 'Tackle Twill',
      /* one backing, Heat Applied — the row still renders, pre-selected, so
         the customer sees what they're getting */
      shape: 0, border: 0, backings: ['heat'],
      /* The lettering IS the product: the customer TYPES it, so there is no
         upload at all and the preview composes the text the way custom names
         does. How many lines they fill in picks the Lines of Text variant. */
      noArt: 1, textLines: 3, autoOpt: 3, layersOpt: 2, swoosh: 1, noLnc: 1,
      cta: 'Start Designing Tackle Twill',
      ctaTitle: 'Design your tackle twill letters',
      ctaSub: 'Type your lettering, pick your size, layers and twill colors. No artwork needed.',
      font: 1, fontProp: '_Font Style', textFill: 0.9, previewDims: 1,
      formats: ['Straight', 'Arch'], stitches: ['Zig Zag', 'Satin'],
      /* layer 1 = the letters themselves; layer 2 (2-layer orders only) is the
         twill underneath, which reads as a contrasting outline around them */
      bg: 1, bgLabel: 'Letter Color', bgProp: '_Letter Color',
      bgHelp: 'The twill your letters are cut from.',
      thread: 1, threadLabel: 'Outline Color', threadProp: '_Outline Color',
      threadHelp: 'The second layer of twill showing behind the letters.',
      /* the option NAMES, their order and their values all come from Shopify
         (CFG.optionNames + CFG.variants) — nothing about them is listed here,
         so an option renamed in admin renames the step by itself */
      optVariant: 1,
      /* option 1 states the physical size ('11" x 4" (Most Popular)'), so
         picking it drives st.w/st.h -> the rulers, the proof prompt and
         _Width (in) / _Height (in), the way the steppers do elsewhere */
      sizeFromOpt: 1,
      fixedSize: 1,
      /* twill letters are cut pieces satin-stitched down: there is no patch
         base to fill and no merrow ring to draw, so the compose is bare art */
      fixedShape: { label: 'Custom', geom: 'custom' },
      bareArt: 1,
      matNote: function () {
        var layTT = st.opt2 ? String(st.opt2.label) : '';
        var linTT = st.opt3 ? String(st.opt3.label) : '';
        var inkTT = (st.bg && st.bg.hex) ? st.bg.label : '';
        var edgeTT = (twoLayers() && st.thread && st.thread.hex) ? st.thread.label : '';
        var zigTT = /zig/i.test(String(st.ttStitch || 'Zig Zag'));
        var fontTT = st.font ? st.font.label : '';
        var laysTT = ttLines().map(function (lT, iT) {
          return 'line ' + (iT + 1) + ' "' + lT + '" ' + String(st['ttLay' + (iT + 1)] || 'Straight').toLowerCase() +
            (iT > 0 && st['ttHalf' + (iT + 1)] ? ' at half height' : '');
        }).join('; ');
        var tailTT = ttSwooshOn() ? ttSwooshDef(st.swooshStyle).name : '';
        var tailTxtTT = ttSwooshOn() ? String(st.swooshText || '').trim() : '';
        return 'TACKLE TWILL LETTERING - this is NOT an embroidered patch: the design is CUT from flat matte twill fabric'
          + (inkTT ? ' in ' + inkTT : '')
          + (layTT ? ' (' + layTT.toLowerCase() + ')' : '')
          + (/2\s*layer/i.test(layTT) ? (' - a second' + (edgeTT ? ' ' + edgeTT : '') + ' twill layer sits beneath the top layer, cut slightly larger so it shows as a narrow even outline around each letter') : '')
          + '. EDGE FINISH - THIS MUST BE CLEARLY VISIBLE IN THE IMAGE: ' + (zigTT
              ? 'every cut edge is finished with an OPEN ZIG-ZAG STITCH - a row of separate slanted thread stitches marching along the edge with visible gaps of twill between them, each stitch individually countable at this size. It is NOT a smooth or solid edge'
              : 'every cut edge is finished with a DENSE SATIN STITCH - a solid, tightly packed column of parallel threads forming a raised glossy band that covers the cut edge completely, with visible thread direction across the band')
          + ', and every stitch thread MATCHES the colour of the twill it secures - there is NO white thread, NO white outline, NO white gap or halo between the twill layers anywhere'
          + (/2\s*layer/i.test(layTT) ? ((edgeTT ? '. The ' + edgeTT : '. The second-layer') + ' outline is a solid, even band of twill fabric about 1/8 inch wide, fully visible and touching the top-layer letter directly along its whole edge') : '')
          + '. CRITICAL: each letter is its OWN separate cut piece with a small gap of empty space between letters, exactly as spaced in the reference image. There is NO patch base, NO background field, NO merrow border and NO material of any kind between, around or behind the letters - the letters sit directly on the garment-free backdrop as individual pieces. Reproduce only the lettering itself.'
          + (linTT ? ' The lettering is laid out as ' + linTT.toLowerCase() + ' of text.' : '')
          + (fontTT ? ' Letterform style: ' + fontTT + '.' : '')
          + (laysTT ? ' Layout, exactly as in the reference image: ' + laysTT + '.' : '')
          + (tailTT ? (' A ' + tailTT + ' tail is cut from the same twill and stitched below the lettering, joined to the last letter as ONE continuous piece'
              + (tailTxtTT ? ', with "' + tailTxtTT.toUpperCase() + '" stitched along it' : '') + '.') : '');
      }
    },
    /* Custom Embroidered Name Patches. The ONLY type with no artwork at all:
       the patch IS the name, so the preview composes TEXT instead of an
       upload, and the whole upload/AI-proof half of the builder sits out.
       Size, border style and backing are fixed by the product and the price
       is flat, so those steps never render and the tier table stays hidden. */
    'custom-names': {
      name: 'Embroidered Name',
      shape: 0, bg: 1, thread: 1, border: 0, font: 1,
      noArt: 1, textPreview: 'Name', textFill: 0.64, textFillW: 0.88, previewDims: 1, noLnc: 1,
      cta: 'Start Designing Custom Names',
      bgLabel: 'Patch Background Color',
      bgProp: '_Background Color',
      threadLabel: 'Border Color',
      threadProp: '_Border Color',
      threadHelp: 'The merrow border around the edge.',
      textColor: 1,
      textLabel: 'Text Thread Color',
      textProp: '_Text Color',
      textHelp: 'Stitches the lettering.',
      bgHelp: 'The felt color behind the lettering.',
      fixedShape: { label: 'Rectangle', geom: 'rectangle' },
      fixedDims: [104, 40],  /* preview aspect = 3.25 : 1.25 */
      fixedWH: [3.25, 1.25],
      fixedSize: 1, flatPrice: 1,
      fixedBorder: 'Merrow', borderProp: 'Border Style',
      fixedBacking: 'Heat Applied (Most Popular)', backingProp: 'Backing',
      fontProp: 'Font Style',
      names: 1, namesMin: QTY_MIN, namesProp: 'List of Names (Separate by Comma)'
    }
  };
  /* ═══ LIVE-TEMPLATE ALIASES ═══════════════════════════════════════════
     The 2.0 builders were authored on their own `*-2-0` templates and reached
     with ?view=. For a theme-level A/B rollout the builder has to run on the
     template each product ACTUALLY uses (its real template_suffix, shared by
     every theme), so the type can no longer be read from the file name alone.
     This maps each live suffix onto its 2.0 type key; the 2.0 names still work
     unchanged, so ?view= previews and existing proof filenames keep working. */
  var SUFFIX_ALIAS = {
    'embroidered-patches': 'embroidery-2-0',
    'chenile-patches': 'chenille-2-0',
    'woven-patches': 'woven-2-0',
    'rubber-patches': 'rubber-pvc-2-0',
    'leather-patches': 'leather-2-0',
    'sublimated-patches': 'fullcolor-2-0',
    '3d-embroidered-patches': '3demb-2-0',
    'silicone-patches': 'silicone-2-0',
    'faux-leather-2': 'fauxleather-2-0',
    'print-and-stitch-patches': 'print-and-stitch-2-0',
    'ninja-flex': 'metallic-flex-2-0',
    'full-color-flex': 'fullcolor-flex-2-0',
    'matte-black-flex': 'matte-black-flex-2-0',
    'matte-white-flex': 'matte-white-flex-2-0',
    'chrome-flex': 'chrome-flex-2-0',
    'tackle-twill': 'tackle-twill-2-0',
    'keychains': 'keychains-2-0'
  };
  /* ONE canonical type key for the whole file — never read the raw suffix for
     identity again, or a live-template render silently falls back to embroidery */
  var TYPE_KEY = SUFFIX_ALIAS[String(CFG.templateSuffix || '')] || String(CFG.templateSuffix || '');
  var PTYPE = PATCH_TYPES[TYPE_KEY] || PATCH_TYPES['embroidery-2-0'];
  /* thickness scale differs per material: PVC (lbZeroMax2) runs 1=barely-there
     to 10=double with 5 as standard, so its slider must START at 5 (Justin
     2026-08-24). Arrivals overwrite this via np_lbt / the ml handoff. */
  if (PTYPE.lbDefault && !st.lbThick) st.lbThick = PTYPE.lbDefault;
  /* STAGING EXPERIMENT (Justin 2026-08-24, post-A/B): Size & Pricing lives ON
     THE PAGE as Step 3 of 3, always beside the digital preview, with the
     proof options (free AI proof / skip to checkout) BELOW it. Inert on the
     published theme. ⚠ remove the id here before publishing staging. */
  var NP_PDP_PRICING = false;
  try { NP_PDP_PRICING = !!(window.Shopify && Shopify.theme && String(Shopify.theme.id) === '188164800831') && !PTYPE.names && !PTYPE.optVariant && !PTYPE.fixedSize; } catch (ePP) {}
  /* KILL-SWITCH — currently OFF (Justin greenlit the AI-mode restore
     2026-08-24 evening after the add-first/pre-add checkout rework). To
     re-engage in an emergency: set the compared id back to the LIVE theme id
     ('187988967743') and push np-emb2.js to live — forces classic mode and
     hides the AI tabs for customers. Justin's call ONLY, both directions. */
  /* ⛔ KILL-SWITCH ENGAGED 2026-08-25 ~01:45 ET on Justin's explicit
     instruction ("set up the kill switch and get everything in classic mode
     only ASAP") after AI mode failed repeatedly on iOS Safari and hung on
     "Finalizing Order & Adding to Cart".
     Set unconditionally — NOT via the Shopify.theme.id comparison — because
     that comparison silently evaluates FALSE (re-enabling AI mode) on any page
     where window.Shopify.theme is unavailable. Classic mode is now the ONLY
     mode for customers: orderMode() returns 'classic' and the AI tab is hidden.
     TO RESTORE AI MODE: set this back to false. Justin's call ONLY. */
  /* STAGING ONLY: AI mode ON here so the flow can be fixed and tested.
     LIVE (#187988967743) keeps this true until Justin says otherwise. */
  var NP_FORCE_CLASSIC = false;
  /* BUILD SPEC SHEETS — OFF (B70, 2026-08-25, Justin: "if you need to get rid
     of spec sheet get rid of it completely").
     The sheet was a canvas composite (patch + a drawn spec panel) uploaded and
     stamped onto the cart line. Measured cost on live: 14.5s and 16.1s clicks,
     plus the "Finalizing Order & Adding to Cart" hang, because compose/upload
     sat behind four unbounded awaits and the click waited on a freshness token
     that could drift. Orders still carry _AI Proof, _Upload, _Original Image
     and every option property — only the drawn panel is gone.
     Set back to true to re-enable sheet generation. */
  /* B95 (2026-08-25) — spec sheets back ON to MEASURE. They were switched off
     when adds ran 14-16s and looked responsible. That whole measurement window
     was on a page starved by ~2,500 runaway timers (see custom-uploader.js
     selectNearestVariant2), so every number from it was inflated and the sheets
     may have taken the blame unfairly. Justin's budget, verbatim: "If it's
     under 7 seconds of additional time it's worth keeping it." Measure against
     the 663ms clean-add baseline before deciding. */
  var NP_SPEC_SHEETS = true;
  (function () {
    var pvT = document.getElementById('np-e2-prevtitle');
    if (pvT) pvT.textContent = 'Your ' + (PTYPE.name === 'Printed' ? 'Full Color' : PTYPE.name) + ' Patch Preview';
    /* molded flex finishes: the material IS the base color — fix it so the
       compose + specs carry it even though the bg step never shows */
    if (PTYPE.fixedBg) {
      /* the finish's own color is ALWAYS swatch #1 for both background and
         border, and it stays there no matter what the customer picks. The
         CFG arrays themselves are reordered because the swatch tiles carry
         their index INTO those arrays — reordering only the display list
         would make every tile select the wrong color. */
      ['bgs', 'threads'].forEach(function (kPin) {
        var arrPin = CFG[kPin];
        if (!arrPin || !arrPin.length) return;
        var labPin = String(PTYPE.fixedBg.label || '').toLowerCase();
        CFG[kPin] = [{ label: PTYPE.fixedBg.label, hex: PTYPE.fixedBg.hex }].concat(
          arrPin.filter(function (cPin) { return String(cPin.label || '').toLowerCase() !== labPin; })
        );
      });
    }
    if (PTYPE.fixedBg && !st.bg && !stepEnabled('bg')) st.bg = PTYPE.fixedBg;
    /* a type whose shape / border / backing / size are PRODUCT facts rather
       than customer choices: seed them up front so the compose, the specs
       and the cart properties all carry them without a step ever showing */
    if (PTYPE.fixedShape && !st.shape) st.shape = PTYPE.fixedShape.label;
    /* leather/faux: NO shape pre-select (Justin 2026-08-21) — the first
       preview still opens AS leather via a compose-time circle fallback
       in composePatchImage; the shape tiles stay unpicked. The FIRST mat
       (Sand etc.) seeds the hide color so that first paint is leather-toned,
       not a white face — the customer changes it like any pick. */
    if (PTYPE.mats && !st.bg && !PTYPE.noArt && PTYPE.mats[0] && PTYPE.mats[0].hex) {
      st.bg = { label: PTYPE.mats[0].label, hex: PTYPE.mats[0].hex, img: PTYPE.mats[0].img };
    }
    if (PTYPE.fixedBorder && !st.border) st.border = { label: PTYPE.fixedBorder };
    if (PTYPE.fixedBacking && !st.backing) st.backing = { label: PTYPE.fixedBacking };
    if (PTYPE.fixedWH) {
      st.w = PTYPE.fixedWH[0];
      st.h = PTYPE.fixedWH[1];
      st.ratio = st.h / st.w;
      st.sizeSeeded = true; /* stop the legacy size poller from moving them */
    }
    /* a one-colour finish is invisible against a same-tone stage: present the
       white finishes on dark material and the dark finishes on light */
    if (PTYPE.monoTone) {
      var lightFinish = (function () {
        var hx = String((PTYPE.fixedBg && PTYPE.fixedBg.hex) || '').replace('#', '');
        if (hx.length !== 6) return false;
        return (0.299 * parseInt(hx.substr(0, 2), 16) + 0.587 * parseInt(hx.substr(2, 2), 16) + 0.114 * parseInt(hx.substr(4, 2), 16)) > 140;
      })();
      document.body.classList.add(lightFinish ? 'np-e2-stage-dark' : 'np-e2-stage-light');
    }
  })();
  /* "Match My Artwork" (previously shown as "Follow Image") is a FLAG, not a
     color. The label string is persisted to line-item properties, sidecars and
     np_bgl/np_thl reorder params, and it comes back WITHOUT the follow flag —
     so both the old and new wording must keep matching forever. */
  var FOLLOW_LABEL = 'Match My Artwork';
  var FOLLOW_RE = /^(follow image|match my artwork)$/i;
  function isFollowVal(c) { return !!(c && (c.follow || FOLLOW_RE.test(c.label || ''))); }
  var PHOTO_LABEL = 'Photo (full bleed)';
  function isPhotoVal(c) { return !!(c && c.label === PHOTO_LABEL); }
  /* "Let AI Choose" picks a REAL color, not a placeholder: the preview, the
     AI proof and the order all carry the same concrete pick, and the customer
     can override it like any other swatch. */
  function npLum(hex) {
    var h = String(hex || '').replace('#', '');
    if (h.length !== 6) return 0;
    return parseInt(h.slice(0, 2), 16) * 0.299 + parseInt(h.slice(2, 4), 16) * 0.587 + parseInt(h.slice(4, 6), 16) * 0.114;
  }
  function npDefaultBgHex() {
    /* white artwork on the default white base is invisible — when EVERY
       colour in the artwork reads near-white, the un-picked base defaults to
       black so the design shows the moment a shape is chosen */
    var pal = st.artColors || [];
    if (pal.length && pal.every(function (h) { return npLum(h) > 215; })) return '#0C0C0E';
    return '#FFFFFF';
  }
  function aiChooseColor(kind) {
    var pal = (st.artColors || []).filter(Boolean);
    var hex = null;
    if (pal.length) {
      var byLum = pal.slice().sort(function (a, b) { return npLum(a) - npLum(b); });
      if (kind === 'bg') {
        /* the base: the darkest color already in their design reads as the
           patch's natural ground */
        hex = byLum[0];
      } else {
        /* border / lettering: the palette color that CONTRASTS hardest with
           the background it will sit against */
        var bgHex = (st.draft && st.draft.bg && st.draft.bg.hex) || (st.bg && st.bg.hex) || byLum[0];
        var best = null, bestD = -1;
        pal.forEach(function (c) {
          if (c.toLowerCase() === String(bgHex || '').toLowerCase()) return;
          var d = Math.abs(npLum(c) - npLum(bgHex));
          if (d > bestD) { bestD = d; best = c; }
        });
        hex = best || byLum[byLum.length - 1];
      }
    }
    if (!hex) hex = kind === 'bg' ? '#0C0C0E' : '#FFFFFF';
    return { label: pmsName(hex), hex: hex };
  }
  /* ═══ NATIVE VARIANT-OPTION STEPS (opt1 / opt2 / opt3) ═══
     Every other 2-0 type picks its variant by patch SIZE alone and carries the
     customer's choices as line-item properties. A type with `optVariant` does
     the opposite: its steps ARE the product's own Shopify options, and all of
     them together resolve the single variant that carries the price. Nothing
     here is product-specific — the names come from CFG.optionNames and the
     values from CFG.variants, so the option strings stay byte-identical to the
     ones Shopify matches variants on. */
  var OPT_RE = /^opt([123])$/;
  function optIdx(k) { var m = OPT_RE.exec(k || ''); return m ? parseInt(m[1], 10) : 0; }
  function optDef(k) {
    if (!PTYPE.optVariant) return null;
    var n = optIdx(k);
    if (!n) return null;
    var nm = (CFG.optionNames || [])[n - 1];
    if (!nm) return null;
    return { n: n, name: String(nm), values: optValues(n) };
  }
  function optValues(n) {
    /* first-seen order = Shopify's own option order */
    var seen = {}, out = [];
    (CFG.variants || []).forEach(function (v) {
      var lab = v['opt' + n];
      if (!lab || seen[lab]) return;
      seen[lab] = 1;
      out.push({ label: lab });
    });
    return out;
  }
  function optSizeWH(label) {
    /* '11" x 4" (Most Popular)' -> [11, 4] */
    var m = /([\d.]+)\s*"?\s*[x\u00d7]\s*([\d.]+)/i.exec(String(label || ''));
    if (m) {
      var w = parseFloat(m[1]), h = parseFloat(m[2]);
      return (isNaN(w) || isNaN(h)) ? null : [w, h];
    }
    /* single-dimension options ('2"' keychains) size the LONGEST side —
       reported as the square envelope the piece fits inside */
    var m1 = /([\d.]+)\s*"/.exec(String(label || ''));
    if (m1) { var n1 = parseFloat(m1[1]); if (!isNaN(n1)) return [n1, n1]; }
    return null;
  }
  function optVariantMatch() {
    /* EVERY enabled dimension has to agree — a partial match would charge the
       wrong price. An unfinished selection falls back to the product's first
       variant purely so the panel has a number to show; committed() still
       blocks checkout until all three rows are answered. */
    var vs = CFG.variants || [];
    var pick = null;
    vs.forEach(function (v) {
      if (pick) return;
      var ok = true;
      for (var n = 1; n <= 3; n++) {
        var d = optDef('opt' + n);
        if (!d) continue;
        var sel = st['opt' + n];
        if (!sel || String(v['opt' + n]) !== String(sel.label)) { ok = false; break; }
      }
      if (ok) pick = v;
    });
    var v2 = pick || vs[0];
    if (!v2) return null;
    var szN = PTYPE.sizeFromOpt ? optSizeWH(v2['opt' + PTYPE.sizeFromOpt]) : null;
    return {
      id: v2.id,
      price: v2.price,
      num: szN ? (szN[0] + szN[1]) / 2 : 0,
      sizeLabel: PTYPE.sizeFromOpt ? String(v2['opt' + PTYPE.sizeFromOpt] || '') : ''
    };
  }
  function commitOptStep() {
    /* commit the variant-option draft AND the physical size the size option
       states, so st.w/st.h feed the rulers, the prompt and the width/height
       properties exactly as the steppers do on every other type */
    if (!PTYPE.optVariant || !st.draft) return;
    ['opt1', 'opt2', 'opt3'].forEach(function (kC) { if (optDef(kC)) st[kC] = st.draft[kC]; });
    if (PTYPE.sizeFromOpt) {
      var selS = st['opt' + PTYPE.sizeFromOpt];
      var whS = selS ? optSizeWH(selS.label) : null;
      if (whS) { st.w = whS[0]; st.h = whS[1]; st.ratio = st.h / st.w; st.sizeSeeded = true; }
    }
  }
  function stepEnabled(k) {
    /* a variant-option step exists only while the product actually has that
       option (a 2-option product simply renders two rows) */
    /* INLINE regex, not OPT_RE: the boot IIFE calls stepEnabled('bg') for the
       fixed-colour flex types BEFORE the var initializers below have run, and
       `var` hoists as undefined — OPT_RE.test here killed the whole builder on
       every fixedBg type (metallic/matte/chrome flex went blank, 2026-08-18) */
    /* charAt, not optIdx(): same hoisting trap as OPT_RE above */
    if (/^opt[123]$/.test(k)) return !!optDef(k) && !(PTYPE.autoOpt && parseInt(k.charAt(3), 10) === PTYPE.autoOpt);
    if (k === 'ttext') return !!PTYPE.textLines;
    if (k === 'thread' && PTYPE.layersOpt) return twoLayers();
    if (k === 'font') return !!PTYPE.font;
    if (k === 'text') return !!PTYPE.textColor;
    /* one backing, decided by the product = nothing to ask; `backing: 0` is a
       product that carries no backing choice at all (nothing to write either) */
    if (k === 'backing') return PTYPE.backing !== 0 && !PTYPE.fixedBacking;
    if (k === 'proof') return false; /* proof choice lives on the footer CTA + skip link now */
    if (k === 'texture') {
      /* a hot-cut silhouette has no molded field to texture — custom and free
         form skip the step entirely */
      var gT = shapeGeom();
      return !!PTYPE.texture && gT !== 'custom';
    }
    /* free form has no patch edge, so there is no border to colour */
    if (k === 'thread' && isFreeFormShape()) return false;
    /* free form has no patch BASE either — no background to colour. The one
       exception is metallic flex, where that colour IS the material the
       pieces are cut from. */
    if (k === 'bg' && isFreeFormShape() && !/^metallic-flex/.test(TYPE_KEY) && !PTYPE.fixedBg && !PTYPE.mats) return false;
    /* "No Border" chosen on the border-style step: there is no border, so
       there is no border colour either */
    if (k === 'thread' && st.border && /no border/i.test(st.border.label || '')) return false;
    if (!k) return false;
    if (k === 'shape') return !!PTYPE.shape;
    if (k === 'bg') return !!PTYPE.bg;
    if (k === 'thread') return !!PTYPE.thread;
    if (k === 'border') return !!PTYPE.border;
    return true;
  }
  function isLeather() { return !!PTYPE.mats; }
  var STITCH_ADDON_TYPES = ['embroidery-2-0', 'fullcolor-2-0', 'fauxleather-2-0', 'leather-2-0', 'print-and-stitch-2-0', '3demb-2-0'];
  function stitchAddonEligible() {
    return STITCH_ADDON_TYPES.indexOf(TYPE_KEY) !== -1 && !!CFG.stitchVid;
  }
  function adjustStitchLine(delta) {
    /* the $19.99 stitchout is billed via the proof-approval product as its
       own cart line; qty = number of patches that requested it */
    try { console.log('[np-e2] stitch addon', { vid: CFG.stitchVid, delta: delta }); } catch (eSL) {}
    if (!CFG.stitchVid || !delta) return Promise.resolve();
    if (delta > 0) {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', keepalive: true, body: JSON.stringify({ id: CFG.stitchVid, quantity: delta }) })
        .then(function (r) {
          if (!r.ok) { console.warn('[np-e2] stitch addon add FAILED', r.status); npToast('Could not add the $19.99 proof line - please retry'); return null; }
          return r.json();
        }).catch(function (eAF) { console.warn('[np-e2] stitch addon add error', eAF); return null; });
    }
    return cartJson().then(function (cart) {
      var ln = (cart.items || []).filter(function (it) { return String(it.variant_id) === String(CFG.stitchVid); })[0];
      if (!ln) return null;
      var q2 = Math.max(0, ln.quantity + delta);
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ id: ln.key, quantity: q2 }) }).then(function (r) { return r.ok ? r.json() : null; });
    }).catch(function () { return null; });
  }
  var LEATHER_ETCH = {
    'Sand':       { hex: '#4A3830' },
    'Brown':      { hex: '#3E2D1C' },
    'Dark Brown': { hex: '#55453A' },
    'F:Black & Silver': { hex: '#9A9A9A' },
    'F:Light Brown':    { hex: '#33180A' },
    'F:Dark Brown':     { hex: '#1A0D06' },
    'F:Tan':            { hex: '#2E2622' }
  };
  function leatherBurnHex(baseHex) {
    /* the etch is TWO-TONE with the hide: the burn is the leather's OWN hue,
       deeper and warmer — never a foreign gray-brown (Justin 2026-08-21,
       Sand leather previews) */
    var h = String(baseHex || '').replace('#', '');
    if (h.length !== 6) return '#2E1B0E';
    var r = Math.round(parseInt(h.substr(0, 2), 16) * 0.46);
    var g = Math.round(parseInt(h.substr(2, 2), 16) * 0.38);
    var b = Math.round(parseInt(h.substr(4, 2), 16) * 0.30);
    function q(v) { return ('0' + Math.max(0, Math.min(255, v)).toString(16)).slice(-2); }
    return '#' + q(r) + q(g) + q(b);
  }
  function leatherEtch() {
    var key = (PTYPE.name === 'Faux Leather' ? 'F:' : '') + (st.bg ? String(st.bg.label).split(' w/ ')[0] : '');
    /* faux mats have a MANUFACTURED imprint color — keep the curated tones;
       real leather burns in its own hue, derived from the picked hide */
    if (key.indexOf('F:') === 0 && LEATHER_ETCH[key]) return LEATHER_ETCH[key];
    if (st.bg && st.bg.hex) return { hex: leatherBurnHex(st.bg.hex) };
    return LEATHER_ETCH[key] || { hex: '#2E1B0E' };
  }
  function etchArtCanvas(img, w, h, toneHex, invertK) {
    /* two-tone laser etch, ENGRAVER'S RULES (Justin 2026-08-21): thin dark
       line-work burns; a BROAD dark fill flips — the fill reads as bare hide
       with a burned rim, and the light detail enclosed in it (letters, gill
       lines) burns instead — how a real vendor etches dark-fill art so the
       patch still reads as leather. Near-white is paper/knockout: always
       bare AND excluded from the ink split, so an un-removed white
       background can no longer collapse the art into one solid silhouette.
       Output stays STRICT TWO-TONE: hide + ONE burn tone. */
    var t = document.createElement('canvas');
    t.width = Math.max(1, Math.round(w)); t.height = Math.max(1, Math.round(h));
    var tx = t.getContext('2d');
    /* inverted designs get a small inset so the burned outline ringing the
       silhouette has room inside the canvas (Justin 2026-08-21) */
    var padK = invertK ? Math.max(4, Math.round(Math.min(t.width, t.height) * 0.025)) : 0;
    tx.drawImage(img, padK, padK, t.width - padK * 2, t.height - padK * 2);
    var id, d;
    try { id = tx.getImageData(0, 0, t.width, t.height); d = id.data; }
    catch (eTaint) {
      /* CORS-tainted source: pixels unreadable — burn the whole silhouette
         in the etch tone rather than break the compose */
      tx.globalCompositeOperation = 'source-in';
      tx.fillStyle = toneHex || leatherEtch().hex;
      tx.fillRect(0, 0, t.width, t.height);
      return t;
    }
    var W2 = t.width, H2 = t.height;
    var __h = []; for (var hi = 0; hi < 256; hi++) __h[hi] = 0;
    var __tot = 0;
    for (var pi = 0; pi < d.length; pi += 4) {
      if (d[pi + 3] < 40) continue;
      var lP = Math.round(0.299 * d[pi] + 0.587 * d[pi + 1] + 0.114 * d[pi + 2]);
      if (lP >= 246) continue; /* knockout white is bare, never ink data */
      __h[Math.max(0, Math.min(255, lP))]++; __tot++;
    }
    var __etchT = 196;
    if (__tot > 100) {
      var sumAll = 0; for (var si = 0; si < 256; si++) sumAll += si * __h[si];
      var wB = 0, sumB = 0, best = -1, bestT = 128;
      for (var ti = 0; ti < 256; ti++) {
        wB += __h[ti]; if (!wB) continue;
        var wF = __tot - wB; if (!wF) break;
        sumB += ti * __h[ti];
        var mB = sumB / wB, mF = (sumAll - sumB) / wF;
        var v = wB * wF * (mB - mF) * (mB - mF);
        if (v > best) { best = v; bestT = ti; }
      }
      var minor = 0; for (var mi = bestT + 1; mi < 256; mi++) minor += __h[mi];
      var minorFrac = Math.min(minor, __tot - minor) / __tot;
      if (minorFrac >= 0.06 && bestT >= 50 && bestT <= 210) __etchT = bestT + 2;
    }
    /* broad-fill analysis on a downsampled mask: morphological opening finds
       fills wider than ~7%% of the art; thin strokes survive as line-work */
    var sw = W2, sh = H2;
    if (Math.max(W2, H2) > 300) {
      if (W2 >= H2) { sw = 300; sh = Math.max(1, Math.round(H2 * 300 / W2)); }
      else { sh = 300; sw = Math.max(1, Math.round(W2 * 300 / H2)); }
    }
    var scv = document.createElement('canvas'); scv.width = sw; scv.height = sh;
    var scx = scv.getContext('2d'); scx.drawImage(t, 0, 0, sw, sh);
    var sdd = null;
    try { sdd = scx.getImageData(0, 0, sw, sh).data; } catch (eT2) { sdd = null; }
    var NN = sw * sh, ink = new Uint8Array(NN), opq = new Uint8Array(NN), inkN = 0;
    if (sdd) for (var qi = 0; qi < NN; qi++) {
      var q4 = qi * 4;
      if (sdd[q4 + 3] < 40) continue;
      opq[qi] = 1;
      var lQ = 0.299 * sdd[q4] + 0.587 * sdd[q4 + 1] + 0.114 * sdd[q4 + 2];
      if (lQ < __etchT && lQ < 246) { ink[qi] = 1; inkN++; }
    }
    function mErode(src) {
      var out = new Uint8Array(NN);
      for (var y = 0; y < sh; y++) for (var x = 0; x < sw; x++) {
        var i2 = y * sw + x; if (!src[i2]) continue;
        if (x > 0 && !src[i2 - 1]) continue; if (x < sw - 1 && !src[i2 + 1]) continue;
        if (y > 0 && !src[i2 - sw]) continue; if (y < sh - 1 && !src[i2 + sw]) continue;
        out[i2] = 1;
      }
      return out;
    }
    function mDilate(src) {
      var out = new Uint8Array(src);
      for (var y = 0; y < sh; y++) for (var x = 0; x < sw; x++) {
        var i2 = y * sw + x; if (src[i2]) continue;
        if ((x > 0 && src[i2 - 1]) || (x < sw - 1 && src[i2 + 1]) || (y > 0 && src[i2 - sw]) || (y < sh - 1 && src[i2 + sw])) out[i2] = 1;
      }
      return out;
    }
    var RR = Math.max(3, Math.round(Math.min(sw, sh) * 0.035)), mz;
    var opn = ink;
    for (mz = 0; mz < RR; mz++) opn = mErode(opn);
    for (mz = 0; mz < RR + 1; mz++) opn = mDilate(opn);
    var opnN = 0;
    for (qi = 0; qi < NN; qi++) { if (opn[qi] && !ink[qi]) opn[qi] = 0; opnN += opn[qi]; }
    /* one plain solid mark (a silhouette logo) still burns solid — flip only
       when real line-work exists alongside the fills */
    var invertOn = inkN > 0 && opnN > 0 && (opnN / inkN) <= 0.92;
    /* inverted designs ALWAYS keep a burned outline around the artwork so
       the silhouette never fades into the hide: a ring just OUTSIDE the
       opaque footprint, in the etch tone */
    var outlM = null;
    if (invertK && sdd) {
      var oR = Math.max(3, Math.round(Math.min(sw, sh) * 0.015)), oz;
      var dil = opq;
      for (oz = 0; oz < oR; oz++) dil = mDilate(dil);
      outlM = new Uint8Array(NN);
      for (qi = 0; qi < NN; qi++) outlM[qi] = (dil[qi] && !opq[qi]) ? 1 : 0;
    }
    var bareM = new Uint8Array(NN), holeM = new Uint8Array(NN);
    if (invertOn) {
      var cor = opn, rimW = Math.max(2, Math.round(RR / 2));
      for (mz = 0; mz < rimW; mz++) cor = mErode(cor);
      for (qi = 0; qi < NN; qi++) bareM[qi] = cor[qi];
      /* enclosed light detail (letters, gill lines INSIDE a fill): bare
         regions that never reach the outside and border mostly-broad ink */
      var lbl = new Int32Array(NN), stk = [], comp = 0, opqN = 0;
      for (qi = 0; qi < NN; qi++) opqN += opq[qi];
      for (var s0 = 0; s0 < NN; s0++) {
        if (lbl[s0] || ink[s0] || !opq[s0]) continue;
        comp++;
        var touchesOut = false, bInk = 0, bOpen = 0, members = [];
        lbl[s0] = comp; stk.push(s0);
        while (stk.length) {
          var c0 = stk.pop(); members.push(c0);
          var cy = (c0 / sw) | 0, cx = c0 - cy * sw;
          for (var dn = 0; dn < 4; dn++) {
            var nx = cx + (dn === 0 ? -1 : dn === 1 ? 1 : 0), ny = cy + (dn === 2 ? -1 : dn === 3 ? 1 : 0);
            if (nx < 0 || ny < 0 || nx >= sw || ny >= sh) { touchesOut = true; continue; }
            var n0 = ny * sw + nx;
            if (!opq[n0]) { touchesOut = true; continue; }
            if (ink[n0]) { bInk++; if (opn[n0]) bOpen++; continue; }
            if (!lbl[n0]) { lbl[n0] = comp; stk.push(n0); }
          }
        }
        if (!touchesOut && bInk && (bOpen / bInk) >= 0.55 && members.length <= opqN * 0.25) {
          for (var m0 = 0; m0 < members.length; m0++) holeM[members[m0]] = 1;
        }
      }
    }
    function mSample(m, fx, fy) {
      var x0 = fx | 0, y0 = fy | 0;
      var x1 = Math.min(sw - 1, x0 + 1), y1 = Math.min(sh - 1, y0 + 1);
      var ax = fx - x0, ay = fy - y0;
      return m[y0 * sw + x0] * (1 - ax) * (1 - ay) + m[y0 * sw + x1] * ax * (1 - ay) + m[y1 * sw + x0] * (1 - ax) * ay + m[y1 * sw + x1] * ax * ay;
    }
    var hx = (toneHex || leatherEtch().hex).replace('#', '');
    var er = parseInt(hx.substr(0, 2), 16), eg = parseInt(hx.substr(2, 2), 16), eb = parseInt(hx.substr(4, 2), 16);
    var kxS = (sw - 1) / Math.max(1, W2 - 1), kyS = (sh - 1) / Math.max(1, H2 - 1);
    for (var i = 0; i < d.length; i += 4) {
      var l = 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2];
      /* BINARY burn with an 8-unit AA ramp only — laser burns or it doesn't */
      var k = l < __etchT - 4 ? 1 : (l < __etchT + 4 ? (__etchT + 4 - l) / 8 : 0);
      if (l >= 246) k = 0;
      if (invertOn) {
        var p0 = i >> 2, pyF = (p0 / W2) | 0, pxF = p0 - pyF * W2;
        var fB = mSample(bareM, pxF * kxS, pyF * kyS), hB = mSample(holeM, pxF * kxS, pyF * kyS);
        k = Math.max(0, Math.min(1, k * (1 - fB) + hB));
      }
      /* INVERT-THE-DESIGN mode (standard shapes): flip burn/bare WITHIN the
         artwork's own opaque footprint — the patch face is untouched */
      if (invertK && d[i + 3] >= 40) k = 1 - k;
      var aOut = Math.round(d[i + 3] * k);
      if (outlM) {
        var p1 = i >> 2, pyO = (p1 / W2) | 0, pxO = p1 - pyO * W2;
        var oV = mSample(outlM, pxO * kxS, pyO * kyS);
        if (oV > 0.02) aOut = Math.max(aOut, Math.round(oV * 255));
      }
      d[i + 3] = aOut;
      d[i] = er; d[i + 1] = eg; d[i + 2] = eb;
    }
    tx.putImageData(id, 0, 0);
    return t;
  }
  function monoArtCanvas(img, w, h, tone) {
    /* single-material finishes (matte black / matte white) are ONE colour of
       flex: the design is not printed, it is molded in the same material, so
       the artwork reads as two tones of that colour rather than full colour.
       Artwork luminance maps between the finish's dark and light tone. */
    var t = document.createElement('canvas');
    t.width = Math.max(1, Math.round(w)); t.height = Math.max(1, Math.round(h));
    var tx = t.getContext('2d');
    tx.drawImage(img, 0, 0, t.width, t.height);
    var id = tx.getImageData(0, 0, t.width, t.height), d = id.data;
    function rgb(hx) {
      hx = String(hx || '').replace('#', '');
      return [parseInt(hx.substr(0, 2), 16), parseInt(hx.substr(2, 2), 16), parseInt(hx.substr(4, 2), 16)];
    }
    var lo = rgb(tone && tone.dark), hi = rgb(tone && tone.light);
    for (var i = 0; i < d.length; i += 4) {
      if (!d[i + 3]) continue;
      var l = (0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2]) / 255;
      d[i] = Math.round(lo[0] + (hi[0] - lo[0]) * l);
      d[i + 1] = Math.round(lo[1] + (hi[1] - lo[1]) * l);
      d[i + 2] = Math.round(lo[2] + (hi[2] - lo[2]) * l);
    }
    tx.putImageData(id, 0, 0);
    return t;
  }
  function effectiveBorders() {
    if (PTYPE.mats) {
      /* leather-family: the border is a laser-etched LINE, not thread.
         CUSTOM SHAPE is cut clean on the artwork's own edge — No Border is
         the ONLY option there (Justin 2026-08-21). */
      var lbCustom = (function () {
        var lab = (st.draft && st.draft.shape) || st.shape;
        var hit = false;
        (CFG.shapes || []).forEach(function (sB) { if (sB.label === lab && sB.geom === 'custom') hit = true; });
        return hit;
      })();
      var lbAll = [
        { label: 'No Border', img: 'https://ninjauploads-production.imgix.net/np-lb-noborder-1786993611.png', note: 'Smooth clean cut edge' },
        { label: 'Etched Border', img: 'https://ninjauploads-production.imgix.net/np-lb-border-1786993636.png', note: 'A border line etched just inside the edge' }
      ];
      return lbCustom ? [lbAll[0]] : lbAll;
    }
    var isCustomB = shapeGeom() === 'custom';
    var listB = (CFG.borders || []).filter(function (b) { return !isCustomB || b.customOnly; });
    if (PTYPE.borders) listB = listB.filter(function (b) { return PTYPE.borders.test(b.label || ''); });
    if (PTYPE.noBorderOpt && (!isCustomB || !listB.length)) listB = listB.concat([{ label: 'No Border', note: 'Background runs edge to edge' }]);
    return listB;
  }
  function effectiveBackings() {
    var bk = CFG.backings || [];
    if (!PTYPE.backings) return bk;
    return bk.filter(function (b) {
      var L = (b.label || '').toLowerCase();
      return PTYPE.backings.some(function (t2) { return L.indexOf(t2) !== -1; });
    });
  }


  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function money(n) { return '$' + (Math.round(n * 100) / 100).toFixed(2); }

  /* ---- legacy bridges ---- */
  function legacyInput(name) { return document.querySelector('input[name="' + name + '"]'); }
  function setLegacySize(w, h) {
    var wi = legacyInput('width__value'), hi = legacyInput('height__value');
    if (wi) { wi.value = w.toFixed(2); wi.dispatchEvent(new Event('keyup', { bubbles: true })); }
    if (hi) { hi.value = h.toFixed(2); hi.dispatchEvent(new Event('keyup', { bubbles: true })); }
  }
  function setLegacyQty(q) {
    var qi = document.querySelector('.customQtyFile__qty');
    if (qi) { qi.value = q; qi.dispatchEvent(new Event('keyup', { bubbles: true })); qi.dispatchEvent(new Event('change', { bubbles: true })); }
  }
  function setFormVariant(id) {
    var f = document.querySelector('product-form.product-form form [name="id"]');
    if (f) { f.value = id; f.dispatchEvent(new Event('change', { bubbles: true })); }
  }
  /* Properties the ORDER ADMIN does not want. Blocked at the single write
     point so no call site can reintroduce them. Image-wise the order keeps
     only _Upload, _AI Proof and _Original Image. */
  function propBlocked(name) {
    var n = String(name || '');
    return n === '_Proof Version' || n === '_Preview Image' || n === '_AI Proof Revisions';
  }
  function setProp(name, value) {
    if (propBlocked(name)) {
      /* switch off any existing field of that name rather than leaving a stale
         value from an earlier build on the line */
      var fB = document.querySelector('product-form.product-form form');
      if (fB) $$('[name="properties[' + name + ']"]', fB).forEach(function (eB) { eB.disabled = true; });
      return;
    }
    var form = document.querySelector('product-form.product-form form');
    if (!form) return;
    /* The options app injects its OWN properties[...] fields asynchronously,
       so a name can end up with two live inputs: the app's field plus a
       hidden one we created before it arrived. Two live fields = two values
       in the FormData. Retire OURS, never theirs — a radio group
       legitimately shares one name, and disabling its siblings would break
       the customer's selection. */
    var allP = $$('[name="properties[' + name + ']"]', form);
    var oursP = allP.filter(function (n2) { return n2.getAttribute('data-np-e2-prop') === '1'; });
    var theirsP = allP.filter(function (n2) { return n2.getAttribute('data-np-e2-prop') !== '1'; });
    if (theirsP.length && oursP.length) oursP.forEach(function (n2) { n2.disabled = true; });
    var el = theirsP.length ? theirsP[0] : oursP[0];
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = 'properties[' + name + ']';
      el.setAttribute('data-np-e2-prop', '1');
      form.appendChild(el);
    }
    var val = value == null ? '' : String(value);
    /* An EMPTY property still rides to the order and shows up as a bare label
       with no value (the legacy underscore fields were filling the order page
       with "_Patch Background Color", "_Border Thickness" and friends). A
       property with nothing in it is not a property — switch it off instead. */
    el.value = val;
    el.disabled = !val;
  }
  /* legacy option fields the old flow left in the DOM. They duplicate what the
     2-0 builder writes (or carry nothing at all), so they are switched off
     before the line is added rather than shipped to the order. */
  var LEGACY_PROPS = [
    '_Patch Background Color', '_Border Color (For Merrow Only)', '_Border Color (Merrow only)',
    '_Border Thread Color', '_Border Thickness', '_Select Shape', '_Select Your Backing'
  ];
  function pruneLegacyProps() {
    var form = document.querySelector('product-form.product-form form');
    if (!form) return;
    var dropped = [];
    $$('[name^="properties["]', form).forEach(function (el2) {
      var mN = /^properties\[(.*)\]$/.exec(el2.getAttribute('name') || '');
      if (!mN) return;
      var nm = mN[1];
      if (propKept(nm) && String(el2.value || '').trim()) { el2.disabled = false; return; }
      if (!el2.disabled) dropped.push(nm);
      el2.disabled = true;
    });
    if (dropped.length) console.log('[np-e2] props stripped from the order:', dropped.join(', '));
  }
  /* ORDER-ADMIN PROPERTY ORDER. Shopify lists line-item properties in the
     order they were SUBMITTED: DOM order for a form post, key-insertion order
     for a /cart/change.js properties object. The two helpers below put the
     contract properties first, in the exact sequence ops asked for; anything
     not listed keeps its relative position behind them. */
  var PROP_ORDER = [
    '_Order Mode',
    '_AI Model',
    '_Upload',
    '_AI Proof',
    '_Mockup Catalog',
    '_Original Image',
    '_Lettering Text',
    '_Font Style',           /* tackle twill lettering face — was being PRUNED at add time (2026-08-24) */
    '_Width (in)',
    '_Height (in)',
    '_Shape',
    '_Corners',
    '_Background Color',
    '_Border Color',
    '_Text Color',
    '_Letter Color',
    '_Outline Color',
    '_Design Format',
    '_Line Sizes',
    '_Border Stitch',
    '_Swoosh',
    '_Swoosh Style',
    '_Swoosh Text',
    '_Swoosh Text Color',
    '_Border Style',
    '_Etch Style',
    '_Select Your Backing',
    'Design Notes',
    '_Proof Preference',
    '_Proof Approval',
    '_AI Proof Status',
    '_Revision Notes'
  ];
  /* NEW ORDERS carry ONLY what rebuilds the patch (PROP_ORDER, in that order)
     plus the functional set below. Anything else is stripped at add time.
     READERS are untouched — they keep their legacy-name fallbacks, so
     reordering an OLD order still works; the new line it creates simply comes
     out clean. */
  var PROP_KEEP = PROP_ORDER.concat([
    '_Background Texture',     /* flex surface — part of the rebuild */
    '_Border Thickness',       /* leather/flex border width — part of the rebuild */
    '_Etch Style',             /* leather inverted-etch flag */
    '_Production Method',      /* PRINT & STITCH split — production reads it */
    '_cartImg',                /* cart/checkout thumbnail */
    '_discount_input',         /* volume pricing — checkout breaks without them */
    '_discount_name',
    /* Design Notes rides along (ordered above); 'AI Edit' deliberately NOT
       kept (2026-08-19): the AI-edited artwork IS the outcome — the prompt
       text is session noise at order level */
    /* custom names (name-patches): the roster IS the order, the font and the
       combined border+text thread colour are its production spec. The thread
       property name carries a TRAILING SPACE to match the live product option
       byte for byte. */
    'List of Names (Separate by Comma)',
    'Font Style',
    'Border & Text Thread Color '
    /* _Art Fill deliberately NOT kept (2026-08-18): nothing reads it back on
       reorder and the proof images already show the final layout — the order
       does not need it. The zoom slider still works in-session. */
  ]);
  function propKept(name) { return PROP_KEEP.indexOf(String(name || '')) !== -1; }
  /* form path: move OUR hidden inputs to the front of the form. A VISIBLE
     field (a radio group / select the options app owns) is left exactly where
     it is - moving it would move the customer-facing UI with it. */
  function orderProps() {
    var form = document.querySelector('product-form.product-form form');
    if (!form) return;
    var mark = document.createComment('np-e2-prop-order');
    form.insertBefore(mark, form.firstChild);
    PROP_ORDER.forEach(function (nmO) {
      $$('[name="properties[' + nmO + ']"]', form).forEach(function (elO) {
        if (elO.tagName !== 'INPUT' || elO.type !== 'hidden') return;
        form.insertBefore(elO, mark);
      });
    });
    if (mark.parentNode) mark.parentNode.removeChild(mark);
  }
  /* /cart/change.js path: rebuild the object with the listed keys inserted
     first, in order, then the remainder in its original order */
  function orderPropsObj(o) {
    if (!o) return o;
    var out = {};
    PROP_ORDER.forEach(function (kO) {
      if (Object.prototype.hasOwnProperty.call(o, kO)) out[kO] = o[kO];
    });
    Object.keys(o).forEach(function (kO) {
      if (!Object.prototype.hasOwnProperty.call(out, kO)) out[kO] = o[kO];
    });
    return out;
  }
  function cleanUrl(u) {
    /* legacy reloads could bake "...png&nocache=..." (params without a "?")
       into properties — truncate the junk so the URL actually resolves */
    if (u) {
      /* flatten-era _cartImg URLs baked a grey background — shed it */
      u = String(u).replace(/[?&]fm=jpg&q=88&bg=f2f2f2/g, function (m) { return m.charAt(0) === '?' ? '?' : ''; });
      u = u.replace(/\?&/, '?').replace(/\?$/, '');
    }
    if (u && u.indexOf('?') === -1 && u.indexOf('&') > -1) return u.split('&')[0];
    return u;
  }
  function isUploadLineage(u) {
    /* every REAL customer file carries the upload pipeline's name token
       (image_<ts>_<rand>) or is a generated proof (ai-proof-*). Catalog /
       style / marketing assets (FULL_COLOR_PRINTED_PATCHES.png poisoning
       real orders, 2026-08-21) carry neither and must never be artwork. */
    return /(image|img)_\d{9,}_\d+|ai-proof-/i.test(String(u || ''));
  }
  function artLineageSfx(u) {
    /* proofs embed the ORIGINAL upload's name after "____" — that suffix is
       the session's artwork lineage (the portal matches on it already) */
    var m = /____((?:image|img)?_?\d{9,}_\d+)/.exec(String(u || ''));
    return m ? m[1] : '';
  }
  function sameLineage(candidate, proofUrl) {
    var sfx = artLineageSfx(proofUrl);
    if (!sfx) return true; /* no lineage on the proof — nothing to enforce */
    return String(candidate || '').indexOf(sfx) > -1;
  }
  function artworkCandidates() {
    var out = [];
    var hero = document.getElementById('fileupload_hero');
    var heroSrc = hero ? (hero.getAttribute('src') || '') : '';
    if (heroSrc && heroSrc.indexOf('loader') === -1) out.push(heroSrc);
    ['properties[_Upload]', 'properties[_cartImg]', 'properties[_Original Image]'].forEach(function (n) {
      var el = legacyInput(n);
      if (el && el.value && el.value.indexOf('http') === 0) out.push(el.value);
    });
    /* the ?file= reuse param is a KNOWN-hosted url — reliable fallback when
       the legacy flow re-uploads under a name that isn't live yet */
    var m = window.location.search.split('file=')[1];
    if (m) { try { var dec = decodeURIComponent(m); if (dec.indexOf('http') === 0) out.push(dec.split('&')[0]); } catch (e) {} }
    /* S3-hosted originals load via the imgix front */
    var imgixHost = '';
    out.forEach(function (u) { if (!imgixHost && u.indexOf('imgix') > -1) { try { imgixHost = new URL(u).hostname; } catch (e) {} } });
    if (imgixHost) out.slice().forEach(function (u) {
      if (u.indexOf('imgix') === -1 && (u.indexOf('s3') > -1 || u.indexOf('amazonaws') > -1)) {
        try { var s = new URL(u); out.push('https://' + imgixHost + s.pathname); } catch (e) {}
      }
    });
    out = out.map(cleanUrl);
    /* customer uploads live on the uploads imgix/S3 ONLY — the legacy hero
       can silently fall back to PRODUCT images (cdn.shopify.com), which must
       never become the artwork */
    out = out.filter(function (u) { return u.indexOf('/cdn/shop/') === -1 && u.indexOf('cdn.shopify.com') === -1; });
    out = out.filter(isUploadLineage);
    return out.filter(function (u, i) { return out.indexOf(u) === i; });
  }
  function legacyArtworkUrl() {
    /* classic mode: the artwork lives in the legacy form's own fields */
    var f = document.querySelector('input[name="properties[_Upload]"], input[name="properties[_cartImg]"]');
    if (f && f.value) return cleanUrl(f.value);
    var im = document.querySelector('#uploadArea img, .np-upload-tabs img, file-preview img');
    return (im && im.src) ? cleanUrl(im.src) : '';
  }
  function artworkUrl() {
    /* prefer a source we KNOW loaded (the builder canvas img), else first candidate */
    var img = document.getElementById('np-e2-artimg');
    if (img && img.naturalWidth > 0 && img.src) return img.src;
    return artworkCandidates()[0] || '';
  }
  /* ═══ VECTOR DISPLAY PROXY (Justin 2026-08-24) ═══
     imgix re-rasterizes an .ai/.eps/.pdf server-side for EVERY unique param
     combination — and the builder requests many (trim/bg-remove toggles,
     several widths) — so every option change took seconds on vector uploads.
     Rasterize ONCE to a hosted PNG and route all DISPLAY paths through it
     (this hook inside applyToggleParams covers loadArt, the compose canvas
     and the analyzer). Order properties keep the TRUE vector: they read
     artworkUrl()/cleanUrl directly and never pass through here. */
  function isVectorArt(u) { return /\.(ai|eps|pdf)$/i.test(String(u || '').split('?')[0]); }
  var vecProxy = { src: null, url: null, busy: false };
  function ensureVectorProxy() {
    var a = cleanUrl(artworkUrl());
    if (!a || !isVectorArt(a)) return;
    if (vecProxy.src === a && (vecProxy.url || vecProxy.busy)) return;
    vecProxy.src = a; vecProxy.url = null; vecProxy.busy = true;
    var vU = toImgixHost(a);
    fetch(vU + (vU.indexOf('?') > -1 ? '&' : '?') + 'fm=png&w=2000')
      .then(function (r) { if (!r.ok) throw new Error('raster ' + r.status); return r.blob(); })
      .then(function (blob) {
        var name = 'vec-raster____image_' + Date.now() + '_' + Math.floor(Math.random() * 1000) + '.png';
        if (typeof window.getPresignedUploadUrl !== 'function') throw new Error('no presign');
        return window.getPresignedUploadUrl(name, 'image/png').then(function (p) {
          if (!p || !p.url) throw new Error('presign');
          return npPut(p.url, blob).then(function (r2) {
            if (!r2.ok) throw new Error('put');
            vecProxy.url = toImgixHost(p.sourceUrl || '');
            vecProxy.busy = false;
            try { loadArt(); } catch (eVL) {}
            try { st.__artAnalyzed = false; analyzeArtwork(); } catch (eVA) {}
          });
        });
      })
      .catch(function (eVP) { vecProxy.busy = false; console.warn('[np-e2] vector proxy failed — staying on live rasterization', eVP); });
  }
  function applyToggleParams(url) {
    /* the canvas render mirrors the toggles directly on the imgix URL:
       Crop+Trim -> trim=colorUnlessAlpha, Remove background -> bg-remove=true */
    try {
      if (vecProxy.url && isVectorArt(url)) url = vecProxy.url;
      if ((url || '').indexOf('imgix') === -1) return url;
      var u = new URL(url);
      if (st.crop) u.searchParams.set('trim', 'colorUnlessAlpha'); else u.searchParams.delete('trim');
      if (st.removeBg) u.searchParams.set('bg-remove', 'true'); else u.searchParams.delete('bg-remove');
      if (/gram-edit/i.test(url)) u.searchParams.set('cs', 'strip'); /* AI-edit outputs: strip the ICC color profile */
      /* VECTORS: imgix rasterizes an SVG at its tiny intrinsic size unless a
         width is forced — small viewBoxes were arriving as thumbnail-sized
         rasters and every preview of them looked soft. Rasterize big. */
      if (/\.svg(\?|$)/i.test(u.pathname)) { u.searchParams.set('w', '1600'); u.searchParams.set('fm', 'png'); }
      return u.toString();
    } catch (e) { return url; }
  }
  var artRetryTimer = null;
  function artLoader(on) {
    var l = document.getElementById('np-e2-artload');
    if (l) l.classList.toggle('is-on', !!on);
    /* never show the broken-image glyph while the artwork loads */
    var im = document.getElementById('np-e2-artimg');
    if (im) im.style.visibility = on ? 'hidden' : '';
  }
  function loadArt() {
    /* NO-ART types (custom names) compose their preview from text — there is
       no artwork to fetch, so every entry here used to hit the retry loop and
       leave the loading spinner pinned over the preview forever */
    if (PTYPE.noArt) {
      if (artRetryTimer) { clearTimeout(artRetryTimer); artRetryTimer = null; }
      artLoader(false);
      return;
    }
    /* walk candidates until one actually loads — the legacy reuse path can
       set a 404ing hero src on some lineages */
    var img = document.getElementById('np-e2-artimg');
    if (!img.__npLoadWired) {
      img.__npLoadWired = true;
      img.addEventListener('load', function () { artLoader(false); });
    }
    artLoader(true);
    try { ensureVectorProxy(); } catch (eEVP) {}
    var cands = artworkCandidates().map(applyToggleParams);
    var i = 0;
    function retrySoon() {
      /* the legacy flow writes properties[_Upload] a few seconds after the
         upload signal — keep retrying until something renders */
      if (artRetryTimer) return;
      artRetryTimer = setTimeout(function () { artRetryTimer = null; loadArt(); }, 1500);
    }
    if (!cands.length) { retrySoon(); return; }
    function tryNext() {
      if (i >= cands.length) { retrySoon(); return; }
      var probe = new Image();
      var url = cands[i++];
      var rbTries = 0;
      probe.onload = function () { if (img.src === url) artLoader(false); img.src = url; };
      probe.onerror = function () {
        /* the bg-remove rendition 5xxes while imgix GENERATES it on the first
           request — falling through to the next candidate silently showed the
           UN-removed image with the toggle ON until a later re-toggle found
           the finished rendition (911, 2026-08-24). It IS coming: retry the
           same URL under the loader instead of abandoning it. */
        if (/[?&]bg-remove=true/.test(url) && rbTries++ < 10) { setTimeout(function () { probe.src = url; }, 2000); return; }
        tryNext();
      };
      probe.src = url;
    }
    tryNext();
  }

  /* ---- pricing (mirrors legacy: variant by mean size, tier % off) ---- */
  function displayShapeLabel(l) {
    /* DISPLAY-ONLY rename (Justin 2026-08-24): the stored value, the _Shape
       property, sidecars, reorder params and the renderer specs all keep
       "Custom Shape" — only what the customer READS changes. */
    return /^custom shape$/i.test(String(l || '').trim()) ? 'Shape of My Design' : l;
  }
  function isFreeFormShape(lbl) {
    /* Free Form shares the 'custom' geometry but has NO patch base at all:
       each element is cut on its own, so there is no contour to fill or ring */
    return /free\s*form/i.test(lbl || st.shape || '');
  }
  function shapeGeom() {
    var g = null;
    (CFG.shapes || []).forEach(function (s) { if (s.label === st.shape) g = s.geom; });
    /* fixed-shape types ship NO shape blocks, so the lookup above finds
       nothing — the profile itself is the answer */
    if (!g && PTYPE.fixedShape) g = PTYPE.fixedShape.geom;
    return g;
  }
  function heightLocked() {
    /* symmetric shapes lock height to width */
    var g = shapeGeom();
    return ['circle', 'square', 'star', 'rhombus', 'hexagon', 'heart', 'shield'].indexOf(g) > -1;
  }
  function sizeMean() { return (st.w + st.h) / 2; }
  function nearestVariant() {
    /* the variant-option steps together ARE the variant: the price rides on it,
       so patch size can never be what chooses it here */
    if (PTYPE.optVariant) return optVariantMatch();
    /* fixed-size types have exactly ONE variant and its title is not a plain
       number ('3.25" x 1.25"'), so the size-matching walk below cannot read
       it — the product's own variant IS the answer */
    if (PTYPE.fixedSize) {
      var fv = (CFG.variants || [])[0];
      return fv ? { id: fv.id, num: parseFloat(String(fv.opt1).replace(/[^0-9.]/g, '')) || 0, price: fv.price } : null;
    }
    var size = sizeMean();
    var vs = (CFG.variants || []).map(function (v) {
      return { id: v.id, num: parseFloat(String(v.opt1).replace(/[^0-9.]/g, '')), price: v.price };
    }).filter(function (v) { return !isNaN(v.num); }).sort(function (a, b) { return a.num - b.num; });
    if (!vs.length) return null;
    for (var i = 0; i < vs.length; i++) { if (size <= vs[i].num) return vs[i]; }
    return vs[vs.length - 1];
  }
  function tiers() { return (CFG.tiers || []).slice().sort(function (a, b) { return a.min - b.min; }); }
  function tierIndexFor(q) {
    var t = tiers(), idx = 0;
    for (var i = 0; i < t.length; i++) { if (q >= t[i].min) idx = i; }
    return idx;
  }
  function pricing() {
    var v = nearestVariant();
    var base = v ? v.price : 0;
    var t = tiers();
    var idx = tierIndexFor(st.qty);
    var off = t.length ? (t[idx].off || 0) : 0;
    var unit = base * (1 - off / 100);
    return { base: base, unit: unit, off: off, idx: idx, variant: v, tiers: t };
  }

  /* ---- render: step 2 + volume panel ---- */
  function renderPricing() {
    if (heightLocked()) st.h = st.w; /* circle/square: height mirrors width */
    var p = pricing();
    var wIn = document.getElementById('np-e2-winput'), hIn = document.getElementById('np-e2-hinput');
    if (wIn && document.activeElement !== wIn) wIn.value = st.w.toFixed(2);
    if (hIn && document.activeElement !== hIn) hIn.value = st.h.toFixed(2);
    var hs = document.querySelector('[data-e2-step="h"]');
    if (hs) hs.classList.toggle('is-locked', heightLocked());
    if (hIn) hIn.disabled = heightLocked();
    var qin = document.getElementById('np-e2-qtyinput');
    if (qin && document.activeElement !== qin) qin.value = st.qty;
    /* Patch Size = the variant actually charged (mean rounded UP to the
       nearest size variant), not the raw average */
    var pv = nearestVariant();
    /* a variant-option type states its size in the option label itself
       ('11" x 4" (Most Popular)') — a mean-of-W-and-H number means nothing */
    $('#np-e2-sizeval').textContent = (pv && pv.sizeLabel)
      ? pv.sizeLabel
      : ((pv ? String(parseFloat(pv.num.toFixed(2))) : (Math.round(sizeMean() * 10) / 10).toFixed(1)) + '"');
    $('#np-e2-qtycap').textContent = QTY_MIN + ' piece minimum';

    var each = $('#np-e2-each'), baseEach = $('#np-e2-base-each');
    var total = $('#np-e2-total'), baseTotal = $('#np-e2-base-total');
    var badge = $('#np-e2-offbadge');
    each.textContent = money(p.unit);
    total.textContent = money(p.unit * st.qty);
    if (p.off > 0) {
      baseEach.textContent = money(p.base); baseEach.style.display = '';
      baseTotal.textContent = money(p.base * st.qty); baseTotal.style.display = '';
      badge.textContent = p.off + '% off'; badge.hidden = false;
    } else {
      baseEach.style.display = 'none'; baseTotal.style.display = 'none';
      badge.textContent = ''; badge.hidden = true;
    }
    $('#np-e2-co-total').textContent = money(p.unit * st.qty) + ' for ' + st.qty + ' pieces';
    /* sizing-phase extras: dimension-arrow chips + modal checkout row */
    var wchip = $('#np-e2-sz-wchip'); if (wchip) wchip.textContent = st.w.toFixed(2) + '"';
    var hchip = $('#np-e2-sz-hchip'); if (hchip) hchip.textContent = st.h.toFixed(2) + '"';
    var szTotal = $('#np-e2-sz-cototal'); if (szTotal) szTotal.textContent = money(p.unit * st.qty);
    var szSub = $('#np-e2-sz-cosub');
    if (szSub) szSub.textContent = st.qty + ' pcs · ' + money(p.unit) + ' ea' + (p.off > 0 ? ' · ' + p.off + '% off' : '');
    var szCo = $('#np-e2-sz-checkout');
    if (szCo) szCo.textContent = 'Continue'; /* Add to Cart lives on the page's approved summary */
    positionDims();
    renderVolume(p);
  }

  function isAlphaSrc(url) {
    /* imgix-hosted files (customer uploads, edit outputs, FC proofs) carry
       real transparency AND CORS headers; local data-URL composes (digital
       proofs) are alpha PNGs too. Sensei mockups (S3) have neither — but a
       flattened display copy (fm=jpg) is opaque even on imgix. */
    if (/fm=jpg/.test(url || '')) return false;
    if (/ai-proof-[a-z0-9-]+--(v\d+|ml)-/i.test(url || '')) return false; /* frozen AI mockup copies: opaque studio shots on imgix */
    return /imgix/.test(url || '') || /^data:image\/png/i.test(url || '');
  }
  /* ---- PMS (Pantone Solid Coated) nearest-match — colors display as PMS
     codes, the embroidery production standard, never raw hex ---- */
  var PMS = [
    ['#FFFFFF','White'],['#0C0C0E','Black 6 C'],['#2D2926','Black C'],['#75787B','Cool Gray 9 C'],['#A7A8AA','Cool Gray 6 C'],['#D0D0CE','Cool Gray 2 C'],['#D9D9D6','Cool Gray 1 C'],
    ['#C8102E','PMS 186 C'],['#EF3340','PMS Red 032 C'],['#A6192E','PMS 187 C'],['#7C2529','PMS 188 C'],['#E03C31','PMS 179 C'],['#F9423A','PMS Warm Red C'],
    ['#FF8200','PMS 151 C'],['#FE5000','PMS Orange 021 C'],['#E87722','PMS 158 C'],['#CB6015','PMS 1595 C'],['#B86125','PMS 1615 C'],
    ['#FFD100','PMS Yellow C'],['#FFC72C','PMS 123 C'],['#F2A900','PMS 130 C'],['#FFB81C','PMS 1235 C'],['#EAAA00','PMS 124 C'],['#FEDD00','PMS Yellow 012 C'],
    ['#78BE20','PMS 368 C'],['#97D700','PMS 375 C'],['#00A651','PMS 355 C'],['#009639','PMS 347 C'],['#00843D','PMS 348 C'],['#046A38','PMS 349 C'],
    ['#154734','PMS 3435 C'],['#43B02A','PMS 361 C'],['#6CC24A','PMS 360 C'],['#A4D65E','PMS 366 C'],['#00B140','PMS 354 C'],['#1AA86C','PMS 340 C'],
    ['#008675','PMS 328 C'],['#00968F','PMS 3282 C'],['#00B2A9','PMS 326 C'],['#2DCCD3','PMS 3115 C'],['#71C5E8','PMS 297 C'],['#41B6E6','PMS 298 C'],
    ['#00A9E0','PMS 299 C'],['#0077C8','PMS 3005 C'],['#0057B7','PMS 293 C'],['#003DA5','PMS 286 C'],['#001A70','PMS 2757 C'],['#1657CF','PMS 2728 C'],
    ['#171C8F','PMS Blue 072 C'],['#13294B','PMS 282 C'],['#003057','PMS 540 C'],['#5B7F95','PMS 5405 C'],['#8DC8E8','PMS 291 C'],['#B9D9EB','PMS 290 C'],
    ['#582C83','PMS 268 C'],['#702F8A','PMS 2597 C'],['#7C3AED','PMS 2665 C'],['#93328E','PMS 2583 C'],['#A05EB5','PMS 2573 C'],['#C6B0D5','PMS 529 C'],
    ['#CE0F69','PMS Rubine Red C'],['#E31C79','PMS 213 C'],['#EC4899','PMS 218 C'],['#F57EB6','PMS 224 C'],['#F8A3BC','PMS 1895 C'],['#FABBCB','PMS 707 C'],
    ['#6A2E2A','PMS 483 C'],['#7C4A21','PMS 731 C'],['#93592B','PMS 730 C'],['#B58150','PMS 729 C'],['#D3A874','PMS 728 C'],['#EFD19F','PMS 468 C'],
    ['#F4EAD3','PMS 7499 C'],['#D6D2C4','PMS 7527 C'],['#B7A99A','PMS 7529 C'],['#8B8178','PMS 7531 C'],
    ['#8A1538','PMS 202 C'],['#651C32','PMS 505 C'],['#3F2A56','PMS 269 C'],['#1D252D','PMS 433 C'],['#425563','PMS 7545 C'],['#5B6770','PMS 431 C'],
    ['#898D8D','PMS 422 C'],['#C1C6C8','PMS 427 C'],['#CBD5E1','PMS 428 C'],['#B45309','PMS 1525 C'],['#946037','PMS 7565 C'],['#DDCBA4','PMS 7501 C'],
    ['#14532D','PMS 3537 C'],['#0D9488','PMS 3292 C'],['#38BDF8','PMS 2915 C'],['#1E3A8A','PMS 288 C'],['#FDE047','PMS 101 C'],['#86EFAC','PMS 351 C'],
    ['#A3E635','PMS 374 C'],['#FB7185','PMS 178 C'],['#C4B5FD','PMS 2635 C'],['#4B5563','PMS 7540 C'],['#D4D4D8','PMS Cool Gray 3 C'],['#F97316','PMS 715 C']
  ];
  function pmsName(hex) {
    var h = (hex || '').replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    var r = parseInt(h.substr(0, 2), 16), g = parseInt(h.substr(2, 2), 16), b = parseInt(h.substr(4, 2), 16);
    if (isNaN(r) || isNaN(g) || isNaN(b)) return hex;
    /* a color with real chroma must NEVER be named after a neutral (a pale
       mint was reading as "White") — match tinted inputs against tinted
       PMS entries only, neutrals against neutrals */
    var inNeutral = (Math.max(r, g, b) - Math.min(r, g, b)) < 16;
    var best = null, bd = Infinity;
    PMS.forEach(function (p) {
      var ph = p[0].slice(1);
      var pr = parseInt(ph.substr(0, 2), 16), pg = parseInt(ph.substr(2, 2), 16), pb = parseInt(ph.substr(4, 2), 16);
      var pNeutral = (Math.max(pr, pg, pb) - Math.min(pr, pg, pb)) < 16;
      if (pNeutral !== inNeutral) return;
      if (p[1] === 'White' && !(r > 244 && g > 244 && b > 244)) return; /* only TRUE white is called White */
      var d = (r - pr) * (r - pr) * 2 + (g - pg) * (g - pg) * 4 + (b - pb) * (b - pb) * 3; /* perceptual-ish weights */
      if (d < bd) { bd = d; best = p[1]; }
    });
    return best || hex;
  }
  var mockupHosted = {};
  function freezeProofCopy(url, tag, cb) {
    /* every approved AI proof becomes a UNIQUE immutable file — the render
       bucket reuses ONE key per style, so a later regen would overwrite the
       file an order already points at */
    try {
      fetch(url, { mode: 'cors' }).then(function (r) { return r.blob(); }).then(function (blob) {
        /* dk token = hash(artwork|size): same art + same size + same patch
           type ⇒ same key, so listings can collapse duplicates */
        var dkSrc = (cleanUrl(artworkUrl()) || '') + '|' + (st.w || 0) + 'x' + (st.h || 0);
        var dkH = 5381;
        for (var iH = 0; iH < dkSrc.length; iH++) dkH = ((dkH << 5) + dkH + dkSrc.charCodeAt(iH)) >>> 0;
        var name = 'ai-proof-' + tag + '-dk' + dkH.toString(36) + '-' + Date.now() + '-' + Math.floor(Math.random() * 10000) + '.png';
        if (typeof window.getPresignedUploadUrl !== 'function') { cb(null); return; }
        window.getPresignedUploadUrl(name, 'image/png').then(function (p) {
          if (!p || !p.url) { cb(null); return; }
          npPut(p.url, blob).then(function (r2) {
            var okF = r2 && r2.ok;
            cb(okF ? toImgixHost(p.sourceUrl || '') : null);
            if (!okF) return;
            /* sidecar JSON: the proof's full line-item data, so My Proofs
               can reorder it with every option intact */
            try {
              var sc = {
                v: 1, type: TYPE_KEY || '',
                shape: st.shape || '', corners: st.corners || '',
                bgl: st.bg ? st.bg.label : '', thl: st.thread ? st.thread.label : '',
                txl: st.text ? st.text.label : '',
                bsl: st.border ? st.border.label : '', bkl: st.backing ? st.backing.label : '',
                lbThick: st.lbThick || null,
                etchInvert: st.etchInvert ? 1 : 0,
                w: st.w, h: st.h, qty: st.qty,
                art: cleanUrl(artworkUrl()) || '',
                notes: (function () { try { return formProp('Design Notes') || ''; } catch (eN) { return ''; } })(),
                pp: (st.proofMode === 'digital' || st.proofMode === 'stitch') ? 'digital' : '',
                tex: st.texture ? st.texture.label : ''
              };
              window.getPresignedUploadUrl(name + '.json', 'application/json').then(function (p2) {
                if (!p2 || !p2.url) return;
                npPut(p2.url, new Blob([JSON.stringify(sc)], { type: 'application/json' }), { 'Content-Type': 'application/json' });
              }).catch(function () {});
            } catch (eSc) {}
            /* register in the customer's uploads DB — fetchDataNew (the My
               Proofs listing) is DB-backed, not a bucket scan */
            try {
              if (CFG.customerId) {
                fetch('https://hpz51rjda5.execute-api.us-east-1.amazonaws.com/production/uploads/saveData', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify([{
                    variant_title: 'custom',
                    file: p.sourceUrl || '',
                    customer_id: String(CFG.customerId),
                    file_name: name,
                    file_crc: name,
                    product_id: 'my-proofs',
                    gangsheet: false
                  }])
                }).then(function (rRg) { console.log('[np-e2] proof registered', name, rRg && rRg.status); }).catch(function (eRg2) { console.warn('[np-e2] proof register failed', eRg2); });
              }
            } catch (eRg) {}
          }).catch(function () { cb(null); });
        }).catch(function () { cb(null); });
      }).catch(function () { cb(null); });
    } catch (e) { cb(null); }
  }
  function toImgixHost(u) {
    return (u || '').replace(/https:\/\/[^/]*ninjauploads[^/]*\.s3\.amazonaws\.com/i, 'https://ninjauploads-production.imgix.net');
  }
  function lightRing() {
    /* light (white/cream) borders are color-identical to the white studio
       backdrop — the color flood eats them (verified: white merrow, 8-16) */
    if (!st.thread || st.thread.none) return false;
    if (st.border && /no border/i.test(st.border.label || '')) return false;
    var hx = st.thread.hex;
    if (!hx || !/^#[0-9a-fA-F]{6}$/.test(hx)) return false;
    var r = parseInt(hx.substr(1, 2), 16), g2 = parseInt(hx.substr(3, 2), 16), b = parseInt(hx.substr(5, 2), 16);
    return 0.299 * r + 0.587 * g2 + 0.114 * b > 210;
  }
  var renderAlphaProbe = {};
  function probeRenderAlpha(url, cb) {
    /* true when the render already carries meaningful transparency */
    if (renderAlphaProbe[url] !== undefined) { cb(renderAlphaProbe[url]); return; }
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var W = 160, H = Math.max(1, Math.round(im.naturalHeight * (W / im.naturalWidth)));
        var c = document.createElement('canvas'); c.width = W; c.height = H;
        var x = c.getContext('2d'); x.drawImage(im, 0, 0, W, H);
        var d = x.getImageData(0, 0, W, H).data, clear = 0;
        for (var i = 3; i < d.length; i += 4) if (d[i] < 8) clear++;
        var frac = clear / (W * H);
        renderAlphaProbe[url] = frac > 0.10;
        cb(renderAlphaProbe[url]);
      } catch (e) { renderAlphaProbe[url] = false; cb(false); }
    };
    im.onerror = function () { renderAlphaProbe[url] = false; cb(false); };
    im.src = url;
  }
  function hostRenderAsIs(url, cb) {
    /* already transparent: re-host it unchanged so the cart/proof pipeline
       still gets its own immutable imgix copy */
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var c = document.createElement('canvas'); c.width = im.naturalWidth; c.height = im.naturalHeight;
        c.getContext('2d').drawImage(im, 0, 0);
        cb(c);
      } catch (e) { cb(null); }
    };
    im.onerror = function () { cb(null); };
    im.src = url;
  }
  function lightBorderPicked() {
    /* white/cream borders sit within the flood tolerance of the studio
       backdrop and get eaten out of the alpha copy (2026-08-24) */
    var tl = (st.thread && st.thread.label) || '';
    var th = (st.thread && st.thread.hex) || '';
    if (/white|cream|ivory|natural|silver|light gr[ae]y/i.test(tl)) return true;
    if (/^#?[0-9a-f]{6}$/i.test(th)) {
      var hh = th.replace('#', '');
      return (0.299 * parseInt(hh.slice(0, 2), 16) + 0.587 * parseInt(hh.slice(2, 4), 16) + 0.114 * parseInt(hh.slice(4, 6), 16)) > 218;
    }
    return false;
  }
  function shapeMaskCutCanvas(url, geom, cb) {
    /* white-on-white cut: the studio backdrop is FLAT; a real patch surface
       (even white merrow) is TEXTURED. Flood from the borders eating only
       flat backdrop-colored pixels — texture blocks the flood at the true
       patch edge, whatever the border color. */
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var MAX = 1200;
        var sc = Math.min(1, MAX / Math.max(img.naturalWidth, img.naturalHeight));
        var W = Math.max(1, Math.round(img.naturalWidth * sc)), H = Math.max(1, Math.round(img.naturalHeight * sc));
        var c = document.createElement('canvas'); c.width = W; c.height = H;
        var x = c.getContext('2d'); x.drawImage(img, 0, 0, W, H);
        var id = x.getImageData(0, 0, W, H), d = id.data;
        var N = W * H;
        var rs = 0, gs = 0, bs = 0, n = 0;
        function acc(px) { var o = px * 4; rs += d[o]; gs += d[o + 1]; bs += d[o + 2]; n++; }
        for (var i = 0; i < W; i++) { acc(i); acc((H - 1) * W + i); }
        for (var j = 1; j < H - 1; j++) { acc(j * W); acc(j * W + W - 1); }
        var br = rs / n, bgc = gs / n, bb = bs / n;
        var bLumS = 0.299 * br + 0.587 * bgc + 0.114 * bb;
        var guardLight = lightBorderPicked();
        var lum = new Float32Array(N);
        for (i = 0; i < N; i++) lum[i] = 0.299 * d[i * 4] + 0.587 * d[i * 4 + 1] + 0.114 * d[i * 4 + 2];
        var grad = new Float32Array(N);
        for (var y2 = 1; y2 < H - 1; y2++) for (var x2 = 1; x2 < W - 1; x2++) {
          var p2 = y2 * W + x2, l0 = lum[p2];
          var g1 = Math.abs(l0 - lum[p2 - 1]), g2 = Math.abs(l0 - lum[p2 + 1]);
          var g3 = Math.abs(l0 - lum[p2 - W]), g4 = Math.abs(l0 - lum[p2 + W]);
          grad[p2] = Math.max(g1, g2, g3, g4);
        }
        var TOL2 = 52 * 52, G = 5.5;
        function isBg(px) {
          var o = px * 4;
          if (d[o + 3] < 12) return true;
          if (grad[px] >= G) return false; /* texture = patch */
          if (guardLight) {
            /* the light border is BRIGHTER than the backdrop; shadows are
               darker — never eat brighter-than-backdrop pixels */
            var lmG = 0.299 * d[o] + 0.587 * d[o + 1] + 0.114 * d[o + 2];
            if (lmG > bLumS + 5) return false;
          }
          var dr = d[o] - br, dg = d[o + 1] - bgc, db = d[o + 2] - bb;
          return dr * dr + dg * dg + db * db < TOL2;
        }
        var mark = new Uint8Array(N);
        var q = new Int32Array(N), qh = 0, qt = 0;
        function push(px) { if (!mark[px] && isBg(px)) { mark[px] = 1; q[qt++] = px; } }
        for (i = 0; i < W; i++) { push(i); push((H - 1) * W + i); }
        for (j = 1; j < H - 1; j++) { push(j * W); push(j * W + W - 1); }
        while (qh < qt) {
          var p = q[qh++], px2 = p % W, py = (p / W) | 0;
          if (px2 > 0) push(p - 1);
          if (px2 < W - 1) push(p + 1);
          if (py > 0) push(p - W);
          if (py < H - 1) push(p + W);
        }
        if (qt < N * 0.05 || qt > N * 0.98) { cb(null); return; }
        for (p = 0; p < N; p++) if (mark[p]) d[p * 4 + 3] = 0;
        x.putImageData(id, 0, 0);
        var minX = W, minY = H, maxX = -1, maxY = -1;
        for (var yy = 0; yy < H; yy++) for (var xx = 0; xx < W; xx++) {
          if (d[(yy * W + xx) * 4 + 3] > 12) {
            if (xx < minX) minX = xx; if (xx > maxX) maxX = xx;
            if (yy < minY) minY = yy; if (yy > maxY) maxY = yy;
          }
        }
        if (maxX < 0) { cb(null); return; }
        var bw = maxX - minX + 1, bh = maxY - minY + 1;
        var pad = Math.round(Math.max(bw, bh) * 0.05);
        var out = document.createElement('canvas'); out.width = bw + pad * 2; out.height = bh + pad * 2;
        out.getContext('2d').drawImage(c, minX, minY, bw, bh, pad, pad, bw, bh);
        cb(out);
      } catch (e) { cb(null); }
    };
    img.onerror = function () { cb(null); };
    img.src = url;
  }
  function outerCutCanvas(url, cb) {
    /* cut the studio backdrop off the mockup LOCALLY: flood fill from the
       image border, so only pixels CONNECTED to the outside are removed —
       the patch base (even pure white) can never be eaten. The AI remover
       this replaces silhouette-cut white patches. */
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var MAX = 1200;
        var sc = Math.min(1, MAX / Math.max(img.naturalWidth, img.naturalHeight));
        var W = Math.max(1, Math.round(img.naturalWidth * sc)), H = Math.max(1, Math.round(img.naturalHeight * sc));
        var c = document.createElement('canvas'); c.width = W; c.height = H;
        var x = c.getContext('2d'); x.drawImage(img, 0, 0, W, H);
        var id = x.getImageData(0, 0, W, H), d = id.data;
        var rs = 0, gs = 0, bs = 0, n = 0;
        function acc(px) { var o = px * 4; rs += d[o]; gs += d[o + 1]; bs += d[o + 2]; n++; }
        for (var i = 0; i < W; i++) { acc(i); acc((H - 1) * W + i); }
        for (var j = 1; j < H - 1; j++) { acc(j * W); acc(j * W + W - 1); }
        var br = rs / n, bgc = gs / n, bb = bs / n;
        var bLum = 0.299 * br + 0.587 * bgc + 0.114 * bb;
        var TOL2 = 52 * 52;
        var guardLightO = lightBorderPicked();
        function isBg(px) {
          var o = px * 4;
          if (d[o + 3] < 12) return true;
          if (guardLightO) {
            var lmG2 = 0.299 * d[o] + 0.587 * d[o + 1] + 0.114 * d[o + 2];
            var chG2 = Math.max(d[o], d[o + 1], d[o + 2]) - Math.min(d[o], d[o + 1], d[o + 2]);
            if (lmG2 > bLum + 5 && chG2 < 24) return false; /* brighter than backdrop = the light border */
          }
          var dr = d[o] - br, dg = d[o + 1] - bgc, db = d[o + 2] - bb;
          if (dr * dr + dg * dg + db * db < TOL2) return true;
          var mx = Math.max(d[o], d[o + 1], d[o + 2]), mn = Math.min(d[o], d[o + 1], d[o + 2]);
          var lum = 0.299 * d[o] + 0.587 * d[o + 1] + 0.114 * d[o + 2];
          return (mx - mn) < 30 && lum >= 110 && lum <= bLum - 12;
        }
        var mark = new Uint8Array(W * H);
        var q = new Int32Array(W * H), qh = 0, qt = 0;
        function push(px) { if (!mark[px] && isBg(px)) { mark[px] = 1; q[qt++] = px; } }
        for (i = 0; i < W; i++) { push(i); push((H - 1) * W + i); }
        for (j = 1; j < H - 1; j++) { push(j * W); push(j * W + W - 1); }
        while (qh < qt) {
          var p = q[qh++], px2 = p % W, py = (p / W) | 0;
          if (px2 > 0) push(p - 1);
          if (px2 < W - 1) push(p + 1);
          if (py > 0) push(p - W);
          if (py < H - 1) push(p + W);
        }
        if (qt < W * H * 0.05 || qt > W * H * 0.98) { cb(null); return; }
        for (p = 0; p < W * H; p++) if (mark[p]) d[p * 4 + 3] = 0;
        x.putImageData(id, 0, 0);
        var minX = W, minY = H, maxX = -1, maxY = -1;
        for (var yy = 0; yy < H; yy++) for (var xx = 0; xx < W; xx++) {
          if (d[(yy * W + xx) * 4 + 3] > 12) {
            if (xx < minX) minX = xx; if (xx > maxX) maxX = xx;
            if (yy < minY) minY = yy; if (yy > maxY) maxY = yy;
          }
        }
        if (maxX < 0) { cb(null); return; }
        var bw = maxX - minX + 1, bh = maxY - minY + 1;
        var pad = Math.round(Math.max(bw, bh) * 0.05);
        var out = document.createElement('canvas'); out.width = bw + pad * 2; out.height = bh + pad * 2;
        out.getContext('2d').drawImage(c, minX, minY, bw, bh, pad, pad, bw, bh);
        cb(out);
      } catch (e) { cb(null); }
    };
    img.onerror = function () { cb(null); };
    img.src = url;
  }
  function geoShapeCut(url, geom, cb) {
    /* photo mockups: NO pixel flood at all — photos contain flat light
       regions every flood misreads (a light merrow ring lets the flood
       breach into sky/sand). Measure the patch bounds (pixels clearly not
       studio white) and clip to the exact chosen geometry. */
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var W = img.naturalWidth, H = img.naturalHeight;
        var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
        var x = cv.getContext('2d');
        x.drawImage(img, 0, 0);
        var d = x.getImageData(0, 0, W, H).data;
        var minX = W, minY = H, maxX = -1, maxY = -1;
        for (var yy = 0; yy < H; yy += 2) for (var xx = 0; xx < W; xx += 2) {
          var o = (yy * W + xx) * 4;
          if (d[o + 3] < 40) continue;
          if ((255 - d[o]) + (255 - d[o + 1]) + (255 - d[o + 2]) > 90) {
            if (xx < minX) minX = xx; if (xx > maxX) maxX = xx;
            if (yy < minY) minY = yy; if (yy > maxY) maxY = yy;
          }
        }
        if (maxX < 0) { cb(null); return; }
        var bw = maxX - minX + 1, bh = maxY - minY + 1;
        if (lightBorderPicked()) {
          /* a light merrow ring reads as "studio white" and vanishes from the
             measured bounds — grow them by the ring width so the geometry
             mask keeps the border (2026-08-24) */
          var gxL = Math.round(bw * 0.045), gyL = Math.round(bh * 0.045);
          minX = Math.max(0, minX - gxL); maxX = Math.min(W - 1, maxX + gxL);
          minY = Math.max(0, minY - gyL); maxY = Math.min(H - 1, maxY + gyL);
          bw = maxX - minX + 1; bh = maxY - minY + 1;
        }
        var m = document.createElement('canvas'); m.width = W; m.height = H;
        var mx = m.getContext('2d');
        mx.beginPath();
        if (geom === 'circle' || geom === 'oval' || geom === 'oval-h') {
          var rx = (geom === 'circle' ? Math.min(bw, bh) : bw) / 2 * 0.99;
          var ry = (geom === 'circle' ? Math.min(bw, bh) : bh) / 2 * 0.99;
          mx.ellipse(minX + bw / 2, minY + bh / 2, rx, ry, 0, 0, Math.PI * 2);
        } else {
          var rr = (st.corners === 'square') ? 0 : Math.min(bw, bh) * 0.1;
          var inx = bw * 0.012, iny = bh * 0.012; /* shadow-inflated bounds: shave the rim */
          if (rr > 0 && mx.roundRect) mx.roundRect(minX + inx, minY + iny, bw - inx * 2, bh - iny * 2, rr);
          else mx.rect(minX + inx, minY + iny, bw - inx * 2, bh - iny * 2);
        }
        mx.closePath(); mx.fillStyle = '#000'; mx.fill();
        x.globalCompositeOperation = 'destination-in';
        x.drawImage(m, 0, 0);
        x.globalCompositeOperation = 'source-over';
        cb(cv);
      } catch (e) { cb(null); }
    };
    img.onerror = function () { cb(null); };
    img.src = url;
  }
  function npCutInteriorSolid(cv) {
    /* a real patch is a solid object: the central region of the cut's own
       bounding box must be nearly fully opaque. Hollow center = the flood
       ate patch content (e.g. white felt with no separating border). */
    try {
      var w = cv.width, h = cv.height;
      var x = cv.getContext('2d');
      var d = x.getImageData(0, 0, w, h).data;
      var minX = w, minY = h, maxX = -1, maxY = -1;
      for (var yy = 0; yy < h; yy += 2) for (var xx = 0; xx < w; xx += 2) {
        if (d[(yy * w + xx) * 4 + 3] > 12) {
          if (xx < minX) minX = xx; if (xx > maxX) maxX = xx;
          if (yy < minY) minY = yy; if (yy > maxY) maxY = yy;
        }
      }
      if (maxX < 0) return false;
      var bw = maxX - minX, bh = maxY - minY;
      var x0 = Math.round(minX + bw * 0.25), x1 = Math.round(minX + bw * 0.75);
      var y0 = Math.round(minY + bh * 0.25), y1 = Math.round(minY + bh * 0.75);
      var tot = 0, op = 0;
      for (var y2 = y0; y2 <= y1; y2 += 2) for (var x2 = x0; x2 <= x1; x2 += 2) {
        tot++;
        if (d[(y2 * w + x2) * 4 + 3] > 12) op++;
      }
      return tot > 0 && (op / tot) >= 0.82;
    } catch (eIS) { return true; } /* unverifiable: don't block */
  }
  /* ═══ DIAGNOSTICS MASTER SWITCH ═══
     Everything below this flag was built on 2026-08-25 to find the runaway
     timer in custom-uploader.js (selectNearestVariant2 spawning ~2,500 live
     intervals). It WRAPS GLOBAL PROTOTYPES — setInterval, clearInterval,
     setTimeout, EventTarget.addEventListener, MutationObserver,
     HTMLCanvasElement.toDataURL and XMLHttpRequest.send — which is acceptable
     on a test theme and NOT acceptable for customers. Flip to true only on an
     unpublished theme while chasing a performance bug; the tooling (leak /
     leakSRC / ticktrace / mtblock) is worth keeping for the next one.
     Method notes live in the np-self-replicating-timer memory. */
  var NP_DIAG = false;
  /* B85 (2026-08-25) — GLOBAL CANVAS CENSUS. The add still jams the thread for
     14s with timerTicks:0 and zero network. Rather than guess at another
     suspect, time EVERY canvas readback and encode in the page, whoever calls
     them, and report the delta across the add window. Sync canvas work is the
     only thing that can freeze both clocks like this; if these counters come
     back near zero the jam is NOT canvas and not ours. */
  if (NP_DIAG) try {
    window.__npCv = { tdu: 0, gid: 0, nT: 0, nG: 0, xSync: 0, xSyncMs: 0, xAsync: 0, ltMax: 0, ltN: 0, ltSrc: '' };
    /* B89 (2026-08-25) — CONTINUOUS TICK TRACE, running from page load.
       On Justin's last add the tab was awake the WHOLE time
       (tabsleep hidden:0ms switches:0) yet BOTH clocks ticked 0 times in 13.5s,
       with no long task (153ms max), no canvas, no sync XHR and no network.
       Timers measured native and healthy on /cart, so whatever stops them is
       specific to the PDP or to the moment of the add. This records the gap
       between every tick from page load, so the dump shows exactly WHEN the
       clock stopped and restarted rather than only that it did. */
    /* B91 (2026-08-25) — LEAK CENSUS. The tick trace showed a 250ms interval
       degrading as 743,1311,2051,3112,5587,8458,13690,27496ms — DOUBLING, i.e.
       the page progressively dying rather than blocking at one instant. That
       reconciles longestTask:148ms (no single long task) with a starved clock:
       thousands of SHORT tasks saturate the loop and longtask never sees them.
       Count what accumulates so the leak names itself instead of being guessed
       at: live intervals, listeners, observers, DOM nodes and heap. */
    window.__npT = { si: 0, siLive: 0, st: 0, ael: 0, mo: 0 };
    try {
      /* B93 (2026-08-25) — WHO IS MAKING THEM? The census came back
         intervalsMade:2505 intervalsLive:2489 timeouts:24914 heapMB:614 on a
         two-minute-old page. ~20 new repeating timers PER SECOND. Record the
         caller of every setInterval so the flood names its own source instead
         of being guessed at. Strip query strings from the frame: this string
         is read back through a tool that rejects URLs. */
      var _oSI = window.setInterval, _oCI = window.clearInterval;
      window.__npT.src = {};
      window.setInterval = function () {
        window.__npT.si++; window.__npT.siLive++;
        try {
          var stk = ((new Error()).stack || '').split('\n');
          var frame = stk[2] || stk[1] || 'unknown';
          var mm = frame.match(/([A-Za-z0-9_.-]+\.js)[^:]*:(\d+):(\d+)/);
          var key = mm ? (mm[1] + ':' + mm[2]) : frame.replace(/https?:[^\s)]+/g, '').trim().slice(0, 40);
          window.__npT.src[key] = (window.__npT.src[key] || 0) + 1;
        } catch (eSt) {}
        return _oSI.apply(window, arguments);
      };
      window.clearInterval = function () { if (window.__npT.siLive > 0) window.__npT.siLive--; return _oCI.apply(window, arguments); };
      var _oST = window.setTimeout;
      window.setTimeout = function () { window.__npT.st++; return _oST.apply(window, arguments); };
      var _oAEL = window.EventTarget && window.EventTarget.prototype && window.EventTarget.prototype.addEventListener;
      if (_oAEL) {
        window.EventTarget.prototype.addEventListener = function () { window.__npT.ael++; return _oAEL.apply(this, arguments); };
      }
      var _oMO = window.MutationObserver;
      if (_oMO) {
        window.MutationObserver = function (cb) { window.__npT.mo++; return new _oMO(cb); };
        window.MutationObserver.prototype = _oMO.prototype;
      }
    } catch (eLk) {}
    window.__npTk = { last: performance.now(), gaps: [], n: 0 };
    setInterval(function () {
      var nT2 = performance.now();
      var gT2 = nT2 - window.__npTk.last;
      window.__npTk.last = nT2; window.__npTk.n++;
      window.__npTk.gaps.push(Math.round(gT2));
      if (window.__npTk.gaps.length > 60) window.__npTk.gaps.shift();
    }, 250);
    /* B86 (2026-08-25) — SYNC-XHR + LONGTASK CENSUS. The add jams 16s with
       BOTH clocks frozen, zero canvas work (0ms/0 calls) and no network. A
       synchronous XMLHttpRequest is the classic way to freeze a main thread
       like that, and XMLHttpRequest.prototype.open is already WRAPPED on this
       page (measured: xhrNative=false), so another script owns it. */
    try {
      var _xo = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
      if (_xo && _xo.open && !_xo.__npWrapped) {
        var _oOpen = _xo.open, _oSend = _xo.send;
        _xo.open = function (m, u, async) {
          try { this.__npSync = (async === false); } catch (e1) {}
          return _oOpen.apply(this, arguments);
        };
        _xo.send = function () {
          if (this.__npSync) {
            var tS = performance.now();
            var rS = _oSend.apply(this, arguments);
            window.__npCv.xSyncMs += performance.now() - tS;
            window.__npCv.xSync++;
            return rS;
          }
          window.__npCv.xAsync++;
          return _oSend.apply(this, arguments);
        };
        _xo.__npWrapped = true;
      }
    } catch (eX) {}
    try {
      if (window.PerformanceObserver) {
        new PerformanceObserver(function (list) {
          list.getEntries().forEach(function (en) {
            window.__npCv.ltN++;
            if (en.duration > window.__npCv.ltMax) {
              window.__npCv.ltMax = en.duration;
              try {
                var at = (en.attribution && en.attribution[0]) || null;
                window.__npCv.ltSrc = at ? (at.containerType || 'window') + ':' + (at.containerName || at.containerId || '-') : 'none';
              } catch (e2) {}
            }
          });
        }).observe({ entryTypes: ['longtask'] });
      }
    } catch (eL) {}
    var _cProto = window.HTMLCanvasElement && window.HTMLCanvasElement.prototype;
    var _xProto = window.CanvasRenderingContext2D && window.CanvasRenderingContext2D.prototype;
    if (_cProto && _cProto.toDataURL && !_cProto.__npWrapped) {
      var _oTdu = _cProto.toDataURL;
      _cProto.toDataURL = function () {
        var tA = performance.now();
        var rA = _oTdu.apply(this, arguments);
        window.__npCv.tdu += performance.now() - tA; window.__npCv.nT++;
        return rA;
      };
      _cProto.__npWrapped = true;
    }
    if (_xProto && _xProto.getImageData && !_xProto.__npWrapped) {
      var _oGid = _xProto.getImageData;
      _xProto.getImageData = function () {
        var tB = performance.now();
        var rB = _oGid.apply(this, arguments);
        window.__npCv.gid += performance.now() - tB; window.__npCv.nG++;
        return rB;
      };
      _xProto.__npWrapped = true;
    }
  } catch (eCv) {}
  var NP_ALPHA_CUT = false; /* B84 — see hostMockup note below */
  function hostMockup(url, cb) {
    /* transparent copy of a sensei mockup: LOCAL edge-connected cut (never
       eats the patch base) hosted via the presign pipeline to imgix. */
    /* Renders come back OPAQUE on a white studio backdrop again (the transparent
       experiment was reverted 2026-08-18 — it made the model render flat product
       cutouts and destroyed embroidery texture). So the cut is back on. The
       probeRenderAlpha path below still short-circuits any render that DOES
       arrive with alpha, so this is safe either way. */
    if (!url || isAlphaSrc(url)) { cb(null); return; }
    /* B84 (2026-08-25) — gated HERE, not at each caller, so every existing
       "cut failed" fallback still runs (upgradeVersionAlpha's freezeProofCopy
       still catalogs the raw render, so proofs keep saving). prepareVersionDisplay
       calls this AT REVEAL — that is why Justin's Safari froze on the second
       checkmark and never advanced: the thread was jammed mid-reveal by the
       same synchronous pixel cut that cost the add 17.9s. */
    if (!NP_ALPHA_CUT) { cb(null); return; }
    if (mockupHosted[url] !== undefined) { cb(mockupHosted[url] || null); return; }
    var gCut = shapeGeom();
    var photoArt = st.artColorCount > 600 || (st.artColorCount > 250 && (st.artGradFrac || 0) > 0.22);
    /* GEOMETRY-FIRST: for every standard shape the intended geometry is
       KNOWN, and a geometric mask can never eat patch content (its only
       failure mode is including a sliver of backdrop). The color flood is
       reserved for CUSTOM silhouettes where geometry is unknown — and its
       result is sanity-checked before it ships. */
    var cutFn;
    if (gCut && gCut !== 'custom') {
      cutFn = photoArt
        ? function (u2, cb2) { geoShapeCut(u2, gCut, cb2); }
        : function (u2, cb2) { shapeMaskCutCanvas(u2, gCut, cb2); };
    } else {
      cutFn = outerCutCanvas;
    }
    var usedFlood = cutFn === outerCutCanvas;
    /* The renderer returns REAL alpha since 2026-08-18 (background=transparent
       on the image API). Those renders must NOT be cut: there is no backdrop
       to remove, and a geometric mask would clip the model's own soft, feathered
       edges back into a hard cut-out. Probe the actual pixels rather than the
       URL, because old opaque renders live at the same URL shape. */
    probeRenderAlpha(url, function (already) {
      if (already) {
        /* same contract as the cut path: cb receives a HOSTED URL, not a canvas */
        console.log('[np-e2] render already transparent — cut skipped', url.slice(-52));
        hostRenderAsIs(url, function (cvA) {
          if (!cvA) { delete mockupHosted[url]; cb(null); return; }
          hostProof(cvA, 'alpha' + (Date.now() % 100000), function (eA, uA) {
            var outA = uA ? toImgixHost(uA) : '';
            if (!outA) { delete mockupHosted[url]; cb(null); return; }
            mockupHosted[url] = outA;
            cb(outA);
          });
        });
        return;
      }
      cutFn(url, function (cv) {
      if (!cv) {
        console.warn('[np-e2] alpha cut FAILED (cutter returned null)', url.slice(-60));
        delete mockupHosted[url]; /* never negative-cache — retries may succeed */
        cb(null); return;
      }
      if (usedFlood && !npCutInteriorSolid(cv)) {
        /* the flood hollowed out the patch — never ship a mutilated cut */
        console.warn('[np-e2] flood cut REJECTED (interior loss)', url.slice(-60));
        delete mockupHosted[url];
        cb(null); return;
      }
      hostProof(cv, 'alpha' + (Date.now() % 100000), function (e, u) {
        var out = u ? toImgixHost(u) : '';
        if (!out) { console.warn('[np-e2] alpha cut hosted FAILED', url.slice(-60)); delete mockupHosted[url]; cb(null); return; }
        mockupHosted[url] = out;
        cb(out);
      });
      });
    });
  }
  var cmpSweep = false; /* one-shot proof reveal animation */
  function wireCompare() {
    wireCompareEls(
      document.getElementById('np-e2-pf-stage'),
      document.getElementById('np-e2-cmp-before'),
      document.getElementById('np-e2-cmp-handle')
    );
  }
  function wireCompareEls(stage, before, handle) {
    /* before/after slider: upload (checkerboard) left, AI proof (green)
       right, draggable divider */
    if (!stage || !before || !handle) return;
    function setPos(p) {
      p = Math.max(0, Math.min(100, p));
      before.style.clipPath = 'inset(0 ' + (100 - p) + '% 0 0)';
      handle.style.left = p + '%';
    }
    setPos(9); /* just enough for the handle circle + arrows to fully show */
    if (cmpSweep) {
      /* one-shot reveal: show the digital preview fully, sweep across to the
         AI proof, then rest at the normal handle position */
      cmpSweep = false;
      var tS = null, durS = 1300, cancelS = false;
      handle.addEventListener('pointerdown', function () { cancelS = true; }, { once: true });
      setPos(100);
      requestAnimationFrame(function stepS(ts) {
        if (cancelS) return;
        if (tS === null) { tS = ts; requestAnimationFrame(stepS); return; }
        var pS = Math.min(1, (ts - tS) / durS);
        var eS = pS < 0.5 ? 2 * pS * pS : 1 - Math.pow(-2 * pS + 2, 2) / 2;
        setPos(100 - eS * 100); /* ends fully on the AI proof */
        if (pS < 1) requestAnimationFrame(stepS);
      });
    }

    function move(e) {
      var r = stage.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
      setPos(x / r.width * 100);
    }
    function up() {
      document.removeEventListener('pointermove', move);
      document.removeEventListener('pointerup', up);
    }
    handle.addEventListener('pointerdown', function (e) {
      e.preventDefault();
      document.addEventListener('pointermove', move);
      document.addEventListener('pointerup', up);
    });
    /* drag starts ONLY from the handle — stage taps must not move the reveal */
  }
  function swapStageAlpha(v) {
    /* the transparent copy replaces the mockup IN PLACE — same layout, same
       slider position, no rebuild, no bounce */
    var sel = (st.selected === null || st.selected === undefined) ? st.versions.length - 1 : st.selected;
    if (st.versions[sel] !== v || pf.hidden) return;
    if (st.proofPhase === 'ready') {
      var pfStage = document.getElementById('np-e2-pf-stage');
      var im = pfStage ? pfStage.querySelector('img') : null;
      if (im) { im.src = v.alpha; pfStage.classList.add('is-alpha'); }
    } else if (st.proofPhase === 'sizing') {
      var szImg = document.getElementById('np-e2-sz-img');
      var szStage = document.getElementById('np-e2-sz-stage');
      if (szImg) szImg.src = v.alpha;
      if (szStage) szStage.classList.add('is-alpha');
    }
  }
  /* max fraction of each shape's bounding box that content can occupy while
     staying FULLY INSIDE the silhouette — 100% fill = largest no-clip size */
  var SHAPE_SAFE = { circle: 0.68, oval: 0.66, 'oval-h': 0.66, square: 0.84, rectangle: 0.84, 'rectangle-v': 0.84, star: 0.46, heart: 0.56, rhombus: 0.5, hexagon: 0.66, shield: 0.58 };
  /* merrow = wrapped thread edge — give the digital ring visible thread texture */
  var MERROW_CSS = 'repeating-linear-gradient(45deg, rgba(0,0,0,.25) 0 2px, rgba(255,255,255,.15) 2px 3px, rgba(0,0,0,0) 3px 6px)';
  function merrowPattern(x, hex, ring) {
    /* stripe pitch scales WITH the ring so the wrap texture reads chunky at
       every render size (fixed 8px tiles went mushy at preview scale) */
    var t = Math.max(6, Math.round((ring || 24) * 0.55));
    var p = document.createElement('canvas'); p.width = t; p.height = t;
    var px = p.getContext('2d');
    px.fillStyle = hex || '#0C0C0E'; px.fillRect(0, 0, t, t);
    px.strokeStyle = 'rgba(0,0,0,0.32)'; px.lineWidth = Math.max(2, t * 0.32);
    px.beginPath(); px.moveTo(-t * 0.25, t * 0.75); px.lineTo(t * 0.75, -t * 0.25);
    px.moveTo(t * 0.25, t * 1.25); px.lineTo(t * 1.25, t * 0.25); px.stroke();
    px.strokeStyle = 'rgba(255,255,255,0.24)'; px.lineWidth = Math.max(1, t * 0.16);
    px.beginPath(); px.moveTo(-t * 0.125, t); px.lineTo(t, -t * 0.125);
    px.moveTo(t * 0.5, t * 1.4); px.lineTo(t * 1.4, t * 0.5); px.stroke();
    return x.createPattern(p, 'repeat');
  }
  /* molded surface ribbing for the flex finishes. Builds ONE seamless tile
     (period = tile width, rows meet at the tile edges) and returns a canvas
     pattern, so the ribs stay crisp at every render size the way the merrow
     wrap does. 'Flat' has no tile — it returns null and nothing is painted. */
  function texturePattern(x, hex, kind, C) {
    var kd = String(kind || '').toLowerCase();
    if (!kd || kd === 'flat') return null;
    var t = Math.max(12, Math.round((C || 1200) * 0.05));
    /* straight ribs run TIGHT — half the period of the sculpted patterns, so
       vertical/horizontal read as fine molded pinstripes like the real flex */
    if (kd === 'vertical' || kd === 'horizontal') t = Math.max(8, Math.round(t * 0.5));
    /* wave + chevron run on a LONG horizontal period — one gentle rise and
       fall per ~3 rib-widths — so the ribs read as sweeping curves instead of
       tight zigzag. Straight ribs keep the square tile. */
    /* the wave sweeps LONG and gentle; the chevron is a steep nested V, so it
       runs on a short period with a tall rise (matches the molded reference) */
    var pw = kd === 'wave' ? Math.round(t * 3.2) : (kd === 'chevron' ? Math.round(t * 1.15) : t);
    var p = document.createElement('canvas'); p.width = pw; p.height = t;
    var px = p.getContext('2d');
    px.fillStyle = hex || '#FFFFFF'; px.fillRect(0, 0, pw, t);
    var dark = 'rgba(0,0,0,0.30)', lite = 'rgba(255,255,255,0.26)';
    if (kd === 'vertical' || kd === 'horizontal') {
      /* straight ribs: a shaded groove + the highlight on its rising edge */
      var horiz = kd === 'horizontal';
      px.fillStyle = dark;
      if (horiz) px.fillRect(0, 0, t, t * 0.42); else px.fillRect(0, 0, t * 0.42, t);
      px.fillStyle = lite;
      if (horiz) px.fillRect(0, t * 0.42, t, t * 0.12); else px.fillRect(t * 0.42, 0, t * 0.12, t);
    } else {
      /* two rows per tile so the ribs tile vertically as well as horizontally */
      var amp = (kd === 'chevron' ? t * 0.62 : t * 0.20), step = t / 2;
      px.lineJoin = 'round'; px.lineCap = 'butt';
      [[dark, Math.max(2, t * 0.20), 0], [lite, Math.max(1, t * 0.10), t * 0.17]].forEach(function (pass) {
        px.strokeStyle = pass[0]; px.lineWidth = pass[1];
        for (var yy = -step; yy <= t + step; yy += step) {
          px.beginPath();
          if (kd === 'chevron') {
            /* apex at the tile centre — both ends sit at the same height, so
               the long V repeats seamlessly across the horizontal join */
            px.moveTo(0, yy + pass[2]);
            px.lineTo(pw / 2, yy + amp + pass[2]);
            px.lineTo(pw, yy + pass[2]);
          } else {
            for (var xx = 0; xx <= pw; xx += Math.max(1, Math.round(pw / 40))) {
              var yv = yy + Math.sin(xx / pw * Math.PI * 2) * amp + pass[2];
              if (xx === 0) px.moveTo(xx, yv); else px.lineTo(xx, yv);
            }
          }
          px.stroke();
        }
      });
    }
    return x.createPattern(p, 'repeat');
  }
  function normalizeCustomBg() {
    if (isLeather() && shapeGeom() === 'custom' && st.border && /etched/i.test(st.border.label || '')) {
      st.border = { label: 'No Border', img: 'https://ninjauploads-production.imgix.net/np-lb-noborder-1786993611.png', note: 'Smooth clean cut edge' };
    }
    /* custom shape defaults the background to None (cut art IS the patch);
       leaving custom clears it so standard shapes ask for a real color */
    try {
      var isCust = st.shape && shapeGeom() === 'custom';
      if (isCust && !isLeather() && !PTYPE.noArt) {
        if (!st.bg) { st.bg = { label: 'None', hex: '' }; if (st.draft && !st.draft.bg) st.draft.bg = st.bg; }
      } else if (!isCust && st.bg && /^none$/i.test(String(st.bg.label || ''))) {
        st.bg = null;
        if (st.draft && st.draft.bg && /^none$/i.test(String(st.draft.bg.label || ''))) st.draft.bg = null;
      }
    } catch (eNB) {}
  }
  function renderMaskPreview() {
    normalizeCustomBg();
    /* the Step-1 preview shows the artwork INSIDE the chosen shape mask, so
       the customer sees how their image sits before generating */
    var canvas = document.getElementById('np-e2-canvas');
    if (!canvas || st.proofApproved) return;
    var art = canvas.querySelector('.np-e2-art');
    var old = canvas.querySelector('.np-e2-maskprev');
    var zrow = document.getElementById('np-e2-zoomrow');
    var g = shapeGeom();
    if (zrow) zrow.hidden = !!PTYPE.noArt || !(st.shape && g !== 'custom');
    if (!st.shape) {
      var aImgR = document.getElementById('np-e2-artimg');
      var hasArtR = !!(aImgR && aImgR.getAttribute('src'));
      if (PTYPE.mats && !PTYPE.noArt && hasArtR) {
        /* leather/faux with no shape picked yet: the first paint must
           already look like leather — compose on a preview circle (the
           composePatchImage fallback supplies ov = {g:'circle'}) */
        g = 'circle';
      } else {
        if (old) old.remove();
        if (art) art.hidden = !!PTYPE.noArt;
        return;
      }
    }
    if (art) art.hidden = true;
    var cw = canvas.offsetWidth || 600, ch = canvas.offsetHeight || cw;
    var d = (PTYPE.previewDims && st.w && st.h) ? [st.w * 100, st.h * 100] : shapeDims(g, 1);
    var fit = PTYPE.textPreview ? 0.86 : 0.68;
    var k = Math.min((cw * fit) / d[0], (ch * fit) / d[1]);
    var w = Math.round(d[0] * k), h = Math.round(d[1] * k);
    var el = old;
    if (!el) {
      el = document.createElement('div');
      el.className = 'np-e2-maskprev';
      canvas.appendChild(el);
    }
    el.style.width = w + 'px'; el.style.height = h + 'px';
    el.style.marginLeft = (-w / 2) + 'px'; el.style.marginTop = (-h / 2) + 'px';
    el.classList.toggle('np-e2-maskprev--guide', !!PTYPE.previewDims);
    previewDims(canvas, el);
    el.style.background = 'transparent';
    el.style.boxShadow = 'none';
    el.style.borderRadius = '';
    el.style.clipPath = '';
    el.style.backgroundImage = 'none';
    var inn = el.querySelector('.np-e2-maskprev__in');
    if (!inn) { el.innerHTML = '<span class="np-e2-maskprev__in"><img alt=""></span>'; inn = el.querySelector('.np-e2-maskprev__in'); }
    inn.style.inset = '0px';
    inn.style.background = 'transparent';
    inn.style.borderRadius = '';
    inn.style.clipPath = '';
    inn.style.filter = '';
    var im = inn.querySelector('img');
    im.style.maxWidth = '100%'; im.style.maxHeight = '100%';
    im.style.width = '100%'; im.style.height = '100%';
    im.style.objectFit = 'contain';
    im.style.transform = ''; im.style.filter = ''; im.style.mixBlendMode = '';
    /* ONE renderer for everything the customer sees: the live preview IS the
       composer's output — perfectly smooth stroked rings on every shape,
       merrow texture, colors — identical to the AI's reference */
    var tok = ++maskPrevSeq;
    /* B60 (Justin, night's end): back to the SIMPLE path this morning had —
       latest-wins by token, nothing else. The single-flight lock, watchdog
       and restart counter I added today were managing load that today's own
       additions created; with the sheet composer off the session (see
       doCheckout) they are pure overhead and the source of dead previews. */
    composePatchImage(function (cv) {
      if (tok !== maskPrevSeq || !cv) return;
      try { im.src = cv.toDataURL('image/png'); } catch (eP) {}
      artLoader(false); /* first composed frame = loading is over (all types) */
    }, 640);
  }
  function previewDims(canvas, patchEl) {
    /* the twill sizes are variant choices, so the step-1 preview carries the
       same measuring arrows the size step does — the customer sees 11" x 4"
       around their lettering the moment they pick it */
    var wd = document.getElementById('np-e2-pv-dimw');
    var hd = document.getElementById('np-e2-pv-dimh');
    if (!wd || !hd) return;
    /* a size-driven type has nothing true to measure until the customer picks
       the size — custom names ships one size, so its rulers are permanent */
    var sizeKnown = !PTYPE.sizeFromOpt || !!st['opt' + PTYPE.sizeFromOpt];
    /* the approved/final view draws its OWN measuring arrows, so the step-1
       pair has to stand down or the customer sees two sets */
    var on = !!(PTYPE.previewDims && st.w && st.h && patchEl && sizeKnown && !st.proofApproved);
    wd.hidden = !on; hd.hidden = !on;
    if (!on) return;
    /* measure the PATCH ITSELF rather than recomputing where it ought to be —
       the recomputed box drifted from the rendered one and the two arrows ended
       up hugging by different amounts */
    var cR = canvas.getBoundingClientRect(), pR = patchEl.getBoundingClientRect();
    var cw = cR.width, ch = cR.height;
    var w = pR.width, h = pR.height;
    var x0 = pR.left - cR.left, y0 = pR.top - cR.top;
    wd.style.left = Math.round(x0) + 'px';
    wd.style.right = Math.round(cw - (x0 + w)) + 'px';
    var OFF = 16; /* one gap for both arrows so they read as a pair */
    wd.style.top = Math.max(4, Math.round(y0) - OFF) + 'px';
    hd.style.top = Math.round(y0) + 'px';
    hd.style.bottom = Math.round(ch - (y0 + h)) + 'px';
    hd.style.left = Math.max(4, Math.round(x0) - OFF) + 'px';
    var wc = wd.querySelector('.np-e2-dim__chip'), hc = hd.querySelector('.np-e2-dim__chip');
    if (wc) wc.textContent = st.w.toFixed(2) + '"';
    if (hc) hc.textContent = st.h.toFixed(2) + '"';
  }
  var maskPrevSeq = 0;
  function renderApprovedCanvas() {
    /* post-approval summary page: the Step-1 preview becomes the PROOF with
       the compare slider; prep tools no longer apply */
    var idx = (st.selected === null || st.selected === undefined) ? st.versions.length - 1 : st.selected;
    var v = st.versions[idx];
    if (!v || !st.proofApproved) return;
    var tbS = document.querySelector('.np-e2-cartrow__thumb');
    if (tbS) {
      tbS.classList.toggle('is-digital', !!v.digital);
      tbS.classList.toggle('is-alpha', !!(v.alpha || v.digital || isAlphaSrc(v.dataUrl || v.hosted || '')));
    }
    var srowS = document.getElementById('np-e2-stitchrow');
    if (srowS) {
      srowS.hidden = !(v.digital && stitchAddonEligible());
      var swS2 = srowS.querySelector('.np-e2-switch');
      if (swS2) swS2.classList.toggle('is-on', !!st.stitchAddon);
      var siS = srowS.querySelector('.np-e2-stitchrow__txt i');
      if (siS) {
        var sfx = TYPE_KEY;
        var verbS = (sfx === 'leather-2-0' || sfx === 'fauxleather-2-0') ? 'laser etches'
          : (sfx === 'fullcolor-2-0' ? 'prints' : 'stitches');
        siS.textContent = 'A specialist ' + verbS + ' a real sample for your approval. Adds 2-4 business days to your order. Billed as its own $19.99 line in your cart.';
      }
    }
    document.body.classList.add('np-e2-approved-view');
    try { paintModeSwitch(); } catch (ePA) {} /* review page: mode tabs leave */
    var canvas = document.getElementById('np-e2-canvas');
    if (!canvas) return;
    var proofSrc = v.alpha || v.dataUrl || v.hosted || '';
    var uploadSrc = sensei.composedLocal || sensei.composedCleanUrl || applyToggleParams(cleanUrl(artworkUrl()) || '') || '';
    var old = canvas.querySelector('.np-e2-cmp-page');
    if (old) old.remove();
    var art = canvas.querySelector('.np-e2-art');
    if (art) art.hidden = true;
    var mp = canvas.querySelector('.np-e2-maskprev');
    if (mp) mp.remove();
    var cmp = document.createElement('div');
    cmp.className = 'np-e2-cmp-page' + (isAlphaSrc(proofSrc) ? ' is-alpha' : '') + (v.digital ? ' is-digital' : '');
    /* the review view: AI proof on green with size rulers AND the
       original-vs-proof compare slider */
    cmp.innerHTML =
      '<i class="np-e2-sz-under" aria-hidden="true"></i>' +
      '<div class="np-e2-cmp-page__proof"><img src="' + proofSrc + '" alt="Approved proof"></div>' +
      '<span class="np-e2-cmp__tag np-e2-cmp__tag--r">' + (v.digital ? 'DIGITAL PROOF' : 'AI PROOF') + '</span>' +
      '<div class="np-e2-dim np-e2-dim--w"><i class="np-e2-dim__line"></i><b class="np-e2-dim__chip"></b></div>' +
      '<div class="np-e2-dim np-e2-dim--h"><i class="np-e2-dim__line"></i><b class="np-e2-dim__chip"></b></div>' +
      '';
    canvas.appendChild(cmp);
    var pimg = cmp.querySelector('.np-e2-cmp-page__proof img');
    if (pimg) pimg.addEventListener('load', function () {
      positionDims();
      centerPatchInBox(pimg, proofSrc);
      try { matchCompareScale(cmp); } catch (eMS2) {}
    });
    if (pimg && pimg.complete) centerPatchInBox(pimg, proofSrc);
    /* one header above BOTH cards: this is the final review step */
    var main = document.querySelector('.np-e2__main');
    if (main && !document.getElementById('np-e2-review-head')) {
      var rh = document.createElement('header');
      rh.id = 'np-e2-review-head';
      rh.className = 'np-e2-stephead np-e2-reviewhead';
      rh.innerHTML = '<span class="np-e2-eyebrow">FINAL STEP</span><h2 class="np-e2-title">Review and Submit Your Patch Order</h2>';
      main.insertBefore(rh, main.firstChild);
    }
    /* the approved note sits under the preview (the options card is hidden) */
    var note = document.getElementById('np-e2-approved-note');
    if (!note) {
      note = document.createElement('p');
      note.id = 'np-e2-approved-note';
      note.className = 'np-e2-apnote';
      canvas.parentElement.insertBefore(note, canvas.nextSibling);
    }
    note.textContent = 'Approved ✓ Your final proof. Size, pricing, and checkout are inside.';
    positionDims();
  }
  function clearApprovedCanvas() {
    document.body.classList.remove('np-e2-approved-view');
    try { paintModeSwitch(); } catch (ePC) {} /* back on the design page: tabs return */
    var strip = document.getElementById('np-e2-orig-strip');
    if (strip) strip.remove();
    var note = document.getElementById('np-e2-approved-note');
    if (note) note.remove();
    var rh = document.getElementById('np-e2-review-head');
    if (rh) rh.remove();
    var canvas = document.getElementById('np-e2-canvas');
    if (!canvas) return;
    var cmp = canvas.querySelector('.np-e2-cmp-page');
    if (cmp) cmp.remove();
    var art = canvas.querySelector('.np-e2-art');
    /* typed products have NO artwork element to show — un-hiding it painted a
       broken-image icon over the preview when they hit Edit selections */
    if (art) art.hidden = !!PTYPE.noArt;
    renderMaskPreview();
  }
  function rerenderProofPhase() {
    if (pf.hidden) return;
    if (st.proofPhase === 'sizing') renderSizing();
    else if (st.proofPhase === 'ready') renderProofReady();
  }
  function preloadImg(src, capMs) {
    return new Promise(function (resolve) {
      if (!src) { resolve(); return; }
      var done = false;
      var fin = function () { if (done) return; done = true; resolve(); };
      var im = new Image();
      im.onload = im.onerror = fin;
      /* B65: a STALLED request fires NEITHER load nor error — iOS holds the
         socket open indefinitely on a flaky connection. prepareVersionDisplay
         gates the whole proof reveal on Promise.all over these, so one stalled
         image pinned the modal on "Rendering your patch" even though the
         render had completed. Resolve after a cap; the image keeps loading and
         paints whenever it arrives. */
      npTick(fin, capMs || 6000);
      im.src = src;
    });
  }
  function prepareVersionDisplay(v, cb) {
    /* WHITE STAGE: the RAW render is what we display — no transparency gate
       before reveal. The transparent copy still cooks in the background for
       the cart-thumbnail contract, and the bounds cache warms for rulers. */
    if (v.dataUrl && !isAlphaSrc(v.dataUrl) && !v.fallbackUpload) {
      measureAlphaBounds(v.dataUrl, function () {});
      hostMockup(v.dataUrl, function (u) { if (u) v.alpha = u; });
    }
    var shown = v.dataUrl || v.alpha || '';
    var cmp = (!v.fallbackUpload && shown)
      ? (sensei.composedLocal || sensei.composedCleanUrl || applyToggleParams(cleanUrl(artworkUrl()) || '') || '')
      : '';
    Promise.all([preloadImg(shown), preloadImg(cmp)]).then(function () { cb(); });
  }
  function upgradeVersionAlpha(v) {
    /* swap the display copy to the transparent imgix re-host when it lands */
    if (!v || v.alpha || !v.dataUrl || isAlphaSrc(v.dataUrl)) return;
    hostMockup(v.dataUrl, function (u) {
      if (!u) {
        /* cut failed — catalog the raw render so the proof still saves */
        if (!v.digital && !v.fallbackUpload && !v.frozenProof && !v.__frozeStart && (v.hosted || v.dataUrl)) {
          v.__frozeStart = true;
          var idxR = st.versions.indexOf(v) + 1 || 1;
          freezeProofCopy(v.hosted || v.dataUrl, (TYPE_KEY || 'patch') + '--v' + idxR, function (uFR) { if (uFR && !v.frozenProof) v.frozenProof = uFR; });
        }
        return;
      }
      v.alpha = u;
      /* My Proofs catalog: the TRANSPARENT copy is the saved proof — no
         white studio box anywhere it's shown (--va tag = alpha-era freeze,
         the old --v tag stays classified opaque in isAlphaSrc) */
      if (!v.digital && !v.fallbackUpload && !v.frozenProof && !v.__frozeStart) {
        v.__frozeStart = true; /* concurrent alpha callbacks must not double-catalog */
        var idxF = st.versions.indexOf(v) + 1 || 1;
        freezeProofCopy(u, (TYPE_KEY || 'patch') + '--va' + idxF, function (uFA) { if (uFA && !v.frozenProof) v.frozenProof = uFA; });
      }
      try { rerenderProofPhase(); } catch (eRr) {}
      if (st.proofApproved) { try { renderApprovedCanvas(); } catch (eRr2) {} }
      /* if this version is already the approved one, upgrade the cart image
         to the transparent copy (patch on checkerboard, no studio white) */
      if (st.proofApproved && st.versions[st.selected] === v) {
        setProp('_cartImg', digitalCartUrl(u));
        if (sensei.added) lineSync({ '_cartImg': digitalCartUrl(u) });
        var th = document.getElementById('np-e2-cart-thumb');
        if (th) th.src = u;
        var tb = document.querySelector('.np-e2-cartrow__thumb');
        if (tb) tb.classList.add('is-alpha');
      }
    });
  }
  var boundsCache = {};
  function measureAlphaBounds(url, cb) {
    /* exact drawn-pixel bounding box as fractions of the image. imgix serves
       CORS natively; the sensei mockup bucket got a CORS policy 2026-08-14 —
       for those OPAQUE mockups the box is the non-near-white region (the
       patch + its soft shadow) instead of the alpha region. */
    if (!url) { cb(null); return; }
    if (boundsCache[url] !== undefined) { cb(boundsCache[url] || null); return; }
    var opaque = !isAlphaSrc(url);
    var img = new Image();
    img.crossOrigin = 'anonymous';
    /* the raw S3 host has no CORS headers, so reading its pixels taints the
       canvas and the scan throws — every frozen proof arriving from a reorder
       hit that and the rulers stayed stretched across the padded PNG. imgix
       fronts the same object WITH CORS, so measure there. */
    var measureUrl = /^data:|^blob:/.test(url) ? url : toImgixHost(url); /* a data URL is canvas-safe as-is — the imgix rewrite mangled it and the scan died to the 75% guess */
    img.onload = function () {
      try {
        var W = 300, H = Math.max(1, Math.round(img.naturalHeight * (W / img.naturalWidth)));
        var c = document.createElement('canvas'); c.width = W; c.height = H;
        var x = c.getContext('2d'); x.drawImage(img, 0, 0, W, H);
        var d = x.getImageData(0, 0, W, H).data;
        var minX = W, minY = H, maxX = -1, maxY = -1;
        /* TRANSPARENCY FROM PIXELS, not URL (Justin 2026-08-24: rulers/compare
           following the backdrop): new renders are transparent on URLs the
           isAlphaSrc heuristic calls opaque — the wrong test then measured
           the backdrop, and rulers + the compare scale fell to the 75% guess.
           If the bitmap carries real alpha, the alpha IS the patch. */
        var clearPx = 0;
        for (var aa = 3; aa < d.length; aa += 4) { if (d[aa] < 13) clearPx++; }
        var useAlpha = !opaque || clearPx > (W * H) * 0.05;
        /* opaque renders: the backdrop is whatever the four corners average —
           white studio, grey stage, off-white — excluded by color distance,
           not a fixed near-white cut that greyish stages slipped through
           (rulers then hugged the whole image instead of the patch) */
        var cIdx = [0, (W - 1) * 4, ((H - 1) * W) * 4, ((H - 1) * W + (W - 1)) * 4];
        var bR = 0, bG = 0, bB = 0;
        cIdx.forEach(function (ci) { bR += d[ci]; bG += d[ci + 1]; bB += d[ci + 2]; });
        bR /= 4; bG /= 4; bB /= 4;
        for (var yy = 0; yy < H; yy++) {
          for (var xx = 0; xx < W; xx++) {
            var i4 = (yy * W + xx) * 4;
            var hit = useAlpha
              ? d[i4 + 3] > 128 /* soft drop shadows (15-40% alpha) are NOT patch — counting them inflated the proof bounds and broke the compare scale (measured k 0.91 vs true 0.65) */
              : (d[i4 + 3] > 12 && (Math.abs(d[i4] - bR) + Math.abs(d[i4 + 1] - bG) + Math.abs(d[i4 + 2] - bB)) > 90);
            if (hit) {
              if (xx < minX) minX = xx; if (xx > maxX) maxX = xx;
              if (yy < minY) minY = yy; if (yy > maxY) maxY = yy;
            }
          }
        }
        if (maxX < 0) { boundsCache[url] = false; cb(null); return; }
        var b = { x0: minX / W, y0: minY / H, x1: (maxX + 1) / W, y1: (maxY + 1) / H };
        boundsCache[url] = b; cb(b);
      } catch (e) { boundsCache[url] = false; cb(null); }
    };
    img.onerror = function () { boundsCache[url] = false; cb(null); };
    img.src = measureUrl;
  }
  function centerPatchInBox(imgX, srcX) {
    /* transparent compositions can be lopsided — translate the img so the
       DRAWN patch (not the bitmap box) centers, then re-place the rulers */
    if (!imgX || !srcX) return;
    measureAlphaBounds(srcX, function (bC) {
      if (!bC) return;
      var bx = (bC.x0 + bC.x1) / 2 - 0.5, by = (bC.y0 + bC.y1) / 2 - 0.5;
      imgX.style.transform = 'translate(' + (-bx * 100) + '%, ' + (-by * 100) + '%)';
      try { positionDims(); } catch (eC) {}
    });
  }
  function matchCompareScale(stage) {
    /* the compare is only honest when the two patches MATCH on screen — same
       drawn size AND same position (Justin 2026-08-24). Bounds come from the
       pixel scan; the preview half is scaled about its center and then
       translated so its patch sits exactly over the proof's. All math in
       real screen pixels so different CSS sizing of the halves can't skew it. */
    if (!stage) return;
    var proofImg = stage.querySelector(':scope > img, .np-e2-cmp-page__proof img');
    var prevImg = stage.querySelector('.np-e2-cmp__before img');
    if (!proofImg || !prevImg) return;
    var got = { p: null, u: null };
    function ctr(b) { return b ? { x: (b.x0 + b.x1) / 2, y: (b.y0 + b.y1) / 2 } : { x: 0.5, y: 0.5 }; }
    function frac(b) { return b ? Math.max(0.02, Math.max(b.x1 - b.x0, b.y1 - b.y0)) : null; }
    function go() {
      if (!got.p || !got.u) return;
      prevImg.style.transform = ''; /* measure the UNTRANSFORMED rect */
      var pR = proofImg.getBoundingClientRect(), uR = prevImg.getBoundingClientRect();
      if (!pR.width || !uR.width) return;
      var k = (frac(got.p) * pR.width) / (frac(got.u) * uR.width);
      if (!isFinite(k) || k <= 0) return;
      k = Math.max(0.4, Math.min(2.5, k));
      var pc = ctr(got.p), uc = ctr(got.u);
      var px = pR.left + pc.x * pR.width, py = pR.top + pc.y * pR.height;
      var ucx = uR.left + uR.width / 2, ucy = uR.top + uR.height / 2;
      var ux = ucx + (uc.x - 0.5) * uR.width * k, uy = ucy + (uc.y - 0.5) * uR.height * k;
      prevImg.style.transformOrigin = '50% 50%';
      prevImg.style.transform = 'translate(' + (px - ux).toFixed(1) + 'px, ' + (py - uy).toFixed(1) + 'px) scale(' + k.toFixed(4) + ')';
      try { stage.classList.remove('is-settling'); } catch (eSv) {} /* matched — reveal */
    }
    /* opaque sensei mockups without a readable box fall back to the
       renderer's known ~75% framing */
    measureAlphaBounds(proofImg.getAttribute('src'), function (b) { got.p = b || { x0: 0.125, y0: 0.125, x1: 0.875, y1: 0.875 }; go(); });
    measureAlphaBounds(prevImg.getAttribute('src'), function (b) { got.u = b || { x0: 0, y0: 0, x1: 1, y1: 1 }; go(); });
    /* the DOM imgs may still be LOADING when the modal renders — zero rects
       made go() bail silently and the halves never matched. Re-run when each
       finishes (go() recomputes from scratch, so extra calls are harmless). */
    if (!proofImg.complete) proofImg.addEventListener('load', go);
    if (!prevImg.complete) prevImg.addEventListener('load', go);
  }
  function positionDims() {
    var sz = document.getElementById('np-e2-sz-stage');
    if (sz) positionDimsIn(sz, document.getElementById('np-e2-sz-img'), 48);
    var pf2 = document.getElementById('np-e2-pf-stage');
    if (pf2) positionDimsIn(pf2, pf2.querySelector('img'), Math.max(12, (pf2.offsetWidth - 430) / 2));
    var ac = document.querySelector('.np-e2-cmp-page');
    if (ac) positionDimsIn(ac, ac.querySelector('.np-e2-cmp-page__proof img'), Math.round((ac.offsetWidth || 0) * 0.12));
  }
  function positionDimsIn(stage, imgEl, inset) {
    /* places BOTH the dimension arrows (when the stage has them) and the
       white under-panel (opaque mockups) at the patch bounds: for
       transparent imgix sources the true alpha bounds are measured from the
       pixels; opaque sensei mockups fall back to the true w:h aspect at the
       renderer's ~75% framing */
    var wd = stage.querySelector('.np-e2-dim--w'), hd = stage.querySelector('.np-e2-dim--h');
    var und = stage.querySelector('.np-e2-sz-under, .np-e2-pf-under');
    if (!(wd && hd) && !und) return;
    var S = stage.offsetWidth;
    if (!S) return; /* modal hidden */
    if (wd && hd) {
      var wc = wd.querySelector('.np-e2-dim__chip'), hc = hd.querySelector('.np-e2-dim__chip');
      if (wc) wc.textContent = st.w.toFixed(2) + '"';
      if (hc) hc.textContent = st.h.toFixed(2) + '"';
    }
    var box = S - inset * 2;
    function apply(x0, y0, x1, y1) {
      if (wd && hd) {
        wd.style.left = Math.round(x0) + 'px'; wd.style.right = Math.round(S - x1) + 'px';
        hd.style.top = Math.round(y0) + 'px'; hd.style.bottom = Math.round(S - y1) + 'px';
        /* hug the patch: the perpendicular offsets track the measured bounds
           instead of the stage edges (the white stage leaves big margins) */
        wd.style.top = Math.max(10, Math.round(y0) - 30) + 'px';
        hd.style.left = Math.max(10, Math.round(x0) - 30) + 'px';
      }
      /* the white under-panel hugs the same patch bounds (opaque mockups) */
      if (und) {
        var ox = Math.max(2, (x1 - x0) * 0.02), oy = Math.max(2, (y1 - y0) * 0.02);
        und.style.left = Math.round(x0 - ox) + 'px';
        und.style.top = Math.round(y0 - oy) + 'px';
        und.style.width = Math.round((x1 - x0) + ox * 2) + 'px';
        und.style.height = Math.round((y1 - y0) + oy * 2) + 'px';
        var g = shapeGeom();
        und.style.borderRadius = g === 'circle' ? '999px' : ((g === 'oval' || g === 'oval-h') ? '50%' : '8%');
        und.style.clipPath = SHAPE_CLIPS[g] || 'none';
        /* custom shapes get the panel too — true colors for the few seconds
           before the transparent copy lands beat a green-tinted render */
        und.style.display = '';
      }
    }
    var src = imgEl ? (imgEl.currentSrc || imgEl.src) : '';
    var nw = imgEl ? imgEl.naturalWidth : 0, nh = imgEl ? imgEl.naturalHeight : 0;
    if (src && nw && nh) {
      /* the image's ACTUAL rendered rect (CSS caps the img smaller than the
         stage box, so the assumed-box math overshot the patch) */
      var sR = stage.getBoundingClientRect();
      var iR = imgEl.getBoundingClientRect();
      var zf = sR.width ? (S / sR.width) : 1; /* modal zoom: rects are visual px */
      var iw = (iR.width || box) * zf, ih = (iR.height || box) * zf;
      var ixL = (iR.left - sR.left) * zf, iyT = (iR.top - sR.top) * zf;
      var scale = Math.min(iw / nw, ih / nh);
      var cw = nw * scale, ch = nh * scale;
      var cx = ixL + (iw - cw) / 2, cy = iyT + (ih - ch) / 2;
      /* DIGITAL proofs: the compose canvas IS the patch, border ring at the
         very edge — the rulers must span the full image so the stroke is
         always measured (pixel-bounds scans can under-shoot pale borders).
         Custom shapes keep the alpha scan (their canvas carries padding). */
      if (stage.classList && stage.classList.contains('is-digital') && shapeGeom() !== 'custom') { apply(cx, cy, cx + cw, cy + ch); return; }
      var b = boundsCache[src];
      if (b) { apply(cx + b.x0 * cw, cy + b.y0 * ch, cx + b.x1 * cw, cy + b.y1 * ch); return; }
      if (b === undefined) measureAlphaBounds(src, function (bb) { if (bb) positionDims(); });
      /* image edges only while the scan is still pending — once it has failed
         (cache === false) fall through to the geometric box, because a padded
         proof PNG is always wider than the patch it contains */
      if (isAlphaSrc(src) && b !== false) { apply(cx, cy, cx + cw, cy + ch); return; }
      /* pixel scan failed (CORS-tainted host / unreadable): frame the patch
         inside the IMAGE rect at the renderer's ~75% canvas framing with the
         true w:h aspect. The stage-box fallback below ignores the img rect
         and overshoots whenever CSS caps the img smaller than the stage —
         a ruler wider than the patch reads as paying for more than you get. */
      var arF = (st.w > 0 && st.h > 0) ? (st.w / st.h) : (nw / nh);
      var fw2 = cw * 0.75, fh2 = fw2 / arF;
      if (fh2 > ch * 0.75) { fh2 = ch * 0.75; fw2 = fh2 * arF; }
      apply(cx + (cw - fw2) / 2, cy + (ch - fh2) / 2, cx + (cw + fw2) / 2, cy + (ch + fh2) / 2);
      return;
    }
    var FILL = 0.75, pw, ph;
    if (st.w >= st.h) { pw = box * FILL; ph = pw * (st.h / st.w); }
    else { ph = box * FILL; pw = ph * (st.w / st.h); }
    var wpad = Math.max(inset - 6, Math.round((S - pw) / 2));
    var hpad = Math.max(inset - 6, Math.round((S - ph) / 2));
    apply(wpad, hpad, S - wpad, S - hpad);
  }

  function renderVolume(p) {
    var t = p.tiers;
    if (!t.length) return;
    /* a tier that ends below the product's minimum quantity can never be
       bought — showing it just dangles a price the customer cannot have */
    var dropT = 0;
    while (dropT < t.length - 1 && t[dropT + 1].min <= QTY_MIN) dropT++;
    if (dropT > 0) t = t.slice(dropT);
    /* derive the active tier from the SLICED list. (This line previously
       referenced pIdx while defining it — NaN — which left no row highlighted
       and the bar stuck on "max discount reached".) */
    var pIdx = 0;
    for (var iP = 0; iP < t.length; iP++) if (st.qty >= t[iP].min) pIdx = iP;
    $('#np-e2-vol-count').textContent = st.qty + ' pieces';
    var nextEl = $('#np-e2-vol-next');
    if (pIdx < t.length - 1) nextEl.textContent = 'next tier at ' + t[pIdx + 1].min;
    else nextEl.textContent = 'max discount reached';

    /* fill: equal segments between tier minimums */
    var fill = 0, segs = t.length - 1;
    if (segs > 0) {
      if (st.qty <= t[0].min) fill = 0;
      else if (st.qty >= t[segs].min) fill = 100;
      else {
        for (var i = 0; i < segs; i++) {
          if (st.qty >= t[i].min && st.qty < t[i + 1].min) {
            fill = (i + (st.qty - t[i].min) / (t[i + 1].min - t[i].min)) * (100 / segs);
            break;
          }
        }
      }
    }
    $('#np-e2-vol-fill').style.width = fill + '%';
    $('#np-e2-vol-scale').innerHTML = t.map(function (x) { return '<span>' + x.min + '</span>'; }).join('');

    var rows = $('#np-e2-vol-rows');
    rows.innerHTML = t.map(function (x, i) {
      var hi = (i < t.length - 1) ? (t[i + 1].min - 1) : null;
      var range = hi ? (x.min + '–' + hi + (i === 0 ? ' pcs' : '')) : (x.min + '+');
      var unit = p.base * (1 - (x.off || 0) / 100);
      var cls = 'np-e2-tier' + (i === pIdx ? ' is-active' : (i === pIdx + 1 ? ' is-next' : ''));
      var offCell = x.off > 0 ? '<em>' + x.off + '% off</em>' : '<i>—</i>';
      var nudge = '';
      /* the nudge belongs to the tier the customer is actually IN, not the
         first row of the table */
      if (i === pIdx && pIdx < t.length - 1) {
        var need = t[pIdx + 1].min - st.qty;
        if (need > 0) nudge = '<span class="np-e2-tier__nudge">Add ' + need + ' of this design to reach ' + t[pIdx + 1].off + '% off in savings.</span>';
      }
      return '<div class="' + cls + '" data-e2-tier="' + x.min + '">' +
        '<span class="np-e2-tier__qty">' + range + '</span>' +
        '<span class="np-e2-tier__price">' + money(unit) + ' ea</span>' +
        '<span class="np-e2-tier__off">' + offCell + '</span>' + nudge + '</div>';
    }).join('');
    $$('#np-e2-vol-rows [data-e2-tier]').forEach(function (row) {
      row.addEventListener('click', function () {
        /* C18 (2026-08-25, Justin: "clicking this on mobile should not change
           quantity"). On a phone the tier table is a price REFERENCE the
           customer scrolls past, not a control — a thumb landing on a row
           silently rewrote the order quantity. Desktop keeps click-to-set,
           where it is a deliberate pointer action. Tested at CLICK time rather
           than render time so a rotate or resize can never leave the wrong
           behaviour wired in. */
        try {
          if (window.matchMedia && window.matchMedia('(max-width: 767px)').matches) return;
        } catch (eMQ) {}
        setQty(parseInt(row.getAttribute('data-e2-tier'), 10));
      });
    });
  }

  function commitSizeQty() {
    /* BACKGROUND SHEET STAMPER (2026-08-24): Add to Cart no longer waits on
       build sheets — they compose HERE, debounced, whenever the approved
       size/qty settles (the AI-lane line is already in the cart at approval).
       applySpecToLine skips itself when the stamped sheet is already fresh. */
    if (st.proofApproved && !coBusy && !commitSizeQty.__stamping) {
      /* BACKGROUND PRE-ADD / PRE-SYNC (Justin 2026-08-24, "less than 2
         seconds"): Shopify cart calls cost 3-12s each on this store, so they
         run HERE — debounced, while the customer is still on sizing. The add
         happens at approval/skip with seeded values, every size/qty settle
         re-syncs the line, and Add to Cart just verifies state + navigates.
         Trade-off (approved direction): leaving the page after approval
         keeps the patch in the cart — same as the AI lane's generate-time
         add always did. */
      /* B61: sheets compose AFTER approval/skip (this whole block is gated on
         st.proofApproved) — never while the customer is picking options, and
         never on the click. Deferred so the cart call goes first. */
      npTick(function () { try { preComposeSheets(); } catch (ePC) {} }, 1200);
      /* STARVATION GUARD (Justin 2026-08-24 late): commitSizeQty has 16
         callers and several fire faster than the debounce — resetting the
         timer on every call meant it NEVER fired (no pre-add, no sheets,
         slow clicks). Reset ONLY when the size/qty/variant state actually
         changed; same-state calls let the pending timer run out. */
      var armTok = curLineState();
      if (commitSizeQty.__armTok !== armTok || !commitSizeQty.__sheetPend) {
      commitSizeQty.__armTok = armTok;
      try { coMark('bg-arm'); } catch (eBa) {}
      /* WORKER CLOCK + generation token (B34): the plain setTimeout version
         ARMED but never FIRED on live (beacon-proven) — page optimizers sweep
         and clear pending timer ids (clearTimeout/clearInterval share one
         pool), and a swept timer dies silently. Worker messages route through
         OUR closure map; nothing on the page can cancel them. */
      var myGen = (commitSizeQty.__sheetGen = (commitSizeQty.__sheetGen || 0) + 1);
      commitSizeQty.__sheetPend = true;
      npTick(function () {
        commitSizeQty.__sheetPend = false;
        if (commitSizeQty.__sheetGen !== myGen) return; /* superseded or cancelled */
        try { coMark(coBusy ? 'bg-fire-cobusy' : (commitSizeQty.__stamping ? 'bg-fire-stamping' : 'bg-fire')); } catch (eBf) {}
        if (coBusy || commitSizeQty.__stamping) return;
        commitSizeQty.__stamping = true;
        /* B66: the `: ensureInCart()` half is GONE — a size settle must never
           CREATE a cart line. It only re-syncs a line that the customer has
           already added themselves via Add to Cart. */
        try { coMark(sensei.added ? 'bg-sync' : 'bg-nosync'); } catch (eBm) {}
        var pre = null;
        try { pre = sensei.added ? syncCartLine() : null; } catch (ePre) {}
        sensei.__syncBusy = Promise.resolve(pre).catch(function () {}).then(function () {
          sensei.__syncBusy = null;
          commitSizeQty.__stamping = false;
          try { coMark('bg-ready'); } catch (eBm2) {}
        });
      }, 700);
      }
    }
    /* orientation follows the chosen shape variant: wide shapes keep the
       width as the long side, tall shapes the height */
    var _g = shapeGeom();
    if ((_g === 'rectangle' || _g === 'oval-h') && st.h > st.w) {
      var _t = st.w; st.w = st.h; st.h = _t;
      st.ratio = st.h / st.w;
    } else if ((_g === 'rectangle-v' || _g === 'oval') && st.w > st.h) {
      var _t2 = st.w; st.w = st.h; st.h = _t2;
      st.ratio = st.h / st.w;
    }
    /* the legacy width/height boxes drive THEIR OWN size->variant matcher;
       feeding them on a variant-option product would fight the variant the
       three option steps just chose (and its price) */
    if (!PTYPE.optVariant) setLegacySize(st.w, st.h);
    setLegacyQty(st.qty);
    var v = nearestVariant();
    if (v) setFormVariant(v.id);
    setProp('_Width (in)', st.w.toFixed(2));
    setProp('_Height (in)', st.h.toFixed(2));
    renderPricing();
  }
  function setQty(q) {
    st.qty = Math.max(QTY_MIN, Math.min(QTY_MAX, q));
    commitSizeQty();
  }

  /* ---- render: option rows + step-3 summary + proof gate ---- */
  function optionLabel(key) {
    if (key === 'shape') return st.shape;
    if (key === 'border') return st.border ? st.border.label : null;
    if (key === 'bg') return st.bg ? st.bg.label : null;
    if (key === 'thread') return st.thread ? st.thread.label : null;
    if (key === 'backing') return st.backing ? st.backing.label : null;
    if (key === 'texture') return st.texture ? st.texture.label : null;
    if (key === 'text') return st.text ? st.text.label : null;
    if (key === 'font') return st.font ? st.font.label : null;
    if (OPT_RE.test(key)) return st[key] ? st[key].label : null;
    return null;
  }
  function shapeChipHTML() {
    /* tiny green chip cut to the CHOSEN shape for the closed accordion row */
    var g = shapeGeom();
    if (!g) return '';
    if (g === 'custom') {
      var aC = artworkUrl();
      return aC ? '<img class="np-e2-valimg np-e2-valimg--art" src="' + cleanUrl(aC) + '" alt="">' : '';
    }
    var s5 = 'background:#1AA86C;';
    var w5 = 22, h5 = 22;
    if (g === 'circle') s5 += 'border-radius:50%;';
    else if (g === 'oval') { s5 += 'border-radius:50%;'; w5 = 27; h5 = 18; }
    else if (g === 'oval-h' || g === 'oval-v') { s5 += 'border-radius:50%;'; w5 = 18; h5 = 27; }
    else if (g === 'square' || g === 'rectangle' || g === 'rectangle-v') {
      s5 += 'border-radius:' + (st.corners === 'square' ? '2px' : '5px') + ';';
      if (g === 'rectangle') { w5 = 28; h5 = 19; }
      if (g === 'rectangle-v') { w5 = 19; h5 = 28; }
    }
    else if (SHAPE_CLIPS[g]) s5 += '-webkit-clip-path:' + SHAPE_CLIPS[g] + ';clip-path:' + SHAPE_CLIPS[g] + ';';
    else s5 += 'border-radius:5px;';
    return '<span class="np-e2-valshape" style="' + s5 + 'width:' + w5 + 'px;height:' + h5 + 'px;"></span>';
  }
  function renderOptions() {
    normalizeCustomBg();
    var map = { shape: 'Select shape', border: 'Select style', bg: 'Select color', thread: 'Select color', backing: 'Select backing', texture: 'Select texture', font: 'Select font', text: 'Select color' };
    /* variant-option rows are named by the product's own option, so their
       placeholder is BUILT from that name rather than listed above */
    ['opt1', 'opt2', 'opt3'].forEach(function (kM) { var dM = optDef(kM); if (dM) map[kM] = 'Select ' + dM.name.toLowerCase(); });
    Object.keys(map).forEach(function (k) {
      var el = $('[data-e2-val="' + k + '"]');
      if (!el) return; /* a row this type does not render */
      var v = optionLabel(k);
      var objV = k === 'bg' ? st.bg : k === 'thread' ? st.thread : k === 'text' ? st.text : k === 'border' ? st.border : k === 'backing' ? st.backing : k === 'texture' ? st.texture : null;
      var vis = '';
      if (k === 'shape' && v) vis = shapeChipHTML();
      else if (v && objV && objV.img) vis = '<img class="np-e2-valimg" src="' + objV.img + '" alt="" loading="lazy">';
      else if (k === 'bg' || k === 'thread' || k === 'text') vis = '<i class="np-e2-swatchdot"' + (v && objV && objV.hex ? ' style="background:' + objV.hex + '"' : '') + '></i>';
      el.innerHTML = vis + (v || map[k]);
      el.classList.toggle('is-set', !!v);
      var sum = $('[data-e2-sum="' + k + '"]');
      if (sum) { sum.textContent = v || '—'; sum.classList.toggle('is-set', !!v); }
    });
    var ready = committed();
    var statusEl = $('#np-e2-opt-status');
    if (statusEl) statusEl.textContent = ready ? 'All options set' : ((PTYPE.names || PTYPE.optVariant) ? stepSeq().length + ' quick choices' : 'Five quick choices');
    var btn = $('#np-e2-proofbtn'), hint = $('#np-e2-proofhint');
    btn.disabled = false;
    /* idle = no button at all (selections auto-generate the proof); the
       button exists only once it has a real action */
    /* the CTA lives and dies by the green checks alone: every section chosen
       -> Generate AI Proof shows, whether or not the last "Continue" was hit */
    if (ready) st.ctaRevealed = true;
    btn.hidden = !(ready || st.versions.length || st.proofApproved);
    var of = btn.closest('.np-e2-optfoot');
    if (of) of.classList.toggle('is-cta-live', !btn.hidden); /* mobile: floats at the bottom */
    var pillF = btn.querySelector('.np-e2-proofbtn__pill');
    if (pillF) pillF.hidden = !!st.versions.length || !!st.proofApproved;
    var skipF = document.getElementById('np-e2-skipproof');
    if (skipF) skipF.hidden = !(ready && !st.versions.length && !st.proofApproved);
    /* this builder IS the proofing process — nothing gets emailed later
       (except the specialist path when the AI render failed) */
    var av = (st.selected === null || st.selected === undefined) ? null : st.versions[st.selected];
    if (st.proofApproved && av && av.fallbackUpload) {
      btn.querySelector('span').textContent = 'Proof requested';
      hint.textContent = 'Our team will prepare your proof and email it shortly.';
      hint.classList.add('is-ready');
    } else if (st.proofApproved) {
      btn.querySelector('span').textContent = 'View approved proof';
      hint.textContent = 'Approved ✓ Your final proof. Size, pricing, and checkout are inside.';
      hint.classList.add('is-ready');
    } else if (st.versions.length) {
      var specsDirty = !st.proofApproved && regensLeft() > 0 && specsChangedSince(st.versions[st.versions.length - 1]);
      btn.querySelector('span').textContent = specsDirty ? 'Generate new proof' : 'View your proof';
      hint.textContent = specsDirty
        ? 'Selections changed \u2014 we\u2019ll render a fresh proof with your updates.'
        : 'Your proof is ready \u2014 approve it to set size and pricing.';
      hint.classList.add('is-ready');
    } else if (ready) {
      btn.querySelector('span').textContent = 'Generate AI Proof';
      hint.textContent = 'Ready — see your patch before it prints.';
      hint.classList.add('is-ready');
    } else {
      hint.textContent = 'Make your choices above to continue.';
      hint.classList.remove('is-ready');
    }
    if (PTYPE.names) {
      /* no AI proof on a names patch — the roster below IS the next step */
      btn.hidden = true;
      if (skipF) skipF.hidden = true;
      hint.textContent = ready ? 'All set \u2014 enter your names below.' : 'Make your choices above to continue.';
      hint.classList.toggle('is-ready', ready);
    }
    renderMaskPreview();
  }
  function lbRingFactor() {
    var tL = Math.max(1, Math.min(10, st.lbThick || PTYPE.lbDefault || 3));
    return PTYPE.lbZeroMax2 ? tL / 5 : (0.55 + tL * 0.15);
  }
  function commitOptions() {
    if (stepEnabled('shape')) setProp('_Shape', st.shape || '');
    /* ONE border property, no shape suffix - clear any per-shape leftovers
       (the old app wrote "_Border Style {Shape}") before rewriting it */
    $$('input[name^="properties[_Border Style"]').forEach(function (el) { el.remove(); });
    if (stepEnabled('border') && st.shape && st.border) setProp('_Border Style', normalizeBorder(st.border.label));
    if (stepEnabled('bg')) setProp(PTYPE.bgProp || PTYPE.bgLabel || '_Background Color', st.bg ? st.bg.label : '');
    if (stepEnabled('thread')) setProp(PTYPE.threadProp || PTYPE.threadLabel || '_Border Color', st.thread ? st.thread.label : '');
    else if (PTYPE.threadProp) setProp(PTYPE.threadProp, ''); /* step switched off — drop what it wrote */
    /* the preview falls back to the FIRST font when none was clicked — the
       order must carry that same font, never a blank (fontless order
       PATCH-2106693, 2026-08-24) */
    if (stepEnabled('font')) setProp(PTYPE.fontProp || '_Font Style', activeNameFont().label || '');
    /* fixed-by-product values still have to reach the order — they are just
       never asked. These write to the CUSTOMER-VISIBLE option names the live
       product already uses, so ops reads one vocabulary either way. */
    if (PTYPE.fixedBorder && PTYPE.borderProp) setProp(PTYPE.borderProp, PTYPE.fixedBorder);
    if (PTYPE.fixedBacking && PTYPE.backingProp) setProp(PTYPE.backingProp, PTYPE.fixedBacking);
    if (!PTYPE.backingProp) setProp('_Select Your Backing', st.backing ? st.backing.label : '');
    if (stepEnabled('texture')) setProp('_Background Texture', st.texture ? st.texture.label : '');
    if (stepEnabled('text')) setProp(PTYPE.textProp || '_Text Color', st.text ? st.text.label : '');
    if (PTYPE.borderThick) setProp('_Border Thickness', Math.max(1, Math.min(10, st.lbThick || 3)) + '/10');
    var g2 = shapeGeom();
    if (stepEnabled('shape')) setProp('_Corners', (g2 === 'square' || g2 === 'rectangle' || g2 === 'rectangle-v') ? (st.corners || 'rounded') : '');
    /* borderThick types wrote their value above — this leather-etch line
       must not CLEAR it (it was wiping flex thickness at add time, 2026-08-24) */
    if (!PTYPE.borderThick) setProp('_Border Thickness', (isLeather() && st.border && /etched/i.test(st.border.label || '')) ? (st.lbThick || 3) + '/10' : '');
    setProp('_Etch Style', (isLeather() && st.etchInvert) ? 'Inverted - background etched, artwork bare' : '');
  }

  /* ---- shape mask helpers (customer image contained in each shape) ---- */
  /* polygon masks for the non-radius shapes (tiles + the white under-panel) */
  var SHAPE_CLIPS = {
    rhombus: 'polygon(50% 2%, 98% 50%, 50% 98%, 2% 50%)',
    star: 'polygon(50% 2%, 61% 36%, 98% 36%, 68% 58%, 79% 92%, 50% 71%, 21% 92%, 32% 58%, 2% 36%, 39% 36%)',
    hexagon: 'polygon(25% 4%, 75% 4%, 99% 50%, 75% 96%, 25% 96%, 1% 50%)',
    shield: 'polygon(15.4% 6.2%, 21.2% 4.9%, 27.0% 3.9%, 32.7% 3.1%, 38.5% 2.5%, 44.2% 2.1%, 50.0% 2.0%, 55.8% 2.1%, 61.5% 2.5%, 67.3% 3.1%, 73.0% 3.9%, 78.8% 4.9%, 84.6% 6.2%, 88.1% 7.6%, 91.1% 9.4%, 93.6% 11.9%, 95.5% 14.9%, 96.9% 18.5%, 97.7% 22.6%, 98.0% 27.3%, 97.8% 32.6%, 96.9% 38.5%, 95.6% 44.2%, 94.0% 49.8%, 92.0% 55.1%, 89.6% 60.2%, 86.9% 65.1%, 83.8% 69.9%, 80.3% 74.4%, 76.5% 78.7%, 72.4% 82.9%, 67.8% 86.8%, 62.9% 90.5%, 57.7% 94.1%, 52.0% 97.4%, 51.0% 97.9%, 50.0% 98.0%, 49.0% 97.9%, 48.0% 97.4%, 42.3% 94.1%, 37.1% 90.5%, 32.2% 86.8%, 27.6% 82.9%, 23.5% 78.7%, 19.7% 74.4%, 16.2% 69.9%, 13.1% 65.1%, 10.4% 60.2%, 8.0% 55.1%, 6.0% 49.8%, 4.4% 44.2%, 3.1% 38.5%, 2.2% 32.6%, 2.0% 27.3%, 2.3% 22.6%, 3.1% 18.5%, 4.5% 14.9%, 6.4% 11.9%, 8.9% 9.4%, 11.9% 7.6%, 15.4% 6.2%)',
    heart: 'polygon(50.0% 10.9%, 47.0% 8.1%, 43.7% 5.8%, 40.1% 4.0%, 36.3% 2.7%, 32.4% 2.1%, 28.4% 2.0%, 24.5% 2.5%, 20.6% 3.7%, 17.0% 5.4%, 13.6% 7.6%, 10.6% 10.3%, 7.9% 13.4%, 5.7% 17.0%, 4.0% 20.8%, 2.8% 24.8%, 2.1% 29.0%, 2.0% 33.2%, 2.5% 37.4%, 3.5% 41.5%, 5.0% 45.4%, 7.1% 49.1%, 9.6% 52.3%, 50.0% 98.0%, 90.4% 52.3%, 92.9% 49.1%, 95.0% 45.4%, 96.5% 41.5%, 97.5% 37.4%, 98.0% 33.2%, 97.9% 29.0%, 97.2% 24.8%, 96.0% 20.8%, 94.3% 17.0%, 92.1% 13.4%, 89.4% 10.3%, 86.4% 7.6%, 83.0% 5.4%, 79.4% 3.7%, 75.5% 2.5%, 71.6% 2.0%, 67.6% 2.1%, 63.7% 2.7%, 59.9% 4.0%, 56.3% 5.8%, 53.0% 8.1%)'
  };
  function shapeStyle(geom, w, h) {
    /* returns CSS for the render element */
    var s = 'width:' + w + 'px;height:' + h + 'px;';
    if (geom === 'circle') s += 'border-radius:999px;';
    else if (geom === 'square' || geom === 'rectangle' || geom === 'rectangle-v') s += 'border-radius:6px;';
    else if (geom === 'oval' || geom === 'oval-h') s += 'border-radius:50%;';
    else if (SHAPE_CLIPS[geom]) s += 'clip-path:' + SHAPE_CLIPS[geom] + ';';
    return s;
  }
  function shapeDims(geom, scale) {
    /* the fixed-size patch has its OWN proportions (3.25 x 1.25), not the
       generic rectangle tile's */
    if (PTYPE.fixedDims && PTYPE.fixedShape && geom === PTYPE.fixedShape.geom) {
      return [Math.round(PTYPE.fixedDims[0] * (scale || 1)), Math.round(PTYPE.fixedDims[1] * (scale || 1))];
    }
    var d = {
      circle: [76, 76], square: [76, 76],
      rectangle: [84, 60], 'rectangle-v': [60, 84],
      oval: [62, 80], 'oval-h': [80, 62],
      heart: [80, 74], star: [82, 82], rhombus: [76, 76], hexagon: [80, 72], shield: [72, 80],
      custom: [76, 76]
    }[geom] || [76, 76];
    return [Math.round(d[0] * (scale || 1)), Math.round(d[1] * (scale || 1))];
  }
  function shapeRenderHTML(geom, opts) {
    /* opts: {img, bg, thread, scale} — customer art contained inside the shape */
    var o = opts || {};
    var dims = shapeDims(geom, o.scale);
    var art = o.img ? '<img src="' + o.img + '" alt="">' : '';
    var fill = o.bg || '#e5e7eb'; /* neutral: light grey shading */
    if (geom === 'custom') {
      /* custom = the artwork's own silhouette: show the (bg-removed) image
         as-is — except LEATHER/FAUX, where the tile must preview the etched
         hide exactly like every other shape tile (composer path below) */
      if (!isLeather()) return '<span class="np-e2-shapetile__render np-e2-shapetile__render--custom" style="width:' + dims[0] + 'px;height:' + dims[1] + 'px;' + (o.thread ? 'filter: drop-shadow(0 0 2px ' + o.thread + ');' : '') + '">' + art + '</span>';
    }
    /* composer-rendered tile: even outline on every shape */
    return '<span class="np-e2-shapetile__render np-e2-shapetile__render--cv" data-e2-tilegeom="' + geom + '" style="width:' + dims[0] + 'px;height:' + dims[1] + 'px;"><i class="np-e2-tilespin"></i></span>';
  }

  /* ---- artwork color analysis (feeds "Colors detected from artwork"
     and the full-color recommendation) ---- */
  st.artColors = [];
  st.artColorCount = 0;
  function analyzeArtwork() {
    /* Analyse the render the customer is LOOKING AT — cleanUrl() strips the
       imgix params, so this used to quantize the RAW upload every time: the
       detected palette ignored Remove background entirely, and it picked up
       the white field plus a spread of anti-aliased edge tones (one green logo
       reading as White + 5 near-identical greens). With the toggles applied a
       bg-removed logo correctly resolves to its real colours. */
    var url = applyToggleParams(cleanUrl(artworkUrl()));
    if (!url) return;
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var artEl0 = document.getElementById('np-e2-artimg');
        st.__analyzedSrc = artEl0 ? artEl0.src : url;
        var S = 96;
        var cv = document.createElement('canvas'); cv.width = S; cv.height = S;
        var cx = cv.getContext('2d');
        var r = Math.min(S / img.width, S / img.height);
        var w = Math.max(1, Math.round(img.width * r)), h = Math.max(1, Math.round(img.height * r));
        cx.drawImage(img, 0, 0, w, h);
        var data = cx.getImageData(0, 0, w, h).data;
        /* BACKGROUND EXCLUSION (Justin 2026-08-22): a solid field behind the
           design (black square, white card) dominated every metric — the
           Elemental logo's black field diluted its non-flat fraction below
           the photo gates. The border-dominant colour bucket (>50% of the
           border ring) is the background; its pixels are excluded from the
           palette and texture measurements. */
        var bKey = function (o) { return (data[o] >> 4) + ',' + (data[o + 1] >> 4) + ',' + (data[o + 2] >> 4); };
        var borderB = {}, bTot = 0;
        var bAdd = function (o) { if (data[o + 3] >= 128) { var kB = bKey(o); borderB[kB] = (borderB[kB] || 0) + 1; bTot++; } };
        for (var xB = 0; xB < w; xB++) { bAdd(xB * 4); bAdd(((h - 1) * w + xB) * 4); }
        for (var yB = 0; yB < h; yB++) { bAdd((yB * w) * 4); bAdd((yB * w + w - 1) * 4); }
        var bgKey = null, bgMax = 0;
        for (var kB2 in borderB) { if (borderB[kB2] > bgMax) { bgMax = borderB[kB2]; bgKey = kB2; } }
        if (!(bTot && bgMax / bTot > 0.5)) bgKey = null;
        var bgParts = bgKey ? bgKey.split(',') : null;
        var isBgPx = function (o) {
          if (!bgParts) return false;
          return Math.abs((data[o] >> 4) - bgParts[0]) <= 1 &&
                 Math.abs((data[o + 1] >> 4) - bgParts[1]) <= 1 &&
                 Math.abs((data[o + 2] >> 4) - bgParts[2]) <= 1;
        };
        /* EXCLUSION FLOOR (2026-08-25): on a background-REMOVED upload the
           border ring is almost all transparent, so the only opaque pixels
           sampled there are the artwork's own edge — the logo's colour then
           wins the "background" vote and the exclusion deletes the entire
           design (measured live: 927 opaque px -> 0 art px -> no swatches at
           all under COLORS FROM YOUR ARTWORK). The exclusion is only ever
           meant to drop a solid FIELD behind the art, so if it would take
           the artwork with it, drop the exclusion instead. */
        if (bgParts) {
          var keepPx = 0, totPx = 0;
          for (var iF = 0; iF < data.length; iF += 4) {
            if (data[iF + 3] < 128) continue;
            totPx++;
            if (!isBgPx(iF)) keepPx++;
          }
          if (!keepPx || keepPx / Math.max(1, totPx) < 0.15) bgParts = null;
        }
        var buckets = {};
        var opaque = 0, artPx = 0;
        /* VIVID SPOT-COLOR signal (Justin 2026-08-24): saturated-pixel share
           + distinct-hue count over the ART pixels. AI art already rendered
           AS an embroidered patch is a THREAD PALETTE — mostly saturated
           pixels in a handful of hues — while painterly/photo art is muted
           or hue-diverse. */
        var hueBins = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0], satPx = 0;
        for (var i = 0; i < data.length; i += 4) {
          if (data[i + 3] < 128) continue;
          opaque++;
          if (isBgPx(i)) continue;
          artPx++;
          var key = (data[i] >> 4) + ',' + (data[i + 1] >> 4) + ',' + (data[i + 2] >> 4);
          var b = buckets[key] = buckets[key] || { n: 0, r: 0, g: 0, b: 0 };
          b.n++; b.r += data[i]; b.g += data[i + 1]; b.b += data[i + 2];
          var rH = data[i] / 255, gH = data[i + 1] / 255, bH = data[i + 2] / 255;
          var mxH = Math.max(rH, gH, bH), mnH = Math.min(rH, gH, bH), dH = mxH - mnH;
          if (mxH > 0.15 && (mxH ? dH / mxH : 0) > 0.25) {
            satPx++;
            var hueD = 0;
            if (dH) {
              if (mxH === rH) hueD = ((gH - bH) / dH) % 6;
              else if (mxH === gH) hueD = (bH - rH) / dH + 2;
              else hueD = (rH - gH) / dH + 4;
              hueD *= 60; if (hueD < 0) hueD += 360;
            }
            hueBins[Math.min(23, Math.floor(hueD / 15))]++;
          }
        }
        st.artSatFrac = artPx ? satPx / artPx : 0;
        var hueUsed = 0;
        for (var hB = 0; hB < 24; hB++) if (satPx && hueBins[hB] / satPx > 0.03) hueUsed++;
        st.artHueBins = hueUsed;
        var keys = Object.keys(buckets);
        st.artColorCount = keys.length;
        /* photo signal: smooth-gradient fraction (neighbor luminance diff
           6-40) — photos are gradient-heavy, flat logos are not */
        var grads = 0, edges = 0, np2 = 0;
        for (var yy2 = 0; yy2 < h - 1; yy2++) for (var xx2 = 0; xx2 < w - 1; xx2++) {
          var o2 = (yy2 * w + xx2) * 4;
          if (data[o2 + 3] < 128) continue;
          if (isBgPx(o2)) continue; /* texture measured over the ART only */
          np2++;
          var l0 = 0.299 * data[o2] + 0.587 * data[o2 + 1] + 0.114 * data[o2 + 2];
          var oR = o2 + 4, oD = o2 + w * 4;
          var dm = Math.max(
            Math.abs(l0 - (0.299 * data[oR] + 0.587 * data[oR + 1] + 0.114 * data[oR + 2])),
            Math.abs(l0 - (0.299 * data[oD] + 0.587 * data[oD + 1] + 0.114 * data[oD + 2])));
          if (dm > 40) edges++;
          else if (dm > 6) grads++;
        }
        st.artGradFrac = np2 ? grads / np2 : 0;
        st.artEdgeFrac = np2 ? edges / np2 : 0;
        try { console.log('[np-e2] art metrics', { colors: st.artColorCount, gradFrac: +st.artGradFrac.toFixed(3), edgeFrac: +st.artEdgeFrac.toFixed(3), nonFlat: +(st.artGradFrac + st.artEdgeFrac).toFixed(3), artFrac: opaque ? +(artPx / opaque).toFixed(2) : 1, bgExcluded: !!bgKey, satFrac: +st.artSatFrac.toFixed(2), hueBins: st.artHueBins }); } catch (eAM) {}
        /* fine-detail signal: fraction of ink pixels ON a boundary — thin
           strokes and small text approach 1, chunky shapes stay low */
        var domKey = null, domN = 0;
        for (var kD in buckets) if (buckets[kD].n > domN) { domN = buckets[kD].n; domKey = kD; }
        var dpD = domKey ? domKey.split(',') : [15, 15, 15];
        var drD = (dpD[0] << 4) + 8, dgD = (dpD[1] << 4) + 8, dbD = (dpD[2] << 4) + 8;
        var ink = new Uint8Array(w * h), inkN = 0;
        for (var yI = 0; yI < h; yI++) for (var xI = 0; xI < w; xI++) {
          var oI = (yI * w + xI) * 4;
          if (data[oI + 3] < 128) continue;
          if (Math.abs(data[oI] - drD) + Math.abs(data[oI + 1] - dgD) + Math.abs(data[oI + 2] - dbD) > 90) { ink[yI * w + xI] = 1; inkN++; }
        }
        var bnd = 0;
        for (var yB = 0; yB < h; yB++) for (var xB = 0; xB < w; xB++) {
          if (!ink[yB * w + xB]) continue;
          if (yB === 0 || xB === 0 || yB === h - 1 || xB === w - 1 ||
              !ink[yB * w + xB - 1] || !ink[yB * w + xB + 1] || !ink[(yB - 1) * w + xB] || !ink[(yB + 1) * w + xB]) bnd++;
        }
        st.artThinFrac = inkN ? bnd / inkN : 0;
        st.artInkFrac = np2 ? inkN / np2 : 0;
        st.artBoundShare = np2 ? bnd / np2 : 0; /* boundary ink per canvas — dense linework signal */
        /* stroke-THICKNESS pass at higher resolution: an opening (erode x2,
           dilate x2) removes features thinner than ~5px at a 240px raster —
           roughly embroidery's physical minimum stitch width. Bold block
           lettering keeps its cores no matter how many letters; genuinely
           small text and hairlines vanish. (At the 96px raster above, EVERY
           letter stroke reads as thin — the Ninja Transfers false positive.) */
        try {
          var S2 = 240;
          var r2 = Math.min(S2 / img.width, S2 / img.height, 4);
          var w2 = Math.max(1, Math.round(img.width * r2)), h2 = Math.max(1, Math.round(img.height * r2));
          var cvH = document.createElement('canvas'); cvH.width = w2; cvH.height = h2;
          var cxH = cvH.getContext('2d');
          cxH.drawImage(img, 0, 0, w2, h2);
          var d2 = cxH.getImageData(0, 0, w2, h2).data;
          var bk2 = {}, dom2 = null, domN2 = 0, op2 = 0;
          for (var i2b = 0; i2b < d2.length; i2b += 4) {
            if (d2[i2b + 3] < 128) continue;
            op2++;
            var k2b = (d2[i2b] >> 4) + ',' + (d2[i2b + 1] >> 4) + ',' + (d2[i2b + 2] >> 4);
            bk2[k2b] = (bk2[k2b] || 0) + 1;
            if (bk2[k2b] > domN2) { domN2 = bk2[k2b]; dom2 = k2b; }
          }
          var dp2 = dom2 ? dom2.split(',') : [15, 15, 15];
          var dr2 = (dp2[0] << 4) + 8, dg2 = (dp2[1] << 4) + 8, db2 = (dp2[2] << 4) + 8;
          var ink2 = new Uint8Array(w2 * h2), inkN2 = 0;
          for (var y2b = 0; y2b < h2; y2b++) for (var x2b = 0; x2b < w2; x2b++) {
            var o2b = (y2b * w2 + x2b) * 4;
            if (d2[o2b + 3] < 128) continue;
            if (Math.abs(d2[o2b] - dr2) + Math.abs(d2[o2b + 1] - dg2) + Math.abs(d2[o2b + 2] - db2) > 90) { ink2[y2b * w2 + x2b] = 1; inkN2++; }
          }
          var mA = new Uint8Array(w2 * h2), mB = new Uint8Array(w2 * h2);
          var erodeH = function (sA, dA) {
            for (var yE = 0; yE < h2; yE++) for (var xE = 0; xE < w2; xE++) {
              dA[yE * w2 + xE] = (sA[yE * w2 + xE] &&
                xE > 0 && sA[yE * w2 + xE - 1] && xE < w2 - 1 && sA[yE * w2 + xE + 1] &&
                yE > 0 && sA[(yE - 1) * w2 + xE] && yE < h2 - 1 && sA[(yE + 1) * w2 + xE]) ? 1 : 0;
            }
          };
          var dilateH = function (sA, dA) {
            for (var yD = 0; yD < h2; yD++) for (var xD = 0; xD < w2; xD++) {
              dA[yD * w2 + xD] = (sA[yD * w2 + xD] ||
                (xD > 0 && sA[yD * w2 + xD - 1]) || (xD < w2 - 1 && sA[yD * w2 + xD + 1]) ||
                (yD > 0 && sA[(yD - 1) * w2 + xD]) || (yD < h2 - 1 && sA[(yD + 1) * w2 + xD])) ? 1 : 0;
            }
          };
          erodeH(ink2, mA); erodeH(mA, mB); dilateH(mB, mA); dilateH(mA, mB);
          var thinN2 = 0;
          for (var iT2 = 0; iT2 < w2 * h2; iT2++) if (ink2[iT2] && !mB[iT2]) thinN2++;
          st.artThinInkFrac = inkN2 ? thinN2 / inkN2 : 0;
          st.artThinInkShare = op2 ? thinN2 / op2 : 0;
          try { console.log('[np-e2] detail metrics', { thinFrac: +(st.artThinInkFrac).toFixed(3), thinShare: +(st.artThinInkShare).toFixed(3), inkFrac: +(st.artInkFrac || 0).toFixed(3) }); } catch (eM) {}
        } catch (eHR) { st.artThinInkFrac = st.artThinFrac; st.artThinInkShare = st.artBoundShare; }
        st.__artAnalyzed = true;
        var top = keys.map(function (k) { return buckets[k]; })
          .sort(function (a, b) { return b.n - a.n; })
          .filter(function (b) { return b.n / Math.max(1, opaque) >= 0.005; })
          .slice(0, 24)
          .map(function (b) {
            function hx(v) { return ('0' + Math.round(v / b.n).toString(16)).slice(-2); }
            return ('#' + hx(b.r) + hx(b.g) + hx(b.b)).toUpperCase();
          });
        /* drop near-duplicates */
        var out = [];
        top.forEach(function (hex) {
          var rr = parseInt(hex.slice(1, 3), 16), gg = parseInt(hex.slice(3, 5), 16), bb = parseInt(hex.slice(5, 7), 16);
          var chN = Math.max(rr, gg, bb) - Math.min(rr, gg, bb);
          var dupe = out.some(function (o) {
            var orr = parseInt(o.slice(1, 3), 16), ogg = parseInt(o.slice(3, 5), 16), obb = parseInt(o.slice(5, 7), 16);
            var oCh = Math.max(orr, ogg, obb) - Math.min(orr, ogg, obb);
            if (chN < 28 && oCh < 28) {
              /* both near-neutral: greys collapse HARD — a mono design is
                 white / grey / black, not eight barely-different PMS greys */
              var lN = 0.299 * rr + 0.587 * gg + 0.114 * bb;
              var lO = 0.299 * orr + 0.587 * ogg + 0.114 * obb;
              return Math.abs(lN - lO) < 72;
            }
            return Math.abs(rr - orr) + Math.abs(gg - ogg) + Math.abs(bb - obb) < 36;
          });
          if (!dupe) out.push(hex);
        });
        var seenNm = {};
        st.artColors = out.filter(function (hx2) {
          var nm2 = pmsName(hx2);
          if (seenNm[nm2]) return false;
          seenNm[nm2] = 1;
          return true;
        }).slice(0, 8);
      } catch (e) { console.warn('[np-emb2] artwork analysis failed', e); }
    };
    /* a CORS/404 failure used to be SILENT: onload never fired, __artAnalyzed
       (set inside onload) stayed false, and the palette stayed empty forever
       with no signal anywhere. Mark it analysed so the proof gate cannot hang
       waiting, and say so in the console. */
    img.onerror = function () {
      st.__artAnalyzed = true;
      console.warn('[np-emb2] artwork analysis: image failed to load (CORS or 404) — no detected colours');
    };
    img.src = url;
  }

  function photoGateOn() {
    /* photographs are producible ONLY by full-color printing — every other
       material (embroidery, chenille, leather, PVC, silicone, flex, woven…)
       stops the generate and converts. Typed products have no upload. */
    if (PTYPE.noArt) return false;
    return !/^(fullcolor-2-0|fullcolor-flex-2-0|print-and-stitch-2-0)$/.test(TYPE_KEY);
  }
  function fullColorLikely(line) {
    /* prefer the backend's confidence/feedback when Ninja Force exposes it */
    if (line && typeof line.confidence === 'number') return line.confidence < 0.5;
    if (line && line.feedback && /full.?color|photo/i.test(String(line.feedback))) return true;
    /* client heuristic: ONLY photo-real art (thousands of distinct colors)
       — flat logos with a few gradients must NOT trigger the banner */
    /* PHOTO vs ILLUSTRATION (Justin 2026-08-21): the separator is gradient
       DOMINANCE. Photos are smooth-gradient heavy with few hard edges (beach
       portraits quantize to only a few hundred colors, so color count alone
       under-detects); illustrations (shaded mascots, cel art) carry strong
       outlines, so their edge fraction rivals or beats their gradients. */
    var gfP = st.artGradFrac || 0, efP = st.artEdgeFrac || 0;
    /* PAINTERLY/RENDERED LOGOS (Justin 2026-08-22, Elemental Clean Slate) —
       thresholds MEASURED with the background excluded, 96px analysis:
         painterly (white bg): 377 colors, nonFlat .99
         painterly (BLACK bg): 438 colors, nonFlat .67   <- the Elemental case
         painterly badge:      445 colors, nonFlat .96
         true photo:           613 colors, nonFlat .64
         cel mascot:           169 colors, nonFlat .67   <- colors separates it
         flat 2-tone logo:      29 colors, nonFlat .21
       nonFlat alone cannot separate cel art from painterly once the bg is
       excluded — ART-ONLY COLOR RICHNESS is the separator, nonFlat is the
       floor that spares flat-but-multicolour designs. */
    /* floor at .35, not .55: real painterly logos contain CALM interior
       fields (whitewashed planks, paper textures) that pull art-only nonFlat
       toward ~.4-.5, while the measured cel mascot sits at .67 — nonFlat
       cannot rank these classes. ART-COLOR RICHNESS separates (169 cel vs
       377-613 painterly/photo); the floor only excludes flat 2-tone art (.21). */
    /* FINAL gates measured on Justin's REAL Elemental file (2026-08-22):
         his file:    254 colors, nonFlat .745  <- must trigger
         cel mascot:  169 colors, nonFlat .667  <- must NOT
       (muted painterly palettes quantize ~30% tighter than vivid ones;
        dominant-fill share does NOT separate these classes.) The gate sits
        between them with ~20% margin each way. */
    /* VIVID SPOT-COLOR EXEMPTION (Justin 2026-08-24, the "Revelators" AI
       patch render): thread-texture renders inflate colors (measured 649)
       and nonFlat (.99), tripping this gate — but the art is a thread
       palette and embroiders perfectly. Measured with bg excluded:
         Revelators render: satFrac .72, hueBins 6  <- must NOT stop
         Elemental logo:    satFrac .14, hueBins 7  <- must stop
         A-NIGHT render:    satFrac .03, hueBins 2  <- stops via fine detail
       Muted painterly and photographic art stays well under .5 saturated. */
    var vividSpot = (st.artSatFrac || 0) > 0.5 && (st.artHueBins || 99) <= 8;
    if (st.artColorCount > 210 && (gfP + efP) > 0.35 && !vividSpot) return true;
    if (st.artColorCount > 1400 && gfP > 0.25 && gfP > efP) return true;
    return st.artColorCount > 250 && gfP > 0.22 && gfP > efP * 1.6;
  }
  function fineDetailLikely() {
    /* small text / hairline strokes that embroidery thread physically can't
       stitch. Photos are owned by the Full Color path first. */
    if (fullColorLikely()) return false;
    /* mostly-thin art: the design itself is small text / hairline linework
       (thin = vanishes under the erosion opening; bold lettering never does) */
    var tf = st.artThinInkFrac || 0, ts = st.artThinInkShare || 0;
    if (tf > 0.55 && ts > 0.012) return true;
    /* MIXED art: chunky fills plus a REAL block of genuinely thin detail
       (that's the Print & Stitch case) */
    /* vivid spot-color art whose "thin ink" is really the satin outlines
       between bold regions (Revelators: tf .21, ts .15) is embroiderable —
       exempt it unless the design is genuinely thin-dominant. A-NIGHT
       (satFrac .03, tf .29, ts .11) stays caught. */
    var vividFd = (st.artSatFrac || 0) > 0.5 && (st.artHueBins || 99) <= 8;
    return ts > 0.05 && (st.artInkFrac || 0) > 0.2 && !(vividFd && tf < 0.4);
  }

  /* ---- wizard ---- */
  var wz = $('#np-e2-wizard');
  var wzReturnToProof = false;
  function openWizard(step) {
    st.step = step;
    st.draft = { shape: st.shape, border: st.border, bg: st.bg, thread: st.thread, backing: st.backing, texture: st.texture, font: st.font, opt1: st.opt1, opt2: st.opt2, opt3: st.opt3, text: st.text };
    wz.hidden = false;
    renderWizard();
  }
  function closeWizard() { wz.hidden = true; st.step = null; st.draft = null; }
  function draftValue(i) {
    var k = WZ_STEPS[i];
    var v = st.draft[k];
    if (!v) return null;
    return (k === 'shape') ? displayShapeLabel(v) : v.label;
  }
  function cornersNeeded() {
    var g2 = shapeGeom();
    return (g2 === 'square' || g2 === 'rectangle' || g2 === 'rectangle-v') && !st.corners;
  }
  function committed() { return WZ_STEPS.every(function (k) { return !stepEnabled(k) || !!st[k]; }) && !(stepEnabled('shape') && cornersNeeded()); }

  function renderWizard() {
    var i = st.step;
    var sqW = stepSeq(), posW = sqW.indexOf(i);
    $('#np-e2-wz-eyebrow').textContent = 'STEP ' + ((posW === -1 ? i : posW) + 1) + ' OF ' + WZ_STEPS.filter(stepEnabled).length;
    var dW = optDef(WZ_STEPS[i]);
    $('#np-e2-wz-title').textContent = dW ? ('Select ' + dW.name) : WZ_TITLES[i];
    /* progress strip */
    $('#np-e2-wz-progress').innerHTML = WZ_STEPS.map(function (k, n) {
      var cls = 'np-e2-progress__seg' + (n === i ? ' is-current' : (draftValue(n) ? ' is-done' : ''));
      var dN = optDef(k);
      var lab = (dN ? dN.name : WZ_LABELS[n]) + (draftValue(n) ? ' <em>' + draftValue(n) + '</em>' : '');
      return '<span class="' + cls + '" data-e2-seg="' + n + '"><span class="np-e2-progress__bar"></span><span class="np-e2-progress__lab">' + lab + '</span></span>';
    }).join('');
    $$('#np-e2-wz-progress [data-e2-seg]').forEach(function (seg) {
      seg.addEventListener('click', function () { st.step = parseInt(seg.getAttribute('data-e2-seg'), 10); renderWizard(); });
    });

    /* body */
    renderStepBody(i, $('#np-e2-wz-body'), renderWizard);
    renderWizardFoot(i);
  }

  /* shared step-body renderer: fills `body` with the option UI for step i and
     calls onChange() after any selection mutates st.draft. Used by the ON-PAGE
     accordion (primary, v2) and the dormant wizard modal. */
  function renderStepBody(i, body, onChange) {
    var art = artworkUrl();
    /* dispatch on the step KEY: WZ_STEPS is reorderable, indices are not */
    var k = WZ_STEPS[i];
    if (k === 'shape') {
      body.innerHTML = '<div class="np-e2-shapes">' + (CFG.shapes || []).map(function (s, n) {
        var on = st.draft.shape === s.label;
        /* customer's uploaded image masked into each shape (contained);
           custom shape = the image silhouette itself. NO placeholder art —
           a spinner holds each shape until the upload resolves (the artimg
           load listener re-renders this row the moment it lands). */
        /* molded finishes preview in their own material color — a matte black
           patch must never preview on the grey placeholder field */
        var tileBg = (PTYPE.fixedBg && ((st.bg && st.bg.hex) || PTYPE.fixedBg.hex)) || '#e5e7eb';
        var render = shapeRenderHTML(s.geom, { img: art || null, bg: tileBg });
        if (isFreeFormShape(s.label)) render = render.replace('data-e2-tilegeom="', 'data-e2-tilefree="1" data-e2-tilegeom="');
        if (!art && render.indexOf('np-e2-tilespin') === -1) render = render.replace('</span>', '<i class="np-e2-tilespin"></i></span>');
        /* Free Form needs explaining: the elements come apart into separate
           pieces rather than sitting on one connected patch */
        var tipFF = /free\s*form/i.test(s.label || '')
          ? '<span class="np-e2-ftip np-e2-ftip--tile" data-e2-ftip tabindex="0" aria-label="What is Free Form?"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg><span class="np-e2-ftip__pop"><img src="' + (CFG.freeformImg || '') + '" alt="Free form patches cut as separate pieces" loading="lazy"><b class="np-e2-ftip__head">Every piece cut on its own</b><i>Free form cuts each element of your design as its own separate patch, instead of one connected shape.</i></span></span>'
          : '';
        /* the custom tile explains itself: we cut to the design's own shape */
        var tipCS = (s.geom === 'custom' && !isFreeFormShape(s.label))
          ? '<span class="np-e2-ftip np-e2-ftip--tile" data-e2-ftip tabindex="0" aria-label="What is Shape of My Design?"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg><span class="np-e2-ftip__pop"><img src="https://ninjauploads-production.imgix.net/np-custom-shape-example-1787593373.png?w=520" alt="A patch cut to the exact shape of the uploaded design" loading="lazy"><b class="np-e2-ftip__head">Your design IS the patch shape</b><i>We cut the patch to the outer shape of your uploaded design \u2014 the edge follows your artwork\u2019s own outline.</i></span></span>'
          : '';
        return '<div class="np-e2-shapetile' + (on ? ' is-on' : '') + '" data-e2-pick="shape" data-e2-i="' + n + '">' + render + '<b>' + displayShapeLabel(s.label) + tipCS + tipFF + '</b>' + '</div>';
      }).join('') + '</div>';
      var dGeom = null;
      (CFG.shapes || []).forEach(function (s3) { if (s3.label === st.draft.shape) dGeom = s3.geom; });
      if (dGeom === 'square' || dGeom === 'rectangle' || dGeom === 'rectangle-v') {
        body.innerHTML += '<p class="np-e2-wz-subhead" style="margin-top:14px">CORNERS <em class="np-e2-req">Required</em></p><div class="np-e2-cornrow">' +
          '<button type="button" class="np-e2-corner' + (st.corners === 'rounded' ? ' is-on' : '') + '" data-e2-corner="rounded"><i class="np-e2-corner__glyph np-e2-corner__glyph--r"></i>Rounded corners</button>' +
          '<button type="button" class="np-e2-corner' + (st.corners === 'square' ? ' is-on' : '') + '" data-e2-corner="square"><i class="np-e2-corner__glyph"></i>Square corners</button></div>';
        $$('[data-e2-corner]', body).forEach(function (cbn) {
          cbn.addEventListener('click', function () {
            st.corners = cbn.getAttribute('data-e2-corner');
            /* in-place: a corner pick only changes the mask radius — a full
               re-render would reload every shape tile's composite */
            $$('[data-e2-corner]', body).forEach(function (b2) {
              var k2 = b2.getAttribute('data-e2-corner');
              var on2 = k2 === st.corners;
              b2.classList.toggle('is-on', on2);
              b2.innerHTML = '<i class="np-e2-corner__glyph' + (k2 === 'rounded' ? ' np-e2-corner__glyph--r' : '') + '"></i>' + (k2 === 'rounded' ? 'Rounded corners' : 'Square corners');
            });
            var contBtn = body.querySelector('[data-e2-acccont]');
            if (contBtn) contBtn.disabled = !st.shape || cornersNeeded();
            renderOptions();
            renderMaskPreview();
            commitOptions();
          });
        });
      }
      if (art) $$('[data-e2-tilegeom]', body).forEach(function (tEl) {
        var tileBg2 = (PTYPE.fixedBg && ((st.bg && st.bg.hex) || PTYPE.fixedBg.hex)) || '#e5e7eb';
        composePatchImage(function (cvT) {
          if (cvT) { try { tEl.innerHTML = '<img src="' + cvT.toDataURL('image/png') + '" alt="">'; } catch (eT) {} }
        }, 200, { g: tEl.getAttribute('data-e2-tilegeom'), bg: tileBg2, ring: '#0C0C0E', thin: true, zoom: 1, freeform: tEl.hasAttribute('data-e2-tilefree') });
      });
    } else if (k === 'border') {
      /* border style — Custom Shape only allows the hot-cut edge */
      var isCustom = false;
      (CFG.shapes || []).forEach(function (s) { if (s.label === st.draft.shape && s.geom === 'custom') isCustom = true; });
      if (PTYPE.mats) {
        var lbList = effectiveBorders();
        /* custom shape: No Border is the single option — pre-select it so the
           step self-completes, and clear a stale Etched pick */
        if (isCustom && lbList.length === 1 && (!st.draft.border || st.draft.border.label !== lbList[0].label)) st.draft.border = lbList[0];
        var lbSel = st.draft.border ? st.draft.border.label : '';
        body.innerHTML = '<p class="np-e2-wz-help">' + (isCustom ? 'A custom shape is cut clean on your artwork\u2019s own edge \u2014 no border options.' : 'Add a laser-etched border line inside the edge \u2014 or keep a smooth clean cut.') + '</p><div class="np-e2-backings np-e2-borders">' + lbList.map(function (bL, nL) {
          var onL = lbSel === bL.label;
          return '<div class="np-e2-backtile' + (onL ? ' is-on' : '') + '" data-e2-lb="' + nL + '"><img src="' + bL.img + '?w=520" alt="' + bL.label + '"><b>' + bL.label + '</b><i>' + (bL.note || '') + '</i></div>';
        }).join('') + '</div>' +
        (/etched/i.test(lbSel) ? '<div class="np-e2-zoomrow np-e2-zoomrow--step"><span>Border thickness</span><input type="range" data-e2-lbthick min="1" max="10" step="1" value="' + (st.lbThick || 3) + '"><b>' + (st.lbThick || 3) + '/10</b></div>' : '');
        $$('[data-e2-lb]', body).forEach(function (tileL) {
          tileL.addEventListener('click', function () {
            st.draft.border = lbList[parseInt(tileL.getAttribute('data-e2-lb'), 10)];
            onChange();
          });
        });
        var lt = body.querySelector('[data-e2-lbthick]');
        if (lt) {
          try { paintSlider(lt); } catch (eL1) {}
          lt.addEventListener('input', function () {
            try { paintSlider(lt); } catch (eL2) {}
            st.lbThick = parseInt(lt.value, 10) || 3;
            var bTh = lt.parentNode.querySelector('b');
            if (bTh) bTh.textContent = lt.value + '/10';
            setProp('_Border Thickness', lt.value + '/10');
            if (!lt.__npRaf) { lt.__npRaf = true; requestAnimationFrame(function () { lt.__npRaf = false; renderMaskPreview(); }); }
          });
        }
        return;
      }
      var blist = effectiveBorders();
      if (isCustom && blist.length === 1 && (!st.draft.border || st.draft.border.label !== blist[0].label)) st.draft.border = blist[0];
      var bhelp = isCustom ? 'Custom shapes are hot cut to your artwork — Merrow requires a standard shape.' : '';
      body.innerHTML = '<p class="np-e2-wz-help">' + bhelp + '</p><div class="np-e2-backings np-e2-borders">' + blist.map(function (b) {
        var on = st.draft.border && st.draft.border.label === b.label;
        var n = (CFG.borders || []).indexOf(b);
        return '<div class="np-e2-backtile' + (on ? ' is-on' : '') + '" data-e2-pick="border" data-e2-i="' + n + '">' + (b.img ? '<img src="' + b.img + '" alt="' + b.label + '">' : '<span class="np-e2-backtile__noimg"><i></i></span>') + '<b>' + b.label + '</b><i>' + (b.note || '') + '</i></div>';
      }).join('') + '</div>' +
      (st.shape && shapeGeom() !== 'custom' ? '<div class="np-e2-zoomrow np-e2-zoomrow--step"><span>Artwork fill</span><input type="range" data-e2-artzoom2 min="60" max="250" step="5" value="' + Math.round((st.artZoom || 1) * 100) + '"><b>' + Math.round((st.artZoom || 1) * 100) + '%</b></div>' : '');
      var z2 = body.querySelector('[data-e2-artzoom2]');
      if (z2) {
        try { paintSlider(z2); } catch (eZ2) {}
        z2.addEventListener('input', function () {
          try { paintSlider(z2); } catch (eZ3) {}
          st.artZoom = parseInt(z2.value, 10) / 100;
          var bV2 = z2.parentNode.querySelector('b');
          if (bV2) bV2.textContent = z2.value + '%';
          var mainS = document.getElementById('np-e2-artzoom');
          var mainV = document.getElementById('np-e2-artzoom-val');
          if (mainS) { mainS.value = z2.value; try { paintSlider(mainS); } catch (eZ4) {} }
          if (mainV) mainV.textContent = z2.value + '%';
          if (!z2.__npRaf) { z2.__npRaf = true; requestAnimationFrame(function () { z2.__npRaf = false; renderMaskPreview(); }); }
          setProp('_Art Fill', z2.value + '%');
        });
      }
    } else if (k === 'bg' || k === 'thread' || k === 'text') {
      var list = k === 'bg' ? CFG.bgs : CFG.threads; /* text shares the thread palette */
      var cur = k === 'bg' ? st.draft.bg : (k === 'text' ? st.draft.text : st.draft.thread);
      var help = ''; /* now shown beside the row label — see stepHelpText() */
      var kindKey = k;
      if (kindKey === 'bg' && PTYPE.mats) {
        var curM = st.draft.bg;
        body.innerHTML = '<div class="np-e2-colorhead"><p class="np-e2-wz-help">The artwork is laser etched into the hide.</p></div>' +
          '<div class="np-e2-swatches np-e2-swatches--mats">' + PTYPE.mats.map(function (c, nM) {
            var onM = curM && curM.label === c.label;
            return '<div class="np-e2-swatch np-e2-swatch--mat' + (onM ? ' is-on' : '') + '" data-e2-mat="' + nM + '"><span class="np-e2-matimg"><img src="' + c.img + '" alt="" loading="lazy"></span><b>' + c.label + '</b></div>';
          }).join('') +
          '<button type="button" class="np-e2-etchinv' + (st.etchInvert ? ' is-on' : '') + '" data-e2-etchinv style="grid-column:' + ((PTYPE.mats.map(function (cc) { return cc.label; }).indexOf(curM && curM.label) + 1) || 1) + '"><b>' + (st.etchInvert ? 'Inverted Etch \u2713' : 'Invert the etch') + '</b></button>' + '</div>';
        $$('[data-e2-mat]', body).forEach(function (tileM) {
          tileM.addEventListener('click', function () {
            st.draft.bg = PTYPE.mats[parseInt(tileM.getAttribute('data-e2-mat'), 10)];
            onChange();
          });
        });
        var invT = body.querySelector('[data-e2-etchinv]');
        if (invT) invT.addEventListener('click', function () {
          st.etchInvert = !st.etchInvert;
          this.classList.toggle('is-on', st.etchInvert);
          var bT = this.querySelector('b');
          if (bT) bT.textContent = st.etchInvert ? 'Inverted Etch \u2713' : 'Invert the etch';
          setProp('_Etch Style', st.etchInvert ? 'Inverted - background etched, artwork bare' : '');
          renderMaskPreview();
        });
        return;
      }
      var isCustomCur = cur && !isFollowVal(cur) && cur.label !== 'Not Sure' && cur.label !== 'Let Ninja Choose' && cur.label !== 'None' && st.artColors.indexOf(cur.hex) === -1 && (list || []).every(function (c) { return c.label !== cur.label; });
      /* "Match My Artwork" is the same idea as the artwork colours, so it sits
         with them. It only stays in the header row when there are none. */
      var artSection = '';
      var artNames = {}; /* one swatch per color NAME — dupes within the artwork
        palette collapse, and standard colors already offered there hide */
      /* custom shape: the patch is cut to the artwork, so "None" (no felt
         background) rides as the LAST artwork swatch — red no-slash icon,
         picked/unpicked exactly like any other swatch */
      /* NOT on lettering types: on tackle twill / name patches the "bg" step
         IS the LETTER colour, and letters must have a colour — "None" there
         meant invisible letters (Justin 2026-08-21) */
      var noneTile = (kindKey === 'bg' && shapeGeom() === 'custom' && !PTYPE.textLines && !PTYPE.textPreview && !PTYPE.bareArt)
        ? '<div class="np-e2-swatch np-e2-swatch--none' + ((cur && cur.label === 'None') ? ' is-on' : '') + '" data-e2-none="' + kindKey + '"><i style="background:linear-gradient(135deg,transparent 44%,#E5484D 44%,#E5484D 56%,transparent 56%),#fff;box-shadow:inset 0 0 0 1px #d5dbe0"></i><b>None</b></div>'
        : '';
      if (st.artColors.length) {
        artSection = '<p class="np-e2-wz-subhead">COLORS FROM YOUR ARTWORK</p><div class="np-e2-swatches np-e2-swatches--art">' + st.artColors.map(function (hex) {
          var nmA = pmsName(hex);
          if (artNames[nmA]) return '';
          artNames[nmA] = 1;
          var on = cur && (cur.hex === hex || cur.label === nmA);
          return '<div class="np-e2-swatch' + (on ? ' is-on' : '') + '" data-e2-artcolor="' + kindKey + '" data-hex="' + hex + '"><i style="background:' + hex + '"></i><b>' + nmA + '</b></div>';
        }).join('') + noneTile + '</div><p class="np-e2-wz-subhead">STANDARD COLORS</p>';
        noneTile = ''; /* consumed */
      }
      var isUnsure = cur && (cur.label === 'Not Sure' || cur.label === 'Let Ninja Choose');
      var isFollow = isFollowVal(cur);
      var moreKey = 'more_' + kindKey;
      var LIMITC = 15; /* + the color wheel = 16 tiles */
      var showAllC = !!st[moreKey] || !!(cur && (list || []).some(function (c2, n2) { return n2 >= LIMITC && c2.label === cur.label; }));
      var moreBtn = ((list || []).length > LIMITC)
        ? '<button type="button" class="np-e2-showmore" data-e2-more="' + kindKey + '">' + (showAllC ? 'Show fewer colors' : 'Show ' + (list.length - LIMITC) + ' more colors') + '</button>'
        : '';
      /* no upload on this type = nothing to follow */
      var followBtnHTML = PTYPE.noArt ? '' : ('<button type="button" class="np-e2-lnc np-e2-lnc--follow' + (isFollow ? ' is-on' : '') + '" data-e2-follow="' + kindKey + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>' + '<span class="np-e2-lnc-full">' + FOLLOW_LABEL + '</span><span class="np-e2-lnc-short">Match Artwork</span>' + (isFollow ? ' \u2713' : '') + '<span class="np-e2-ftip" data-e2-ftip tabindex="0" aria-label="What does Match My Artwork do?"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg><span class="np-e2-ftip__pop"><img src="https://ninjauploads-production.imgix.net/np-follow-example-1786985124.png?w=520" alt="Example artwork with its own border and background" loading="lazy"><b class="np-e2-ftip__head">Image already designed correctly?</b><i>We will follow the background and border in your image to make sure your patch matches your design</i></span></span>' + '</button>');
      /* full colour: the artwork IS the whole patch face, so there is no felt
         behind it to colour. Leads the row; Let Ninja Choose sits right of it. */
      var photoBtnHTML = ((kindKey === 'bg' && PTYPE.photoBtn)
          ? '<button type="button" class="np-e2-lnc np-e2-lnc--photo' + (isPhotoVal(cur) ? ' is-on' : '') + '" data-e2-photo="bg"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>' + '<span class="np-e2-lnc-full">It\u2019s a photo</span><span class="np-e2-lnc-short">Photo</span>' + (isPhotoVal(cur) ? ' \u2713' : '') + '</button>'
          : '');
      /* the artwork-colours heading carries the Match My Artwork button; the
         token is only resolvable here, after followBtnHTML is built */
      body.innerHTML = '<div class="np-e2-colorhead">' + (help ? '<p class="np-e2-wz-help">' + help + '</p>' : '') + '<span class="np-e2-colorhead__acts">' +
        followBtnHTML + photoBtnHTML +
        /* Let Ninja Choose — a REAL button, upper right (the specialist picks).
           Typed products (names, tackle twill) are ordered on the exact colours
           the customer sees in the preview, so it is suppressed there. */
        (PTYPE.noLnc ? '' :
        '<button type="button" class="np-e2-lnc' + (isUnsure ? ' is-on' : '') + '" data-e2-unsure="' + kindKey + '">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l1.7 4.3L18 9l-4.3 1.7L12 15l-1.7-4.3L6 9l4.3-1.7z"/><path d="M19 15l.9 2.1L22 18l-2.1.9L19 21l-.9-2.1L16 18l2.1-.9z"/></svg>' +
        (isUnsure ? 'AI chose \u2713' : 'Let AI Choose') +
        '<span class="np-e2-ftip" data-e2-ftip tabindex="0" aria-label="What does Let AI Choose do?"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg><span class="np-e2-ftip__pop"><b class="np-e2-ftip__head">Let AI choose</b><i>AI will choose for you based on your design \u2014 the pick shows in your preview and you can change it anytime.</i></span></span>' +
        '</button>') +
        '</span></div>' +
        artSection + '<div class="np-e2-swatches">' + noneTile + (list || []).map(function (c, n) {
        if (!showAllC && n >= LIMITC) return '';
        if (artNames[c.label]) return ''; /* already offered under COLORS FROM YOUR ARTWORK */
        var on = cur && cur.label === c.label;
        return '<div class="np-e2-swatch' + (on ? ' is-on' : '') + '" data-e2-pick="' + kindKey + '" data-e2-i="' + n + '"><i style="background:' + c.hex + '"></i><b>' + c.label + '</b></div>';
      }).join('') +
      /* color wheel — pick ANY color; it's named by its hex code and that
         hex is what lands on the line-item property */
      '<div class="np-e2-swatch np-e2-swatch--wheel' + (isCustomCur ? ' is-on' : '') + '" data-e2-wheel="' + kindKey + '">' +
        '<i' + (isCustomCur ? ' style="background:' + cur.hex + '"' : '') + '></i>' +
        '<b>' + (isCustomCur ? cur.label : 'Custom') + '</b>' +
        '<input type="color" value="' + (isCustomCur ? cur.hex : '#1AA86C') + '">' +
      '</div>' + moreBtn + '</div>';
      $$('[data-e2-none]', body).forEach(function (tile) {
        tile.addEventListener('click', function () {
          var kN = tile.getAttribute('data-e2-none');
          var val = { label: 'None', hex: '' };
          if (kN === 'bg') st.draft.bg = val; else if (kN === 'text') st.draft.text = val; else st.draft.thread = val;
          onChange();
        });
      });
      $$('[data-e2-artcolor]', body).forEach(function (tile) {
        tile.addEventListener('click', function () {
          var hex = tile.getAttribute('data-hex');
          var val = { label: pmsName(hex), hex: hex };
          var kA = tile.getAttribute('data-e2-artcolor');
          if (kA === 'bg') st.draft.bg = val; else if (kA === 'text') st.draft.text = val; else st.draft.thread = val;
          onChange();
        });
      });
      $$('[data-e2-photo]', body).forEach(function (tile) {
        tile.addEventListener('click', function () {
          /* photo = no patch background at all; follow:true makes the compose go
             full bleed and drops background_color from the renderer specs */
          st.draft.bg = { label: PHOTO_LABEL, hex: '', follow: true };
          onChange();
        });
      });
      $$('[data-e2-unsure]', body).forEach(function (tile) {
        tile.addEventListener('click', function (evU) {
          /* a tooltip tap must never trigger the pick */
          if (evU.target && evU.target.closest && evU.target.closest('[data-e2-ftip]')) return;
          var kU = tile.getAttribute('data-e2-unsure');
          var val = aiChooseColor(kU);
          if (kU === 'bg') st.draft.bg = val; else if (kU === 'text') st.draft.text = val; else st.draft.thread = val;
          npToast('\u2713 AI picked ' + val.label + ' from your design \u2014 tap any swatch to change it');
          onChange();
        });
      });
      $$('[data-e2-follow]', body).forEach(function (tile) {
        tile.addEventListener('click', function () {
          /* the artwork already carries this element — follow the image */
          var val = { label: FOLLOW_LABEL, hex: '', follow: true };
          var kF = tile.getAttribute('data-e2-follow');
          if (kF === 'bg') st.draft.bg = val; else if (kF === 'text') st.draft.text = val; else st.draft.thread = val;
          onChange();
        });
      });
      $$('[data-e2-more]', body).forEach(function (bM) {
        bM.addEventListener('click', function () {
          st[moreKey] = !st[moreKey];
          renderAccordion();
        });
      });
      if (kindKey === 'thread' && PTYPE.borderThick) {
        /* molded flex: the border is part of the mold, so its WIDTH is a
           choice — same 1-10 control (and _Border Thickness property) the
           laser-etched leather border already uses */
        var thWrap = document.createElement('div');
        thWrap.className = 'np-e2-zoomrow np-e2-zoomrow--step';
        thWrap.innerHTML = '<span>Border thickness</span><input type="range" data-e2-lbthick min="1" max="10" step="1" value="' + (st.lbThick || 3) + '"><b>' + (st.lbThick || 3) + '/10</b>';
        body.appendChild(thWrap);
        var ltF = thWrap.querySelector('[data-e2-lbthick]');
        try { paintSlider(ltF); } catch (eF1) {}
        ltF.addEventListener('input', function () {
          try { paintSlider(ltF); } catch (eF2) {}
          st.lbThick = parseInt(ltF.value, 10) || 3;
          var bF = thWrap.querySelector('b');
          if (bF) bF.textContent = ltF.value + '/10';
          setProp('_Border Thickness', ltF.value + '/10');
          if (!ltF.__npRaf) { ltF.__npRaf = true; requestAnimationFrame(function () { ltF.__npRaf = false; renderMaskPreview(); }); }
        });
      }
      $$('[data-e2-wheel]', body).forEach(function (tile) {
        var picker = tile.querySelector('input[type="color"]');
        /* two open paths: the input covers the tile (native), plus an
           explicit showPicker() for contexts where the covered-input click
           doesn't open (zoomed/stacked modals) */
        picker.addEventListener('click', function (e) { e.stopPropagation(); });
        tile.addEventListener('click', function (e) {
          if (e.target === picker) return;
          try {
            if (typeof picker.showPicker === 'function') picker.showPicker();
            else picker.click();
          } catch (err) { try { picker.click(); } catch (e2) {} }
        });
        picker.addEventListener('input', function () {
          /* fires continuously while sliding — update the draft + this tile
             IN PLACE only. Re-rendering here would destroy the input and
             snap the native picker shut mid-drag. */
          var hex = picker.value.toUpperCase();
          var val = { label: pmsName(hex), hex: hex };
          var kW = tile.getAttribute('data-e2-wheel');
          if (kW === 'bg') st.draft.bg = val; else if (kW === 'text') st.draft.text = val; else st.draft.thread = val;
          tile.classList.add('is-on');
          tile.querySelector('i').style.background = hex;
          tile.querySelector('b').textContent = val.label;
        });
        picker.addEventListener('change', function () { onChange(); });
      });
    } else if (k === 'font') {
      /* the tile IS the sample: each option shows the very word the patch
         will carry, set in that face */
      var fontsF = nameFonts();
      body.innerHTML = '<p class="np-e2-wz-help">The lettering style your names are stitched in.</p>' +
        '<div class="np-e2-fonts">' + fontsF.map(function (f2, nF) {
          var onF = st.draft.font && st.draft.font.label === f2.label;
          return '<div class="np-e2-fonttile' + (onF ? ' is-on' : '') + '" data-e2-font="' + nF + '">' +
            '<span class="np-e2-fonttile__samp" style="font-family:' + nameFontStack(f2) + ';font-weight:' + ((f2 && f2.weight) || 700) + '">' + nameTileSample(f2) + '</span>' +
            '<b>' + f2.label + '</b></div>';
        }).join('') + '</div>';
      $$('[data-e2-font]', body).forEach(function (tileF) {
        tileF.addEventListener('click', function () {
          st.draft.font = fontsF[parseInt(tileF.getAttribute('data-e2-font'), 10)];
          onChange();
        });
      });
    } else if (k === 'backing') {
      body.innerHTML = '<div class="np-e2-backings">' + effectiveBackings().map(function (b) {
        var n = (CFG.backings || []).indexOf(b);
        var on = st.draft.backing && st.draft.backing.label === b.label;
        return '<div class="np-e2-backtile' + (on ? ' is-on' : '') + '" data-e2-pick="backing" data-e2-i="' + n + '"><img src="' + b.img + '" alt="' + b.label + '"><b>' + b.label + '</b><i>' + (b.note || '') + '</i></div>';
      }).join('') + '</div>';
    } else if (OPT_RE.test(k)) {
      /* one tile per value of THIS Shopify option. The tile label is the option
         value byte-for-byte, because that exact string is what matches a
         variant — never a prettified copy of it. */
      var dO = optDef(k) || { name: '', values: [] };
      var helpO = (PTYPE.optHelp || {})[dO.name];
      body.innerHTML = (helpO ? '<p class="np-e2-wz-help">' + helpO + '</p>' : '') +
        '<div class="np-e2-backings np-e2-backings--txt">' + dO.values.map(function (o2, nO) {
          var onO = st.draft[k] && st.draft[k].label === o2.label;
          /* a value with a configured example image renders as a PICTURE tile
             (the Layers choice shows real 1-layer vs 2-layer stitched work) */
          var imgO = (CFG.optImgs || {})[o2.label];
          return '<div class="np-e2-backtile' + (imgO ? ' np-e2-backtile--full' : ' np-e2-backtile--txt') + (onO ? ' is-on' : '') + '" data-e2-opt="' + nO + '">' + (imgO ? '<img src="' + imgO + '" alt="" loading="lazy">' : '') + '<b>' + o2.label + '</b></div>';
        }).join('') + '</div>';
      $$('[data-e2-opt]', body).forEach(function (tileO) {
        tileO.addEventListener('click', function () {
          st.draft[k] = dO.values[parseInt(tileO.getAttribute('data-e2-opt'), 10)];
          onChange();
        });
      });
    } else if (k === 'texture') {
      /* ═══ Background texture — molded flex surface ═══ */
      var texes = PTYPE.texture || [];
      body.innerHTML = '<p class="np-e2-wz-help">The molded surface texture behind your design.</p><div class="np-e2-backings np-e2-textures">' + texes.map(function (t2, nT) {
        var onT = st.draft.texture && st.draft.texture.label === t2.label;
        return '<div class="np-e2-backtile' + (onT ? ' is-on' : '') + '" data-e2-tex="' + nT + '"><img src="' + t2.img + '" alt="' + t2.label + '"><b>' + t2.label + '</b></div>';
      }).join('') + '</div>';
      $$('[data-e2-tex]', body).forEach(function (tileT) {
        tileT.addEventListener('click', function () {
          st.draft.texture = texes[parseInt(tileT.getAttribute('data-e2-tex'), 10)];
          onChange();
        });
      });
    }
    /* info tips are bound for EVERY step body — a tip click never counts as
       choosing the tile it sits on */
    $$('[data-e2-ftip]', body).forEach(function (tip) {
      tip.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        tip.classList.toggle('is-open');
      });
    });
    $$('[data-e2-pick]', body).forEach(function (tile) {
      tile.addEventListener('click', function () {
        var kind = tile.getAttribute('data-e2-pick');
        var n = parseInt(tile.getAttribute('data-e2-i'), 10);
        if (kind === 'shape') st.draft.shape = CFG.shapes[n].label;
        else if (kind === 'border') st.draft.border = (n === -1 ? { label: 'No Border' } : CFG.borders[n]);
        else if (kind === 'bg') st.draft.bg = CFG.bgs[n];
        else if (kind === 'thread') st.draft.thread = CFG.threads[n];
        else if (kind === 'text') st.draft.text = CFG.threads[n];
        else st.draft.backing = CFG.backings[n];
        /* capture BEFORE onChange(): the re-render detaches this tile, and
           closest() on a detached node finds no ancestors — reading it after
           onChange() made the whole scroll block silently skip */
        var rowC = (kind === 'shape' && tile.closest) ? tile.closest('.np-e2-accrow') : null;
        var accI = rowC ? rowC.getAttribute('data-e2-acc') : null;
        onChange();
        /* SHAPE picked: bring this step's own row to the top of the screen so
           the Continue button is in view on every screen size — the shape grid
           is the tallest step, so on short viewports the button sat below the
           fold (Justin 2026-08-21). Clears the mobile sticky preview via
           npScrollPad(). */
        if (kind === 'shape') {
          /* onChange() re-renders the accordion, so the clicked tile's row is
             DETACHED by the time we measure (a detached node reports 0s and
             the scroll silently went nowhere). Capture the step index first,
             then re-query the live row after the re-render. */
          /* the accordion REBUILDS on pick, so the row is briefly absent from
             the DOM — a single rAF lands mid-rebuild, finds nothing and the
             scroll silently never happens. Poll briefly for the rebuilt row,
             and wait for its shape tiles (the tallest content) so the measured
             offset is the settled one. */
          if (accI !== null) (function () {
            var tries = 0;
            (function attempt() {
              var live = document.querySelector('.np-e2-accrow[data-e2-acc="' + accI + '"]');
              var ready = live && (live.querySelector('[data-e2-pick="shape"]') || tries > 6);
              if (!ready) {
                if (tries++ < 12) return setTimeout(attempt, 60);
                return;
              }
              /* target: row top below the sticky preview — but on SHORT
                 viewports the shape grid is taller than the visible band, so
                 the Continue button would still sit below the fold. The
                 button is the point (Justin): scroll however far it takes to
                 get it on screen, keeping as much of the grid visible as the
                 viewport allows. */
              var targetY = function () {
                var lv = document.querySelector('.np-e2-accrow[data-e2-acc="' + accI + '"]');
                if (!lv) return null;
                var y = lv.getBoundingClientRect().top + window.pageYOffset - npScrollPad();
                var ct = lv.querySelector('.np-e2-acc-cont');
                if (ct) {
                  var yB = ct.getBoundingClientRect().bottom + window.pageYOffset - window.innerHeight + 16;
                  if (yB > y) y = yB;
                }
                return Math.max(0, y);
              };
              var yS = targetY();
              if (yS === null) return;
              window.scrollTo({ top: yS, behavior: 'smooth' });
              /* settle pass: the sticky preview re-measures mid-scroll and
                 some engines ignore smooth scrolling — recompute once the
                 layout settles and correct with an instant jump if off */
              setTimeout(function () {
                var y2 = targetY();
                if (y2 !== null && Math.abs(window.pageYOffset - y2) > 6) window.scrollTo(0, y2);
              }, 550);
            })();
          })();
        }
      });
    });
  }

  /* The accordion's DOM order is the CUSTOMER's order. WZ_STEPS indices are
     a stable key (liquid rows + WZ_TITLES ride them), so a type that wants a
     different sequence — custom names lead with Font, which is index 6 —
     reorders its ROWS, not the array. For every existing type the two orders
     are identical, so this returns exactly what the old index walk did. */
  function stepSeq() {
    var out = [];
    $$('.np-e2-accrow').forEach(function (r) {
      var n = parseInt(r.getAttribute('data-e2-acc'), 10);
      if (!isNaN(n) && WZ_STEPS[n] && stepEnabled(WZ_STEPS[n])) out.push(n);
    });
    if (!out.length) for (var i = 0; i < WZ_STEPS.length; i++) if (stepEnabled(WZ_STEPS[i])) out.push(i);
    return out;
  }
  function stepAfter(i) {
    var sq = stepSeq(), p = sq.indexOf(i);
    return (p === -1 || p === sq.length - 1) ? -1 : sq[p + 1];
  }
  function wzFirstIdx() { for (var a = 0; a < WZ_STEPS.length; a++) { if (stepEnabled(WZ_STEPS[a])) return a; } return 0; }
  function wzLastIdx() { for (var b = WZ_STEPS.length - 1; b >= 0; b--) { if (stepEnabled(WZ_STEPS[b])) return b; } return WZ_STEPS.length - 1; }
  function renderWizardFoot(i) {
    var lastI = wzLastIdx();
    var prev = $('#np-e2-wz-prev');
    prev.style.visibility = i === wzFirstIdx() ? 'hidden' : 'visible';
    var hasVal = !!draftValue(i);
    var next = $('#np-e2-wz-next');
    next.disabled = !hasVal;
    /* proof-first flow: the first wizard completion IS the generate action */
    next.textContent = i === lastI
      ? (st.versions.length ? (committed() ? 'Save selections' : 'Apply selections') : 'Apply and generate proof')
      : 'Next';
    $('#np-e2-wz-hint').style.display = hasVal ? 'none' : '';
    $('#np-e2-wz-save').hidden = !(committed() && i < lastI);
  }

  /* ═══ ON-PAGE OPTIONS ACCORDION (v2.1 — no modal; options are chosen
     right on the page, right column). Selections commit INSTANTLY, the
     next unset row auto-opens, and the 5th selection auto-fires the proof. */
  var accOpen = null;
  function accEnsureDraft() {
    if (!st.draft) st.draft = { shape: st.shape, border: st.border, bg: st.bg, thread: st.thread, backing: st.backing, proof: st.proof, texture: st.texture, font: st.font, opt1: st.opt1, opt2: st.opt2, opt3: st.opt3, text: st.text };
  }
  function openAcc(i) { accEnsureDraft(); accOpen = i; renderAccordion(); }
  function autoPickSingles() {
    /* a step with exactly ONE valid option needs no question — pre-select it
       (e.g. Custom Shape narrows border style to Hot Cut alone) */
    var changed = false;
    if (stepEnabled('border') && st.shape) {
      var blistA = effectiveBorders();
      var okA = st.border && blistA.some(function (b) { return b.label === st.border.label; });
      if (blistA.length === 1 && !okA) {
        st.border = blistA[0];
        if (st.draft) st.draft.border = blistA[0];
        changed = true;
      }
    }
    var bkE = effectiveBackings();
    if (bkE.length === 1 && !st.backing) {
      st.backing = bkE[0];
      if (st.draft) st.draft.backing = bkE[0];
      changed = true;
    }
    if (changed) { try { commitOptions(); } catch (eAp) {} }
  }
  function stepHelpText(k) {
    if (k === 'bg') return isFreeFormShape() ? 'Free form is molded in ONE solid color — this is the color of every piece.' : (PTYPE.bgHelp || 'The felt color behind your artwork.');
    if (k === 'thread') return PTYPE.threadHelp || 'The stitched border around the edge of your patch.';
    if (k === 'text') return PTYPE.textHelp || 'The thread color of the lettering.';
    if (k === 'border') return 'How the edge of your patch is finished.';
    return '';
  }
  function renderAccordion() {
    autoPickSingles();
    accEnsureDraft();
    $$('.np-e2-accrow').forEach(function (row) {
      var i = parseInt(row.getAttribute('data-e2-acc'), 10);
      /* rows that are not wizard steps (the tackle-twill lettering and border
         stitch panels) own their own visibility — walking them here made
         stepEnabled(undefined) fall through to true and showed an empty
         Border stitch row on leather and faux leather */
      if (isNaN(i)) return;
      var enR = stepEnabled(WZ_STEPS[i]);
      row.hidden = !enR;
      var doneR = !!st[WZ_STEPS[i]] && !(WZ_STEPS[i] === 'shape' && cornersNeeded());
      row.classList.toggle('is-done', doneR && !open);
      if (!enR) { var bR = row.querySelector('[data-e2-accbody]'); if (bR) { bR.hidden = true; bR.innerHTML = ''; } return; }
      var labR = row.querySelector('.np-e2-accrow__lab');
      if (labR) {
        /* ONE decision, resolved into a variable before anything else touches
           this block. This used to be an if/else-if chain and an unrelated
           insertion in the middle of it re-parented the later arms onto the
           hint's own `if`, silently dropping the thread row's label. */
        var labTxt = null;
        if (WZ_STEPS[i] === 'bg') labTxt = isFreeFormShape() ? 'Patch color' : (PTYPE.bgLabel || null);
        else if (WZ_STEPS[i] === 'thread') labTxt = PTYPE.threadLabel || null;
        else if (WZ_STEPS[i] === 'text') labTxt = PTYPE.textLabel || 'Text Color';
        else if (WZ_STEPS[i] === 'font') labTxt = 'Font style';
        else if (optDef(WZ_STEPS[i])) labTxt = optDef(WZ_STEPS[i]).name;
        if (labTxt) labR.textContent = labTxt;
        /* the explainer sits BESIDE the row label, freeing the body row for the
           choice buttons (which no longer fit alongside it) */
        var hintR = labR.parentNode.querySelector('.np-e2-accrow__hint');
        var hintTxt = stepHelpText(WZ_STEPS[i]);
        if (hintTxt) {
          if (!hintR) {
            hintR = document.createElement('span');
            hintR.className = 'np-e2-accrow__hint';
            labR.parentNode.insertBefore(hintR, labR.nextSibling);
          }
          hintR.textContent = hintTxt;
        } else if (hintR) { hintR.remove(); }
      }
      var open = accOpen === i;
      row.classList.toggle('is-open', open);
      /* the lifted choice buttons belong to the OPEN panel — left in the header
         of a collapsed row they sat on top of the done check */
      if (!open) {
        var closedActs = row.querySelector('.np-e2-accrow__head .np-e2-colorhead__acts');
        if (closedActs) closedActs.parentNode.removeChild(closedActs);
      }
      var body = row.querySelector('[data-e2-accbody]');
      if (!body) return;
      body.hidden = !open;
      if (open) {
        renderStepBody(i, body, function () { accApply(i); });
        /* lift the colour-step choice buttons onto the ROW HEADER line — they
           are the widest thing in the panel and sitting them beside the label
           reclaims a whole row of vertical space. The header is itself the
           open/close click target, so the moved buttons must stop the click
           from bubbling or every press would collapse the row. */
        var actsA = body.querySelector('.np-e2-colorhead__acts');
        var headA = row.querySelector('.np-e2-accrow__head');
        var staleA = headA && headA.querySelector('.np-e2-colorhead__acts');
        if (staleA && staleA !== actsA) staleA.parentNode.removeChild(staleA);
        if (actsA && headA) {
          actsA.classList.add('np-e2-acts--inhead');
          actsA.addEventListener('click', function (eA) { eA.stopPropagation(); });
          headA.appendChild(actsA);
        }
        /* explicit stepping: each section ends with its own Continue — except
           the LAST one, where the big footer "Generate AI Proof" is the CTA */
        var nxC = stepAfter(i);
        /* shape needs a label too: it is usually the FIRST step, but on
           variant-sized products (keychains) the size option precedes it —
           without this the button read "Continue to undefined" */
        var STEP_LABELS = { shape: 'Shape', text: PTYPE.textLabel || 'Text Color', bg: (isFreeFormShape() ? 'Patch Color' : (PTYPE.bgLabel || 'Background Color')), border: 'Border Style', thread: PTYPE.threadLabel || 'Border Thread', backing: 'Backing', texture: 'Background Texture', proof: 'Your Proof Type', font: 'Font Style' };
        ['opt1', 'opt2', 'opt3'].forEach(function (kL) { var dL = optDef(kL); if (dL) STEP_LABELS[kL] = dL.name; });
        var has = !!st[WZ_STEPS[i]];
        if (WZ_STEPS[i] === 'shape' && cornersNeeded()) has = false;
        var cont = document.createElement('div');
        cont.className = 'np-e2-acc-cont';
        var inSlotC = row.parentElement && row.parentElement.id === 'np-e2-tt-fontslot';
        if (PTYPE.textLines && inSlotC && row === row.parentElement.lastElementChild) {
          cont.innerHTML = '<button type="button" class="np-e2-btn np-e2-btn--green np-e2-acc-cont__btn" data-e2-acctext="1"' + (has ? '' : ' disabled') + '>Continue to your lettering</button>';
        } else if (nxC !== -1) {
          var nxLbl = STEP_LABELS[WZ_STEPS[nxC]];
          /* the stitch picker sits between the colours and Backing — it is not
             an accordion row, so the hand-off names IT, not Backing */
          if (PTYPE.stitches && WZ_STEPS[nxC] === 'backing') nxLbl = 'Border stitch';
          cont.innerHTML = '<button type="button" class="np-e2-btn np-e2-btn--green np-e2-acc-cont__btn" data-e2-acccont="' + i + '"' + (has ? '' : ' disabled') + '>Continue to ' + nxLbl + '</button>';
        } else {
          /* last step: close up and hand off to the proof CTA — or, on a
             no-artwork type, straight to the names roster */
          /* Once the LAST step is answered the Generate AI Proof button (and
             its bypass line) is already showing right below — a second
             "Continue to Your Proof" is noise, so it only appears while the
             step is still unanswered (Justin 2026-08-21). Names types keep
             theirs: the roster is a separate destination, not the CTA. */
          if (has && !PTYPE.names) cont.innerHTML = '';
          else cont.innerHTML = '<button type="button" class="np-e2-btn np-e2-btn--green np-e2-acc-cont__btn" data-e2-accdone="1"' + (has ? '' : ' disabled') + '>Continue to ' + (PTYPE.names ? 'Your Names' : 'Your Proof') + '</button>';
        }
        body.appendChild(cont);
      }
      else body.innerHTML = '';
    });
    renderOptions();
  }
  function accApply(i) {
    /* instant commit — but STAY on this row; the Continue button advances */
    var wasLocked = heightLocked();
    var prevShape = st.shape;
    st.shape = st.draft.shape;
    var nowLocked = heightLocked();
    if (wasLocked && !nowLocked) {
      st.h = Math.max(SIZE_MIN, Math.round(st.w * st.ratio * 100) / 100);
    }
    if (st.shape !== prevShape && !nowLocked) {
      /* the PATCH defines the proportions, not the artwork — a Rectangle
         patch seeds rectangle numbers even when the logo is ultra-wide */
      var gA = shapeGeom();
      if (gA && gA !== 'custom') {
        var dA = shapeDims(gA);
        st.ratio = dA[1] / dA[0];
        st.h = clampSize(Math.round(st.w * st.ratio * 100) / 100, true);
      }
    }
    st.border = st.draft.border;
    st.bg = st.draft.bg;
    st.thread = st.draft.thread;
    st.backing = st.draft.backing;
    st.texture = st.draft.texture;
    st.text = st.draft.text;
    st.proof = st.draft.proof;
    st.font = st.draft.font;
    commitOptStep();
    /* 2 Layers -> 1 Layer: there is no underlay any more, so the outline colour
       is dropped from state AND from the order (a stale one would ship) */
    if (PTYPE.layersOpt && !twoLayers()) {
      st.thread = null;
      if (st.draft) st.draft.thread = null;
    }
    commitOptions();
    if (heightLocked()) st.h = st.w;
    commitSizeQty();
    /* font / layers / colour / SIZE changes all change how the lettering draws,
       and the size option drives the rulers — repaint, do not just re-read */
    if (PTYPE.textLines) ttSync();
    unapproveIfChanged();
    renderAccordion();
  }

  function applyDraft() {
    var wasLocked = heightLocked();
    st.shape = st.draft.shape;
    var nowLocked = heightLocked();
    if (wasLocked && !nowLocked) {
      /* back to a free shape: repopulate the proportional height from the
         image's own aspect ratio */
      st.h = Math.max(SIZE_MIN, Math.round(st.w * st.ratio * 100) / 100);
    }
    st.border = st.draft.border;
    st.bg = st.draft.bg;
    st.thread = st.draft.thread;
    st.backing = st.draft.backing;
    st.texture = st.draft.texture;
    st.text = st.draft.text;
    st.proof = st.draft.proof;
    commitOptStep();
    /* 2 Layers -> 1 Layer: there is no underlay any more, so the outline colour
       is dropped from state AND from the order (a stale one would ship) */
    if (PTYPE.layersOpt && !twoLayers()) {
      st.thread = null;
      if (st.draft) st.draft.thread = null;
    }
    commitOptions();
    if (heightLocked()) st.h = st.w;
    commitSizeQty();
    renderOptions();
    closeWizard();
    if (wzReturnToProof) {
      wzReturnToProof = false;
      pf.hidden = false;
      if (st.versions.length) { st.proofPhase = 'ready'; renderProofReady(); }
    } else if (!st.versions.length && st.shape && st.border && st.bg && st.thread && st.backing) {
      /* all set: the customer explicitly picks Generate AI Proof or Skip */
      var fB2 = document.getElementById('np-e2-proofbtn');
      if (fB2) { var yB2 = fB2.getBoundingClientRect().top + window.pageYOffset - npScrollPad() - 80; window.scrollTo({ top: Math.max(0, yB2), behavior: 'smooth' }); }
    }
  }

  /* ═══ PATCH-SENSEI PROOFING (the same backend Shinobi / the proof-
     preview page uses — see sections/proof-preview-v3.liquid).
     Contract: POST {EP}/api/proof/session {cart_token, line_items:[{
       line_item_id, title, quantity, artwork_url, specs:{shape,
       background_color, border_color, width_inches, height_inches, ...}}]}
     → {session_id, line_items:[{line_item_id, mockup_url, status
       pending|ready, decision, revision_count, revision_limit, error}]}
     GET {EP}/api/proof/session/{cartToken} to poll; POST
     {EP}/api/proof/decision {session_id, line_item_id, status, note}.
     The item must be IN the cart first (sessions are cart-token keyed).
     The canvas composite below stays as the offline fallback. ═══ */
  var SENSEI_EP = 'https://d14rzh04nceswa.cloudfront.net';
  var sensei = { sessionId: null, lineItemId: null, renderLineId: null, cartToken: null, added: false, busy: false };

  var npPutQ = Promise.resolve();
  function npPut(url, body, hdrs) {
    /* UPLOAD GATE (Justin 2026-08-24, B30): approval fires several multi-MB
       PNG uploads at once — they saturated the customer's upstream and the
       tiny /cart/add POST drowned behind them (server measured 0.4s while
       the browser waited 20s). All background PUTs now run ONE at a time,
       and hold completely while a checkout is in flight. */
    var run = function () { return fetch(url, hdrs ? { method: 'PUT', body: body, headers: hdrs } : { method: 'PUT', body: body }); };
    /* B52: the serial queue is GONE — it was built on the disproven
       saturation theory and became the bottleneck itself (sheet PNGs stuck
       for 30s behind multi-MB proof copies, beacon-proven). Browsers manage
       upload parallelism fine. */
    return run();
  }
  function coMark(n) {
    /* checkout sub-beacon: appends to the same localStorage timeline the
       doCheckout stages write — survives the /cart navigation */
    try { var t = Math.round(performance.now()); localStorage.setItem('np_co_log', (localStorage.getItem('np_co_log') || '') + n + '@' + t + 'ms | '); console.log('[np-e2] co', n, t + 'ms'); } catch (eM) {}
  }
  /* B76: wall-clock every cleanFetch cart call so np_co_log always has a
     number even when resource timing is unavailable. */
  function cfTimed(url, opts, tag) {
    var t0 = Date.now();
    return cleanFetch()(url, opts).then(function (r) {
      try { coMark('cf:' + tag + ':' + (Date.now() - t0) + 'ms:' + r.status); } catch (e) {}
      return r;
    }, function (e) {
      try { coMark('cf:' + tag + ':FAIL:' + (Date.now() - t0) + 'ms'); } catch (e2) {}
      throw e;
    });
  }
  function cleanFetch() {
    /* window.fetch AND XMLHttpRequest are WRAPPED by theme/app scripts on
       this store (measured 2026-08-24) — a wrapper can queue a /cart/add
       behind its own drawer re-renders for tens of seconds. Cart calls on
       the checkout path use a PRISTINE fetch from a hidden same-origin
       iframe that no wrapper has touched. Falls back to window.fetch. */
    try {
      if (cleanFetch.__f) return cleanFetch.__f;
      var ifr = document.createElement('iframe');
      ifr.setAttribute('aria-hidden', 'true');
      ifr.style.display = 'none';
      document.documentElement.appendChild(ifr); /* stays attached — removing it kills its realm */
      cleanFetch.__ifr = ifr;
      cleanFetch.__f = ifr.contentWindow.fetch.bind(window);
      return cleanFetch.__f;
    } catch (eCF) { return window.fetch.bind(window); }
  }
  function cartJson() { return cleanFetch()('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }

  function ourCartLine(cart) {
    /* Shopify RE-KEYS a cart line whenever its properties change, so a stored
       key goes stale after every /cart/change.js that touches properties.
       Match by key first, then by this session's artwork/proof fingerprint —
       and NEVER fall back to an arbitrary line (that clobbers other patches). */
    var items = (cart && cart.items) || [];
    var byKey = items.filter(function (it) { return (it.key || String(it.id)) === sensei.lineItemId; })[0];
    if (byKey) return byKey;
    var marks = [];
    var art = cleanUrl(artworkUrl());
    if (art) marks.push(art.split('/').pop().split('?')[0]);
    st.versions.forEach(function (x) { if (x.hosted) marks.push(String(x.hosted).split('/').pop().split('?')[0]); });
    marks = marks.filter(Boolean);
    if (!marks.length) return null;
    var hit = items.filter(function (it) {
      var blob = JSON.stringify(it.properties || {});
      return marks.some(function (m) { return blob.indexOf(m) > -1; });
    })[0];
    if (hit) sensei.lineItemId = hit.key || String(hit.id); /* re-key for later calls */
    return hit || null;
  }

  function curLineState() {
    /* fingerprint of what the CART LINE should hold — when the line already
       matches, the click has nothing left to write and can navigate at once.
       Includes an OPTIONS fingerprint (B43): an option flipped after approval
       must force the full sync, never ride the fast path with stale props. */
    var v = null; try { v = nearestVariant(); } catch (eV) {}
    var opts = '';
    try {
      opts = [st.shape, st.corners, st.border && st.border.label, st.bg && st.bg.label,
        st.thread && st.thread.label, st.text && st.text.label, st.backing && st.backing.label,
        st.texture && st.texture.label, st.font && st.font.label,
        (st.selected !== null && st.selected !== undefined && st.versions[st.selected]) ? (st.versions[st.selected].frozenProof || st.versions[st.selected].hosted || '') : ''
      ].map(function (xO) { return xO || ''; }).join('~');
    } catch (eO) {}
    return st.w.toFixed(2) + '|' + st.h.toFixed(2) + '|' + st.qty + '|' + ((v && v.id) || '') + '|' + opts;
  }
  function formPropsObject() {
    /* the SAME property set an add would carry — scraped from the prepared
       form, the single source of truth for order props */
    var form = document.querySelector('product-form.product-form form');
    if (!form) return null;
    var o = {};
    try {
      new FormData(form).forEach(function (vF, kF) {
        var mF = /^properties\[(.+)\]$/.exec(kF);
        if (mF && typeof vF === 'string' && vF.trim() !== '') o[mF[1]] = vF;
      });
    } catch (eFP) { return null; }
    return o;
  }
  function mergedOrderProps() {
    /* B51: outgoing REPLACE-writes merge the line snapshot with the form —
       late-arriving props (the _Mockup Catalog copy lands only after its
       upload) can never be raced off the order again */
    var base = {};
    try { var sp = (sensei.__lineSnap && sensei.__lineSnap.props) || {}; Object.keys(sp).forEach(function (k) { base[k] = sp[k]; }); } catch (eM1) {}
    var f = formPropsObject() || {};
    Object.keys(f).forEach(function (k) { base[k] = f[k]; });
    return base;
  }
  function finalSyncFire() {
    /* B46 — THE checkout write: one read-free /cart/change built entirely
       from local state, aimed at the snapshot's line index. This store
       commits mutations the instant they arrive even when responses crawl
       (0.4s-32s measured), so firing IS finishing. Returns true when the
       composed spec sheets rode along. */
    if (!sensei.added || !sensei.__lineSnap) return false;
    try {
      commitOptions(); commitSizeQty();
      /* B54: the freshness token is computed BEFORE this function's own
         setProps/prune mutate the form — comparing across that boundary made
         the token drift on EVERY click and forced a pointless recompose. */
      var pre = sensei.__preSheets, dkN = null;
      try { dkN = specDkToken(specLines(specFormProps())); } catch (eDk2) {}
      var complete = !!(pre && (pre.aiBase ? pre.ai : true) && (pre.upBase ? pre.up : true) && (pre.ai || pre.up));
      var withSheets = !!(pre && dkN && complete && pre.dk === dkN);
      if (!withSheets && complete && pre && pre.wh === (st.w.toFixed(2) + 'x' + st.h.toFixed(2))) {
        withSheets = true; /* near-fresh: sizes match; a sheet beats no sheet */
        try { coMark('sheets-nearfresh'); } catch (eNf) {}
      }
      if (digitalNoRender()) setProp('_AI Proof', '');
      setProp('_Proof Approval', proofApprovalLabel());
      var avF = (st.proofApproved && st.selected !== null && st.selected !== undefined) ? st.versions[st.selected] : null;
      if (avF && !avF.digital && (avF.frozenProof || avF.hosted)) setProp('_AI Proof', avF.frozenProof || avF.hosted);
      if (avF && (avF.alpha || avF.hosted)) setProp('_cartImg', digitalCartUrl(avF.alpha || avF.hosted));
      pruneLegacyProps();
      var props = mergedOrderProps();
      if (!Object.keys(props).length) return false;
      props['_Width (in)'] = st.w.toFixed(2);
      props['_Height (in)'] = st.h.toFixed(2);
      if (withSheets) {
        if (pre.ai && !digitalNoRender()) props['_AI Proof'] = pre.ai;
        var upF = pre.up || pre.ai;
        if (upF) props['_Upload'] = upF;
        sensei.__sheetsFiredDk = dkN;
      }
      props = orderPropsObj(props);
      /* B62 PRICE INTEGRITY: /cart/change.js CANNOT change a variant. The line
         is created at generate/skip time on the seeded size, so a customer who
         sizes up crossed a variant boundary and kept the OLD price (a 6.09"
         patch billed as 2.5"). When the variant must change, ADD the correct
         one first, then zero the old line — never the other way round. */
      var vWant = null;
      try { vWant = nearestVariant(); } catch (eVW) {}
      if (vWant && sensei.__lineVariant && String(vWant.id) !== String(sensei.__lineVariant)) {
        coMark('variant-swap:' + sensei.__lineVariant + '->' + vWant.id);
        var fdV = new FormData();
        fdV.set('id', String(vWant.id));
        fdV.set('quantity', String(st.qty));
        Object.keys(props).forEach(function (kV) { fdV.set('properties[' + kV + ']', props[kV] == null ? '' : props[kV]); });
        var oldLine = sensei.__lineSnap.line;
        sensei.__lineVariant = String(vWant.id);
        sensei.__swapBusy = cleanFetch()('/cart/add.js', { method: 'POST', body: fdV, credentials: 'same-origin' })
          .then(function () {
            return cleanFetch()('/cart/change.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
              body: JSON.stringify({ line: oldLine, quantity: 0 })
            });
          })
          .then(function (r) { return r.json(); })
          .then(function (c3) {
            try {
              var mine3 = ourCartLine(c3);
              if (mine3) sensei.__lineSnap = { line: (c3.items || []).indexOf(mine3) + 1, props: mine3.properties || {} };
              coMark('variant-swapped');
            } catch (eS3) {}
            sensei.__swapBusy = null;
          }).catch(function () { sensei.__swapBusy = null; });
        return withSheets;
      }
      coMark(withSheets ? ('final-fire+sheets:dk' + dkN) : ('final-fire:dk' + dkN + (pre ? '/pre' + pre.dk : '/nopre')));
      cleanFetch()('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
        body: JSON.stringify({ line: sensei.__lineSnap.line, quantity: st.qty, properties: props })
      }).then(function (r) { return r.json(); }).then(function (c2) {
        try {
          var mine = ourCartLine(c2);
          if (mine) sensei.__lineSnap = { line: (c2.items || []).indexOf(mine) + 1, props: mine.properties || {} };
          coMark('final-landed');
        } catch (eFl) {}
      }).catch(function () {});
      return withSheets;
    } catch (eFF) { return false; }
  }
  var addPromise = null;
  function ensureInCart() {
    /* Add DIRECTLY via /cart/add.js with the form's own fields. The legacy
       add-to-cart click chain carries redirects and a location.reload() on
       its error path (resetLoading) — that was the post-generation white
       screen. Direct add sidesteps every legacy side effect.
       MEMOIZED: concurrent callers share ONE in-flight add — a second click
       during the alpha wait was creating a duplicate cart line. */
    if (sensei.added) return Promise.resolve(null); /* callers re-read via syncCartLine when needed — the extra cartJson cost 0.3-12s per click */
    if (addPromise) return addPromise;
    addPromise = ensureInCartNow();
    addPromise.then(function () { addPromise = null; }, function () { addPromise = null; });
    return addPromise;
  }
  function proofApprovalLabel() {
    /* every order carries _Proof Approval: how this patch's proof was settled.
       Stitchout outranks the rest — a paid physical sample means production
       waits on it. PENDING REVISIONS outrank an approval: once notes are filed
       for the specialist, the customer is NOT ordering the render as-is. */
    if (st.stitchAddon && stitchAddonEligible()) return 'Stitchout Needed';
    if (/REVISIONS REQUESTED/i.test(formProp('_AI Proof Status') || '')) return 'Submitted with Revisions';
    if (st.proofApproved) {
      var vP = (st.selected !== null && st.selected !== undefined) ? st.versions[st.selected] : st.versions[st.versions.length - 1];
      return (vP && vP.digital) ? 'Digital Proof Approved' : 'AI Proof Approved';
    }
    return 'Submitted with Revisions';
  }
  function keepTypeActive() {
    /* "Keep this patch type" is FINAL for this artwork (Justin 2026-08-24):
       no re-nag from the re-arm when bg-remove/crop merely change the src
       params. A genuinely different upload re-arms the detector. */
    if (!st.__keepArtBase) return false;
    return (cleanUrl(artworkUrl()) || '').split('?')[0] === st.__keepArtBase;
  }
  function digitalNoRender() {
    /* the attached proof is a DIGITAL preview (no AI render) — such orders
       must not carry _AI Proof at all (Justin 2026-08-24) */
    var vD = (st.selected !== null && st.selected !== undefined) ? st.versions[st.selected] : (st.versions.length ? st.versions[st.versions.length - 1] : null);
    return !!(vD && vD.digital);
  }
  function pdpPricingOn() { return NP_PDP_PRICING && document.body.classList.contains('np-e2-pdp-pricing'); }
  function mountPdpPricing() {
    var card = document.getElementById('np-e2-step-pricing');
    var slot = document.getElementById('np-e2-pricing-slot');
    var pane = document.getElementById('np-e2-pf-sizing');
    var footSlot = document.getElementById('np-e2-proof-options');
    var optsFoot = document.querySelector('#np-e2-step-options .np-e2-optfoot');
    if (!card || !slot || !pane) return;
    if (!slot.contains(pane)) slot.appendChild(pane);
    if (optsFoot && footSlot && !footSlot.contains(optsFoot)) footSlot.appendChild(optsFoot);
    var skipL = document.getElementById('np-e2-skipproof');
    if (skipL) skipL.textContent = 'Skip AI Proof, Continue with Digital Preview';
    var apH = document.getElementById('np-e2-approved');
    if (apH && !document.getElementById('np-e2-final-head')) {
      var fh = document.createElement('header');
      fh.className = 'np-e2-stephead';
      fh.id = 'np-e2-final-head';
      fh.innerHTML = '<div class="np-e2-stephead__left"><span class="np-e2-eyebrow">FINAL STEP</span><h2 class="np-e2-title">Review and Submit Your Patch Order</h2></div>';
      apH.insertBefore(fh, apH.firstChild);
    }
    document.body.classList.add('np-e2-pdp-pricing');
    card.hidden = false;
    pane.hidden = false;
    /* the stage mirrors the LIVE digital preview until a proof is approved —
       debounced + async-decoded so option clicks never wait on the copy */
    (function () {
      var mirrorT = null;
      var mirror = function () {
        clearTimeout(mirrorT);
        mirrorT = setTimeout(function () {
          if (st.proofApproved || st.versions.length) return;
          var pv = document.querySelector('.np-e2-maskprev img');
          var szI = document.getElementById('np-e2-sz-img');
          if (pv && pv.src && szI && szI.src !== pv.src) { szI.decoding = 'async'; szI.src = pv.src; }
        }, 250);
      };
      var host = document.getElementById('np-e2-canvas');
      if (host) new MutationObserver(mirror).observe(host, { attributes: true, subtree: true, attributeFilter: ['src'] });
      setTimeout(mirror, 800);
    })();
    /* ── STICKY CUMULATIVE-DISCOUNTS RAIL (right column) ── */
    (function () {
      var main = document.querySelector('.np-e2__main');
      if (!main || document.getElementById('np-e2-tier-rail')) return;
      var rail = document.createElement('aside');
      rail.className = 'np-e2-tierrail';
      rail.id = 'np-e2-tier-rail';
      rail.innerHTML = '<div class="np-e2-tierrail__head"><span>CUMULATIVE DISCOUNTS</span><b>Buy more, save up to 75%</b><i>Cumulative across every patch in your order.</i></div>' +
        '<div class="np-e2-tierrail__body">' +
          '<div class="np-e2-vol__row"><b id="np-e2-rail-count">10 pieces</b><span id="np-e2-rail-next"></span></div>' +
          '<div class="np-e2-vol__bar"><span id="np-e2-rail-fill"></span></div>' +
          '<div class="np-e2-vol__scale" id="np-e2-rail-scale"></div>' +
          '<div class="np-e2-vol__rows" id="np-e2-rail-rows"></div>' +
        '</div>';
      main.appendChild(rail);
      var railT = null;
      var syncRail = function () {
        clearTimeout(railT);
        railT = setTimeout(function () {
          var pairs = [['np-e2-vol-count', 'np-e2-rail-count'], ['np-e2-vol-next', 'np-e2-rail-next'], ['np-e2-vol-scale', 'np-e2-rail-scale'], ['np-e2-vol-rows', 'np-e2-rail-rows']];
          pairs.forEach(function (pr) {
            var src2 = document.getElementById(pr[0]), dst = document.getElementById(pr[1]);
            if (src2 && dst && dst.innerHTML !== src2.innerHTML) dst.innerHTML = src2.innerHTML;
          });
          var fS = document.getElementById('np-e2-vol-fill'), fD = document.getElementById('np-e2-rail-fill');
          if (fS && fD) fD.style.width = fS.style.width;
        }, 150);
      };
      var volHost = document.querySelector('.np-e2-vol--modal');
      if (volHost) new MutationObserver(syncRail).observe(volHost, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['style'] });
      setTimeout(syncRail, 600);
    })();
    try { renderSizing(); } catch (ePS) {}
  }
  function artOfRecord() {
    /* the SELECTED version's creation-time capture is the first authority —
       approving an older version after an art swap must record THAT art.
       Then the latest render capture; the live (clobber-prone) input last. */
    var vR = (st.selected !== null && st.selected !== undefined) ? st.versions[st.selected] : null;
    var vu = vR && cleanUrl(vR.artUsed || '');
    if (vu && isUploadLineage(vu)) return vu;
    var rec = cleanUrl(sensei.artAtRender || '');
    if (st.versions.length && rec && isUploadLineage(rec)) return rec;
    return cleanUrl(artworkUrl());
  }
  function ensureInCartNow() {
    commitOptions(); commitSizeQty();
    if (digitalNoRender()) setProp('_AI Proof', ''); /* a digital order never carries an AI proof */
    /* A/B rollout attribution (Justin 2026-08-24): every AI-mode order
       records which engine rendered it — 'Nano 2' on the staging theme's
       nb2 generator, 'Open AI' on the PatchSensei lane. Hidden underscore
       property (invisible in cart/checkout, visible in order admin); a
       Shopify Flow can tag the order from it. */
    try { setProp('_AI Model', genActive() ? 'Nano 2' : 'Open AI'); } catch (eAM2) {}
    setProp('_Proof Approval', proofApprovalLabel());
    /* cart thumbnail contract: the APPROVED AI PROOF is the cart image —
       the upload is only the placeholder when no proof was ever approved
       (Add to Cart runs AFTER approval now, so never clobber the proof) */
    var art = artOfRecord();
    /* order-admin contract: _Upload = the customer's COMPOSED digital patch
       (shape + colors + merrow preview), _Original Image = the raw upload,
       _AI Proof = the approved render (set at approval) */
    var composedUp = sensei.composedCleanUrl || '';
    if (composedUp || art) setProp('_Upload', toImgixHost(composedUp || art));
    var rawBase = (art || '').split('?')[0].split('&')[0];
    if (rawBase) setProp('_Original Image', rawBase);
    var prevImg = sensei.composedCleanUrl || (art ? applyToggleParams(art) : '');
    if (prevImg) setProp('_Preview Image', withMonoBackdrop(prevImg));
    var avc = (st.proofApproved && st.selected !== null && st.selected !== undefined) ? st.versions[st.selected] : null;
    /* diagnostic: what image contract goes on this add */
    try { console.log('[np-e2] add-time _cartImg source', { alpha: avc && avc.alpha, frozen: avc && avc.frozenProof, hosted: avc && avc.hosted, clean: sensei.composedCleanUrl, comp: sensei.composedUrl }); } catch (eLg) {}
    var proofImg = (avc && !avc.fallbackUpload)
      ? (avc.alpha || avc.frozenProof || avc.hosted || sensei.composedCleanUrl || '')
      : (formProp('_AI Proof') || sensei.composedCleanUrl || '');
    if (proofImg) proofImg = digitalCartUrl(proofImg);
    if (proofImg) setProp('_cartImg', proofImg);
    if (!st.proofApproved && !PTYPE.noArt) {
      /* submitted WITHOUT approving a render: flag it and carry the revisions */
      setProp('_AI Proof Status', 'PROOF NOT APPROVED - see revision notes');
      var revN = formProp('_Revision Notes') || '';
      if (revN) setProp('_AI Proof Revisions', revN);
      if (!proofImg && art) setProp('_cartImg', digitalCartUrl(art));
    }
    /* B46: sheets ready at add time ride the ADD itself — one atomic write */
    var sheetsRode = false;
    try {
      var preA = sensei.__preSheets;
      var dkA = specDkToken(specLines(specFormProps()));
      var freshDk = (preA && sensei.__clickDk && preA.dk === sensei.__clickDk);
      if (preA && (preA.ai || preA.up) && ((dkA && preA.dk === dkA) || freshDk)) {
        if (preA.ai && !digitalNoRender()) setProp('_AI Proof', preA.ai);
        var upA = preA.up || preA.ai;
        if (upA) setProp('_Upload', toImgixHost(upA));
        sensei.__sheetsFiredDk = dkA;
        sheetsRode = true;
        try { coMark('sheetsapplied[' + (freshDk && preA.dk !== dkA ? 'fresh-click' : 'dk-match') +
                     '|ai:' + (preA.ai ? 'y' : 'n') + '|up:' + (preA.up ? 'y' : 'n') + ']'); } catch (eSa) {} /* B96: the SHEET owns _AI Proof/_Upload — do not overwrite below */
      }
    } catch (eAS) {}
    /* C12 (2026-08-25) — SEND IMGIX URLS, NOT RAW S3. Justin spotted _Upload
       arriving as ninja-services-production-ninjauploadss3bucket-….s3.amazonaws.com
       while _Original Image and _cartImg beside it were ninjauploads-production
       .imgix.net. toImgixHost() already rewrites exactly that host but was not
       applied at these write sites, so whichever source won (a raw upload path,
       or the C07 empty-field fallback) could ship the S3 form. That is why the
       value wrapped onto its own line in the order admin — the S3 hostname is
       far longer — and it breaks the contract that _Upload is the previewed
       imgix render. Harmless on values already on imgix: the regex simply does
       not match. ═══ B95 (2026-08-25) — WRITE THE FINAL IMAGE INTO THE ADD ═══
       The authoritative image contract (_Upload / _AI Proof / _Original Image /
       _cartImg / _Preview Image) used to be stamped by lineSync() 400ms AND
       2600ms AFTER the add. That was invisible while adds took 15 seconds, but
       the add now completes in 663ms and we leave for /cart immediately, so the
       late passes never land and the cart line shows an unfinished thumbnail
       (Justin, 2026-08-25: "this shows as a broken image because we are moving
       so fast now"). Compute it BEFORE the add so the line is correct the moment
       it is created — one atomic write, no race. The post-add lineSync stays as
       a harmless safety net for anything that hosts late. */
    try {
      var artP = artOfRecord();
      var compP = sensei.composedCleanUrl || '';
      if (!sheetsRode && (compP || artP)) setProp('_Upload', toImgixHost(compP || artP));
      var rawP = (artP || '').split('?')[0].split('&')[0];
      if (rawP) setProp('_Original Image', toImgixHost(rawP));
      var avP = (st.proofApproved && st.selected !== null && st.selected !== undefined) ? st.versions[st.selected] : null;
      /* C10 (2026-08-25, Justin): "make sure the specs write to _Upload and
         _Mockup Catalog when a digital proof is approved". _Upload already gets
         the composed sheet via the sheet-ride block above; _Mockup Catalog was
         still taking the BARE frozen proof, so production saw specs on one and
         not the other. Prefer the sheet, fall back to the frozen proof when no
         sheet composed (spec sheets off, or a compose that timed out) so the
         catalog copy is never empty. */
      if (avP && avP.digital) {
        var pS = sensei.__preSheets;
        var mcSheet = (sheetsRode && pS) ? String(pS.up || pS.ai || '') : '';
        var mcVal = mcSheet || avP.frozenProof || '';
        if (mcVal) { setProp('_Mockup Catalog', mcVal); coMark('mcat:' + (mcSheet ? 'sheet' : 'frozen')); }
      }
      else if (!sheetsRode && avP && (avP.frozenProof || avP.hosted)) setProp('_AI Proof', avP.frozenProof || avP.hosted);
      var ciP = '';
      if (avP && !avP.fallbackUpload && (avP.alpha || avP.frozenProof || avP.hosted)) ciP = avP.alpha || avP.frozenProof || avP.hosted;
      else if (compP) ciP = compP;
      if (ciP) {
        var ciUrl = digitalCartUrl(ciP);
        setProp('_cartImg', ciUrl);
        /* B98 (2026-08-25, Justin's idea) — WARM THE CART THUMBNAIL. We already
           know the exact URL /cart will request, and we are about to spend
           ~500ms waiting on sheets and ~470ms on the add. Start the image
           fetch now so the cart paints it from cache instead of blank-then-pop.
           Fire and forget: it can only help, and a failure changes nothing. */
        try { var pw = new Image(); pw.decoding = 'async'; pw.src = ciUrl; } catch (ePw) {}
      }
      if (compP) setProp('_Preview Image', compP);
      /* B96 (2026-08-25) — DO NOT CLOBBER THE SPEC SHEET. B95 set _AI Proof and
         _Upload from the raw render, but it runs AFTER the block that stamps the
         COMPOSED SHEET onto those same two properties, so it overwrote the sheet
         every time. Justin caught it: _AI Proof came back 1536x1024 (raw render
         dimensions) instead of a composed sheet. `sheetsRode` records whether the
         sheet claimed those props; the image contract now fills only what the
         sheet did not. _cartImg is still always ours — that one is the thumbnail,
         not the proof of record. */
      coMark('imgprops[cartImg:' + (ciP ? 'set' : 'MISSING') + '|comp:' + (compP ? 'y' : 'n') +
             '|sheets:' + (sheetsRode ? 'RODE' : 'not-ready') + ']');
      /* B98: 'not-ready' is too blunt — say WHICH gate failed. */
      if (!sheetsRode) {
        try {
          var pD = sensei.__preSheets;
          var dkNow = specDkToken(specLines(specFormProps()));
          coMark('sheetgate[pre:' + (pD ? 'y' : 'NONE') +
                 '|dkMatch:' + (pD && pD.dk === dkNow ? 'y' : 'n') +
                 '|ai:' + (pD && pD.ai ? 'y' : 'n') +
                 '|up:' + (pD && pD.up ? 'y' : 'n') + ']');
          /* C01: name the drifting field */
          if (pD && pD.snap && pD.dk !== dkNow) {
            var nowP = specFormProps(), diffs = [];
            var seen = {};
            Object.keys(pD.snap).forEach(function (k) { seen[k] = 1; });
            Object.keys(nowP).forEach(function (k) { seen[k] = 1; });
            Object.keys(seen).forEach(function (k) {
              var a = String(pD.snap[k] === undefined ? '(absent)' : pD.snap[k]);
              var b = String(nowP[k] === undefined ? '(absent)' : nowP[k]);
              if (a === b) return;
              var trim = function (v) { return v.indexOf('://') > -1 ? ('url:' + v.split('/').pop().split('?')[0].slice(-22)) : v.slice(0, 22); };
              diffs.push(k.replace(/^_+/, '') + ':' + trim(a) + '=>' + trim(b));
            });
            coMark('dkdrift[' + (diffs.length ? diffs.slice(0, 5).join(' ; ') : 'NO-PROP-DIFF(token inputs read outside form)') + ']');
            /* C03: which COMPONENT of the token moved? */
            try {
              if (pD.dbg) {
                var oIn = document.querySelector('input[name="properties[_Original Image]"]');
                var nowDbg = {
                  a: oIn ? String(oIn.value || '').split('?')[0].slice(-28) : '(none)',
                  w: String((st && st.w) || ''),
                  h: String((st && st.h) || ''),
                  l: specLines(nowP).map(function (l) { return l.join(':'); }).join(';')
                };
                var parts = [];
                if (pD.dbg.a !== nowDbg.a) parts.push('ART');
                if (pD.dbg.w !== nowDbg.w) parts.push('W:' + pD.dbg.w + '=>' + nowDbg.w);
                if (pD.dbg.h !== nowDbg.h) parts.push('H:' + pD.dbg.h + '=>' + nowDbg.h);
                if (pD.dbg.l !== nowDbg.l) {
                  var oldL = pD.dbg.l.split(';'), newL = nowDbg.l.split(';');
                  var only = oldL.filter(function (x) { return newL.indexOf(x) < 0; })
                    .concat(newL.filter(function (x) { return oldL.indexOf(x) < 0; }))
                    .map(function (x) { return x.split(':')[0]; });
                  parts.push('LINES[' + only.slice(0, 4).join(',') + ']');
                }
                coMark('dkpart[' + (parts.length ? parts.join(' ; ') : 'IDENTICAL?!') + ']');
              }
            } catch (eDp) {}
          }
        } catch (eSg) {}
      }
    } catch (eFP) {}
    /* ═══ C07 (2026-08-25) — NEVER SHIP AN EMPTY _Upload / _cartImg ═══
       Live order 2107222 (Classic mode) arrived with _Original Image populated
       but _Upload and _cartImg EMPTY. Those have different writers: our code
       stamps _Original Image at click, while custom-uploader.js writes _Upload
       when its own processing finishes. Add-to-Cart used to take 13-20s, which
       always gave that write time to land; at ~600ms a fast customer can now
       beat it. Production cannot receive a line with no artwork on it.
       This ONLY fills a field that is already empty, so it can never overwrite
       a good value, and it prefers the most faithful source available. */
    try {
      var upEl = document.querySelector('input[name="properties[_Upload]"]');
      if (upEl && !String(upEl.value || '').trim()) {
        var oiEl = document.querySelector('input[name="properties[_Original Image]"]');
        var fbU = String(window.__npLastUploadedFilePath || '') ||
                  (oiEl ? String(oiEl.value || '') : '') ||
                  String(artOfRecord() || '');
        if (fbU) { setProp('_Upload', toImgixHost(fbU)); coMark('FALLBACK:_Upload'); }
      }
      var ciEl = document.querySelector('input[name="properties[_cartImg]"]');
      if (ciEl && !String(ciEl.value || '').trim()) {
        var upNow = document.querySelector('input[name="properties[_Upload]"]');
        var fbC = upNow ? String(upNow.value || '') : '';
        if (fbC) { setProp('_cartImg', digitalCartUrl(fbC)); coMark('FALLBACK:_cartImg'); }
      }
    } catch (eFb) {}
    pruneLegacyProps();
    orderProps();
    var form = document.querySelector('product-form.product-form form');
    if (!form) return Promise.reject(new Error('form missing'));
    try { stampOrderMode(); } catch (eOMF) {}
    var fd = new FormData(form);
    fd.set('quantity', String(st.qty));
    var vid = nearestVariant();
    if (vid) fd.set('id', String(vid.id));
    /* ═══ C11 (2026-08-25) — THE VARIANT MUST AGREE WITH THE SIZE ON THE LINE ═══
       Live: a line carried _Width 2.69 x _Height 3.00 (mean 2.845, so a 3"
       patch) while the VARIANT charged was 2". Both are normally written by
       selectNearestVariant2 from the same two inputs, so they only diverge when
       the size moves after the variant was chosen — and every such path is a
       silent undercharge. Rather than chase each one, enforce the rule where it
       actually matters: at the add.
       Justin's rule, verbatim: "its width + height / 2 and then we always round
       up to the next variant. so 2+3 = 5/2 = 2.5 that would be patch size 2.5
       but if it was 2.5+3 /2 = 2.75 that would be patch size 3 for pricing."
       `mean <= num` on an ascending list honours an exact match and otherwise
       takes the next size up, which is exactly that. Reads the properties that
       SHIP, so it is correct for Classic and AI alike. */
    try {
      /* C14 (2026-08-25) — READ THE BUILDER'S OWN SIZE, NOT THE FIRST MATCH IN
         THE DOCUMENT. document.querySelector returns the FIRST
         properties[_Width (in)] on the page, and custom-uploader.js PREPENDS its
         own hidden width/height inputs to the product form
         (setWidthHeightProperties2). On an AI order that made this guard read
         the legacy widget's stale numbers and "correct" the variant to a wildly
         wrong one — measured live: builder showed 3.00 x 2.24 (mean 2.62 -> 3"
         at $8.05) while the cart line came through at $26.07, the 8.5" variant.
         In AI mode st.w/st.h ARE the size of record and are what the displayed
         price is computed from, so use them; only fall back to the form inputs
         (scoped to THIS form, not the document) when the builder has no size. */
      var wV = NaN, hV = NaN;
      if (isFinite(st.w) && st.w > 0 && isFinite(st.h) && st.h > 0) {
        wV = st.w; hV = st.h;
      } else {
        var wEl = form.querySelector('input[name="properties[_Width (in)]"], input[name="properties[Width (in)]"]');
        var hEl = form.querySelector('input[name="properties[_Height (in)]"], input[name="properties[Height (in)]"]');
        wV = wEl ? parseFloat(wEl.value) : NaN;
        hV = hEl ? parseFloat(hEl.value) : NaN;
      }
      if (isFinite(wV) && isFinite(hV) && wV > 0 && hV > 0) {
        var meanV = Math.round(((wV + hV) / 2) * 100) / 100;
        var vList = (CFG.variants || []).map(function (vC) {
          return { id: vC.id, num: parseFloat(String(vC.opt1).replace(/[^0-9.]/g, '')) };
        }).filter(function (vC) { return !isNaN(vC.num); }).sort(function (a, b) { return a.num - b.num; });
        var want = null;
        for (var iV = 0; iV < vList.length; iV++) { if (meanV <= vList[iV].num) { want = vList[iV]; break; } }
        if (!want && vList.length) want = vList[vList.length - 1];
        if (want && String(fd.get('id') || '') !== String(want.id)) {
          coMark('VARIANT-FIX:' + meanV + '=>' + want.num);
          fd.set('id', String(want.id));
        }
        /* C14 — and make the SIZE on the line agree with the size we just
           priced from. setProp writes into the options app's / legacy widget's
           input when one exists, and custom-uploader.js's
           setWidthHeightProperties2 keeps rewriting that SAME input on its own
           interval, so the value riding to the cart is whoever wrote last.
           fd.set replaces every entry of that name with one value, so this both
           wins the race and collapses any duplicate field. Size & Pricing is
           the only source for width, height and the priced variant. */
        if (isFinite(st.w) && st.w > 0 && isFinite(st.h) && st.h > 0) {
          if (fd.has('properties[_Width (in)]')) fd.set('properties[_Width (in)]', st.w.toFixed(2));
          if (fd.has('properties[_Height (in)]')) fd.set('properties[_Height (in)]', st.h.toFixed(2));
          if (fd.has('properties[Width (in)]')) fd.set('properties[Width (in)]', st.w.toFixed(2));
          if (fd.has('properties[Height (in)]')) fd.set('properties[Height (in)]', st.h.toFixed(2));
        }
      }
    } catch (eVv) {}
    rememberMode('ai'); /* mode memory follows the last ADD TO CART */
    /* B78 (2026-08-25) — MEASURE THE POST BODY. Justin's adds run 5.4s-13.7s with
       only ~70ms of our code; the whole cost is this one request. A bare JSON
       /cart/add.js in the same browser runs ~650ms, so the suspect is payload
       size: FormData(form) serializes EVERY field in the product form, including
       any file input or data: URL still sitting in a hidden property. */
    try {
      var fdB = 0, fdF = 0, fdBig = '';
      fd.forEach(function (v, k) {
        var n = String(k).length;
        if (v && typeof v === 'object' && typeof v.size === 'number') { n += v.size; fdF++; }
        else n += String(v).length;
        fdB += n;
        if (n > 51200) fdBig += (fdBig ? ',' : '') + String(k).slice(0, 28) + ':' + Math.round(n / 1024) + 'kb';
      });
      coMark('body[' + Math.round(fdB / 1024) + 'kb|files:' + fdF + (fdBig ? '|big:' + fdBig : '') + ']');
    } catch (eFB) {}
    try { window.__npAdding = true; } catch (eA1) {}
    coMark('add-pre');
    /* B82 (2026-08-25) — IS IT THE NETWORK, OR A JAMMED MAIN THREAD?
       Every isolated piece measures fast in Justin's own browser: /cart/add.js
       627ms, iframe realm 477ms, multipart 667ms, /cart/update.js 605ms. Yet the
       real add marks 5.4s / 13.7s / 18.9s. `add-resp` is marked in a .then()
       microtask, which CANNOT run while the main thread is busy — so a blocked
       thread is indistinguishable from a slow response at this mark. This
       100ms sampler measures the largest gap between ticks during the add: a
       gap near the total means the thread was jammed (our problem to fix), a
       small gap means the response genuinely took that long (Shopify's). */
    var mtLast = performance.now(), mtMax = 0, mtTicks = 0, mtWTicks = 0;
    var mtWall = Date.now(), mtVisPre = document.visibilityState;
    var mtT0 = performance.now(); /* B83: window start for the traffic census */
    /* B87 (2026-08-25) — HOW LONG WAS THE TAB ASLEEP? Every other explanation is
       now excluded by measurement: thread never blocked (longestTask 173ms over
       a 15.7s window), no sync XHR, no canvas work, no network, and the request
       itself runs 627-932ms in isolation. A frozen BACKGROUND tab is the only
       remaining thing that stops plain timers AND worker callbacks AND network
       at once. Justin clicks Add to Cart and then switches apps to message me,
       so the stopwatch keeps running while Chrome has the tab suspended. */
    var hidMs = 0, hidN = 0, hidStart = (document.visibilityState === 'hidden') ? performance.now() : 0;
    var onVisB87 = function () {
      if (document.visibilityState === 'hidden') { hidStart = performance.now(); hidN++; }
      else if (hidStart) { hidMs += performance.now() - hidStart; hidStart = 0; }
    };
    try { document.addEventListener('visibilitychange', onVisB87); } catch (eV) {}
    var cvPre = window.__npCv ? { tdu: window.__npCv.tdu, gid: window.__npCv.gid, nT: window.__npCv.nT, nG: window.__npCv.nG,
                                  xSync: window.__npCv.xSync, xSyncMs: window.__npCv.xSyncMs, xAsync: window.__npCv.xAsync,
                                  ltMax: 0, ltN: window.__npCv.ltN } : null;
    if (window.__npCv) { window.__npCv.ltMax = 0; window.__npCv.ltSrc = ''; }
    var mtIv = setInterval(function () {
      mtTicks++;
      var nMt = performance.now(), gMt = nMt - mtLast;
      if (gMt > mtMax) mtMax = gMt;
      mtLast = nMt;
    }, 100);
    /* worker clock in parallel: it keeps ticking when a THROTTLED tab freezes
       plain timers, so tick counts that disagree prove throttling rather than
       a jammed thread (mtblock[0ms] on Justin's 15.4s add meant the setInterval
       callback never fired ONCE, while the fetch .then microtask ran fine). */
    var mtWStop = false;
    var mtWArm = function () {
      if (mtWStop) return;
      try { npTick(function () { mtWTicks++; mtWArm(); }, 100); } catch (eW) {}
    };
    mtWArm();
    return cleanFetch()('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin' })
      .then(function (r) {
        try {
          clearInterval(mtIv); mtWStop = true;
          var mtEl = Date.now() - mtWall;
          /* expected ticks if nothing was throttled = elapsed/100 */
          coMark('mtblock[gap:' + Math.round(mtMax) + 'ms|timerTicks:' + mtTicks +
                 '|workerTicks:' + mtWTicks + '|expect:' + Math.round(mtEl / 100) +
                 '|vis:' + mtVisPre + '>' + document.visibilityState + ']');
          /* B83 (2026-08-25) — IS THE PIPE BUSY? Every ingredient of the add
             measures <1s from an idle console, but the real click takes 15s.
             The untested variable is what else is in flight at that moment:
             a small POST can queue behind megabytes of proof imagery. Census
             every resource that started during the add window. */
          try {
            var rEnt = performance.getEntriesByType('resource').filter(function (rr) { return rr.startTime >= mtT0 - 1000; });
            var rBytes = 0, rOpen = 0;
            rEnt.forEach(function (rr) { rBytes += (rr.transferSize || 0); if (!rr.responseEnd) rOpen++; });
            coMark('net[reqs:' + rEnt.length + '|kb:' + Math.round(rBytes / 1024) + '|unfinished:' + rOpen + ']');
            if (cvPre && window.__npCv) {
              coMark('cv[toDataURL:' + Math.round(window.__npCv.tdu - cvPre.tdu) + 'ms/' + (window.__npCv.nT - cvPre.nT) +
                     '|getImageData:' + Math.round(window.__npCv.gid - cvPre.gid) + 'ms/' + (window.__npCv.nG - cvPre.nG) +
                     '|alphaCut:' + (NP_ALPHA_CUT ? 'ON' : 'OFF') + ']');
              coMark('blk[syncXHR:' + (window.__npCv.xSync - cvPre.xSync) + '/' + Math.round(window.__npCv.xSyncMs - cvPre.xSyncMs) +
                     'ms|asyncXHR:' + (window.__npCv.xAsync - cvPre.xAsync) +
                     '|longestTask:' + Math.round(window.__npCv.ltMax) + 'ms|tasks:' + (window.__npCv.ltN - cvPre.ltN) +
                     '|from:' + (window.__npCv.ltSrc || '-') + ']');
            }
          } catch (eNet) {}
        } catch (eMt) {}
        try {
          if (hidStart) { hidMs += performance.now() - hidStart; hidStart = 0; }
          document.removeEventListener('visibilitychange', onVisB87);
          var totB87 = Math.round(performance.now() - mtT0);
          coMark('tabsleep[hidden:' + Math.round(hidMs) + 'ms|switches:' + hidN +
                 '|awake:' + Math.max(0, totB87 - Math.round(hidMs)) + 'ms|of:' + totB87 + 'ms]');
          if (window.__npTk) {
            var gz = window.__npTk.gaps.slice(-18).join(',');
            coMark('ticktrace[n:' + window.__npTk.n + '|last18gaps:' + gz + ']');
          }
          if (window.__npT) {
            var hp = '';
            try { if (performance.memory) hp = '|heapMB:' + Math.round(performance.memory.usedJSHeapSize / 1048576); } catch (eH) {}
            try {
              var srcArr = Object.keys(window.__npT.src || {}).map(function (k) { return [k, window.__npT.src[k]]; });
              srcArr.sort(function (a, b) { return b[1] - a[1]; });
              coMark('leakSRC[' + srcArr.slice(0, 4).map(function (x) { return x[0] + '=' + x[1]; }).join(' | ') + ']');
            } catch (eSrc) {}
            coMark('leak[intervalsMade:' + window.__npT.si + '|intervalsLive:' + window.__npT.siLive +
                   '|timeouts:' + window.__npT.st + '|listeners:' + window.__npT.ael +
                   '|observers:' + window.__npT.mo + '|domNodes:' + document.getElementsByTagName('*').length + hp + ']');
          }
        } catch (eV2) {}
        try { window.__npAdding = false; } catch (eA2) {}
        coMark('add-resp');
        try {
          var perfR = (cleanFetch.__ifr && cleanFetch.__ifr.contentWindow && cleanFetch.__ifr.contentWindow.performance) || performance;
          var eAdd = perfR.getEntriesByType('resource').filter(function (rr) { return /cart\/add\.js/.test(rr.name); }).pop();
          if (eAdd) coMark('addnet[queue:' + Math.round(eAdd.requestStart ? (eAdd.requestStart - eAdd.startTime) : -1) + '|srv:' + Math.round(eAdd.responseStart ? (eAdd.responseStart - (eAdd.requestStart || eAdd.startTime)) : -1) + '|dl:' + Math.round(eAdd.responseEnd - (eAdd.responseStart || eAdd.startTime)) + ']');
        } catch (eNp) {}
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || ('add failed ' + r.status)); });
        return null; /* body unused — awaiting its download cost 3.8s (measured) */
      })
      .then(function () {
        coMark('add-ok');
        sensei.added = true;
        try { sensei.__lineVariant = vid ? String(vid.id) : ''; } catch (eLV) {} /* B62: variant the LINE holds */
        try { sensei.__lineState = curLineState(); } catch (eLS1) {} /* the add carried FINAL qty/variant/props */
        var stitchP = null;
        if (st.stitchAddon && !st.__stitchCharged && stitchAddonEligible()) { st.__stitchCharged = true; stitchP = adjustStitchLine(1); }
        /* the legacy uploader's timers can clobber the hidden image inputs
           with THIS PRODUCT's previous upload right before the add (seen on
           converted-product arrivals: the cart line carried an OLD session's
           proof). Force-correct the image contract on the ACTUAL cart line. */
        (function () {
          var fix = {};
          var artF = artOfRecord();
          var compF = sensei.composedCleanUrl || '';
          if (compF || artF) fix['_Upload'] = compF || artF;
          var rawF = (artF || '').split('?')[0].split('&')[0];
          if (rawF) fix['_Original Image'] = rawF;
          var avF = (st.proofApproved && st.selected !== null && st.selected !== undefined) ? st.versions[st.selected] : null;
          if (avF && avF.digital) {
            /* C10: keep the late pass consistent with the pre-add write above —
               the sheet is the catalog copy of record on a digital order. */
            var pS2 = sensei.__preSheets;
            var mcS2 = (pS2 && (pS2.up || pS2.ai)) ? String(pS2.up || pS2.ai) : '';
            var mcV2 = mcS2 || avF.frozenProof || '';
            if (mcV2) fix['_Mockup Catalog'] = mcV2;
          }
          else if (avF && (avF.frozenProof || avF.hosted)) fix['_AI Proof'] = avF.frozenProof || avF.hosted;
          /* cart image = the AI proof, always; a FAILED generation falls back
             to the composed digital preview (border + fill), never raw art */
          if (avF && !avF.fallbackUpload && (avF.alpha || avF.frozenProof || avF.hosted)) fix['_cartImg'] = avF.alpha || avF.frozenProof || avF.hosted;
          else if (compF) fix['_cartImg'] = compF;
          if (fix['_cartImg']) fix['_cartImg'] = digitalCartUrl(fix['_cartImg']);
          if (compF) fix['_Preview Image'] = compF;
          setTimeout(function () { lineSync(fix); }, 400);
          /* second pass outlasts slow compose hosting + legacy timers */
          setTimeout(function () {
            var late = sensei.composedCleanUrl || '';
            if (late) {
              if (!fix['_cartImg'] || (avF && avF.digital && !avF.hosted)) fix['_cartImg'] = late;
              fix['_Preview Image'] = late;
              if (fix['_cartImg']) fix['_cartImg'] = digitalCartUrl(fix['_cartImg']);
            }
            lineSync(fix);
          }, 2600);
        })();
        var s3 = document.getElementById('np-e2-step-options');
        /* only the legacy interactive add may scroll — a BACKGROUND pre-add
           or a checkout-time add yanking the viewport was the mystery
           "keeps focusing to the bottom" (Justin 2026-08-24) */
        if (s3 && !commitSizeQty.__stamping && !coBusy) s3.scrollIntoView({ block: 'center' });
        /* checkout path skips the banked-pieces recount — syncCartLine reads
           the cart right after anyway (0.6s saved, measured) */
        return (stitchP || Promise.resolve()).then(function () { return coBusy ? null : cartJson(); });
      })
      .then(function (cart) {
        if (!cart) return null;
        /* PIECES banked in OTHER lines — exclude our own line by fingerprint
           (Shopify merges identical adds, so subtracting st.qty over-counts) */
        var mine = ourCartLine(cart);
        if (mine) sensei.__lineSnap = { line: (cart.items || []).indexOf(mine) + 1, props: mine.properties || {} }; /* B46: arms the read-free final sync */
        st.cart = Math.max(0, (cart.item_count || 0) - (mine ? mine.quantity : st.qty));
        return cart;
      });
  }

  function customerNotes() {
    var t = ($('#np-e2-change-text') ? $('#np-e2-change-text').value : '').trim();
    return t;
  }
  function normalizeBorder(label) {
    /* the sensei backend + production tooling parse the exact legacy BCPO
       strings — send those regardless of the CMS display label */
    var l = (label || '').toLowerCase();
    if (l.indexOf('merrow') > -1) return 'Merrow';
    if (l.indexOf('hot') > -1 || l.indexOf('embroider') > -1) return 'Embroidered / Hot Cut (Most Popular)';
    return label || '';
  }
  var SHAPE_DESC = {
    'shield': 'a badge/crest outline: flat top edge, sides curving down to a point at the bottom center',
    'heart': 'a classic heart symbol outline',
    'star': 'a five-point star outline',
    'rhombus': 'a diamond outline standing on a point',
    'hexagon': 'a six-sided hexagon outline',
    'oval': 'a vertical (tall) oval',
    'oval-h': 'a horizontal (wide) oval',
    'rectangle': 'a horizontal (wide) rounded rectangle',
    'rectangle-v': 'a vertical (tall) rounded rectangle'
  };
  /* ═══ TEXT PREVIEW (custom names) — the patch carries LETTERING, not an
     upload, so the "artwork" the composer places inside the shape is a
     canvas of the word rendered in the chosen font and thread colour. It is
     handed to the composer as a data URL, which means the shape, the merrow
     ring, the background fill and the safe-area fit all stay exactly the
     same code path every other patch type uses. ═══ */
  function nameFonts() { return CFG.fonts || []; }
  function nameFontStack(f) {
    return "'" + String((f && f.family) || 'sans-serif').replace(/['"\\]/g, '') + "', " + ((f && f.fallback) || 'sans-serif');
  }
  function nameBlockFont() {
    var nf = nameFonts();
    for (var i = 0; i < nf.length; i++) { if (!nf[i].script) return nf[i]; }
    return null;
  }
  function nameTileSample(f2) {
    /* script tiles preview the real treatment: BLOCK first letter, script rest */
    var sTxt = (f2 && f2.greekmap) ? ttGreekify(PTYPE.textPreview || 'NAME') : (PTYPE.textPreview || 'NAME');
    if (PTYPE.names && f2 && f2.script && sTxt.length > 1) {
      var bF = nameBlockFont();
      if (bF) return '<i style="font-style:normal;font-family:' + nameFontStack(bF) + ';font-weight:' + (bF.weight || 700) + '">' + sTxt.charAt(0) + '</i>' + sTxt.slice(1);
    }
    return sTxt;
  }
  function activeNameFont() { return st.font || nameFonts()[0] || { label: 'San Serif', family: 'sans-serif', weight: 700 }; }
  function nameInkHex() {
    /* the thread colour stitches the lettering AND the border; before it is
       picked the preview uses a neutral so the font is still legible */
    var c = st.text || st.thread; /* the text colour owns the lettering now */
    if (c && c.hex && c.label !== 'Let Ninja Choose' && c.label !== 'Not Sure') return c.hex;
    return '#0C0C0E';
  }
  var nameFontsLoaded = false, nameFontsP = null;
  function ensureNameFonts(cb) {
    /* CRITICAL: a canvas fillText that runs before the webfont file has
       loaded silently paints in the browser's default face and never
       repaints. Wait for the real faces, THEN draw. */
    if (!nameFontsP) {
      nameFontsP = new Promise(function (res) {
        if (!document.fonts || !document.fonts.load) { res(); return; }
        var jobs = nameFonts().map(function (f) {
          try { return document.fonts.load(((f && f.weight) || 700) + ' 400px ' + nameFontStack(f)); }
          catch (eNF) { return null; }
        }).filter(Boolean).map(function (p) { return p.catch(function () {}); });
        Promise.all(jobs)
          /* only the two lettering faces — chaining document.fonts.ready made
             the preview wait for every font on the page */
          .then(function () { res(); }, function () { res(); });
      });
    }
    nameFontsP.then(function () { nameFontsLoaded = true; cb(); }, function () { nameFontsLoaded = true; cb(); });
  }
  function twoLayers() {
    /* '2 Layers' on the layers option = an underlay showing as an outline */
    if (!PTYPE.layersOpt) return false;
    var vL = st['opt' + PTYPE.layersOpt];
    return !!(vL && /2/.test(String(vL.label || '')));
  }
  function ttLines() {
    var out = [];
    for (var iL = 1; iL <= (PTYPE.textLines || 3); iL++) {
      var elL = document.getElementById('np-e2-tt-l' + iL);
      var vT = elL ? String(elL.value || '').replace(/\s+/g, ' ').trim() : '';
      if (vT) out.push(vT);
    }
    return out;
  }
  /* the Symbol-font keyboard convention every Greek-merch shop uses:
     C=Chi, Q=Theta, W=Omega, X=Xi, Y=Psi — everything else is the obvious one */
  var GREEK_MAP = { A:'\u0391', B:'\u0392', C:'\u03A7', D:'\u0394', E:'\u0395', F:'\u03A6', G:'\u0393', H:'\u0397', I:'\u0399', K:'\u039A', L:'\u039B', M:'\u039C', N:'\u039D', O:'\u039F', P:'\u03A0', Q:'\u0398', R:'\u03A1', S:'\u03A3', T:'\u03A4', U:'\u03A5', V:'\u03A5', W:'\u03A9', X:'\u039E', Y:'\u03A8', Z:'\u0396', J:'\u0399' };
  function ttGreekify(str) {
    return String(str).toUpperCase().replace(/[A-Z]/g, function (ch) { return GREEK_MAP[ch] || ch; });
  }
  function ttFontIsScript() {
    var fS = activeNameFont();
    return !!(fS && (fS.script || /script/i.test(fS.label || '')));
  }
  function ttSwooshTextHex() {
    var c = st.swooshTextColor;
    if (c && c.hex) return c.hex;
    /* no pick yet: whichever of white/black reads on the tail's twill */
    var h = ttInk().replace('#', '');
    var lum = parseInt(h.slice(0, 2), 16) * 0.299 + parseInt(h.slice(2, 4), 16) * 0.587 + parseInt(h.slice(4, 6), 16) * 0.114;
    return lum > 140 ? '#0C0C0E' : '#FFFFFF';
  }
  function ttSwooshOn() {
    /* the tail exits the LAST line's baseline: straight or slanted both give
       it one — only an ARCH has no baseline to leave from */
    var nL = ttLines().length || 1;
    return !!(st.swoosh && ttFontIsScript() && !/arch/i.test(String(st['ttLay' + nL] || 'Straight')));
  }
  function ttInk() {
    var c = st.bg;
    return (c && c.hex && c.label !== 'Let Ninja Choose' && c.label !== 'Not Sure') ? c.hex : '#0C0C0E';
  }
  function ttEdge() {
    var c = st.thread;
    if (c && c.hex && c.label !== 'Let Ninja Choose' && c.label !== 'Not Sure') return c.hex;
    /* 2 Layers picked but no outline colour yet: show the second layer in WHITE
       as a placeholder, so the customer sees the underlay exists before they
       choose its colour */
    return '#FFFFFF';
  }
  var TT_ARCH = 0.42; /* half-angle of the arch, radians — a varsity curve */
  var TT_SLANT = 0.21; /* ~12 degrees, ascending to the right (Huskies look) */
  function ttGlyphs(x, txt, cx, baseY, mode) {
    /* mode: true|'arch' = arched, 'slant' = tilted line, anything else straight.
       NOTE it is a STRING now — a truthy 'straight' used to arch everything. */
    var arch = mode === true || mode === 'arch';
    var chars = String(txt).split('');
    var ws = chars.map(function (c) { return x.measureText(c).width; });
    var total = ws.reduce(function (a, b) { return a + b; }, 0) || 1;
    var out = [], s0 = 0, i;
    if (!arch) {
      for (i = 0; i < chars.length; i++) {
        out.push({ ch: chars[i], x: cx - total / 2 + s0 + ws[i] / 2, y: baseY, a: 0 });
        s0 += ws[i];
      }
      if (mode === 'slant') {
        /* rotate the finished line about its centre — letters lean WITH the
           baseline so the whole word tilts as one piece */
        var ca = Math.cos(-TT_SLANT), sa = Math.sin(-TT_SLANT);
        out.forEach(function (g) {
          var dx = g.x - cx, dy = g.y - baseY;
          g.x = cx + dx * ca - dy * sa;
          g.y = baseY + dx * sa + dy * ca;
          g.a = -TT_SLANT;
        });
      }
      return out;
    }
    var R = (total / 2) / Math.sin(TT_ARCH);
    for (i = 0; i < chars.length; i++) {
      var mid = s0 + ws[i] / 2;
      var th = ((mid - total / 2) / (total / 2)) * TT_ARCH;
      out.push({
        ch: chars[i],
        x: cx + R * Math.sin(th),
        y: baseY + R - R * Math.cos(th),
        a: th
      });
      s0 += ws[i];
    }
    return out;
  }
  function ttArchRise(x, txt) {
    /* how much taller an arched line is than a straight one */
    var total = String(txt).split('').reduce(function (a, c) { return a + x.measureText(c).width; }, 0) || 1;
    var R = (total / 2) / Math.sin(TT_ARCH);
    return R - R * Math.cos(TT_ARCH);
  }
  function ttPaintGlyphs(x, gs, mode, boostPx) {
    gs.forEach(function (g) {
      x.save();
      x.translate(g.x, g.y);
      if (g.a) x.rotate(g.a);
      if (mode === 'fill') {
        x.fillText(g.ch, 0, 0);
        /* faux weight: a stroke in the SAME colour thickens a light face to
           match the block font without redrawing its letterforms */
        if (boostPx) {
          var prevS = x.strokeStyle, prevW = x.lineWidth;
          x.strokeStyle = x.fillStyle; x.lineWidth = boostPx;
          x.strokeText(g.ch, 0, 0);
          x.strokeStyle = prevS; x.lineWidth = prevW;
        }
      } else x.strokeText(g.ch, 0, 0);
      x.restore();
    });
  }
  function ttBoost(PX) {
    var fB = activeNameFont();
    var bV = parseFloat((fB && fB.boost) || 0);
    return bV ? Math.max(1, PX * bV) : 0;
  }
  function ttBez(t, a, b, c, d) {
    var mt = 1 - t;
    return mt * mt * mt * a + 3 * mt * mt * t * b + 3 * mt * t * t * c + t * t * t * d;
  }
  function ttBezD(t, a, b, c, d) {
    var mt = 1 - t;
    return 3 * mt * mt * (b - a) + 6 * mt * t * (c - b) + 3 * t * t * (d - c);
  }
  function ttSwooshCtl(x0, x1, yBase, drop) {
    /* the classic varsity tail: dips under the block, sweeps up on the right */
    var sp = x1 - x0;
    return {
      xs: [x0, x0 + sp * 0.24, x0 + sp * 0.70, x1],
      ys: [yBase - drop * 0.30, yBase + drop * 0.92, yBase + drop * 0.92, yBase - drop * 0.62]
    };
  }
  /* ── the 13 stock swoosh tails ──────────────────────────────────────────
     Every style is a CENTERLINE (sampled points) + a WIDTH PROFILE + an
     optional edge modulation, so each renders in the customer's twill colour
     with the 2-layer outline, at any size. Numbers match the catalog sheet. */
  /* display numbers run 1-8 in order; `geo` is the internal geometry key
     (the old catalog case numbers — old orders keep rendering) */
  var TT_SWOOSHES = [
    { n: 1, geo: 1, name: 'Classic Tail' }, { n: 2, geo: 2, name: 'Hook Underline' },
    { n: 3, geo: 3, name: 'Tail Hook' }, { n: 4, geo: 5, name: 'Blade' },
    { n: 5, geo: 8, name: 'Double Wave' }, { n: 6, geo: 10, name: 'Long Hook' }
    /* #7 Wing removed 2026-08-19 (never matched the reference); ttSwooshDef
       falls back to Classic Tail for any session that still stores 7 */
  ];
  function ttSwooshDef(nS) {
    var n = parseInt(nS, 10) || 1;
    for (var i = 0; i < TT_SWOOSHES.length; i++) if (TT_SWOOSHES[i].n === n) return TT_SWOOSHES[i];
    return TT_SWOOSHES[0]; /* Classic Tail */
  }
  function ttCurlPts(cx, cy, r, a0, a1, N) {
    var out = [];
    for (var i = 1; i <= N; i++) {
      var a = a0 + (a1 - a0) * (i / N);
      out.push([cx + Math.cos(a) * r, cy + Math.sin(a) * r]);
    }
    return out;
  }
  function ttInkExit(txt, pxSize, f) {
    /* the REAL end of the last letter: rightmost ink pixel and the height of
       the stroke there — the advance-width box lies about where a cursive
       exit stroke actually finishes */
    try {
      var spec = ((f && f.weight) || 700) + ' ' + Math.round(pxSize) + 'px ' + nameFontStack(f);
      var pad2 = Math.ceil(pxSize * 0.3);
      var probe2 = document.createElement('canvas').getContext('2d');
      probe2.font = spec;
      var m2 = probe2.measureText(txt);
      var w2 = Math.ceil(m2.width), asc2 = Math.ceil(m2.actualBoundingBoxAscent || pxSize * 0.78), desc2 = Math.ceil(m2.actualBoundingBoxDescent || pxSize * 0.22);
      var cv2 = document.createElement('canvas'); cv2.width = w2 + pad2 * 2; cv2.height = asc2 + desc2 + pad2 * 2;
      var x2 = cv2.getContext('2d');
      x2.font = spec; x2.textBaseline = 'alphabetic'; x2.textAlign = 'left';
      x2.fillStyle = '#000'; x2.fillText(txt, pad2, pad2 + asc2);
      var d2 = x2.getImageData(0, 0, cv2.width, cv2.height).data;
      var xe = -1, yy, xx;
      for (xx = cv2.width - 1; xx >= 0 && xe < 0; xx--) {
        for (yy = 0; yy < cv2.height; yy++) { if (d2[(yy * cv2.width + xx) * 4 + 3] > 40) { xe = xx; break; } }
      }
      if (xe < 0) return null;
      var ys = 0, n2 = 0, x3, y3;
      for (x3 = Math.max(0, xe - Math.round(pxSize * 0.05)); x3 <= xe; x3++) {
        for (y3 = 0; y3 < cv2.height; y3++) { if (d2[(y3 * cv2.width + x3) * 4 + 3] > 40) { ys += y3; n2++; } }
      }
      return { dx: xe - pad2, dy: (n2 ? ys / n2 : pad2 + asc2) - (pad2 + asc2) };
    } catch (eIE) { return null; }
  }
  function ttTailGeom(styleN, x0, x1, yB, swH, PX) {
    /* centerline points LEFT→RIGHT + width profile w(t) in [0,1] of halfW */
    var N = 120, pts = [], i, t;
    var span = x1 - x0;
    function bez(cys) {
      for (i = 0; i <= N; i++) {
        t = i / N;
        pts.push([ttBez(t, x0, x0 + span * 0.3, x1 - span * 0.14, x1), ttBez(t, cys[0], cys[1], cys[2], cys[3])]);
      }
    }
    var flat = yB + swH * 0.4;
    var curl = null, wf, mod = null;
    switch (styleN) {
      case 1: /* heavy swash, curl up at the right */
        bez([flat + swH * 0.06, flat - swH * 0.12, flat + swH * 0.1, flat - swH * 0.05]);
        wf = function (t2) { return 0.5 + 0.75 * Math.pow(1 - t2, 0.8); };
        curl = { r: swH * 0.3, up: 1 }; break;
      case 2: /* flat underline, small hook */
        bez([flat, flat, flat, flat - swH * 0.04]);
        wf = function () { return 0.5; };
        curl = { r: swH * 0.22, up: 1 }; break;
      case 3: /* pointed left, flat, hook right */
        bez([flat, flat, flat, flat - swH * 0.04]);
        wf = function (t2) { return 0.55 * Math.min(1, t2 * 6); };
        curl = { r: swH * 0.22, up: 1 }; break;
      case 4: /* tribal leaves */
        bez([flat, flat - swH * 0.05, flat + swH * 0.05, flat]);
        wf = function () { return 0.5; };
        mod = 'flame'; break;
      case 5: /* blade: pointed both ends, belly middle */
        bez([flat + swH * 0.02, flat - swH * 0.1, flat - swH * 0.1, flat + swH * 0.02]);
        wf = function (t2) { return Math.pow(Math.sin(Math.PI * t2), 0.6); };
        break;
      case 6: /* smooth wave */
        bez([flat - swH * 0.06, flat + swH * 0.3, flat - swH * 0.3, flat + swH * 0.02]);
        wf = function (t2) { return 0.45 + 0.3 * Math.sin(Math.PI * t2); };
        break;
      case 7: /* plain bar */
        bez([flat, flat, flat, flat]);
        wf = function () { return 0.55; };
        break;
      case 8: /* double wave, rising right */
        bez([flat + swH * 0.05, flat - swH * 0.42, flat + swH * 0.42, flat - swH * 0.25]);
        wf = function (t2) { return Math.pow(Math.sin(Math.PI * Math.min(1, t2 * 1.04)), 0.5); };
        break;
      case 9: /* lightning */
        bez([flat, flat, flat, flat - swH * 0.1]);
        wf = function () { return 0.42; };
        mod = 'zig';
        curl = { r: swH * 0.2, up: 1 }; break;
      case 10: /* long taper, flick right */
        bez([flat + swH * 0.02, flat, flat, flat - swH * 0.06]);
        wf = function (t2) { return 0.75 * Math.pow(t2, 0.55); };
        curl = { r: swH * 0.24, up: 1 }; break;
      case 12: /* arrow blade: diamond bulge */
        bez([flat, flat, flat, flat]);
        wf = function (t2) { var d = Math.abs(t2 - 0.45); return Math.max(0.06, 1 - d * 2.4); };
        break;
      case 16: /* WING — barbed at the left like a feather, but the RIGHT end
                   is the classic tail's: it sweeps up and fattens back to
                   full width so it welds into the last letter's exit stroke
                   instead of arriving as a thin thread. */
        bez([flat + swH * 0.08, flat - swH * 0.08, flat + swH * 0.1, flat - swH * 0.35]);
        wf = function (t2) {
          var barb = 0.4 + 1.05 * Math.pow(1 - t2, 0.7);
          var weld = t2 > 0.72 ? 0.6 * Math.pow((t2 - 0.72) / 0.28, 2) : 0;
          return Math.min(1.45, barb + weld);
        };
        break;
      case 13: /* crescent smile */
        bez([flat - swH * 0.15, flat + swH * 0.55, flat + swH * 0.55, flat - swH * 0.15]);
        wf = function (t2) { return Math.pow(Math.sin(Math.PI * t2), 0.8); };
        break;
      default: /* 11 — the classic baseball swoosh: NO end curl, the band
                   sweeps up and WELDS into the last letter's exit stroke */
        bez([flat - swH * 0.05, flat + swH * 0.34, flat + swH * 0.3, flat - swH * 0.35]);
        wf = function (t2) { return Math.pow(t2, 0.7); };
        break;
    }
    var attachY = yB - PX * 0.06;
    if (!curl) {
      /* rise into the last letter's baseline exit over the final stretch */
      var M0 = pts.length - 1, i0 = Math.round(M0 * 0.8);
      for (i = i0; i <= M0; i++) {
        var f = (i - i0) / (M0 - i0);
        pts[i][1] += (attachY - pts[i][1]) * f * f;
      }
    } else {
      var last = pts[pts.length - 1];
      pts = pts.concat(ttCurlPts(last[0] - curl.r * 0.15, last[1] - curl.r, curl.r, Math.PI * 0.5, -Math.PI * 0.35, 26));
    }
    return { pts: pts, wf: wf, mod: mod, curlN: curl ? 26 : 0 };
  }
  function ttWingOld(x, x0, x1, yT, sH, fill, edge, ringPx) {
    /* The classic athletic tail: a barbed FORK at the left (two sharp points
       with a notch between), a long tapering body, and a hook that curls up
       and back over itself at the right. */
    var w = x1 - x0, mid = yT + sH * 0.42;
    var bodyT = sH * 0.2;            /* thickest part of the body */
    var hookX = x1 - w * 0.06;
    function path() {
      x.beginPath();
      /* upper barb tip, back along the top edge to the hook */
      x.moveTo(x0, mid - sH * 0.3);
      x.bezierCurveTo(x0 + w * 0.3, mid - bodyT * 0.55, x0 + w * 0.62, mid - bodyT * 0.42, hookX - w * 0.03, mid - bodyT * 0.5);
      /* the hook: up, over the top, and curling back down to the left */
      x.bezierCurveTo(x1, mid - sH * 0.46, x1 + w * 0.012, mid - sH * 0.02, hookX - w * 0.035, mid + sH * 0.03);
      x.bezierCurveTo(x1 - w * 0.055, mid - sH * 0.12, x1 - w * 0.03, mid - sH * 0.28, hookX - w * 0.08, mid - sH * 0.2);
      /* underside of the body running back to the lower barb */
      x.bezierCurveTo(x0 + w * 0.55, mid + bodyT * 0.16, x0 + w * 0.26, mid + bodyT * 0.5, x0 + w * 0.03, mid + sH * 0.3);
      /* the notch between the two barbs */
      x.bezierCurveTo(x0 + w * 0.16, mid + bodyT * 0.1, x0 + w * 0.15, mid - bodyT * 0.12, x0, mid - sH * 0.3);
      x.closePath();
    }
    if (ringPx) { path(); x.strokeStyle = edge; x.lineWidth = ringPx * 2; x.lineJoin = 'round'; x.stroke(); }
    path(); x.fillStyle = fill; x.fill();
  }
  function ttWing(x, x0, x1, yT, sH, fill, edge, ringPx, joinY) {
    /* the standard athletic tail: a BARBED fork at the left (two sharp points
       with a notch bitten out between them), a body that swells then tapers
       to a point at the right — which RISES to meet the last letter's exit
       stroke, so the two read as one cut piece */
    var w = x1 - x0, mid = yT + sH * 0.45;
    var tipY = (typeof joinY === 'number') ? joinY : mid - sH * 0.27;
    function path() {
      x.beginPath();
      x.moveTo(x0, mid - sH * 0.30);                                   /* upper barb */
      x.bezierCurveTo(x0 + w * 0.34, mid - sH * 0.17, x0 + w * 0.72, tipY + sH * 0.04, x1, tipY - sH * 0.06);
      x.bezierCurveTo(x0 + w * 0.72, tipY + sH * 0.2, x0 + w * 0.36, mid + sH * 0.11, x0 + w * 0.05, mid + sH * 0.34);
      x.bezierCurveTo(x0 + w * 0.16, mid + sH * 0.07, x0 + w * 0.15, mid - sH * 0.05, x0, mid - sH * 0.30);
      x.closePath();
    }
    if (ringPx) { path(); x.strokeStyle = edge; x.lineWidth = ringPx * 2; x.lineJoin = 'round'; x.stroke(); }
    path(); x.fillStyle = fill; x.fill();
  }
  function ttBandFromPts(x, g, halfW, fill, edge, ringPx) {
    var pts = g.pts, M = pts.length - 1, top = [], bot = [];
    for (var i = 0; i <= M; i++) {
      var t = i / M;
      var p = pts[i], pp = pts[Math.max(0, i - 1)], pn = pts[Math.min(M, i + 1)];
      var dx = pn[0] - pp[0], dy = pn[1] - pp[1];
      var L = Math.sqrt(dx * dx + dy * dy) || 1;
      var nx = -dy / L, ny = dx / L;
      var hw = halfW * g.wf(Math.min(1, i / (M - g.curlN || M)));
      /* the curl thins to a point along its own length */
      if (g.curlN && i > M - g.curlN) hw = halfW * g.wf(1) * (M - i) / g.curlN;
      if (g.mod === 'zig') hw *= (Math.floor(t * 11) % 2 ? 0.24 : 1);
      if (g.mod === 'flame') hw *= (0.25 + 0.75 * Math.abs(Math.sin(t * Math.PI * 5.5)));
      top.push([p[0] + nx * hw, p[1] + ny * hw]);
      bot.push([p[0] - nx * hw, p[1] - ny * hw]);
    }
    x.beginPath();
    top.forEach(function (p2, i2) { if (i2) x.lineTo(p2[0], p2[1]); else x.moveTo(p2[0], p2[1]); });
    for (var j = bot.length - 1; j >= 0; j--) x.lineTo(bot[j][0], bot[j][1]);
    x.closePath();
    if (ringPx) { x.strokeStyle = edge; x.lineWidth = ringPx * 2; x.lineJoin = 'round'; x.stroke(); }
    x.fillStyle = fill; x.fill();
  }
  function ttTailBand(x, c, halfW, fill, edge, ringPx) {
    /* the baseball tail: pointed at the LEFT tip, full width at the RIGHT end
       where it joins the last letter's exit stroke */
    var N = 96, top = [], bot = [];
    for (var i = 0; i <= N; i++) {
      var t = i / N;
      var px = ttBez(t, c.xs[0], c.xs[1], c.xs[2], c.xs[3]);
      var py = ttBez(t, c.ys[0], c.ys[1], c.ys[2], c.ys[3]);
      var dx = ttBezD(t, c.xs[0], c.xs[1], c.xs[2], c.xs[3]);
      var dy = ttBezD(t, c.ys[0], c.ys[1], c.ys[2], c.ys[3]);
      var L = Math.sqrt(dx * dx + dy * dy) || 1;
      var nx = -dy / L, ny = dx / L;
      var hw = halfW * Math.pow(t, 0.7);
      top.push([px + nx * hw, py + ny * hw]);
      bot.push([px - nx * hw, py - ny * hw]);
    }
    x.beginPath();
    top.forEach(function (p, i2) { if (i2) x.lineTo(p[0], p[1]); else x.moveTo(p[0], p[1]); });
    for (var j = bot.length - 1; j >= 0; j--) x.lineTo(bot[j][0], bot[j][1]);
    x.closePath();
    if (ringPx) { x.strokeStyle = edge; x.lineWidth = ringPx * 2; x.lineJoin = 'round'; x.stroke(); }
    x.fillStyle = fill; x.fill();
  }
  function ttSwooshBand(x, c, halfW, fill, edge, ringPx) {
    /* one closed ribbon: the top edge forward, the bottom edge back, with the
       ends tapered the way a cut twill tail is */
    var N = 96, top = [], bot = [];
    for (var i = 0; i <= N; i++) {
      var t = i / N;
      var px = ttBez(t, c.xs[0], c.xs[1], c.xs[2], c.xs[3]);
      var py = ttBez(t, c.ys[0], c.ys[1], c.ys[2], c.ys[3]);
      var dx = ttBezD(t, c.xs[0], c.xs[1], c.xs[2], c.xs[3]);
      var dy = ttBezD(t, c.ys[0], c.ys[1], c.ys[2], c.ys[3]);
      var L = Math.sqrt(dx * dx + dy * dy) || 1;
      var nx = -dy / L, ny = dx / L;
      var hw = halfW * Math.pow(Math.sin(Math.PI * t), 0.32);
      top.push([px + nx * hw, py + ny * hw]);
      bot.push([px - nx * hw, py - ny * hw]);
    }
    x.beginPath();
    top.forEach(function (p, i) { if (i) x.lineTo(p[0], p[1]); else x.moveTo(p[0], p[1]); });
    for (var j = bot.length - 1; j >= 0; j--) x.lineTo(bot[j][0], bot[j][1]);
    x.closePath();
    if (ringPx) { x.strokeStyle = edge; x.lineWidth = ringPx * 2; x.lineJoin = 'round'; x.stroke(); }
    x.fillStyle = fill; x.fill();
  }
  function ttSwooshLabel(x, c, txt, hex, fontSpec, fitPx, fitFam) {
    /* the banner lettering follows the curve, glyph by glyph, the way it is
       stitched onto the real tail */
    if (!txt) return;
    var pts = [], len = [0], i;
    if (c.pts) {
      pts = c.pts;
      for (i = 1; i < pts.length; i++) {
        var dxp = pts[i][0] - pts[i - 1][0], dyp = pts[i][1] - pts[i - 1][1];
        len.push(len[i - 1] + Math.sqrt(dxp * dxp + dyp * dyp));
      }
    } else {
    var N = 240;
    for (i = 0; i <= N; i++) {
      var t = i / N;
      pts.push([ttBez(t, c.xs[0], c.xs[1], c.xs[2], c.xs[3]), ttBez(t, c.ys[0], c.ys[1], c.ys[2], c.ys[3])]);
      if (i) {
        var ddx = pts[i][0] - pts[i - 1][0], ddy = pts[i][1] - pts[i - 1][1];
        len.push(len[i - 1] + Math.sqrt(ddx * ddx + ddy * ddy));
      }
    }
    }
    var total = len[len.length - 1];
    x.save();
    x.font = fontSpec;
    /* the label must live INSIDE the tail: shrink it until the whole string
       fits the usable run of the shape (it used to spill off the thin end) */
    if (fitPx && fitFam) {
      var pxTry = fitPx, guard = 0;
      while (guard++ < 24) {
        x.font = '700 ' + Math.max(6, Math.round(pxTry)) + 'px ' + fitFam;
        if (x.measureText(String(txt)).width <= total * 0.82 || pxTry <= 7) break;
        pxTry *= 0.92;
      }
    }
    x.textBaseline = 'middle';
    x.textAlign = 'center';
    x.fillStyle = hex;
    var chars = String(txt).split('');
    var widths = chars.map(function (ch) { return x.measureText(ch).width; });
    var tw = widths.reduce(function (a, b) { return a + b; }, 0);
    if (tw > total * 0.9) { /* nothing to do but let it ride the whole tail */ }
    var cur = (total - tw) / 2;
    chars.forEach(function (ch, ci) {
      var at = cur + widths[ci] / 2;
      var k = 1;
      while (k < len.length - 1 && len[k] < at) k++;
      /* INTERPOLATE along the segment — snapping to the nearest sample point
         quantized glyph positions and opened phantom gaps on uneven curves */
      var p0 = pts[k - 1], p1 = pts[k];
      var seg = len[k] - len[k - 1] || 1;
      var f = Math.max(0, Math.min(1, (at - len[k - 1]) / seg));
      var gx = p0[0] + (p1[0] - p0[0]) * f;
      var gy = p0[1] + (p1[1] - p0[1]) * f;
      var ang = Math.atan2(p1[1] - p0[1], p1[0] - p0[0]);
      x.save();
      x.translate(gx, gy);
      x.rotate(ang);
      x.fillText(ch, 0, 0);
      x.restore();
      cur += widths[ci];
    });
    x.restore();
  }
  function ttTextCanvas(ov) {
    /* the typed lettering, drawn as the cut twill pieces: one pass per line,
       an underlay stroke when the order is 2-layer, and the varsity swoosh
       under the block when the script face is on */
    var lines = ttLines();
    if (!lines.length) lines = ['YOUR TEXT'];
    var f = activeNameFont();
    /* the Greek face maps the LATIN keyboard onto Greek letters — typing A
       stitches an Alpha */
    if (f && f.greekmap) lines = lines.map(ttGreekify);
    else if (f && f.caps) lines = lines.map(function (sU) { return sU.toUpperCase(); });
    /* a script face is ALWAYS initial caps — all-caps script is not a thing */
    else if (f && (f.script || /script/i.test(f.label || ''))) {
      lines = lines.map(function (sT) {
        return sT.toLowerCase().replace(/(^|[\s'-])([a-z])/g, function (mT, pre, ch) { return pre + ch.toUpperCase(); });
      });
    }
    var PX = 260, LEAD = 1.16;
    var specFor = function (pxL) { return ((f && f.weight) || 700) + ' ' + Math.round(pxL) + 'px ' + nameFontStack(f); };
    /* line 1 always leads at full size; 2 and 3 can be dropped to half */
    var pxs = lines.map(function (sP, iP) { return iP > 0 && st['ttHalf' + (iP + 1)] ? PX * 0.5 : PX; });
    var spec = specFor(PX);
    var probe = document.createElement('canvas').getContext('2d');
    var widths = [], ascs = [], descs = [], lineHs = [];
    lines.forEach(function (sW, iW) {
      probe.font = specFor(pxs[iW]);
      var mW = probe.measureText(sW);
      widths.push(mW.width);
      ascs.push(mW.actualBoundingBoxAscent || pxs[iW] * 0.78);
      descs.push(mW.actualBoundingBoxDescent || pxs[iW] * 0.22);
      lineHs.push(Math.round((ascs[iW] + descs[iW]) * LEAD));
    });
    probe.font = spec;
    var maxW = Math.max.apply(null, widths) || PX;
    var asc = ascs[0];
    var lineH = Math.max.apply(null, lineHs);
    var ring = twoLayers() ? Math.max(3, Math.round(PX * 0.02)) + 5 : 0; /* +5 each side = ~10px more twill showing */
    var swoosh = ttSwooshOn();
    var pad = Math.round(PX * 0.22) + ring;
    var swH = swoosh ? Math.round(PX * 0.55) : 0;
    /* PER-LINE layout: each line is Straight, Arch or Slanted, and each adds
       its own headroom so stacked lines never collide */
    var lays = lines.map(function (_, iL) { return String(st['ttLay' + (iL + 1)] || 'Straight').toLowerCase(); });
    var slantRises = [], archPad = 0;
    lines.forEach(function (sA, iA) {
      probe.font = specFor(pxs[iA]);
      if (lays[iA] === 'arch') {
        lineHs[iA] += Math.ceil(ttArchRise(probe, sA));
        slantRises.push(0);
      } else if (lays[iA] === 'slanted' || lays[iA] === 'slant') {
        /* parallel slanted lines never collide, so the tilt costs NOTHING
           between lines — only the block's top and bottom need headroom.
           (Charging every line for it spaced them far apart.) */
        slantRises.push(Math.ceil((widths[iA] / 2) * Math.sin(TT_SLANT)) + 4);
      } else slantRises.push(0);
    });
    var slantTop = slantRises[0] || 0;
    var slantBot = slantRises[slantRises.length - 1] || 0;
    lays = lays.map(function (v) { return v === 'slanted' ? 'slant' : v; });
    probe.font = spec;
    var cv = document.createElement('canvas');
    cv.width = Math.ceil(maxW + pad * 2);
    cv.height = Math.ceil(lineHs.reduce(function (a, b) { return a + b; }, 0) + pad * 2 + swH + archPad + slantTop + slantBot);
    var x = cv.getContext('2d');
    x.font = spec;
    x.textBaseline = 'alphabetic';
    x.textAlign = 'center';
    x.lineJoin = 'round';
    x.miterLimit = 2;
    var ink = ttInk(), edge = ttEdge();
    var zig = /zig/i.test(String(st.ttStitch || 'Zig Zag'));
    var baseYs = [], runY = pad + slantTop;
    lines.forEach(function (sB, iB) { baseYs.push(runY + ascs[iB]); runY += lineHs[iB]; });
    var glyphSets = lines.map(function (sG, iG) {
      x.font = specFor(pxs[iG]);
      return ttGlyphs(x, sG, cv.width / 2, baseYs[iG], lays[iG]);
    });
    /* every pass repaints line by line, each in its own size */
    var paintLines = function (mode, widthFn, boostFn) {
      glyphSets.forEach(function (gs, iL) {
        x.font = specFor(pxs[iL]);
        var kL = pxs[iL] / PX; /* a half-size line gets half the stroke weight */
        if (widthFn) x.lineWidth = widthFn(kL);
        ttPaintGlyphs(x, gs, mode, boostFn ? boostFn(kL) : 0);
      });
    };
    /* underlay FIRST for every line, then the tops — otherwise a stacked
       line's outline paints over the line above it */
    if (ring) {
      x.strokeStyle = edge;
      x.setLineDash([]);
      /* the second twill layer is a BORDER on each letter */
      paintLines('stroke', function (kL) { return (ring * 2 + ttBoost(PX)) * kL; });
    }
    /* EVERY order gets an edge stitch — single layer, top layer or stacked.
       Satin is a dense band that covers the cut edge completely; zig-zag is the
       open tacking stitch, so its individual stitches stay visible. */
    {
      /* The reference USED to ship with no edge detail at all, and the renderer
         filled the gap with an invented white satin layer between the twill
         colours. Now that the stitch is self-coloured it goes to Sensei too —
         but always tonal and solid there, never the contrast dashes, so there
         is nothing white for the model to copy. */
      var refOnlyS = !!(ov && ov.refOnly);
      x.strokeStyle = ttStitchHex(refOnlyS ? true : !zig);
      x.setLineDash((zig && !refOnlyS) ? [Math.max(3, PX * 0.03), Math.max(3, PX * 0.028)] : []);
      x.lineCap = (zig && !refOnlyS) ? 'butt' : 'round';
      paintLines('stroke', function (kL) {
        var wS = zig ? Math.max(2, PX * 0.026) : Math.max(3, PX * 0.052) + 10;
        /* TWO LAYERS: the stitch is capped against the underlay so the outline
           colour always stays visible — a full-width satin band covered it */
        if (ring) wS = Math.min(wS, Math.max(2, ring * 0.7));
        return (wS + ttBoost(PX) * 0.6) * kL;
      });
      x.setLineDash([]);
      x.lineCap = 'butt';
    }
    x.fillStyle = ink;
    paintLines('fill', null, function (kL) { return ttBoost(PX) * kL; });
    if (swoosh) {
      /* BASEBALL TAIL: exits the LAST letter's baseline stroke, dips under the
         whole design and tapers to a point past its left edge */
      var lastI = lines.length - 1;
      /* the tail belongs to the line it exits: a half-size last line gets a
         half-size tail — thickness, depth and reach all scale with it */
      var kSw = pxs[lastI] / PX;
      var leftEdge = cv.width / 2 - (widths[lastI] * 1.35) / 2;
      leftEdge = Math.max(cv.width / 2 - Math.max.apply(null, widths) / 2, leftEdge);
      var lastBase = baseYs[lastI];
      var attachX = Math.min(cv.width - pad * 0.4, cv.width / 2 + widths[lastI] / 2 - PX * 0.04 * kSw);
      var attachY = lastBase - PX * 0.06 * kSw;
      /* connect at the letter's ACTUAL exit stroke — measured from the ink,
         then pulled slightly INTO the stroke; the letters repaint on top, so
         the weld reads as one continuous stroke (the cursive-e case) */
      var slantLast = lays[lastI] === 'slant';
      var exitP = ttInkExit(lines[lastI], pxs[lastI], f);
      if (exitP) {
        var lineLeft = cv.width / 2 - widths[lastI] / 2;
        attachX = Math.min(cv.width - pad * 0.3, lineLeft + exitP.dx - Math.max(4, PX * 0.03 * kSw));
        attachY = baseYs[lastI] + exitP.dy;
      }
      var tipX = Math.max(pad * 0.35, leftEdge - PX * 0.1 * kSw);
      /* the tail HUGS the word: a shallow dip just under the baseline, the way
         the classic baseball script underline sits (Royals reference) */
      var deepY = lastBase + swH * 0.52;
      var ctl = {
        xs: [tipX, tipX + (attachX - tipX) * 0.3, attachX - (attachX - tipX) * 0.12, attachX],
        ys: [lastBase + swH * 0.2, deepY, deepY * 0.997, attachY]
      };
      var halfW = Math.max(5, Math.round(PX * 0.085 * kSw));
      /* the tail rides the slant: rotate the whole thing about the line's
         centre so it leaves the letter at the same angle the word sits at */
      if (slantLast) {
        x.save();
        x.translate(cv.width / 2, baseYs[lastI]);
        x.rotate(-TT_SLANT);
        x.translate(-cv.width / 2, -baseYs[lastI]);
      }
      var styleNo = ttSwooshDef(st.swooshStyle).geo;
      var geomT = ttTailGeom(styleNo, tipX, attachX, lastBase, Math.round(swH * kSw), Math.round(PX * kSw));
      if (styleNo === 16) {
        /* the athletic WING is a drawn SHAPE — barbed fork left, swelling
           body, and a hook that curls up-and-over at the right. The hook is
           pushed slightly PAST the attach point so its crest rises under the
           last letter's exit stroke; the letters repaint on top and the two
           read as one cut piece. (The band centerline is kept only as the
           path the on-tail text rides.) */
        ttWingOld(x, tipX, attachX + Math.round(PX * 0.03 * kSw), lastBase, Math.round(swH * kSw), ink, edge, ring);
      } else {
        ttBandFromPts(x, geomT, halfW * 1.3, ink, edge, ring);
      }
      /* optional lettering stitched along the tail, in the contrast colour */
      var swTxt = String(st.swooshText || '').trim();
      if (swTxt) {
        /* the label paints in the same face as the lettering */
        var famT = nameFontStack(f);
        var lblPx = Math.round(halfW * 1.35);
        var lblHex = ttSwooshTextHex();
        var ptsAll = geomT.pts.slice(0, geomT.pts.length - geomT.curlN);
        /* sample the width profile and put the text where the tail is THICK —
           some styles fatten toward the left tip, others toward the join */
        var pathT = (geomT.wf(0.15) >= geomT.wf(0.85))
          ? ptsAll.slice(Math.floor(ptsAll.length * 0.05), Math.floor(ptsAll.length * 0.66))
          : ptsAll.slice(Math.floor(ptsAll.length * 0.34), Math.floor(ptsAll.length * 0.95));
        ttSwooshLabel(x, { pts: pathT }, swTxt.toUpperCase(), lblHex,
          '700 ' + lblPx + 'px ' + famT, lblPx, famT);
      }
      x.font = spec; /* the label reset it */
      if (slantLast) x.restore();
      /* the letters paint back on top so the join reads as ONE stroke */
      x.fillStyle = ink;
      paintLines('fill', null, function (kL) { return ttBoost(PX) * kL; });
    }
    return trimToInk(cv);
  }
  function ttShade(hex, f) {
    /* f > 0 lightens toward white, f < 0 darkens toward black */
    var h = String(hex || '#888888').replace('#', '');
    if (h.length !== 6) h = '888888';
    var out = '#';
    for (var i = 0; i < 3; i++) {
      var v = parseInt(h.substr(i * 2, 2), 16);
      v = f >= 0 ? v + (255 - v) * f : v * (1 + f);
      out += ('0' + Math.round(Math.max(0, Math.min(255, v))).toString(16)).slice(-2);
    }
    return out;
  }
  function ttStitchHex(satin) {
    var inkH = ttInk();
    var h = inkH.replace('#', '');
    var lum = parseInt(h.slice(0, 2), 16) * 0.299 + parseInt(h.slice(2, 4), 16) * 0.587 + parseInt(h.slice(4, 6), 16) * 0.114;
    /* satin = SELF-COLOURED thread: a tonal shade of the letter twill (the
       white contrast band read as a weird outline and buried the real outline
       colour); zig-zag keeps its contrast dashes — they read as stitches */
    if (satin) return lum > 140 ? ttShade(inkH, -0.22) : ttShade(inkH, 0.28);
    return lum > 140 ? 'rgba(12,12,14,.62)' : 'rgba(255,255,255,.78)';
  }
  function ttSampleInk() {
    /* the tile sits on white — a white/cream twill would vanish on it */
    var h = ttInk().replace('#', '');
    var lum = parseInt(h.slice(0, 2), 16) * 0.299 + parseInt(h.slice(2, 4), 16) * 0.587 + parseInt(h.slice(4, 6), 16) * 0.114;
    return lum > 210 ? '#3A3F52' : ttInk();
  }
  function ttSampleCanvas(arch) {
    var f = activeNameFont();
    var lbl = 'ABCD';
    var PX = 120;
    var spec = ((f && f.weight) || 700) + ' ' + PX + 'px ' + nameFontStack(f);
    var probe = document.createElement('canvas').getContext('2d');
    probe.font = spec;
    var w = probe.measureText(lbl).width || PX * 3;
    var rise = arch ? ttArchRise(probe, lbl) : 0;
    var cv = document.createElement('canvas');
    cv.width = Math.ceil(w + PX * 0.45);
    cv.height = Math.ceil(PX * 1.3 + rise);
    var x = cv.getContext('2d');
    x.font = spec;
    x.textAlign = 'center';
    x.textBaseline = 'alphabetic';
    x.fillStyle = ttSampleInk();
    ttPaintGlyphs(x, ttGlyphs(x, lbl, cv.width / 2, PX * 1.02, arch), 'fill', ttBoost(PX));
    return cv;
  }
  function ttFormatTiles() {
    /* redrawn whenever the font or the twill colour changes, so the tiles are
       a true preview of the choice rather than two words */
    $$('[data-tt-seg="fmt"]').forEach(function (bT) {
      var imT = bT.querySelector('img');
      if (!imT) return;
      try { imT.src = ttSampleCanvas(/arch/i.test(bT.getAttribute('data-tt-val') || '')).toDataURL('image/png'); }
      catch (eT) {}
    });
  }
  function ttStitchOpen(open) {
    var bodyS = document.getElementById('np-e2-tt-stitchbody');
    var rowS = document.getElementById('np-e2-tt-stitchrow');
    if (!bodyS || !rowS) return;
    bodyS.hidden = !open;
    rowS.classList.toggle('is-open', !!open);
    if (!open && st.ttStitchSeen) rowS.classList.add('is-done');
  }
  function ttLetterOpen(open) {
    var bodyL = document.getElementById('np-e2-tt-letterbody');
    var rowL = document.getElementById('np-e2-tt-letterrow');
    if (!bodyL || !rowL) return;
    bodyL.hidden = !open;
    rowL.classList.toggle('is-open', !!open);
  }
  function ttSync(repaint) {
    if (!PTYPE.textLines) return;
    var lines = ttLines();
    st.ttext = lines.length ? lines.join(' / ') : null;
    /* the number of filled lines IS the Lines of Text variant option */
    if (PTYPE.autoOpt) {
      /* the swoosh is its own cut piece stitched under the lettering — it takes
         a line, exactly like a typed row does */
      var want = Math.max(1, Math.min(PTYPE.textLines || 3, (lines.length || 1) + (ttSwooshOn() ? 1 : 0)));
      var hit = null;
      optValues(PTYPE.autoOpt).forEach(function (vO) {
        var mO = /(\d+)/.exec(String(vO.label || ''));
        if (mO && parseInt(mO[1], 10) === want) hit = vO;
      });
      if (hit) {
        st['opt' + PTYPE.autoOpt] = hit;
        if (st.draft) st.draft['opt' + PTYPE.autoOpt] = hit;
      }
    }
    setProp('_Lettering Text', lines.join(' | '));
    setProp('_Line Sizes', lines.map(function (sL, iL) {
      return 'L' + (iL + 1) + ' ' + (iL > 0 && st['ttHalf' + (iL + 1)] ? 'half' : 'full');
    }).join(', '));
    setProp('_Design Format', lines.length
      ? lines.map(function (sF, iF) { return 'L' + (iF + 1) + ' ' + (st['ttLay' + (iF + 1)] || 'Straight'); }).join(', ')
      : 'Straight');
    setProp('_Border Stitch', st.ttStitch || 'Zig Zag');
    setProp('_Swoosh', ttSwooshOn() ? 'Yes' : '');
    var swSel = document.getElementById('np-e2-tt-swstyle');
    if (swSel && swSel.value) st.swooshStyle = swSel.value;
    var defSw = ttSwooshDef(st.swooshStyle || 11);
    setProp('_Swoosh Style', ttSwooshOn() ? ('#' + defSw.n + ' ' + defSw.name) : '');
    var stitchValE = document.getElementById('np-e2-tt-stitchval');
    if (stitchValE) {
      stitchValE.textContent = st.ttStitch || 'Zig Zag';
      stitchValE.classList.add('is-set');
    }
    var swStyleRow = document.getElementById('np-e2-tt-swstylerow');
    if (swStyleRow) swStyleRow.hidden = !ttSwooshOn();
    var swColSel = document.getElementById('np-e2-tt-swtxtcolor');
    if (swColSel) {
      if (!swColSel.options.length) {
        var oAuto = document.createElement('option');
        oAuto.value = ''; oAuto.textContent = 'Auto';
        swColSel.appendChild(oAuto);
        (CFG.threads || CFG.bgs || []).forEach(function (cT) {
          if (!cT || !cT.hex) return;
          var oC = document.createElement('option');
          oC.value = cT.label; oC.textContent = cT.label;
          swColSel.appendChild(oC);
        });
      }
      var pickC = null;
      (CFG.threads || CFG.bgs || []).forEach(function (cT) { if (cT && cT.label === swColSel.value) pickC = cT; });
      st.swooshTextColor = pickC;
      setProp('_Swoosh Text Color', ttSwooshOn() && pickC ? pickC.label : '');
    }
    var swIn = document.getElementById('np-e2-tt-swtxt');
    st.swooshText = swIn ? String(swIn.value || '').trim() : '';
    setProp('_Swoosh Text', ttSwooshOn() ? st.swooshText : '');
    var swTxtRow = document.getElementById('np-e2-tt-swtxtrow');
    if (swTxtRow) swTxtRow.hidden = !ttSwooshOn();
    /* the swoosh occupies a line, and three lines is the maximum — at three
       typed lines it is off the table (and switched off if it was on) */
    var swFits = lines.length < (PTYPE.textLines || 3);
    /* only an ARCHED bottom line rules the tail out — slanted is fine */
    var bentS = /arch/i.test(String(st['ttLay' + (lines.length || 1)] || 'Straight'));
    if (st.swoosh && (!swFits || bentS)) st.swoosh = false;
    var swR = document.getElementById('np-e2-tt-swooshrow');
    if (swR) swR.hidden = !(ttFontIsScript() && swFits && !bentS);
    var swBtn = document.getElementById('np-e2-tt-swoosh');
    if (swBtn) {
      var swSw = swBtn.querySelector('.np-e2-switch');
      if (swSw) swSw.classList.toggle('is-on', !!st.swoosh);
      swBtn.setAttribute('aria-pressed', st.swoosh ? 'true' : 'false');
    }
    ensureNameFonts(ttFormatTiles);
    var valL = document.getElementById('np-e2-tt-letterval');
    if (valL) {
      valL.textContent = lines.length ? lines.join(' \u00b7 ') : 'Type your text';
      valL.classList.toggle('is-set', !!lines.length);
    }
    var rowL2 = document.getElementById('np-e2-tt-letterrow');
    if (rowL2) rowL2.classList.toggle('is-done', !!lines.length && !rowL2.classList.contains('is-open'));
    var contL = document.getElementById('np-e2-tt-lettercont');
    if (contL) contL.disabled = !lines.length;
    var lbR = document.getElementById('np-e2-tt-lines');
    if (lbR) {
      lbR.textContent = lines.length
        ? (lines.length + ' line' + (lines.length === 1 ? '' : 's') + ' \u2014 pricing updated')
        : 'Type your lettering to see it on the patch';
      lbR.classList.toggle('is-set', !!lines.length);
    }
    try { commitOptions(); } catch (eTT) {}
    /* a text/option change makes the existing proof stale — the CTA goes back
       to offering a fresh render */
    if (st.versions.length && !st.proofApproved) st.ctaRevealed = true;
    unapproveIfChanged();
    renderPricing();
    renderOptions();
    if (repaint !== false) renderMaskPreview();
  }
  function trimToInk(cv) {
    /* crop to the drawn pixels so the composer centres the ARTWORK, not the
       canvas box (font metrics lie: swashes, caps-height, descenders) */
    try {
      var xc = cv.getContext('2d');
      var idT = xc.getImageData(0, 0, cv.width, cv.height).data;
      var x0 = cv.width, y0 = cv.height, x1 = -1, y1 = -1;
      for (var yy = 0; yy < cv.height; yy++) for (var xx = 0; xx < cv.width; xx++) {
        if (idT[(yy * cv.width + xx) * 4 + 3] > 8) { if (xx < x0) x0 = xx; if (xx > x1) x1 = xx; if (yy < y0) y0 = yy; if (yy > y1) y1 = yy; }
      }
      if (x1 > -1) {
        var out = document.createElement('canvas');
        out.width = x1 - x0 + 1; out.height = y1 - y0 + 1;
        out.getContext('2d').drawImage(cv, x0, y0, out.width, out.height, 0, 0, out.width, out.height);
        return out;
      }
    } catch (eTr) {}
    return cv;
  }
  function textPreviewCanvas(ov) { return PTYPE.textLines ? ttTextCanvas(ov) : nameTextCanvas(); }
  function nameTextCanvas() {
    var txt = String(st.namePreview || PTYPE.textPreview || 'NAME');
    var f = activeNameFont();
    var PX = 400; /* drawn big, then contained into the patch by the composer */
    /* SCRIPT treatment (classic chain-stitch name patch): the FIRST letter
       stitches in the block face, the rest flows in script — and the script
       gets a stroke pass so the thread reads thicker */
    var isScript = !!PTYPE.names && !!(f && f.script) && txt.length > 1;
    var blockF = isScript ? nameBlockFont() : null;
    var specMain = ((f && f.weight) || 700) + ' ' + PX + 'px ' + nameFontStack(f);
    var runs;
    if (isScript && blockF) {
      runs = [
        { t: txt.charAt(0), spec: ((blockF.weight) || 700) + ' ' + Math.round(PX * 0.98) + 'px ' + nameFontStack(blockF) },
        { t: txt.slice(1), spec: specMain }
      ];
    } else {
      runs = [{ t: txt, spec: specMain }];
    }
    var probe = document.createElement('canvas').getContext('2d');
    var asc = 0, desc = 0, leftOv = 0, rightOv = 0, totalAdv = 0;
    runs.forEach(function (r, i) {
      probe.font = r.spec;
      var m = probe.measureText(r.t);
      r.adv = m.width || 0;
      asc = Math.max(asc, m.actualBoundingBoxAscent || PX * 0.78);
      desc = Math.max(desc, m.actualBoundingBoxDescent || PX * 0.24);
      if (i === 0) leftOv = m.actualBoundingBoxLeft || 0;
      if (i === runs.length - 1) rightOv = Math.max(0, (m.actualBoundingBoxRight || m.width || PX) - r.adv);
      totalAdv += r.adv;
    });
    /* script faces overshoot their own metrics (swashes, tails) — pad so the
       flourishes are not clipped by the canvas edge */
    var pad = Math.ceil(PX * 0.08);
    var strokeW = (PTYPE.names && f && f.script) ? Math.max(2, Math.round(PX * 0.012)) : 0;
    var cv = document.createElement('canvas');
    cv.width = Math.max(2, Math.ceil(leftOv + totalAdv + rightOv) + pad * 2 + strokeW * 2);
    cv.height = Math.max(2, Math.ceil(asc + desc) + pad * 2 + strokeW * 2);
    var x = cv.getContext('2d');
    x.textBaseline = 'alphabetic';
    x.textAlign = 'left';
    x.fillStyle = nameInkHex();
    x.strokeStyle = nameInkHex();
    x.lineJoin = 'round';
    var cx = pad + strokeW + leftOv, cy = pad + strokeW + asc;
    runs.forEach(function (r) {
      x.font = r.spec;
      if (strokeW) { x.lineWidth = strokeW; x.strokeText(r.t, cx, cy); }
      x.fillText(r.t, cx, cy);
      cx += r.adv;
    });
    return trimToInk(cv);
  }

  function composePatchImage(cb, Csize, ov) {
    /* the colorized mask preview, rendered at high resolution: shape, border
       ring, background, art placement and fill — a faithful reference image
       for the renderer to convert into a patch */
    /* leather with NO shape picked yet: preview on a circle WITHOUT
       selecting it (Justin 2026-08-21 — no Circle pre-select) */
    if (!ov && !st.shape && PTYPE.mats && !PTYPE.noArt) ov = { g: 'circle' };
    var g = (ov && ov.g) || shapeGeom();
    if ((!ov && !st.shape) || !g) { cb(null); return; }
    /* text-preview types: the face has to be resident before the first paint
       or the patch renders in the browser default font, permanently */
    if ((PTYPE.textPreview || PTYPE.textLines) && !(ov && ov.src) && !nameFontsLoaded) {
      ensureNameFonts(function () { composePatchImage(cb, Csize, ov); });
      return;
    }
    var raw = (ov && ov.src) || ((PTYPE.textPreview || PTYPE.textLines)
      ? textPreviewCanvas(ov).toDataURL('image/png')
      : applyToggleParams(cleanUrl(artworkUrl()) || ''));
    if (!raw) { cb(null); return; }
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var d = (PTYPE.previewDims && st.w && st.h) ? [st.w * 100, st.h * 100] : shapeDims(g, 1);
        var C = Csize || 1200;
        var k = (C * 0.94) / Math.max(d[0], d[1]);
        var W = Math.round(d[0] * k), H = Math.round(d[1] * k);
        var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
        var x = cv.getContext('2d');
        var pick = function (c) { return c && c.hex && c.label !== 'Let Ninja Choose' && c.label !== 'Not Sure' ? c.hex : null; };
        var thNoneC = !!(st.thread && (st.thread.none || isFollowVal(st.thread) || /^none$/i.test(st.thread.label || '')));
        var followBgC = !(ov && ov.bg) && isFollowVal(st.bg);
        var threadHex = pick(st.thread), bgHex = (ov && ov.bg) || pick(st.bg) || (followBgC ? null : npDefaultBgHex());
        /* a BARE-ART type (tackle twill letters) has no patch base at all: the
           cut pieces ARE the artwork, so nothing may be filled behind them */
        if (PTYPE.bareArt && !(ov && ov.bg)) bgHex = null;
        var isMerrow = st.border && /merrow/i.test(st.border.label || '');
        var ringHex = (ov && ov.ring) || threadHex || '#9CA3AF'; /* no color picked yet: neutral grey ring so the border STYLE still previews (merrow texture included) */
        var noBorderC = !!(st.border && /no border/i.test(st.border.label || ''));
        var ring = (ov && ov.thin) ? Math.round(C * 0.02) : ((thNoneC || noBorderC || isLeather() || (!st.thread && !st.border)) ? 0 : Math.round(C * (isMerrow ? 0.024 : 0.016)));
        /* BARE ART (tackle twill): there is no patch base and no patch border —
           the cut pieces ARE the artwork. Its outline colour is the second twill
           layer, drawn per letter inside the text canvas, so the composer must
           not also ring the whole silhouette (that read as a custom-shape base
           padded around the lettering). */
        if (PTYPE.bareArt) ring = 0;
        /* molded flex/PVC: the border is part of the mold, so the 1-10
           thickness choice scales the ring. Flex: 3 = standard (0.55+0.15x).
           PVC (lbZeroMax2): 5 = standard, 1 = barely-there, 10 = double. */
        if (ring > 0 && PTYPE.borderThick && !(ov && ov.thin)) {
          ring = Math.max(PTYPE.lbZeroMax2 ? 1 : 2, Math.round(ring * lbRingFactor()));
        }
        /* surface texture rides ON the background color, UNDER the artwork.
           Skipped on the little shape tiles, where ribbing only reads as mush. */
        var texKind = (!(ov && ov.thin) && PTYPE.texture && st.texture) ? st.texture.label : null;
        /* METALLIC FLEX free form is molded from ONE solid colour: the artwork
           takes that colour as two tones, like the single-material finishes.
           Every other free-form material (silicone, full-color flex) molds in
           the artwork's own colors — never flatten those. */
        var ffTone = null;
        if (isFreeFormShape() && bgHex && /^metallic-flex/.test(TYPE_KEY)) {
          var _h = bgHex.replace('#', '');
          var _r = parseInt(_h.substr(0, 2), 16), _g2 = parseInt(_h.substr(2, 2), 16), _b = parseInt(_h.substr(4, 2), 16);
          var _hex = function (r2, g3, b2) {
            return '#' + [r2, g3, b2].map(function (v) { return ('0' + Math.max(0, Math.min(255, Math.round(v))).toString(16)).slice(-2); }).join('');
          };
          ffTone = { dark: _hex(_r * 0.62, _g2 * 0.62, _b * 0.62), light: _hex(_r + (255 - _r) * 0.30, _g2 + (255 - _g2) * 0.30, _b + (255 - _b) * 0.30) };
        }
        /* BARE ART never gets the custom-shape treatment: tackle twill letters
           are individual cut pieces, so there is no silhouette base to dilate
           and no contour to run a border along. The second twill layer is a
           BORDER on each letter, drawn in the text canvas — the bubble below
           was what padded it out into one blob. */
        if (g === 'custom' && !PTYPE.bareArt) {
          /* CUSTOM SHAPE IS STILL A SHAPE: the base is the artwork silhouette
             DILATED into one smooth continuous contour (a bubble hugging the
             whole design), filled with the background color — the border runs
             along that OUTER contour, never around individual letters */
          var padC = Math.round(C * 0.1);
          var sC = Math.min((C - padC * 2) / img.naturalWidth, (C - padC * 2) / img.naturalHeight);
          var awC = Math.max(1, Math.round(img.naturalWidth * sC)), ahC = Math.max(1, Math.round(img.naturalHeight * sC));
          var WC = awC + padC * 2, HC = ahC + padC * 2;
          var cvC = document.createElement('canvas'); cvC.width = WC; cvC.height = HC;
          var xC = cvC.getContext('2d');
          var freeF = ov ? !!ov.freeform : isFreeFormShape();
          var ringC = freeF ? 0 : ((ov && ov.thin) ? Math.round(C * 0.012) : ((thNoneC || noBorderC || isLeather() || (!st.thread && !st.border)) ? 0 : Math.round(C * (isMerrow ? 0.016 : 0.012))));
          if (ringC > 0 && PTYPE.borderThick && !(ov && ov.thin)) ringC = Math.max(PTYPE.lbZeroMax2 ? 1 : 2, Math.round(ringC * lbRingFactor()));
          /* LEATHER / FAUX LEATHER custom shape: the hide is cut ON the
             artwork's own outer contour — no dilated margin ("border") around
             it. Interior detail stays leather (hole-filled below) with the
             etch showing the art's indentations. */
          var leatherCutC = isLeather();
          /* background "None" acts EXACTLY like Match My Artwork: no dilated
             base bubble, and any border runs along the ART's own contour.
             The neutral grey style-preview ring stays off until a REAL
             thread color is picked (Justin 2026-08-21). */
          var noneBgC = !!(st.bg && /^none$/i.test(String(st.bg.label || '')));
          if (noneBgC && !((ov && ov.thin)) && !(st.thread && st.thread.hex)) ringC = 0;
          var baseR = (freeF || followBgC || leatherCutC || noneBgC) ? 0 : Math.round(C * 0.05);
          var sil = document.createElement('canvas'); sil.width = awC; sil.height = ahC;
          var sx2 = sil.getContext('2d');
          sx2.drawImage(img, 0, 0, awC, ahC);
          sx2.globalCompositeOperation = 'source-in';
          sx2.fillStyle = '#000';
          sx2.fillRect(0, 0, awC, ahC);
          /* HARD-EDGE the silhouette (Justin 2026-08-24): AI uploads carry
             faint (alpha 1-60) junk pixels and soft anti-aliased edges that
             are invisible on the page — but the dilation below stamps this
             silhouette ~100 times, accumulating that residue toward full
             opacity, and the Match-My-Artwork bg fill then paints it (the
             pixelated halo). Binarize: alpha < 64 is not part of the patch. */
          (function () {
            var sdI = sx2.getImageData(0, 0, awC, ahC), sdD = sdI.data;
            for (var oS = 3; oS < sdD.length; oS += 4) sdD[oS] = sdD[oS] < 64 ? 0 : 255;
            sx2.putImageData(sdI, 0, 0);
          })();
          /* SELF-ENCLOSED ART CUTS ON ITS OWN EDGE (Justin 2026-08-24, the
             "AIR BOSS" framed logo): when the artwork already draws ONE
             connected outline, the patch IS that contour — interior holes
             fill with the background and no dilated bubble pads the edge.
             The bubble stays for disconnected art, which needs bridging. */
          var contourCut = false;
          if (!leatherCutC && !freeF) (function () {
            var sdI2 = sx2.getImageData(0, 0, awC, ahC), dd2 = sdI2.data;
            var ext2 = new Uint8Array(awC * ahC), stk2 = [];
            var push2 = function (px, py) {
              if (px < 0 || py < 0 || px >= awC || py >= ahC) return;
              var o2 = py * awC + px;
              if (ext2[o2] || dd2[o2 * 4 + 3] > 127) return;
              ext2[o2] = 1; stk2.push(o2);
            };
            for (var bi = 0; bi < awC; bi++) { push2(bi, 0); push2(bi, ahC - 1); }
            for (var bj = 0; bj < ahC; bj++) { push2(0, bj); push2(awC - 1, bj); }
            while (stk2.length) {
              var oP = stk2.pop(), pxP = oP % awC, pyP = (oP / awC) | 0;
              push2(pxP + 1, pyP); push2(pxP - 1, pyP); push2(pxP, pyP + 1); push2(pxP, pyP - 1);
            }
            var filled = new Uint8Array(awC * ahC), fillN = 0, seed = -1;
            for (var oF = 0; oF < awC * ahC; oF++) if (!ext2[oF]) { filled[oF] = 1; fillN++; if (seed < 0) seed = oF; }
            if (!fillN) return;
            var comp = new Uint8Array(awC * ahC), compN = 0, stk3 = [seed];
            comp[seed] = 1;
            while (stk3.length) {
              var oC = stk3.pop(); compN++;
              var pxC = oC % awC, pyC = (oC / awC) | 0;
              if (pxC + 1 < awC && !comp[oC + 1] && filled[oC + 1]) { comp[oC + 1] = 1; stk3.push(oC + 1); }
              if (pxC > 0 && !comp[oC - 1] && filled[oC - 1]) { comp[oC - 1] = 1; stk3.push(oC - 1); }
              if (pyC + 1 < ahC && !comp[oC + awC] && filled[oC + awC]) { comp[oC + awC] = 1; stk3.push(oC + awC); }
              if (pyC > 0 && !comp[oC - awC] && filled[oC - awC]) { comp[oC - awC] = 1; stk3.push(oC - awC); }
            }
            if (compN / fillN < 0.97) return; /* disconnected pieces keep the bubble */
            contourCut = true;
            for (var oW = 0; oW < awC * ahC; oW++) dd2[oW * 4 + 3] = filled[oW] ? 255 : 0;
            sx2.putImageData(sdI2, 0, 0);
          })();
          var mask = document.createElement('canvas'); mask.width = WC; mask.height = HC;
          var mx2 = mask.getContext('2d');
          mx2.drawImage(sil, padC, padC);
          if (!contourCut) for (var ri = 1; ri <= 4; ri++) {
            var rr = baseR * ri / 4;
            for (var aI = 0; aI < 24; aI++) {
              var angC = aI / 24 * Math.PI * 2;
              mx2.drawImage(sil, padC + Math.cos(angC) * rr, padC + Math.sin(angC) * rr);
            }
          }
          if (ringC > 0) {
            var ringLayer = document.createElement('canvas'); ringLayer.width = WC; ringLayer.height = HC;
            var rx2 = ringLayer.getContext('2d');
            for (var aJ = 0; aJ < 28; aJ++) {
              var ang2 = aJ / 28 * Math.PI * 2;
              rx2.drawImage(mask, Math.cos(ang2) * ringC, Math.sin(ang2) * ringC);
            }
            rx2.globalCompositeOperation = 'source-in';
            rx2.fillStyle = ringHex;
            rx2.fillRect(0, 0, WC, HC);
            xC.drawImage(ringLayer, 0, 0);
          }
          if (leatherCutC) {
            /* fill INTERIOR holes of the silhouette so knockout detail sits on
               leather (etched), while the outer contour stays the exact cut:
               flood the exterior from the canvas border, then everything not
               exterior becomes mask */
            var midL = mx2.getImageData(0, 0, WC, HC), mdL = midL.data;
            var extL = new Uint8Array(WC * HC);
            var stkL = [];
            var pushL = function (px3, py3) {
              if (px3 < 0 || py3 < 0 || px3 >= WC || py3 >= HC) return;
              var o3 = py3 * WC + px3;
              if (extL[o3] || mdL[o3 * 4 + 3] > 40) return;
              extL[o3] = 1; stkL.push(o3);
            };
            for (var bi3 = 0; bi3 < WC; bi3++) { pushL(bi3, 0); pushL(bi3, HC - 1); }
            for (var bj3 = 0; bj3 < HC; bj3++) { pushL(0, bj3); pushL(WC - 1, bj3); }
            while (stkL.length) {
              var oP = stkL.pop();
              var pxP = oP % WC, pyP = (oP / WC) | 0;
              pushL(pxP + 1, pyP); pushL(pxP - 1, pyP); pushL(pxP, pyP + 1); pushL(pxP, pyP - 1);
            }
            for (var oF = 0; oF < WC * HC; oF++) { if (!extL[oF]) mdL[oF * 4 + 3] = 255; }
            mx2.putImageData(midL, 0, 0);
          }
          /* NO base bubble until the customer actually PICKS a background —
             the default white read as an uninvited sticker border around
             bg-removed art (Justin 2026-08-21). Leather always shows its
             hide. */
          var bgPickedC2 = !noneBgC && !!((ov && ov.bg) || (st.bg && (st.bg.hex || st.bg.follow)));
          if (bgHex && !freeF && (bgPickedC2 || leatherCutC)) {
            var baseLayer = document.createElement('canvas'); baseLayer.width = WC; baseLayer.height = HC;
            var bx2 = baseLayer.getContext('2d');
            bx2.drawImage(mask, 0, 0);
            bx2.globalCompositeOperation = 'source-in';
            bx2.fillStyle = bgHex;
            bx2.fillRect(0, 0, WC, HC);
            var texPC = texturePattern(bx2, bgHex, texKind, C);
            if (texPC) { bx2.fillStyle = texPC; bx2.fillRect(0, 0, WC, HC); }
            xC.drawImage(baseLayer, 0, 0);
          }
          if (leatherCutC && st.etchInvert) {
            /* INVERTED etch on a custom cut: burn the whole cut face */
            var invL = document.createElement('canvas'); invL.width = WC; invL.height = HC;
            var ivx = invL.getContext('2d');
            ivx.drawImage(mask, 0, 0);
            ivx.globalCompositeOperation = 'source-in';
            ivx.fillStyle = leatherEtch().hex;
            ivx.fillRect(0, 0, WC, HC);
            xC.drawImage(invL, 0, 0);
          }
          if (isLeather()) xC.drawImage(etchArtCanvas(img, awC, ahC, st.etchInvert ? (bgHex || '#DCA05F') : null), padC, padC, awC, ahC);
          else if (ffTone || PTYPE.monoTone) xC.drawImage(monoArtCanvas(img, awC, ahC, ffTone || PTYPE.monoTone), padC, padC, awC, ahC);
          else xC.drawImage(img, padC, padC, awC, ahC);
          if (leatherCutC && st.border && /etched/i.test(st.border.label || '')) {
            /* etched border on a CUSTOM cut (Justin 2026-08-21): a burn band
               that FOLLOWS the contour, inset from the cut edge, thickness
               1-10 — erosion by 28-direction intersection (the inverse of
               the dilation used for the ring above) */
            var lbTC = Math.max(1, Math.min(10, st.lbThick || 3));
            var lbWC = Math.max(2, Math.min(20, lbTC * 2));
            var lbInC = Math.round(Math.min(WC, HC) * 0.045) + 2;
            var erodeC = function (rE) {
              var e = document.createElement('canvas'); e.width = WC; e.height = HC;
              var ex2 = e.getContext('2d');
              ex2.drawImage(mask, 0, 0);
              ex2.globalCompositeOperation = 'destination-in';
              for (var aK = 0; aK < 28; aK++) {
                var angK = aK / 28 * Math.PI * 2;
                ex2.drawImage(mask, Math.cos(angK) * rE, Math.sin(angK) * rE);
              }
              return e;
            };
            var bandC = erodeC(lbInC);
            var bx3 = bandC.getContext('2d');
            bx3.globalCompositeOperation = 'destination-out';
            bx3.drawImage(erodeC(lbInC + lbWC), 0, 0);
            bx3.globalCompositeOperation = 'source-in';
            bx3.fillStyle = leatherEtch().hex;
            bx3.fillRect(0, 0, WC, HC);
            xC.globalAlpha = 0.92;
            xC.drawImage(bandC, 0, 0);
            xC.globalAlpha = 1;
          }
          cb(cvC);
          return;
        }
        var polyPts = null;
        if (SHAPE_CLIPS[g]) {
          polyPts = [];
          (SHAPE_CLIPS[g].match(/([\d.]+)%\s+([\d.]+)%/g) || []).forEach(function (p) {
            var m = p.match(/([\d.]+)%\s+([\d.]+)%/);
            polyPts.push([parseFloat(m[1]) / 100, parseFloat(m[2]) / 100]);
          });
        }
        function shapePath(x0, y0, w2, h2) {
          x.beginPath();
          if (g === 'circle' || g === 'oval' || g === 'oval-h') {
            x.ellipse(x0 + w2 / 2, y0 + h2 / 2, w2 / 2, h2 / 2, 0, 0, Math.PI * 2);
          } else if (polyPts) {
            polyPts.forEach(function (p, i2) {
              var px = x0 + p[0] * w2, py = y0 + p[1] * h2;
              if (i2 === 0) x.moveTo(px, py); else x.lineTo(px, py);
            });
          } else {
            var r = (((ov && ov.corners) || (ov ? 'rounded' : st.corners)) === 'square') ? 0 : Math.min(w2, h2) * 0.1;
            if (r > 0 && x.roundRect) x.roundRect(x0, y0, w2, h2, r);
            else x.rect(x0, y0, w2, h2);
          }
          x.closePath();
        }
        /* the border is a STROKE along the shape path — uniform width on every
           contour (an inset-scaled copy pinches at hearts' clefts and tips) */
        var inset = Math.max(ring, 2);
        if (bgHex) {
          shapePath(inset, inset, W - inset * 2, H - inset * 2);
          x.fillStyle = bgHex; x.fill();
          var texP = texturePattern(x, bgHex, texKind, C);
          if (texP) {
            x.save();
            shapePath(inset, inset, W - inset * 2, H - inset * 2);
            x.clip();
            x.fillStyle = texP;
            x.fillRect(0, 0, W, H);
            x.restore();
          }
        }
        x.save();
        shapePath(inset, inset, W - inset * 2, H - inset * 2);
        x.clip();
        /* Match My Artwork must NOT change the artwork fill — the full-face
           bump made the preview visibly jump/zoom on the MMA click. The
           customer owns fill via the Artwork fill slider alone. */
        var safe = thNoneC ? 1 : (SHAPE_SAFE[g] || 0.68);
        if (PTYPE.textFill) safe = PTYPE.textFill; /* names fill the patch more generously */
        /* long names are WIDTH-bound: give them their own, wider cap so a
           'Christopher' runs close to the merrow while the height keeps its
           breathing room above and below the lettering */
        var safeW = PTYPE.textFillW || safe;
        /* MATCH MY ARTWORK on a standard shape (B56): the artwork IS the
           patch face, so it fills the shape completely — the shape clip
           (incl. ROUNDED corners) then genuinely cuts its edges. At the old
           68% fit the art's own sharp corners sat inside the rounded clip
           untouched — Justin's "MMA overrides rounded corners" bug. */
        if (followBgC) { safe = 1; safeW = 1; }
        var zmV = (ov && ov.zoom) || st.artZoom;
        var maxW = W * safeW * zmV, maxH = H * safe * zmV;
        var s = Math.min(maxW / img.naturalWidth, maxH / img.naturalHeight);
        /* MMA (B57): COVER with a 4% bleed — the art runs past the clip so
           the shape's rounded corner is the ONLY curve; contain-fit left the
           art's own baked-in corners fighting the clip (chamfered mess) */
        if (followBgC) s = Math.max(maxW / img.naturalWidth, maxH / img.naturalHeight) * 1.04;
        var aw = img.naturalWidth * s, ah = img.naturalHeight * s;
        var cyF = ({ shield: 0.44, heart: 0.45 })[g] || 0.5;
        /* INVERTED etch on a standard shape: the PATCH FACE never changes —
           only the DESIGN flips (fills burn, detail reads as bare hide) */
        if (isLeather()) x.drawImage(etchArtCanvas(img, aw, ah, null, st.etchInvert), (W - aw) / 2, H * cyF - ah / 2, aw, ah);
        else if (ffTone || PTYPE.monoTone) x.drawImage(monoArtCanvas(img, aw, ah, ffTone || PTYPE.monoTone), (W - aw) / 2, H * cyF - ah / 2, aw, ah);
        else x.drawImage(img, (W - aw) / 2, H * cyF - ah / 2, aw, ah);
        x.restore();
        if (isLeather() && st.border && /etched/i.test(st.border.label || '')) {
          /* laser-etched border line, inset from the edge (thickness 1-10) */
          var lbT = Math.max(1, Math.min(10, st.lbThick || 3));
          var lbIn = inset + Math.round(Math.min(W, H) * 0.055);
          shapePath(lbIn, lbIn, W - lbIn * 2, H - lbIn * 2);
          x.strokeStyle = leatherEtch().hex;
          x.globalAlpha = 0.92;
          x.lineWidth = Math.max(2, Math.min(20, lbT * 2));
          x.lineJoin = 'round';
          x.stroke();
          x.globalAlpha = 1;
        }
        if (ring > 0 && ringHex) {
          shapePath(inset, inset, W - inset * 2, H - inset * 2);
          /* The diagonal merrow hatching is a shorthand for the CUSTOMER'S view.
             It must never reach Patch Sensei: the renderer treats the composed
             image as the finished layout, so it reproduced those stripes as a
             literal striped metal band. It already receives border_style:
             Merrow as a mandatory spec and its style profile knows how to build
             a merrow edge — so the reference gets a solid ring in the thread
             colour and the renderer supplies the real texture. */
          x.strokeStyle = (isMerrow && !(ov && ov.refOnly)) ? merrowPattern(x, ringHex, ring) : ringHex;
          x.lineWidth = ring * 2;
          x.lineJoin = 'round'; /* no round caps — they dot the path start */
          x.stroke();
        }
        cb(cv);
      } catch (e) { cb(null); }
    };
    img.onerror = function () { cb(null); };
    img.src = raw;
  }
  function backdropCanvas(cv, avoid) {
    /* the renderer flattens transparent padding to white, so a white patch
       background is indistinguishable from the studio backdrop and the model
       silhouette-cuts the patch (2026-08-15 skull/rectangle case). Host the
       reference on an explicit neutral grey stage so the patch boundary is
       unambiguous; display surfaces keep the transparent copy. */
    /* pick whichever grey sits FURTHEST from the patch's own colors */
    var cands = [[179, 179, 179, '#B3B3B3'], [98, 102, 109, '#62666D']];
    var back = cands[0][3], bestD = -1;
    cands.forEach(function (c) {
      var dMin = Infinity;
      (avoid || []).forEach(function (h) {
        if (!h || !/^#[0-9a-fA-F]{6}$/.test(h)) return;
        var r = parseInt(h.substr(1, 2), 16), g2 = parseInt(h.substr(3, 2), 16), b = parseInt(h.substr(5, 2), 16);
        var d = Math.sqrt((r - c[0]) * (r - c[0]) + (g2 - c[1]) * (g2 - c[1]) + (b - c[2]) * (b - c[2]));
        if (d < dMin) dMin = d;
      });
      if (dMin > bestD) { bestD = dMin; back = c[3]; }
    });
    var pad = Math.round(Math.max(cv.width, cv.height) * 0.12);
    var out = document.createElement('canvas');
    out.width = cv.width + pad * 2; out.height = cv.height + pad * 2;
    var x = out.getContext('2d');
    x.fillStyle = back;
    x.fillRect(0, 0, out.width, out.height);
    x.drawImage(cv, pad, pad);
    return out;
  }
  function composeAndHost() {
    /* returns a promise; sets sensei.composedUrl (null on any failure —
       generation falls back to the raw artwork) */
    return new Promise(function (resolve) {
      composePatchImage(function (cv) {
        if (!cv) { sensei.composedUrl = null; sensei.composedLocal = null; sensei.composedCleanUrl = null; sensei.composedCleanDone = true; resolve(null); return; }
        /* local copy: the compare slider can always show the TRUE preview
           even if hosting fails */
        try { sensei.composedLocal = cv.toDataURL('image/png'); } catch (e) { sensei.composedLocal = null; }
        var bp = backdropCanvas(cv, [st.bg && st.bg.hex, st.thread && st.thread.hex]);
        sensei.composedCleanUrl = null;
        sensei.composedCleanDone = false;
        var cseq = (sensei.composeSeq = (sensei.composeSeq || 0) + 1);
        /* C13 (2026-08-25) — NORMALISE TO IMGIX AT THE SOURCE. hostProof returns
           the presign S3 URL. Storing that raw broke TWO things at once on live
           order PATCH-2107255: _Upload shipped as
           ninja-services-production-ninjauploadss3bucket-….s3.amazonaws.com, and
           the SPEC SHEET never built — composeSpec loads its base with
           crossOrigin='anonymous' and the raw S3 host sends no CORS headers, so
           the canvas taints and the compose dies silently. imgix fronts the same
           object WITH CORS. A third assignment site already did this
           (`= toImgixHost(u4)`); these two did not. */
        hostProof(cv, 'refclean' + (Date.now() % 100000), function (e2, cu) { if (sensei.composeSeq === cseq) { sensei.composedCleanUrl = cu ? toImgixHost(cu) : null; sensei.composedCleanDone = true; } });
        var done = false;
        var t = setTimeout(function () { if (!done) { done = true; sensei.composedUrl = null; resolve(null); } }, 8000);
        hostProof(bp, 'ref' + (Date.now() % 100000), function (e, url) {
          if (done) return;
          done = true; clearTimeout(t);
          sensei.composedUrl = url ? toImgixHost(url) : null; /* C13: imgix, not raw S3 */
          resolve(sensei.composedUrl);
        });
      }, null, { refOnly: 1, corners: st.corners, freeform: isFreeFormShape() });
    });
  }
  function senseiNoteDirective() {
    /* explicit render instructions — the shape MUST be honored */
    var parts = [];
    parts.push('CAMERA: perfectly FLAT top-down product photo taken straight above the patch — no perspective tilt, no visible side thickness or stacked edge, NO white plate, backing board, or mat beneath or behind the patch, no halo. The patch is the ONLY object, lying flat directly on the plain studio backdrop.');
    /* a type whose construction is NOT "artwork sitting on a patch base"
       states its own MATERIAL paragraph and skips the generic base/shape copy
       below, which would otherwise instruct the renderer to invent a patch */
    if (PTYPE.matNote) parts.push(typeof PTYPE.matNote === 'function' ? PTYPE.matNote() : PTYPE.matNote);
    if (st.fdChoice === 'ps') parts.push('HYBRID PRINT & STITCH: render the LARGE solid areas as embroidered thread and the small text / fine-detail areas as smooth flat printed sublimation on the twill — a realistic mixed-media patch.');
    if (isLeather()) {
      parts.push('HARD RULE: this is ' + (PTYPE.name === 'Faux Leather' ? 'FAUX' : 'GENUINE') + ' LEATHER — absolutely NO stitching, thread, embroidery, or merrow anywhere. The artwork is a single-tone laser etch (' + leatherEtch().hex + ' burn tone), never full color.');
      if (isLeather() && st.etchInvert) parts.push('INVERTED ETCH: the entire leather face is laser-burned to the dark etch tone, and the ARTWORK is left as bare un-burned leather \u2014 the design reads leather-light on burned-dark, the exact inverse of a normal etch.');
      if (st.border && /etched/i.test(st.border.label || '')) parts.push('BORDER: a thin laser-etched border LINE runs parallel to the patch edge, inset slightly from it like a debossed groove, thickness ' + (st.lbThick || 3) + ' out of 10, in the same etch tone. A clean continuous line — never stitching.');
      else parts.push('The patch edge is a smooth clean-cut leather edge with NO border line of any kind.');
    }
    /* LIGHT BORDER vs LIGHT BACKDROP (Justin 2026-08-24): a white/cream
       border sits ~5% away from the #F2F2F2 studio backdrop — generative
       renderers absorb near-identical tones into one region and the border
       washes out or thins. Spell out the separation. */
    var thLbN = (st.thread && st.thread.label) || '';
    var thHxN = (st.thread && st.thread.hex) || '';
    var isLightBorder = /white|cream|ivory|natural|silver|light gr[ae]y/i.test(thLbN);
    if (!isLightBorder && /^#?[0-9a-f]{6}$/i.test(thHxN)) {
      var hN = thHxN.replace('#', '');
      isLightBorder = (0.299 * parseInt(hN.slice(0, 2), 16) + 0.587 * parseInt(hN.slice(2, 4), 16) + 0.114 * parseInt(hN.slice(4, 6), 16)) > 218;
    }
    if (isLightBorder && st.thread && !/^none$/i.test(thLbN) && !isLeather()) {
      parts.push('LIGHT BORDER ON A LIGHT BACKDROP: the ' + thLbN + ' border is nearly the same tone as the studio backdrop \u2014 it must remain CLEARLY visible at its full thickness on every side: render its raised thread texture crisply and add a soft neutral contact shadow just outside the patch edge so the border reads against the backdrop. NEVER thin, dim, grey, or blend the border into the backdrop.');
    }
    if (PTYPE.borderThick && PTYPE.lbZeroMax2 && st.thread && !/^none$/i.test(st.thread.label || '')) {
      var tSN = Math.max(1, Math.min(10, st.lbThick || PTYPE.lbDefault || 5));
      parts.push('BORDER RIM THICKNESS: the raised moulded border rim is ' + (tSN / 5).toFixed(1) + 'x the standard rim width (' + tSN + ' of 10, where 5 is standard, 1 is a barely-there fine rim and 10 is twice standard). Keep it identical on every side.');
    }
    if (/silicone|rubber/.test(TYPE_KEY) && st.backing && /hook|velcro/i.test(st.backing.label || '')) parts.push('ABSOLUTE RULE \\u2014 VELCRO BACKING SEW LINE (overrides any no-stitching rule for this material): the hook-and-loop backing is SEWN on and its attachment stitching MUST be clearly visible on the front of the patch: one single continuous track of small, even machine stitches running around the ENTIRE outer rim, inset about 2mm from the outer edge, following the patch outline exactly, unbroken with no gaps \\u2014 it reads like a fine dashed thread line drawn around the rim. A render without this visible perimeter stitch track is WRONG.');
    /* The renderer improvises border thickness — it came back thinner on one
       side of a merrow patch. Our reference ring is uniform by construction, so
       this has to be stated explicitly in the prompt. */
    if (!isLeather() && st.border && !/no border/i.test(st.border.label || '')) {
      parts.push('BORDER WIDTH: the border runs around the ENTIRE patch at exactly the SAME thickness on every side — top, bottom, left and right are identical. Never taper, thin, or thicken it on one edge, and never let it fade out or break at a corner. Measure it as one constant band following the outline.');
    }
    var thNoneD = !!(st.thread && (st.thread.none || /^none$/i.test(st.thread.label || '')));
    var thFollowD = isFollowVal(st.thread);
    var bgFollowD = isFollowVal(st.bg);
    if (sensei.composedUrl && !sensei.titleOverride && !PTYPE.bareArt) {
      parts.push('The supplied artwork image IS the fully composed patch layout — shape, background color, border ring, and art placement are already exact. The patch lies on a neutral grey studio backdrop in that image: the grey area is the photography surface, NOT part of the patch. Keep the full patch base shape exactly as shown and reproduce it faithfully as a real embroidered patch — do NOT cut the patch outline to the artwork silhouette.');
    }
    if (st.shape && !PTYPE.bareArt) {
      var sg = shapeGeom();
      if (PTYPE.monoTone) parts.push('SINGLE MATERIAL FINISH: this patch is molded entirely from ' + (PTYPE.fixedBg ? PTYPE.fixedBg.label : 'one colour') + ' flex. The design is NOT printed in colour — it is raised in the SAME material, so the whole patch is one colour and the artwork reads only through its raised relief, highlights and shadow. Do NOT reproduce the artwork colours.');
      if (sg === 'custom' && isFreeFormShape()) parts.push('The patch is FREE FORM: every element of the design is cut as its OWN separate piece, with no shared backing, no connecting base, no background field behind the design and NO border of any kind. Reproduce only the artwork itself, cut out.');
      else if (sg === 'custom' && isLeather()) parts.push('The patch is a CUSTOM SHAPE cut from the hide EXACTLY along the artwork\'s own outer contour \u2014 no margin around the design, no base sticking out past it, and NO border of any kind. Interior knockout detail stays leather; the artwork is laser-etched into the surface so every line and indentation of the design reads as burn marks.');
      else if (sg === 'custom') parts.push('The patch is a CUSTOM SHAPE: the base is cut as ONE smooth continuous contour hugging the overall outline of the whole design — NEVER cut around individual letters or elements — and filled with the background color' + ((thNoneD || thFollowD) ? '.' : (', with a ' + ((st.thread && st.thread.hex && st.thread.label !== 'Let Ninja Choose' && st.thread.label !== 'Not Sure') ? st.thread.label + ' ' : '') + 'border running along that outer contour.')));
      else parts.push('The patch base shape MUST be a ' + st.shape + (SHAPE_DESC[sg] ? ' (' + SHAPE_DESC[sg] + ')' : '') + ((sg === 'square' || sg === 'rectangle' || sg === 'rectangle-v') ? (st.corners === 'square' ? ', with sharp SQUARE corners (no rounding),' : ', with softly rounded corners,') : '') + ' — the fabric patch itself is a ' + st.shape + ' with the artwork placed on it, NOT cut to the artwork outline.');
    }
    parts.push('Patch dimensions: ' + st.w.toFixed(2) + '" wide x ' + st.h.toFixed(2) + '" tall.');
    if (bgFollowD) parts.push('BACKGROUND: the artwork already contains its own background — reproduce it exactly as shown in the artwork; do NOT add or change any background color.');
    else if (st.bg && st.bg.label !== 'Let Ninja Choose' && st.bg.label !== 'Not Sure') parts.push('Patch background color: ' + st.bg.label + (st.bg.hex ? ' (' + st.bg.hex + ')' : '') + (thNoneD ? ' — this color fills the design INTERIOR only; it must NEVER extend beyond or wrap around the artwork\'s outermost edge.' : '.'));
    if (thNoneD) parts.push('NO ADDED BORDER: do not add any border, outline, rim, ring, or edge highlight of your own. FOLLOW THE ARTWORK EDGE-FOR-EDGE — if the artwork already includes its own border, outer ring, or edge design, reproduce that edge EXACTLY as drawn in the artwork colors, and the patch is CUT exactly at that outermost edge: NO patch material, base color, or margin of ANY color extends beyond the artwork\'s outer boundary. Only if the artwork has no edge design of its own does the background color run cleanly to the edge.');
    else if (thFollowD) parts.push('BORDER: the artwork already includes its own border/edge treatment — keep it exactly as drawn in the artwork; do NOT add another border ring.');
    else if (st.thread && st.thread.label !== 'Let Ninja Choose' && st.thread.label !== 'Not Sure') parts.push('Border thread color: ' + st.thread.label + (st.thread.hex ? ' (' + st.thread.hex + ')' : '') + '.');
    if (st.border) parts.push('Border style: ' + normalizeBorder(st.border.label) + '.');
    if (st.artZoom && Math.abs(st.artZoom - 1) > 0.02) {
      parts.push('Artwork fill: scale the artwork to about ' + Math.round(st.artZoom * 100) + '% of standard sizing within the patch (' + (st.artZoom > 1 ? 'larger — filling more of the patch' : 'smaller — leaving more margin') + ').');
    }
    parts.push('PLACEMENT: the design group must sit in the EXACT CENTER of the patch — equal empty space above and below the design, equal space left and right. Never place the design in the top half with empty material below it.');
    return '[' + parts.join(' ') + ']';
  }
  function senseiSpecs() {
    return {
      /* bare art (tackle twill) = the renderer's FREE FORM path: separate cut
         pieces, no base, no contour border — its colours travel in the NOTE,
         because background_color/border_color read as patch base + ring specs
         and produced one solid patch with a merrow around everything */
      shape: PTYPE.bareArt ? 'Free Form' : (st.shape || ''),
      background_color: (!PTYPE.bareArt && !isLeather() && stepEnabled('bg') && st.bg && !isFollowVal(st.bg) && st.bg.label !== 'Not Sure' && st.bg.label !== 'Let Ninja Choose') ? (st.bg.label + (st.bg.hex ? ' (exact hex ' + st.bg.hex + ')' : '')) : '',
      leather_color: (isLeather() && st.bg) ? st.bg.label : '',
      border_color: (!PTYPE.bareArt && stepEnabled('thread') && st.thread && !isFollowVal(st.thread) && st.thread.label !== 'Not Sure' && st.thread.label !== 'Let Ninja Choose' && st.thread.label !== 'None') ? (st.thread.label + (st.thread.hex ? ' (exact hex ' + st.thread.hex + ')' : '')) : '',
      border_style: (function () {
        var bs = (stepEnabled('border') && st.border && !(st.thread && (st.thread.none || /^none$/i.test(st.thread.label || '')))) ? normalizeBorder(st.border.label) : '';
        if (bs && isLeather() && /etched/i.test(bs)) bs += ' (etched line thickness ' + (st.lbThick || 3) + ' of 10)';
        return bs;
      })(),
      background_texture: (stepEnabled('texture') && st.texture) ? st.texture.label : '',
      border_thickness: PTYPE.borderThick ? (Math.max(1, Math.min(10, st.lbThick || PTYPE.lbDefault || 3)) + ' of 10' + (PTYPE.lbZeroMax2 ? ' (5 = the standard rim width, 1 = a barely-there fine rim, 10 = twice the standard width)' : '')) : '',
      /* velcro-backed PVC/silicone: the sewn-on backing's stitch track must
         show on the front. Rides as a SPEC (mandatory prompt line) because
         the render Lambda never sees the line-level note (2026-08-24). */
      backing_sew_line: (/silicone|rubber/.test(TYPE_KEY) && st.backing && /hook|velcro/i.test(st.backing.label || ''))
        ? 'VELCRO BACKING SEW LINE (required): the hook-and-loop backing is SEWN on \u2014 render one single continuous track of small, even machine stitches around the ENTIRE outer rim, inset about 2mm from the outer edge, following the patch outline exactly, unbroken with no gaps, clearly visible on the front like a fine dashed thread line. A render without this stitch track is wrong.'
        : '',
      corner_style: (function () { var g3 = shapeGeom(); return (g3 === 'square' || g3 === 'rectangle' || g3 === 'rectangle-v') && st.corners ? (st.corners === 'square' ? 'Square (sharp corners, no rounding)' : 'Rounded corners') : ''; })(),
      border_stitch: (PTYPE.stitches && st.ttStitch) ? st.ttStitch : '',
      width_inches: st.w.toFixed(2),
      height_inches: st.h.toFixed(2)
    };
  }
  function senseiArtworkOf(item) {
    var p = item.properties || {};
    return cleanUrl(p._cartImg || p['_Original Image'] || p._artwork_url || p._Upload || p.Upload || artworkUrl());
  }
  function specsFromProps(p) {
    var shape = p['_Shape'] || p['_Select Shape'] || p['Select Shape'] || '';
    return {
      shape: shape,
      /* fallback chain covers every name any era wrote: canonical first, then
         the legacy shared names, then the per-type labels (leather/faux wrote
         'Leather Color'/'Faux Leather Color'; PVC/silicone/flex wrote plain
         'Border Color') — an OLD order of any type must still rebuild */
      background_color: p['_Background Color'] || p['Patch Background Color'] || p['Leather Color'] || p['Faux Leather Color'] || '',
      border_color: p['_Border Color'] || p['Border Thread Color'] || p['Border Color'] || p['Border Color (Merrow only)'] || '',
      border_style: normalizeBorder(p['_Border Style'] || p['_Border Style ' + shape] || ''),
      width_inches: p['_Width (in)'] || p['Width (in)'] || '',
      height_inches: p['_Height (in)'] || p['Height (in)'] || ''
    };
  }
  function senseiLines(cart, regenNote) {
    /* THE PAYLOAD IS THIS SESSION ONLY: one line — fresh render id, the
       image in the canvas right now, the current selections, the note.
       Other cart lines are never sent, so old sessions/test lines can't
       leak into the render (the proof-preview page rebuilds its own full
       session from the cart when it loads). */
    return [{
      line_item_id: sensei.renderLineId,
      /* full-color proofs render under the FC product title — the backend
         derives its render style from the title */
      title: sensei.titleOverride || CFG.productTitle || 'Embroidered Patches',
      quantity: st.qty,
      /* embroidered renders get the COMPOSED reference image (shape+colors
         baked in); Full Color and fallbacks use the raw artwork */
      artwork_url: ((!sensei.titleOverride || PTYPE.noArt) && sensei.composedUrl) || cleanUrl(artworkUrl()),
      specs: (function () {
        var sp = senseiSpecs();
        if (sensei.editBase) { sp.revision_note = sensei.editBase.note; sp.prev_mockup_url = sensei.editBase.url; sensei.editBase = null; }
        return sp;
      })(),
      /* the renderer respects the PROMPT more than the specs — spell the
         shape (and everything else) out explicitly in the note */
      note: ((regenNote
        ? 'CUSTOMER REVISION REQUEST \u2014 HIGHEST PRIORITY, apply it even where it conflicts with the reference image layout: \"' + regenNote + '\". '
        : ((customerNotes() || '') + ' ')) + senseiNoteDirective()).trim()
    }];
  }
  function findOurLine(cart) {
    /* identify OUR cart line by the artwork it carries — position-based
       matching (items[0]) breaks when an add merges into an existing line
       and once caused a stale patch's render to show as the proof */
    var art = cleanUrl(artworkUrl());
    var match = null;
    (cart.items || []).forEach(function (it) {
      if (match) return;
      var p = it.properties || {};
      var lineArt = cleanUrl(p._cartImg || p._Upload || p['_Original Image'] || '');
      if (art && lineArt && (lineArt === art || lineArt.split('?')[0] === art.split('?')[0])) match = it.key || String(it.id);
    });
    return match || ((cart.items && cart.items[0]) ? (cart.items[0].key || String(cart.items[0].id)) : null);
  }
  /* ═══ STAGING GENERATOR OVERRIDE (Justin 2026-08-21) ═══
     When assets/np-ideogram-gen.js is present (staging only) AND the page
     carries ?np_gen=1, generation is routed through window.NP_GEN instead of
     the PatchSensei render API. Everything downstream — versions, the proof
     modal, approve, cart properties, spec sheets — is untouched: the override
     just has to resolve to a hosted image URL, exactly like a mockup_url.
     On live the asset does not exist, genOn() is false, and this is inert. */
  function genOn() {
    try {
      if (/[?&]np_gen=0/.test(window.location.search)) return false; /* escape hatch */
      /* AUTO-ON for the staging theme (Justin 2026-08-21): every product page
         on "Justin Staging 8-21" uses the nb2 generator with no URL param.
         Inert everywhere else — the LIVE theme id never matches, and the
         generator asset only exists on staging anyway. ⚠ If this staging
         theme is ever PUBLISHED, remove its id here first. */
      /* nano lane RETIRED on staging (Justin 2026-08-24): 8-21 renders via
         PatchSensei/OpenAI exactly like live. Keyed to no theme. */
      if (window.Shopify && Shopify.theme && String(Shopify.theme.id) === '0') return true;
      /* STAGING ONLY (Justin 2026-08-24): np_gen=1 once persisted to
         localStorage and the generator asset now ships on BOTH themes (for
         the shared prompt code), so the flag was silently routing LIVE
         renders through nano instead of PatchSensei. Off the staging theme,
         the generator never runs — and the leaked flag is scrubbed. */
      try { localStorage.removeItem('np_gen'); } catch (eGc) {}
      return false;
    } catch (eG) { return false; }
  }
  function genLoad() {
    if (!genOn() || window.NP_GEN || window.__npGenLoading) return;
    window.__npGenLoading = true;
    var mine = document.querySelector('script[src*="np-emb2.js"]');
    var src = window.NP_E2_GEN_SRC ||
      (mine ? mine.src.replace(/np-emb2\.js/, 'np-ideogram-gen.js') : '');
    if (!src) { console.warn('[np-e2] cannot locate generator asset'); return; }
    var sc = document.createElement('script');
    sc.src = src;
    sc.async = true;
    sc.onerror = function () { console.warn('[np-e2] generator override asset missing — staying on sensei'); };
    document.head.appendChild(sc);
  }
  function genActive() { return genOn() && !!(window.NP_GEN && window.NP_GEN.render); }
  try { genLoad(); } catch (eGL) {}
  /* dark upload skin now gates in np-emb2-builder.liquid (theme.id) so the
     stylesheet is present at FIRST PAINT — the JS loader here caused FOUC */
  function genContext(regenNote) {
    var geomG = shapeGeom();
    var thNoneG = !!(st.thread && (st.thread.none || isFollowVal(st.thread) || /^none$/i.test(st.thread.label || '')));
    var noteG = regenNote || customerNotes() || '';
    return {
      typeKey: TYPE_KEY,
      materialPhrase: (function () {
        if (isLeather()) return (PTYPE.name === 'Faux Leather' ? 'faux leather' : 'genuine leather');
        if (PTYPE.monoTone) return 'molded ' + ((PTYPE.fixedBg && PTYPE.fixedBg.label) || 'flex') + ' flex';
        if (/fullcolor/.test(TYPE_KEY)) return 'full-colour printed';
        if (/woven/.test(TYPE_KEY)) return 'woven';
        if (/chenille/.test(TYPE_KEY)) return 'chenille';
        if (/silicone|rubber/.test(TYPE_KEY)) return 'moulded PVC';
        return 'embroidered';
      })(),
      isLeather: isLeather(),
      etchHex: isLeather() ? leatherEtch().hex : '',
      etchInvert: !!st.etchInvert,
      monoTone: !!PTYPE.monoTone,
      fixedBg: PTYPE.fixedBg || null,
      fullColor: /fullcolor/.test(TYPE_KEY) || !!sensei.titleOverride && /full color/i.test(sensei.titleOverride || ''),
      woven: /woven/.test(TYPE_KEY) || !!sensei.titleOverride && /woven/i.test(sensei.titleOverride || ''),
      printStitch: st.fdChoice === 'ps' || /print-and-stitch/.test(TYPE_KEY),
      freeform: (typeof isFreeFormShape === 'function') ? !!isFreeFormShape() : false,
      bareArt: !!PTYPE.bareArt,
      chenille: /chenille/.test(TYPE_KEY),
      pvc: /silicone|rubber/.test(TYPE_KEY),
      shape: st.shape || '',
      shapeDesc: SHAPE_DESC ? (SHAPE_DESC[geomG] || '') : '',
      geom: geomG,
      corners: (geomG === 'square' || geomG === 'rectangle' || geomG === 'rectangle-v') ? (st.corners || '') : '',
      w: st.w ? st.w.toFixed(2) : '', h: st.h ? st.h.toFixed(2) : '',
      bg: st.bg || null, bgFollow: isFollowVal(st.bg),
      thread: st.thread || null, threadNone: thNoneG,
      borderStyle: st.border ? normalizeBorder(st.border.label) : '',
      borderThickness: st.lbThick || PTYPE.lbDefault || 3,
      lbTuned: !!(PTYPE.borderThick && PTYPE.lbZeroMax2),
      texture: (st.texture && st.texture.label) || '',
      backing: (st.backing && st.backing.label) || '',
      velcroSew: /silicone|rubber/.test(TYPE_KEY) && !!(st.backing && /hook|velcro/i.test(st.backing.label || '')),
      notes: noteG,
      referenceUrl: sensei.composedUrl || '',
      artworkUrl: cleanUrl(artworkUrl())
    };
  }
  function senseiCreate(cart, regenNote) {
    /* B72 (2026-08-25) — STRIP THE CART-TOKEN QUERY STRING.
       Shopify's cart.token now comes back as "<token>?key=<hash>". The proof
       poll builds its URL with encodeURIComponent(cartToken), which turns that
       "?key=" into "%3Fkey%3D" INSIDE the path segment, so the ECS looks up a
       token that does not exist, answers 200 with no matching line, and the
       client waits on a render that will never appear (versions stays 0, the
       modal spins forever on "Rendering your patch").
       Diagnosed live from Justin's Safari session uP0GCLkHMA:
         GET /api/proof/session/hWNG3H8ROlGnKZuP0GCLkHMA%3Fkey%3D9d89... 200
       It is cart-dependent, not browser-dependent — which is why it reproduced
       on his cart and never on mine. */
    sensei.cartToken = String(cart.token || '').split('?')[0];
    /* ARTWORK OF RECORD (PATCH-2106699, 2026-08-24): the upload that this
       render is generated FROM. The legacy uploader's timers can clobber the
       hidden art inputs with an OLD upload right before Add to Cart — that
       order's _Original Image showed a file from two days earlier. The art
       captured at render time is the truth the proof was made from. */
    var artAR = cleanUrl(artworkUrl());
    if (artAR && isUploadLineage(artAR)) sensei.artAtRender = artAR;
    /* pre-Add-to-Cart there is no cart line — a stable synthetic id keys the
       session line instead (create + decision must use the same id) */
    sensei.syntheticId = sensei.syntheticId || ('npe2-' + Date.now());
    sensei.lineItemId = findOurLine(cart) || sensei.syntheticId;
    if (sensei.forceFresh) {
      /* one unique render id per generate — guarantees the render reflects
         the CURRENT config (cached session lines can carry old configs) and
         costs exactly one render (the old echo-comparison approach was
         double-rendering every generate: ~45s instead of ~15s) */
      sensei.renderLineId = sensei.lineItemId + '::g' + (new Date().getTime() % 10000000);
      sensei.forceFresh = false;
    }
    if (!sensei.renderLineId) sensei.renderLineId = sensei.lineItemId;
    if (genActive()) {
      /* staging: Ideogram renders instead of sensei. Resolve into the same
         shape senseiPoll returns, so the wait loop needs no special case. */
      sensei.__gen = { status: 'processing', url: '' };
      window.NP_GEN.render(genContext(regenNote)).then(function (u) {
        sensei.__gen = { status: 'complete', url: u };
      }).catch(function (e) {
        console.warn('[np-gen] render failed', e);
        sensei.__gen = { status: 'error', error: String((e && e.message) || e) };
      });
      return Promise.resolve({ session_id: 'gen-' + sensei.renderLineId });
    }
    return fetch(SENSEI_EP + '/api/proof/session', {
      method: 'POST',
      body: JSON.stringify({ cart_token: cart.token, line_items: senseiLines(cart, regenNote) })
    }).then(function (r) {
      if (!r.ok) throw new Error('session ' + r.status);
      return r.json();
    }).then(function (j) { sensei.sessionId = j.session_id; return j; });
  }
  function senseiPoll() {
    if (genActive() && sensei.__gen) {
      var g = sensei.__gen;
      return Promise.resolve({
        line_item_id: sensei.renderLineId,
        session_id: 'gen-' + sensei.renderLineId,
        status: g.status,
        mockup_url: g.url || '',
        error: g.error || '',
        revision_count: 0
      });
    }
    /* B77 (2026-08-25) — DEFEAT THE POLL CACHE.
       This was a bare GET with no cache directives. Safari caches such GETs
       aggressively and re-served the FIRST "pending" body for the life of the
       render: the client never saw status:complete, and the origin barely saw
       traffic (measured: ONE poll in four minutes while a render ran to
       completion). Chrome revalidates more eagerly, which is why it only ever
       failed on Safari. Cache-bust per request AND ask for no-store. */
    var _pollUrl = SENSEI_EP + '/api/proof/session/' + encodeURIComponent(sensei.cartToken) +
                   '?_=' + Date.now() + '.' + Math.floor(Math.random() * 100000);
    /* NO custom request headers here. Cache-Control/Pragma are NOT CORS-safelisted,
       so adding them forced an OPTIONS preflight — and the backend advertises
       `access-control-allow-headers: content-type` ONLY. Every poll failed CORS,
       and after 95s the modal fell back to the uploaded design. Measured 2026-08-25;
       cost Justin a live test round. The `?_=` param alone defeats the cache, and
       fetch's `cache` init is not an author header so it never preflights. */
    return fetch(_pollUrl, { method: 'GET', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('poll ' + r.status); return r.json(); })
      .then(function (j) {
        var items = j.line_items || [];
        /* the backend PREFIXES line ids with "li-" — match both forms */
        var mine = items.filter(function (x) { return x.line_item_id === sensei.renderLineId || x.line_item_id === 'li-' + sensei.renderLineId; })[0] ||
                   items.filter(function (x) { return x.line_item_id === sensei.lineItemId || x.line_item_id === 'li-' + sensei.lineItemId; })[0] || items[0];
        if (mine && mine.session_id) sensei.sessionId = mine.session_id;
        if (j.session_id) sensei.sessionId = j.session_id;
        return mine;
      });
  }
  function senseiDecide(status, note) {
    return fetch(SENSEI_EP + '/api/proof/decision', {
      method: 'POST',
      body: JSON.stringify({
        session_id: sensei.sessionId,
        line_item_id: sensei.lineItemId,
        status: status,
        note: note || '',
        reference_url: '',
        reference_name: ''
      })
    }).then(function (r) { if (!r.ok) throw new Error('decision ' + r.status); return r.json(); });
  }
  function cleanProof(mockupUrl) {
    /* the renderer returns the patch on a white studio backdrop — run it
       through our proxy's bg-removal, which also re-hosts on imgix
       (persistent + CORS-open), then trim to the patch itself. Falls back
       to the raw mockup if the cleanup is unavailable. */
    return fetch('https://ruhg140mmf.execute-api.us-east-1.amazonaws.com/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ model: 'gram', imageUrl: mockupUrl })
    }).then(function (r) {
      if (!r.ok) throw new Error('cleanup ' + r.status);
      return r.json();
    }).then(function (j) {
      if (!j || !j.url) throw new Error('cleanup no url');
      return j.url + '?trim=colorUnlessAlpha&fm=png';
    }).catch(function (e) {
      console.warn('[np-emb2] proof cleanup unavailable', e);
      return mockupUrl;
    });
  }
  /* THROTTLE-PROOF TIMER (Justin 2026-08-24): hidden tabs clamp setTimeout
     to as little as once per MINUTE, so a backgrounded generation looked
     stalled even though the render finished server-side long ago. Worker
     timers are exempt from tab throttling — one shared worker plays the
     clock for the generation poll and the progress checklist. */
  var npwSeq = 0, npwCbs = {};
  function npWorker() {
    if (npWorker.__w !== undefined) return npWorker.__w;
    try {
      var b = new Blob(['onmessage=function(e){setTimeout(function(){postMessage(e.data.id)},e.data.ms)}'], { type: 'text/javascript' });
      var w = new Worker(URL.createObjectURL(b));
      w.onmessage = function (e) { var f = npwCbs[e.data]; delete npwCbs[e.data]; if (f) { try { f(); } catch (eF) {} } };
      npWorker.__w = w;
    } catch (eW) { npWorker.__w = null; } /* CSP-blocked worker → plain timers */
    return npWorker.__w;
  }
  function npTick(fn, ms) {
    /* DUAL CLOCK (B65, 2026-08-25 — Justin: "I can't generate a proof on
       mobile, it just gets stuck").
       The worker keeps the CLOCK off the main thread so background throttling
       cannot stall it. But if that worker is never created, is KILLED under
       memory pressure (iOS Safari reclaims workers aggressively on a page
       holding multi-MB canvases), or its message is dropped, the callback
       simply never fires — and EVERYTHING scheduled through here stops
       silently, including senseiWaitReady's poll. A render that finished on
       the backend in 12s then sits forever behind "Rendering your patch".
       Both clocks are now armed; a latch keeps it exactly-once. The plain
       timer is deliberately 250ms LATE so the worker normally wins and we keep
       its throttle immunity. */
    var ran = false;
    var once = function () { if (ran) return; ran = true; try { fn(); } catch (eF) {} };
    var w = npWorker();
    if (!w) { setTimeout(once, ms); return 0; }
    var id = ++npwSeq;
    npwCbs[id] = once;
    try { w.postMessage({ id: id, ms: ms }); }
    catch (eP) { try { npWorker.__w = null; } catch (eN) {} }
    setTimeout(once, (ms || 0) + 250);
    return -id;
  }
  function senseiWaitChanged(prevUrl, prevRev, cb, maxMs) {
    var start = Date.now();
    (function tick() {
      senseiPoll().then(function (mine) {
        var done = mine && mine.mockup_url && (mine.status === 'complete' || mine.status === 'ready');
        var changed = done && (mine.mockup_url !== prevUrl || (mine.revision_count || 0) > prevRev);
        if (changed) cb(null, mine);
        else if (mine && (mine.status === 'error' || mine.error)) cb(new Error(mine.error || 'render error'));
        else if (Date.now() - start > (maxMs || 95000)) cb(new Error('revision timed out'));
        else npTick(tick, 2000);
      }).catch(function () {
        if (Date.now() - start > (maxMs || 95000)) cb(new Error('revision timed out'));
        else npTick(tick, 2000);
      });
    })();
  }
  function senseiWaitReady(cb, maxMs) {
    /* B88 (2026-08-25) — SURVIVE A SUSPENDED TAB. Two bugs made "leave the page
       and come back" fatal, which is why Safari sat on "Rendering" while the
       backend was healthy (sessions created, renders COMPLETE in 22-25s, polls
       reaching origin):
       1. The budget was WALL CLOCK. Background the tab for two minutes and the
          first poll on return sees >95s elapsed and reports "render timed out"
          for a render that actually succeeded. Hidden time is now EXCLUDED, so
          the budget only counts time the page could actually work.
       2. Nothing re-polled on return — it waited for a tick that a suspended
          tab may never deliver. Coming back to the tab now fires a poll
          IMMEDIATELY (guarded by inFlight so it cannot double-poll).
       Justin has reported the leave-and-return failure since the start:
       "if I leave the browser and come back it's frozen and then the whole
       screen goes blank". */
    var start = Date.now();
    var hidden = 0, hidAt = (document.visibilityState === 'hidden') ? Date.now() : 0;
    var fin = false, inFlight = false;
    var elapsed = function () {
      return Date.now() - start - hidden - (hidAt ? (Date.now() - hidAt) : 0);
    };
    var onVis = function () {
      if (document.visibilityState === 'hidden') { if (!hidAt) hidAt = Date.now(); return; }
      if (hidAt) { hidden += Date.now() - hidAt; hidAt = 0; }
      if (!fin && !inFlight) tick(); /* woke up — check RIGHT NOW */
    };
    var done = function (e, m) {
      if (fin) return;
      fin = true;
      try { document.removeEventListener('visibilitychange', onVis); } catch (eR) {}
      cb(e, m);
    };
    try { document.addEventListener('visibilitychange', onVis); } catch (eA) {}
    function tick() {
      if (fin) return;
      inFlight = true;
      senseiPoll().then(function (mine) {
        inFlight = false;
        /* the render statuses are pending/processing -> complete | error
           ("ready" was only ever a UI state in the proof-preview bundle) */
        var ok = mine && mine.mockup_url && (mine.status === 'complete' || mine.status === 'ready');
        if (ok) done(null, mine);
        else if (mine && (mine.status === 'error' || mine.error)) done(new Error(mine.error || 'render error'));
        else if (elapsed() > (maxMs || 95000)) done(new Error('render timed out'));
        else npTick(tick, elapsed() < 8000 ? 1200 : 2500); /* tight cadence early — most renders land ~10s */
      }).catch(function (e) {
        inFlight = false;
        if (elapsed() > (maxMs || 95000)) done(e);
        else npTick(tick, 2000);
      });
    }
    tick();
  }

  /* ---- proof compositing (canvas — offline fallback only) ---- */
  function compositeProof(cb) {
    var art = artworkUrl();
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var W = 900, H = 900;
        var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
        var ctx = cv.getContext('2d');
        var geom = null;
        (CFG.shapes || []).forEach(function (s) { if (s.label === st.shape) geom = s.geom; });
        var bg = (st.bg && st.bg.hex) ? st.bg.hex : '#ffffff';
        var thread = st.thread ? st.thread.hex : '#0C0C0E';
        var ring = 26;

        function drawShapePath(pad) {
          ctx.beginPath();
          if (geom === 'circle') ctx.arc(W / 2, H / 2, W / 2 - pad, 0, Math.PI * 2);
          else if (geom === 'oval') ctx.ellipse(W / 2, H / 2, W * 0.38 - pad, H * 0.48 - pad, 0, 0, Math.PI * 2);
          else if (geom === 'rectangle') roundRect(ctx, pad + 30, H * 0.18 + pad, W - 2 * (pad + 30), H * 0.64 - 2 * pad, 28);
          else roundRect(ctx, pad, pad, W - 2 * pad, H - 2 * pad, 28); /* square */
          ctx.closePath();
        }
        function roundRect(c, x, y, w, h, r) {
          c.moveTo(x + r, y); c.arcTo(x + w, y, x + w, y + h, r); c.arcTo(x + w, y + h, x, y + h, r);
          c.arcTo(x, y + h, x, y, r); c.arcTo(x, y, x + w, y, r);
        }
        function drawArtContained(x, y, w, h) {
          var r = Math.min(w / img.width, h / img.height);
          var dw = img.width * r, dh = img.height * r;
          ctx.drawImage(img, x + (w - dw) / 2, y + (h - dh) / 2, dw, dh);
        }

        if (geom === 'custom' || !geom) {
          /* silhouette of the art: draw art, then stroke via shadow ring */
          ctx.save();
          ctx.shadowColor = thread; ctx.shadowBlur = 0;
          var off = 10;
          [[off,0],[-off,0],[0,off],[0,-off],[off,off],[-off,-off],[off,-off],[-off,off]].forEach(function (d) {
            ctx.shadowOffsetX = d[0]; ctx.shadowOffsetY = d[1];
            drawArtContained(60, 60, W - 120, H - 120);
          });
          ctx.restore();
          drawArtContained(60, 60, W - 120, H - 120);
        } else {
          /* thread ring */
          drawShapePath(6); ctx.fillStyle = thread; ctx.fill();
          /* background */
          drawShapePath(6 + ring); ctx.fillStyle = bg; ctx.fill();
          /* artwork clipped + contained inside the background area */
          ctx.save(); drawShapePath(6 + ring); ctx.clip();
          var inset = 6 + ring + 40;
          drawArtContained(inset, inset, W - 2 * inset, H - 2 * inset);
          ctx.restore();
        }
        cb(null, cv);
      } catch (err) { cb(err); }
    };
    img.onerror = function () { cb(new Error('artwork load failed')); };
    img.src = art;
  }

  function canvasPngBlob(canvas) {
    /* toBlob callbacks can be DEFERRED FOREVER on hidden/backgrounded pages
       (Chromium) — dataURL->Blob is synchronous and always completes */
    try {
      var dU = canvas.toDataURL('image/png');
      var bin = atob(dU.split(',')[1]);
      var arr = new Uint8Array(bin.length);
      for (var iB = 0; iB < bin.length; iB++) arr[iB] = bin.charCodeAt(iB);
      return new Blob([arr], { type: 'image/png' });
    } catch (eB) { return null; }
  }
  function hostProof(canvas, version, cb) {
    if (typeof window.getPresignedUploadUrl !== 'function') { cb(null, ''); return; }
    var blob = canvasPngBlob(canvas);
    if (!blob) { cb(null, ''); return; }
    var name = 'ai-proof-v' + version + '____image_' + Date.now() + '_' + Math.floor(Math.random() * 1000) + '.png';
    window.getPresignedUploadUrl(name, 'image/png').then(function (p) {
      if (!p || !p.url) { cb(null, ''); return; }
      return npPut(p.url, blob).then(function () { cb(null, p.sourceUrl || ''); });
    }).catch(function () { cb(null, ''); });
  }

  function formProp(name) {
    var el = document.querySelector('product-form.product-form form [name="properties[' + name + ']"]');
    return el ? el.value : '';
  }
  function stripBlockedProps(o) {
    if (!o) return o;
    Object.keys(o).forEach(function (kB) { if (propBlocked(kB) || !propKept(kB)) delete o[kB]; });
    return o;
  }
  function lineSync(extra) {
    stripBlockedProps(extra);
    /* notes entered AFTER the item was added only exist on the form —
       mirror them (plus anything in `extra`) onto the cart line itself so
       they actually reach the order */
    if (!sensei.added) return Promise.resolve();
    return cartJson().then(function (cart) {
      var line = ourCartLine(cart);
      if (!line) return;
      var props = {};
      Object.keys(line.properties || {}).forEach(function (k) { props[k] = line.properties[k]; });
      /* AI Edit stays out: the edited artwork is the record, not the prompt */
      ['Design Notes', '_Revision Notes'].forEach(function (k) {
        var v = formProp(k);
        if (v) props[k] = v;
      });
      delete props['AI Edit'];
      Object.keys(extra || {}).forEach(function (k) {
        /* the composed build sheet must never be downgraded back to a plain
           image by a late fixer pass */
        if ((k === '_AI Proof' || k === '_Upload') && /--spec-dk/.test(String(props[k] || '')) && !/--spec-dk/.test(String(extra[k] || ''))) return;
        props[k] = extra[k];
      });
      if (digitalNoRender()) delete props['_AI Proof'];
      props = orderPropsObj(props);
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        /* PROPERTY mirror only — the LINE's own quantity is preserved. This
           helper fires from lingering builder tabs (notes, toggles, late
           promises); imposing st.qty here was silently resetting quantities
           the customer had already changed on the cart page. */
        body: JSON.stringify({ id: line.key, quantity: line.quantity, properties: props })
      }).then(function (r) { return r.json(); }).then(function (c2) { ourCartLine(c2); });
    }).catch(function (e) { console.warn('[np-emb2] line sync failed', e); });
  }

  /* ---- proof modal ---- */
  var pf = $('#np-e2-proof');
  /* revisions are UNLIMITED (2026-08-18): customers may keep editing selections
     and regenerating until they are happy. Kept as a function so the old call
     sites stay valid. */
  function regensLeft() { return 999; }
  function showPageLoader(msg) {
    /* plain full-page loader — the skip/digital path never shows the AI
       generation checklist */
    var ov = document.getElementById('np-e2-pageloader');
    if (!ov) {
      ov = document.createElement('div');
      ov.id = 'np-e2-pageloader';
      ov.className = 'np-e2-ov np-e2-ov--loader';
      ov.innerHTML = '<div class="np-e2-pl"><i class="np-e2-pl-spin"></i><b></b></div>';
      document.body.appendChild(ov);
    }
    ov.querySelector('b').textContent = msg || 'Loading\u2026';
    ov.hidden = false;
    /* VEIL WATCHDOG (Justin 2026-08-24, "stop covering my flow in white"):
       no veil may EVER outlive its work. Whatever loses its hide call \u2014 a
       dead host callback, a dropped promise \u2014 the veil clears itself and the
       finished page underneath is usable. Every show re-arms it. */
    try { clearTimeout(showPageLoader.__wd); } catch (eW1) {}
    showPageLoader.__wd = setTimeout(function reWd() {
      /* an ACTIVE checkout owns its veil for as long as the add genuinely
         runs (22s server adds measured) — everything else clears at 8s */
      if (typeof coBusy !== 'undefined' && coBusy) { showPageLoader.__wd = setTimeout(reWd, 3000); return; }
      hidePageLoader();
    }, 8000);
  }
  function hidePageLoader() {
    try { clearTimeout(showPageLoader.__wd); } catch (eW2) {}
    var ov = document.getElementById('np-e2-pageloader');
    if (ov) ov.hidden = true;
  }
  /* TAB-RETURN SAFETY (Justin 2026-08-24, mobile): leave the page mid-flow
     and come back — any veil that was up when the tab froze is an orphan
     (its work either finished throttled or died with the freeze). Give it
     3s after return, then clear unless a checkout is actively running. */
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    /* returning to the tab: a preview compose that froze while hidden gets
       cleared and repainted IMMEDIATELY — no waiting out the throttle backlog
       (Justin 2026-08-24: "major delay on the digital preview when I come back") */
    try {
      if (renderMaskPreview.__busy && Date.now() - (renderMaskPreview.__busyAt || 0) > 4000) {
        renderMaskPreview.__busy = false;
        renderMaskPreview.__again = false;
        ++maskPrevSeq;
      }
      if (document.body.classList.contains('np-e2-active') && !st.proofApproved && !renderMaskPreview.__busy) renderMaskPreview();
    } catch (eRV) {}
    var ovV = document.getElementById('np-e2-pageloader');
    if (!ovV || ovV.hidden) return;
    try { clearTimeout(showPageLoader.__wd); } catch (eV1) {}
    showPageLoader.__wd = setTimeout(function () { if (!coBusy) hidePageLoader(); }, 3000);
  });
  function showProofLoading(desc) {
    pf.hidden = false;
    var hn = document.getElementById('np-e2-pf-headnotice');
    if (hn) hn.hidden = true;
    $('#np-e2-pf-title').textContent = 'Generating your proof';
    $('#np-e2-pf-loading').hidden = false;
    $('#np-e2-pf-ready').hidden = true;
    var er = $('#np-e2-pf-error'); if (er) er.hidden = true;
    var sz = $('#np-e2-pf-sizing'); if (sz) sz.hidden = true;
    var eb = $('#np-e2-pf-eyebrow'); if (eb) eb.textContent = 'AI PROOF';
    var panel = pf.querySelector('.np-e2-modal'); if (panel) panel.classList.remove('is-sizing');
    st.proofPhase = 'loading';
    startFunStatus();
    var etaEl = document.querySelector('.np-e2-pf-eta');
    if (etaEl) {
      /* nano (theme B) really does finish in 12-15s — promise what each
         engine delivers, same file on both themes (A/B parity, 2026-08-24) */
      etaEl.textContent = genOn() ? 'Usually takes 15–20 seconds.' : 'Usually takes 20–25 seconds.';
      setTimeout(function () {
        if (st.proofPhase === 'loading') etaEl.textContent = 'Still stitching — taking a little longer than usual.';
      }, 18000);
    }
  }
  /* keep them smiling while the machine does its thing — no option recap */
  /* jokes match the MATERIAL being made (Justin 2026-08-24): no felt or
     thread gags on rubber, leather, silicone, printed or flex renders */
  var FUN_GENERIC = [
    'Inspecting every detail with a comically large magnifying glass…',
    'Politely shooing the lint away…',
    'Double-checking everything for good luck…',
    'Teaching a ninja patience. Slowly…'
  ];
  var FUN_BY_KIND = {
    stitch: [
      'Threading the world’s tiniest needle…',
      'Negotiating with the thread spools…',
      'Teaching a ninja to sew blindfolded…',
      'Counting stitches. Twice. Lost count. Again…',
      'Untangling exactly one (1) very dramatic knot…',
      'Convincing the border to stay in its lane…',
      'Asking the twill very politely to hold still…',
      'Sharpening scissors to ninja specification…',
      'Double-knotting for good luck…'
    ],
    woven: [
      'Threading the loom with microscopic thread…',
      'Counting warp and weft. Twice…',
      'Convincing ten thousand threads to cooperate…',
      'Weaving your pixels into fabric…',
      'Tuning the loom to ninja pitch…',
      'Sharpening scissors to ninja specification…'
    ],
    leather: [
      'Warming up the laser (it likes to stretch first)…',
      'Polishing the hide to ninja standard…',
      'Calibrating the etch depth to the millimeter…',
      'Asking the leather very politely to hold still…',
      'Burning in your artwork, one careful pass at a time…',
      'Buffing the edges for good luck…'
    ],
    molded: [
      'Carving the mold with ninja precision…',
      'Mixing colors to the exact drop…',
      'Pouring very carefully. Very, very carefully…',
      'Asking the mold very politely to let go…',
      'Smoothing each layer with a tiny squeegee…',
      'De-bubbling the pour for good luck…'
    ],
    printed: [
      'Loading inks one pixel at a time…',
      'Color-matching to the nearest nanometer…',
      'Convincing the printer it CAN do photo-real…',
      'Asking the ink very politely to dry faster…',
      'Heat-setting the colors for good luck…',
      'Cutting edges sharper than a ninja star…'
    ],
    flex: [
      'Polishing the finish to ninja standard…',
      'Pressing at exactly the right temperature…',
      'Asking the vinyl very politely to lie flat…',
      'Cutting edges sharper than a ninja star…',
      'Buffing out one (1) very dramatic smudge…'
    ],
    chenille: [
      'Fluffing the chenille to regulation fluffiness…',
      'Looping yarn like a tiny rollercoaster…',
      'Asking the felt very politely to hold still…',
      'Combing the pile with a very small comb…',
      'Counting loops. Twice. Lost count. Again…'
    ]
  };
  function funKindOf(label) {
    var L = String(label || '');
    if (/leather/i.test(L)) return 'leather';
    if (/pvc|rubber|silicone|keychain/i.test(L)) return 'molded';
    if (/flex|chrome/i.test(L)) return 'flex';
    if (/woven/i.test(L)) return 'woven';
    if (/chenille/i.test(L)) return 'chenille';
    if (/printed|full color/i.test(L)) return 'printed';
    return 'stitch';
  }
  function funStatusList() {
    /* the same kind resolution the checklist uses — conversions joke about
       what is ACTUALLY being rendered */
    var kindF = sensei.titleOverride === 'Full Color Printed Patches' ? 'Printed'
      : (sensei.titleOverride === 'Woven Patches' ? 'Woven'
      : (st.fdChoice === 'ps' ? 'Print & Stitch' : PTYPE.name));
    return (FUN_BY_KIND[funKindOf(kindF)] || FUN_BY_KIND.stitch).concat(FUN_GENERIC);
  }
  var CHECK_STEPS = ['Artwork prepared', 'Shape and colors applied', 'Matching thread colors', 'Stitching the border', 'Attaching the backing', 'Final quality inspection'];
  function currentCheckSteps() {
    /* checklist wording matches what's ACTUALLY being made — including
       conversions rendering a different type than the page's own */
    var kindL = sensei.titleOverride === 'Full Color Printed Patches' ? 'Printed'
      : (sensei.titleOverride === 'Woven Patches' ? 'Woven'
      : (st.fdChoice === 'ps' ? 'Print & Stitch' : PTYPE.name));
    var CL = {
      'Leather': ['Artwork prepared', 'Cutting the hide', 'Calibrating the laser', 'Etching your artwork', 'Finishing the edge', 'Final quality inspection'],
      'Faux Leather': ['Artwork prepared', 'Cutting the hide', 'Calibrating the laser', 'Etching your artwork', 'Finishing the edge', 'Final quality inspection'],
      'PVC / Rubber': ['Artwork prepared', 'Carving the mold', 'Mixing rubber colors', 'Pouring the PVC', 'Molding the border', 'Final quality inspection'],
      'Silicone': ['Artwork prepared', 'Carving the mold', 'Mixing silicone colors', 'Pouring the silicone', 'Molding the border', 'Final quality inspection'],
      'Printed': ['Artwork prepared', 'Color-matching your design', 'Printing at high resolution', 'Heat-setting the inks', 'Cutting the edge', 'Final quality inspection'],
      'Woven': ['Artwork prepared', 'Threading the loom', 'Weaving fine threads', 'Setting the colors', 'Finishing the border', 'Final quality inspection'],
      'Chenille': ['Artwork prepared', 'Cutting the felt base', 'Looping chenille yarn', 'Setting the colors', 'Finishing the edge', 'Final quality inspection'],
      '3D Embroidered': ['Artwork prepared', 'Shape and colors applied', 'Laying the puff foam', 'Stitching raised layers', 'Attaching the backing', 'Final quality inspection'],
      'Print & Stitch': ['Artwork prepared', 'Shape and colors applied', 'Printing the fine detail', 'Stitching the large areas', 'Attaching the backing', 'Final quality inspection']
    };
    return CL[kindL] || CHECK_STEPS;
  }

  var funTimer = null, funIdx = 0, checkTimer = null;
  function startFunStatus() {
    var el = $('#np-e2-pf-desc');
    if (!el) return;
    clearInterval(funTimer);
    var funL = funStatusList();
    funIdx = Math.floor(Date.now() / 1000) % funL.length;
    el.textContent = funL[funIdx];
    funTimer = setInterval(function () {
      if (st.proofPhase !== 'loading') { clearInterval(funTimer); return; }
      funIdx = (funIdx + 1) % funL.length;
      el.textContent = funL[funIdx];
    }, 2600);
    /* progressive checklist (Justin 2026-08-24: "fill faster, leave only the
       last one"): every item except the LAST goes green within ~9s — well
       inside any render time — and the reveal completes the final one. Runs
       on the throttle-proof clock so a backgrounded tab keeps pace too. */
    var checks = document.querySelector('.np-e2-pf-checks');
    if (checks) {
      var stepsL = currentCheckSteps();
      checks.innerHTML = stepsL.map(function (s, i) {
        return '<span class="' + (i === 0 ? 'is-done' : 'is-wait') + '"><i></i>' + s + '</span>';
      }).join('');
      var ci = 0;
      var myChk = (startFunStatus.__chk = (startFunStatus.__chk || 0) + 1);
      (function chkStep() {
        if (myChk !== startFunStatus.__chk || st.proofPhase !== 'loading') return;
        if (ci < stepsL.length - 2) {
          ci++;
          var span = checks.querySelectorAll('span')[ci];
          if (span) span.className = 'is-done';
          npTick(chkStep, 2200);
        }
      })();
    }
  }
  function pushVersion(v) {
    if (st.proofApproved) {
      /* a new render after approval supersedes it — the customer must approve
         the version they actually want on the order */
      st.proofApproved = false;
      var ap = document.getElementById('np-e2-approved');
      if (ap) ap.hidden = true;
      clearApprovedCanvas(); /* prep tools return with the un-approval */
      renderOptions();
    }
    st.versions.push(v);
    upgradeVersionAlpha(v); /* transparent copy for display + the My Proofs catalog */
    /* with one version it's the choice; with more, the customer must pick */
    st.selected = st.versions.length === 1 ? 0 : null;
    st.proofPhase = 'ready';
    try { renderProofReady(); }
    catch (e) { console.error('[np-emb2] proof render failed', e); pf.hidden = true; }
    renderOptions(); /* keep the page button in sync ("View your proof") even if the modal was closed mid-render */
  }
  function newVersionMeta() {
    /* artUsed: the upload this version was built from, captured at version
       creation — the per-version anchor for _Original Image (2026-08-24) */
    return { shape: st.shape, border: st.border, bg: st.bg, thread: st.thread, backing: st.backing, w: st.w, h: st.h, corners: st.corners, opts: optSnapshot(), letters: letterSnapshot(), artUsed: cleanUrl(sensei.artAtRender || '') || cleanUrl(artworkUrl()) };
  }
  function compositeFallback() {
    /* offline fallback when the patch-sensei render is unreachable */
    var t0 = Date.now();
    compositeProof(function (err, canvas) {
      var v = newVersionMeta();
      v.dataUrl = err ? '' : canvas.toDataURL('image/png');
      v.hosted = ''; v.rev = 0; v.fallback = true;
      if (canvas) hostProof(canvas, st.versions.length + 1, function (_e, url) { v.hosted = url ? toImgixHost(url) : ''; });
      var wait = Math.max(0, 2400 - (Date.now() - t0));
      setTimeout(function () { pushVersion(v); }, wait);
    });
  }
  function digitalConvert(altKind) {
    /* customer chose an INSTANT digital proof and the assessment converted
       the patch type — hand the digital proof to the target product with no
       AI render anywhere */
    pf.hidden = true;
    showPageLoader('Preparing your digital proof\u2026');
    composeAndHost().then(function () {
      var fin2 = function (hostedUrl) {
        var v = newVersionMeta();
        v.hosted = hostedUrl || '';
        v.dataUrl = sensei.composedLocal || hostedUrl || '';
        v.digital = true;
        v.fullColor = altKind !== 'ps';
        v.altKind = altKind;
        st.versions = [v];
        st.selected = 0;
        st.proofApproved = true; try { prewarmAlphaForCart(); } catch (ePW2) {}
        switchToFullColor(v);
      };
      awaitCleanHosted(fin2);
    });
  }
  function awaitCleanHosted(cbIn) {
    /* watchdog: whatever goes wrong below, the flow ALWAYS completes */
    var fired = false;
    var cb = function (u) { if (fired) return; fired = true; cbIn(u); };
    setTimeout(function () { cb(sensei.composedCleanUrl || ''); }, 6000); /* was 20s — never hold the flow */
    return awaitCleanHostedInner(cb);
  }
  function awaitCleanHostedInner(cb) {
    /* resolve a CLEAN hosted compose (transparent patch: border, colors,
       merrow). sensei.composedUrl is the GREY-STAGED renderer reference --
       it exists only so the AI never cuts to the artwork silhouette, and
       must never reach a customer-facing surface or an order property. */
    var tries = 0;
    (function tickC() {
      if (sensei.composedCleanUrl) { cb(sensei.composedCleanUrl); return; }
      if (!sensei.composedCleanDone && tries++ < 20) { setTimeout(tickC, 300); return; }
      try {
        composePatchImage(function (cv2) {
          if (!cv2) { cb(''); return; }
          hostProof(cv2, 'digital' + (Date.now() % 100000), function (e4, u4) {
            if (u4) sensei.composedCleanUrl = toImgixHost(u4);
            cb(sensei.composedCleanUrl || '');
          });
        }, 1200);
      } catch (e5) { cb(''); }
    })();
  }
  function monoBackdropHex() {
    /* the stage tone the matte finishes present against, WITHOUT the '#' —
       imgix flattens transparency onto it so the thumbnail keeps the same
       look in the cart, at checkout and on the order as it has in the
       builder (a white patch on a transparent thumb reads as blank) */
    if (!PTYPE.monoTone) return '';
    var hx = String((PTYPE.fixedBg && PTYPE.fixedBg.hex) || '').replace('#', '');
    if (hx.length !== 6) return '';
    var lum = 0.299 * parseInt(hx.substr(0, 2), 16) + 0.587 * parseInt(hx.substr(2, 2), 16) + 0.114 * parseInt(hx.substr(4, 2), 16);
    return lum > 140 ? '17181A' : 'E9E9E4';
  }
  function withMonoBackdrop(u) {
    var bgH = monoBackdropHex();
    if (!u || !bgH || !/imgix/.test(u) || /[?&]bg=/.test(u)) return u || '';
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'bg=' + bgH;
  }
  function digitalCartUrl(u) {
    /* Cart images ship TRANSPARENT — every display surface draws its own
       checkerboard behind them. This is the single choke point for the cart
       image treatment.
       When the transparent copy never landed we fall back to an OPAQUE source
       (the raw studio render, which carries a white field). Those get imgix's
       bg-remove so the cart thumb still shows the patch alone instead of a
       white box. Sources that are already transparent are left untouched —
       running bg-remove over them risks eating pale patch interiors. */
    /* transparent sources ship as-is; an OPAQUE source (raw studio render, when
       the cut did not produce an alpha copy) gets imgix bg-remove so the cart
       thumb is the patch alone instead of a white box */
    if (!u) return '';
    if (isAlphaSrc(u)) return u;
    if (!/imgix/.test(u) || /bg-remove=/.test(u)) return u;
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'bg-remove=true';
  }
  function startDigitalPath(withStitch) {
    /* Skip path: the digital preview becomes the proof; stitched types
       still get the photo / fine-detail assessment first */
    st.pendingProofKind = withStitch ? 'stitch' : 'digital';
    var goD = function () { digitalProofFlow(withStitch); };
    if (PTYPE.fdGate && !st.versions.length && !st.fdChoice && !st.fcConfirmed && !st.__photoCleared) {
      /* B50 (Justin: the bypass must be INSTANT — there is no generation):
         sizing opens NOW; the artwork check runs in PARALLEL and interrupts
         on top only if it actually trips. Photos still get stopped. */
      if (!st.__artAnalyzed) { try { analyzeArtwork(); } catch (eA2) { st.__artAnalyzed = true; } }
      var wA2 = 0;
      (function tickB() {
        if (st.__artAnalyzed) {
          if (!st.__photoCleared && fullColorLikely()) { openPhotoConfirm(); return; }
          if (!st.__photoCleared && fineDetailLikely()) { openFineDetailChoice(); return; }
          return;
        }
        if (wA2++ > 24) return;
        npTick(tickB, 250);
      })();
    }
    goD();
  }
  function composeDigitalFast() {
    /* digital-lane compose (Justin 2026-08-24, "20s to size & pricing"): NO
       grey AI-reference upload (that exists only for generation), and the
       clean hosted copy gets a 2.5s grace instead of a blocking wait. It
       keeps uploading in the background; digitalProofFlow patches it into
       the version, props and cart line whenever it lands. */
    return new Promise(function (resolve) {
      composePatchImage(function (cv) {
        if (!cv) { sensei.composedLocal = null; sensei.composedCleanUrl = null; sensei.composedCleanDone = true; resolve(''); return; }
        try { sensei.composedLocal = cv.toDataURL('image/png'); } catch (eL) { sensei.composedLocal = null; }
        sensei.composedCleanUrl = null;
        sensei.composedCleanDone = false;
        var cseq = (sensei.composeSeq = (sensei.composeSeq || 0) + 1);
        var done = false;
        var fin = function () { if (!done) { done = true; resolve(sensei.composedCleanUrl || ''); } };
        hostProof(cv, 'refclean' + (Date.now() % 100000), function (e2, cu) {
          /* C13: same imgix normalisation as the other hostProof callback — an
             S3 URL here means no CORS, which kills the spec-sheet compose. */
          if (sensei.composeSeq === cseq) { sensei.composedCleanUrl = cu ? toImgixHost(cu) : null; sensei.composedCleanDone = true; }
          fin();
        });
        setTimeout(fin, 2500);
      }, null, { refOnly: 1, corners: st.corners, freeform: isFreeFormShape() });
    });
  }
  function digitalProofFlow(withStitch) {
    /* no AI render — the composed digital preview IS the proof */
    st.proofMode = withStitch ? 'stitch' : 'digital';
    setProp('_Proof Preference', withStitch ? 'REAL STITCHOUT REQUESTED ($19.99)' : 'DIGITAL PROOF (no AI render)');
    pf.hidden = true;
    showPageLoader('Preparing your digital proof\u2026');
    /* sizing opens INSTANTLY off the preview already on screen (Justin
       2026-08-24: "we already have it while they're building it") — the
       fresh compose + hosting run entirely in the background and upgrade
       the version, props and cart line as they land. */
    var quickPrev = '';
    try {
      var pvQ = document.querySelector('.np-e2-maskprev img');
      if (pvQ && pvQ.src) quickPrev = pvQ.src;
      if (!quickPrev && sensei.composedLocal) quickPrev = sensei.composedLocal;
      if (!quickPrev) { var aQ = document.getElementById('np-e2-artimg'); if (aQ && aQ.src && aQ.naturalWidth > 0) quickPrev = aQ.src; }
    } catch (eQP) {}
    try { coMark(quickPrev ? 'skip-quick' : 'skip-noprev'); } catch (eQB) {}
    var bgCompose = composeDigitalFast();
    Promise.race([bgCompose, new Promise(function (resQ) { npTick(function () { resQ(''); }, quickPrev ? 200 : 2500); })]).then(function (hostedFast) {
      var finishD = function (hostedUrl) {
        var v = newVersionMeta();
        v.dataUrl = sensei.composedLocal || hostedUrl || quickPrev || cleanUrl(artworkUrl()) || '';
        v.hosted = hostedUrl || '';
        v.rev = 0;
        v.digital = true;
        st.versions = [v];
        st.selected = 0;
        st.proofApproved = true; try { prewarmAlphaForCart(); } catch (ePW2) {}
        /* the cart image is the HOSTED digital preview — never a data URL,
           never the raw upload */
        if (hostedUrl) setProp('_cartImg', digitalCartUrl(hostedUrl));
        if (hostedUrl) freezeProofCopy(hostedUrl, (TYPE_KEY || 'patch') + '--digital', function (fzD) {
          /* the frozen copy IS the approved digital proof — writing it to
             _AI Proof puts the catalog filename on the ORDER, which is what
             lets My Mockups mark a purchased digital mockup as Purchased */
          if (!fzD) return;
          v.frozenProof = fzD;
          /* the catalog filename still reaches the ORDER (My Mockups marks a
             purchased digital mockup by it) — but in its own hidden property:
             a digital order must not show _AI Proof (Justin 2026-08-24) */
          setProp('_Mockup Catalog', fzD);
          setProp('_AI Proof', '');
          if (sensei.added) lineSync({ '_Mockup Catalog': fzD });
        });
        /* no AI proof = no status line: "DIGITAL PREVIEW APPROVED - no AI
           proof generated" read as noise on the order. _Proof Approval and
           _Proof Preference already tell the whole story. */
        setProp('_AI Proof Status', withStitch ? 'DIGITAL PREVIEW - REAL STITCHOUT requested ($19.99)' : '');
        commitOptions();
        commitSizeQty();
        renderOptions();
        /* approved summary fields — approveProof never runs on this path */
        var apD = document.getElementById('np-e2-approved');
        if (apD) apD.hidden = false;
        var thD = document.getElementById('np-e2-cart-thumb');
        if (thD) thD.src = hostedUrl || v.dataUrl;
        var tbD = document.querySelector('.np-e2-cartrow__thumb');
        if (tbD) { tbD.classList.add('is-alpha'); tbD.classList.add('is-digital'); } /* transparent compose on a plain grey card */
        var lineD = document.getElementById('np-e2-cart-line');
        if (lineD) lineD.textContent = [
          PTYPE.textLines ? null : v.shape,
          PTYPE.textLines && st.font ? st.font.label : null,
          PTYPE.textLines && st['opt' + (PTYPE.layersOpt || 2)] ? st['opt' + (PTYPE.layersOpt || 2)].label : null,
          st.border ? st.border.label + ' border' : null,
          v.bg ? v.bg.label + (PTYPE.textLines ? ' letters' : (isLeather() ? '' : ' background')) : null,
          v.thread ? v.thread.label + (PTYPE.textLines ? ' outline' : ' thread') : null,
          PTYPE.stitches ? (st.ttStitch || 'Zig Zag') + ' stitch' : null,
          v.backing ? v.backing.label : null,
          withStitch ? 'Real stitchout requested' : 'Digital proof'
        ].filter(Boolean).join(' \u00b7 ');
        var pflD = document.getElementById('np-e2-prooffile');
        if (pflD) pflD.textContent = withStitch ? 'digital-proof.png (real stitchout to follow)' : 'digital-proof.png';
        var coID = document.querySelector('.np-e2-checkoutrow i');
        if (coID) coID.textContent = withStitch ? 'A real stitched sample is produced and photographed for your approval first (adds 2-4 business days).' : 'Your digital preview is your proof above.';
        var crID = document.querySelector('.np-e2-cartrow__mid i');
        if (crID) crID.textContent = 'Your original upload and your digital preview both attach to this order.';
        try { renderApprovedCanvas(); } catch (eD1) {}
        renderSizing();
      };
      finishD(hostedFast || '');
      if (!hostedFast) (function lateTick(nT) {
        /* the hosted copy is still uploading — patch it in when it lands so
           the cart image / catalog copy still reach the order */
        var uT = sensei.composedCleanUrl || '';
        if (uT) {
          var vT = st.versions[0];
          if (vT && vT.digital && !vT.hosted) {
            /* the fresh compose replaces the quick on-screen copy */
            if (sensei.composedLocal) { vT.dataUrl = sensei.composedLocal; try { renderApprovedCanvas(); } catch (eRC2) {} }
            vT.hosted = uT;
            setProp('_cartImg', digitalCartUrl(uT));
            if (sensei.added) lineSync({ '_cartImg': digitalCartUrl(uT) });
            var thT = document.getElementById('np-e2-cart-thumb');
            if (thT) thT.src = uT;
            freezeProofCopy(uT, (TYPE_KEY || 'patch') + '--digital', function (fzT) {
              if (!fzT) return;
              vT.frozenProof = fzT;
              setProp('_Mockup Catalog', fzT);
              setProp('_AI Proof', '');
              if (sensei.added) lineSync({ '_Mockup Catalog': fzT });
            });
          }
          return;
        }
        if (nT < 60) setTimeout(function () { lateTick(nT + 1); }, 500);
      })(0);
    });
  }
  function openProof() {
    sensei.editBase = null; /* fresh generations never ride a stale edit base */
    /* B42: the line returns to the cart at GENERATION time — the original v2
       design. Rendering takes 15-25s plus review dwell, which gives the
       background add all the headroom Shopify's wildly variable /cart/add
       latency needs (2.4s and 14.6s measured minutes apart). Approval already
       knows how to update props on an existing line; the sheets then stamp
       minutes before any click. Abandoned generations leave the line in the
       cart — the original, accepted behavior. */
    /* PRE-ADD REMOVED (B66, 2026-08-25 — Justin, twice: "ai gen is creating a
       line item before I even add it to cart", "why would anything be added to
       cart until I physically hit the add to cart button").
       This block used to fire ensureInCart() 2.5s after Generate, so the cart
       carried a line — at the SEEDED size the customer never chose — from the
       moment a proof started rendering. It bought a fast Add-to-Cart click at
       the cost of a phantom cart item, a wrong-priced line for anyone who
       abandoned, and the seed-variant duplicate when the size later crossed a
       variant boundary. The cart is now mutated in exactly ONE place:
       doCheckout, when the customer presses Add to Cart. Build sheets still
       pre-compose in the background (preComposeSheets), so the click stays
       fast without touching the cart early. */
    /* the REAL proof: patch-sensei (Shinobi's renderer). The item goes into
       the cart first (sessions are cart-token keyed), then the session is
       created with every selected option + the customer's Step-1 notes. */
    if ((PTYPE.fdGate || photoGateOn()) && !st.versions.length && !sensei.titleOverride && !st.__artAnalyzed) {
      /* Patch Sensei assesses the image BEFORE anything renders */
      showProofLoading('Patch Sensei is checking your artwork first.');
      try { analyzeArtwork(); } catch (eAn) { st.__artAnalyzed = true; }
      var waitA = 0;
      (function tickA() {
        if (st.__artAnalyzed || waitA++ > 40) { openProof(); return; }
        setTimeout(tickA, 250);
      })();
      return;
    }
    if (photoGateOn() && !st.versions.length && !sensei.titleOverride && !st.__photoCleared && fullColorLikely()) {
      /* photographs can't be stitched — STOP before generating and make the
         conversion explicit; the popup is the sign-off */
      if (!st.fcConfirmed) { openPhotoConfirm(); return; }
      st.fcForced = true;
      st.fcForcedReason = 'photo';
      st.fcOffered = true;
      generateFullColor();
      return;
    }
    if (PTYPE.fdGate && !st.versions.length && !sensei.titleOverride && !st.fdChoice && !st.__photoCleared && fineDetailLikely()) {
      /* fine detail can't be stitched either — but it has MULTIPLE viable
         productions, so the customer chooses (the modal is the sign-off).
         __photoCleared = the UPLOAD check already ran on this art — the
         customer was prompted there (or the art passed); never re-interrupt
         at Generate (Justin: detection belongs at upload) */
      openFineDetailChoice();
      return;
    }
    if (sensei.busy) return; /* one render at a time — concurrent generates duplicate versions and burn regens */
    sensei.busy = true;
    var gen = sensei.genSeq = (sensei.genSeq || 0) + 1;
    showProofLoading('Applying your artwork' + (stepEnabled('shape') && st.shape ? ', ' + st.shape + ' cut' : '') + (stepEnabled('border') && st.border ? ', ' + st.border.label + ' border' : '') + (stepEnabled('bg') && st.bg ? ', ' + st.bg.label + (isLeather() ? '' : ' background') : '') + (stepEnabled('thread') && st.thread ? ', ' + st.thread.label + ' border thread' : '') + ', and ' + (st.backing ? st.backing.label : 'selected') + ' backing.');
    /* NOTHING goes in the cart until "Add to Cart" — the session only needs
       the cart TOKEN. verify + token + composed reference run in parallel. */
    /* B75 (2026-08-25) — THE GENERATE GATE CAN NEVER HANG AGAIN.
       This Promise.all fed senseiCreate (the POST that starts a render). If ANY
       of the three never settles, the POST is never sent and the modal spins on
       "Rendering your patch" forever — with no error, because nothing rejected.
       Diagnosed from Justin's Safari session: composed=hosted, busy=true,
       versions=0, and ZERO POST /api/proof/session in the ECS logs.
       Each leg now resolves-or-reports within its own cap (never rejects), and
       marks which one stalled so np_co_log names it. A missing cart is retried
       once directly, because the session is keyed on the cart token. */
    var gate = function (p, name, ms) {
      return new Promise(function (res) {
        var done = false;
        var fin = function (v, why) { if (done) return; done = true; if (why) { try { coMark(why + ':' + name); } catch (e0) {} } res(v); };
        try { Promise.resolve(p).then(function (v) { fin(v, null); }, function (e) { fin(null, 'gate-rej'); }); }
        catch (eS) { fin(null, 'gate-threw'); }
        npTick(function () { fin(null, 'gate-stall'); }, ms);
        setTimeout(function () { fin(null, 'gate-stall2'); }, ms + 500);
      });
    };
    Promise.all([gate(verifyArtwork(), 'verify', 8000), gate(cartJson(), 'cart', 8000), gate(composeAndHost(), 'compose', 12000)])
      .then(function (r) {
        if (r[1]) return r[1];
        /* cart token is REQUIRED — one direct retry before giving up */
        try { coMark('gate-cart-retry'); } catch (eC) {}
        return cleanFetch()('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (x) { return x.json(); })
          .catch(function () { return null; });
      })
      .then(function (cart) {
        if (!cart) { try { coMark('gate-cart-FAILED'); } catch (eF) {} throw new Error('cart unavailable — please try again'); }
        return cart;
      })
      .then(function (cart) {
        sensei.renderLineId = null; sensei.lineItemId = null; sensei.forceFresh = true;
        return senseiCreate(cart);
      })
      .then(function () {
        return new Promise(function (res, rej) { senseiWaitReady(function (e, m) { e ? rej(e) : res(m); }, 95000); });
      })
      .then(function (mine) {
        var v = newVersionMeta();
        v.dataUrl = mine.mockup_url; v.hosted = mine.mockup_url; v.rev = mine.revision_count || 0;
        v.line = mine;
        v.fullColor = !!sensei.titleOverride;
        sensei.titleOverride = null;
        return new Promise(function (res) { prepareVersionDisplay(v, function () { pushVersion(v); res(); }); });
      })
      .catch(function (err) {
        console.warn('[np-emb2] sensei proof failed', err);
        sensei.titleOverride = null;
        pushUploadFallback(err);
        /* the ramp fired but the render is usually still cooking — keep
           listening and swap the REAL AI proof in the moment it lands */
        senseiWaitReady(function (e2, mine) {
          if (!e2 && mine && gen === sensei.genSeq) adoptLateRender(mine);
        }, 150000);
      })
      .then(function () { sensei.busy = false; });
  }
  function adoptLateRender(mine) {
    /* a render that finished after the exit ramp replaces the upload-preview
       fallback version — the customer must always end up with the AI patch */
    if (!mine.mockup_url) return;
    var idx = -1;
    st.versions.forEach(function (x, i) { if (x.fallbackUpload) idx = i; });
    if (idx === -1) return;
    var v = st.versions[idx];
    v.dataUrl = mine.mockup_url; v.hosted = mine.mockup_url;
    v.rev = mine.revision_count || 0; v.line = mine;
    v.fallbackUpload = false;
    v.alpha = null;
    prepareVersionDisplay(v, function () { rerenderProofPhase(); });
    if (st.selected === null || st.selected === undefined) st.selected = idx;
    if (!pf.hidden && st.proofPhase === 'ready') renderProofReady();
    else if (!pf.hidden && st.proofPhase === 'sizing') renderSizing();
    renderOptions();
    if (st.proofApproved && st.selected === idx) {
      /* they approved the fallback — upgrade the order line to the real render */
      setProp('_AI Proof', v.hosted); setProp('_cartImg', digitalCartUrl(v.alpha || v.hosted));
      setProp('_AI Proof Status', 'AI render attached');
      lineSync({ '_AI Proof': v.hosted, '_cartImg': digitalCartUrl(v.alpha || v.hosted), '_AI Proof Status': 'AI render attached', '_Proof Version': 'v' + (idx + 1) });
      var th = document.getElementById('np-e2-cart-thumb'); if (th) th.src = v.dataUrl;
      var pfl = document.getElementById('np-e2-prooffile'); if (pfl) pfl.textContent = 'ai-proof-v' + (idx + 1) + '.png';
    }
  }
  function generateFullColor(altKind) {
    if (sensei.busy) return;
    sensei.editBase = null; /* FC proofs always render fresh */
    sensei.busy = true;
    var gen = sensei.genSeq = (sensei.genSeq || 0) + 1; /* invalidate any late-swap listener */
    st.fcOffered = true;
    sensei.titleOverride = altKind === 'woven' ? 'Woven Patches' : 'Full Color Printed Patches';
    sensei.renderLineId = (sensei.lineItemId || 'line') + '::fc' + (new Date().getTime() % 10000000);
    showProofLoading(altKind === 'woven' ? 'Rendering your design as a Woven Patch.' : 'Rendering your design as a Full Color Printed Patch.');
    Promise.all([verifyArtwork(), cartJson()])
      .then(function (r) { return senseiCreate(r[1], customerNotes()); })
      .then(function () {
        return new Promise(function (res, rej) { senseiWaitReady(function (e, m) { e ? rej(e) : res(m); }, 95000); });
      })
      .then(function (mine) {
        var v = newVersionMeta();
        v.dataUrl = mine.mockup_url; v.hosted = mine.mockup_url; v.rev = 0; v.line = mine; v.fullColor = true; v.altKind = altKind === 'woven' ? 'woven' : 'fc';
        sensei.titleOverride = null;
        return new Promise(function (res) { prepareVersionDisplay(v, function () { pushVersion(v); res(); }); });
      })
      .catch(function (err) {
        console.warn('[np-emb2] full color proof failed', err);
        sensei.titleOverride = null;
        if (!st.versions.length) {
          /* forced-FC first render: NEVER strand an empty review view — show
             the upload fallback and keep listening for the real render */
          pushUploadFallback(err);
          senseiWaitReady(function (e2, mine2) {
            if (e2 || !mine2 || gen !== sensei.genSeq) return;
            adoptLateRender(mine2);
            if (st.fcForced) {
              var lv = st.versions[st.versions.length - 1];
              if (lv && !lv.fallbackUpload) { lv.fullColor = true; try { renderProofReady(); } catch (e3) {} }
            }
          }, 150000);
        } else {
          st.proofPhase = 'ready';
          renderProofReady();
        }
      })
      .then(function () { sensei.busy = false; });
  }
  function verifyArtwork() {
    /* the render MUST depict the customer's uploaded image — an unfetchable
       artwork_url makes the backend produce a demo/sample render. Confirm
       the exact URL loads before any session is created. */
    return new Promise(function (resolve, reject) {
      /* TYPED products have no upload at all: their artwork IS the composed
         lettering, hosted by composeAndHost(). Wait for that instead of failing
         with 'no artwork url' (which is what killed the tackle twill proof). */
      if (PTYPE.noArt) {
        composeAndHost().then(function () {
          var urlT = cleanUrl(sensei.composedUrl || '');
          if (!urlT) { reject(new Error('composed artwork not hosted')); return; }
          var probeT = new Image();
          probeT.onload = function () { resolve(urlT); };
          probeT.onerror = function () { reject(new Error('composed artwork not fetchable')); };
          probeT.src = urlT;
        }, function () { reject(new Error('composed artwork not hosted')); });
        return;
      }
      var url = cleanUrl(artworkUrl());
      if (!url) { reject(new Error('no artwork url')); return; }
      var probe = new Image();
      var pDone = false;
      probe.onload = function () { if (pDone) return; pDone = true; resolve(url); };
      probe.onerror = function () { if (pDone) return; pDone = true; reject(new Error('artwork not fetchable')); };
      /* B67 (2026-08-25): a STALLED request fires NEITHER event — iOS keeps the
         socket open on a flaky connection — so this promise never settled and
         NO SESSION WAS EVER CREATED. The modal then span forever while the
         checklist ticked on its own timers ("mobile refuses to render an AI
         image even if I never leave the page"). A timeout is INCONCLUSIVE, not
         a failure: the backend fetches this URL server-side and is unaffected
         by the phone's connection, so proceed. A real 404 still rejects above. */
      npTick(function () {
        if (pDone) return;
        pDone = true;
        console.warn('[np-e2] artwork probe stalled — proceeding (backend fetches server-side)');
        resolve(url);
      }, 7000);
      probe.src = url;
    });
  }
  function pushUploadFallback(err) {
    /* LAST RESORT ONLY. The loader must hold until the real render lands —
       this ramp shows the customer's own upload labelled as their proof, which
       is worse than waiting. The wait was raised to 95s on 2026-08-18 when
       transparent output moved renders from ~15s to ~40s; at 40s this ramp was
       firing on perfectly good renders that arrived moments later. */
    console.warn('[np-emb2] proof render unavailable, continuing with upload', err);
    var art = cleanUrl(artworkUrl());
    if (!art) { showProofError(err); return; }
    var v = newVersionMeta();
    v.dataUrl = art; v.hosted = ''; v.rev = 0; v.fallbackUpload = true;
    pushVersion(v);
  }
  function showProofError(err) {
    $('#np-e2-pf-title').textContent = 'Review your proof';
    $('#np-e2-pf-loading').hidden = true;
    $('#np-e2-pf-ready').hidden = true;
    $('#np-e2-pf-error').hidden = false;
    var why = $('#np-e2-pf-error-why');
    if (why) why.textContent = err ? String(err.message || err).slice(0, 140) : '';
    st.proofPhase = null;
  }
  function specsChangedSince(v) {
    if (!v) return false;
    return v.shape !== st.shape ||
      (v.border && st.border && v.border.label !== st.border.label) ||
      (v.bg && st.bg && v.bg.label !== st.bg.label) ||
      (v.thread && st.thread && v.thread.label !== st.thread.label) ||
      (v.backing && st.backing && v.backing.label !== st.backing.label) ||
      (v.w != null && v.w !== st.w) || (v.h != null && v.h !== st.h) ||
      (v.opts != null && v.opts !== optSnapshot()) ||
      (v.letters != null && v.letters !== letterSnapshot()) ||
      (v.corners || 'rounded') !== (st.corners || 'rounded');
  }
  function letterSnapshot() {
    /* everything the customer typed or chose about the lettering, as one
       comparable string — text, per-line layout and size, font, tail */
    if (!PTYPE.textLines) return '';
    return ttLines().map(function (l, i) {
      return l + '|' + (st['ttLay' + (i + 1)] || 'Straight') + '|' + (st['ttHalf' + (i + 1)] ? 'h' : 'f');
    }).join('~') + '~' + (st.font ? st.font.label : '') +
      '~' + (ttSwooshOn() ? ttSwooshDef(st.swooshStyle).name + ':' + String(st.swooshText || '') : '') +
      '~' + (st.ttStitch || '');
  }
  /* an approved proof stops being "approved" the moment the design changes —
     the customer must see (and approve) what they are actually ordering */
  function unapproveIfChanged() {
    if (!st.proofApproved || !st.versions.length) return;
    var vA = st.versions[(st.selected === null || st.selected === undefined) ? st.versions.length - 1 : st.selected];
    if (!vA || !specsChangedSince(vA)) return;
    st.proofApproved = false;
    st.ctaRevealed = true;
    try { clearApprovedCanvas(); } catch (eU) {}
    try { renderOptions(); } catch (eU2) {}
  }
  function optSnapshot() {
    /* Layers / Lines of Text change how the piece is BUILT without moving a
       dimension, so the width/height compare above cannot see them */
    return ['opt1', 'opt2', 'opt3'].map(function (kV) {
      return (optDef(kV) && st[kV]) ? st[kV].label : '';
    }).join('|');
  }
  /* explicit color instructions in a revision note ("make the border green",
     "red background") UPDATE the selections — so the cart line, the checkout
     properties, and the recomposed reference all reflect the request */
  var NOTE_COLORS = [
    ['dark green', '#1D3C34'], ['light blue', '#69B3E7'], ['dark blue', '#003087'], ['navy', '#003087'],
    ['red', '#D6001C'], ['green', '#00843D'], ['blue', '#0057B8'], ['black', '#0C0C0E'], ['white', '#FFFFFF'],
    ['yellow', '#FFD100'], ['gold', '#A28D5B'], ['orange', '#FF6A13'], ['purple', '#582C83'], ['pink', '#E93CAC'],
    ['brown', '#6B4C35'], ['tan', '#D3BC8D'], ['grey', '#8E9089'], ['gray', '#8E9089'], ['teal', '#008C95'],
    ['maroon', '#5E2A2B'], ['silver', '#C7C9C7']
  ];
  function applyNoteSelections(note) {
    var n = ' ' + note.toLowerCase() + ' ';
    var hit = false, usedB = false, usedG = false;
    NOTE_COLORS.forEach(function (cw) {
      var w = cw[0], hex = cw[1];
      if (!usedB && new RegExp('(?:border|thread|merrow|edge|outline)[^.,;!\\n]{0,26}\\b' + w + '\\b|\\b' + w + '\\b[^.,;!\\n]{0,12}(?:border|thread|merrow|edge|outline)').test(n)) {
        st.thread = { label: pmsName(hex), hex: hex }; usedB = true; hit = true;
      }
      if (!usedG && new RegExp('(?:background|base)[^.,;!\\n]{0,26}\\b' + w + '\\b|\\b' + w + '\\b[^.,;!\\n]{0,12}(?:background|base)').test(n)) {
        st.bg = { label: pmsName(hex), hex: hex }; usedG = true; hit = true;
      }
    });
    /* size intents change the COMPOSITION — the reference image is the
       strongest channel to the renderer, so "make the logo smaller" must
       literally recompose smaller */
    if (/(logo|design|image|artwork|art|graphic|text|it)\b/.test(n)) {
      var z0 = st.artZoom || 1;
      if (/(smaller|shrink|reduce|tinier|too big|too large)/.test(n)) st.artZoom = Math.max(0.6, Math.round((z0 - 0.25) * 20) / 20);
      else if (/(bigger|larger|enlarge|increase|too small)/.test(n)) st.artZoom = Math.min(2.5, Math.round((z0 + 0.25) * 20) / 20);
      if (st.artZoom !== z0) {
        hit = true;
        var zs = document.getElementById('np-e2-artzoom'), zv = document.getElementById('np-e2-artzoom-val');
        if (zs) { zs.value = Math.round(st.artZoom * 100); try { paintSlider(zs); } catch (ez) {} }
        if (zv) zv.textContent = Math.round(st.artZoom * 100) + '%';
      }
    }
    if (hit) { commitOptions(); renderAccordion(); }
    return hit;
  }
  function regenerateWithNotes(note) {
    if (sensei.busy) return;
    sensei.busy = true;
    var gen = sensei.genSeq = (sensei.genSeq || 0) + 1; /* invalidate any late-swap listener */
    var prev = st.versions[st.versions.length - 1] || {};
    showProofLoading('Applying your notes and re-rendering your patch.');
    /* quick edit (note only, selections unchanged): pass the CURRENT render
       as the edit base — the renderer re-edits it with high input fidelity,
       so "remove the small text" style requests actually land instead of
       fighting the redraw-from-artwork fidelity rules */
    var editV = st.versions[(st.selected === null || st.selected === undefined) ? st.versions.length - 1 : st.selected] || prev;
    sensei.editBase = (note && !specsChangedSince(prev) && editV && editV.hosted && !editV.fallbackUpload)
      ? { url: String(editV.hosted).split('?')[0], note: note }
      : null;
    /* converted sessions REVISE in the converted style — a revision must
       never silently fall back to an embroidered render */
    var convKind = (editV && editV.fullColor) ? (editV.altKind || 'fc') : ((prev && prev.fullColor) ? (prev.altKind || 'fc') : null);
    if (convKind) sensei.titleOverride = convKind === 'woven' ? 'Woven Patches' : 'Full Color Printed Patches';
    /* keep every revision request on the order too */
    var el = document.querySelector('input[name="properties[_Revision Notes]"]');
    var existing = el ? el.value : '';
    setProp('_Revision Notes', (existing ? existing + ' | ' : '') + 'v' + (st.versions.length + 1) + ': ' + note);
    lineSync();
    if (sensei.sessionId || st.versions.length) {
      var diffs = 'Updated selections: ' + [st.shape, st.border && normalizeBorder(st.border.label), st.bg && st.bg.label + ' background', st.thread && st.thread.label + ' thread', st.backing && st.backing.label].filter(Boolean).join(', ') + '.';
      var fullNote = note ? (specsChangedSince(prev) ? diffs + ' ' + note : note) : diffs;
      sensei.renderLineId = (sensei.lineItemId || (sensei.syntheticId = sensei.syntheticId || ('npe2-' + Date.now()))) + '::v' + (st.versions.length + 1);
      composeAndHost() /* the regen must submit the CURRENT selections' composition, not the prior one */
        .then(function () { return cartJson(); })
        .then(function (cart) { return senseiCreate(cart, fullNote); })
        .then(function () {
          return new Promise(function (res, rej) { senseiWaitChanged(prev.hosted || '', -1, function (e, m) { e ? rej(e) : res(m); }, 95000); });
        })
        .then(function (mine) {
          var v = newVersionMeta();
          v.dataUrl = mine.mockup_url; v.hosted = mine.mockup_url; v.rev = mine.revision_count || 0;
          if (convKind) { v.fullColor = true; v.altKind = convKind; }
          sensei.titleOverride = null;
          return new Promise(function (res) { prepareVersionDisplay(v, function () { pushVersion(v); res(); }); });
        })
        .catch(function (err) {
          console.warn('[np-emb2] sensei revision failed', err);
          sensei.titleOverride = null;
          pushUploadFallback(err);
          /* same as first-generation: keep listening and swap the real
             render in over the fallback the moment it lands */
          senseiWaitChanged(prev.hosted || '', -1, function (e2, m2) {
            if (!e2 && m2 && gen === sensei.genSeq) adoptLateRender(m2);
          }, 150000);
        })
        .then(function () { sensei.busy = false; });
    } else {
      /* no session yet (e.g. earlier failure) — run a fresh generation */
      sensei.busy = false;
      openProof();
    }
  }
  function renderProofReady() {
    $('#np-e2-pf-title').textContent = 'Review your proof';
    $('#np-e2-pf-loading').hidden = true;
    $('#np-e2-pf-ready').hidden = false;
    var szPane = $('#np-e2-pf-sizing'); if (szPane) szPane.hidden = true;
    var eb = $('#np-e2-pf-eyebrow'); if (eb) eb.textContent = 'AI PROOF';
    var szPanel = pf.querySelector('.np-e2-modal'); if (szPanel) szPanel.classList.remove('is-sizing');
    st.proofPhase = 'ready';
    var hasPick = st.selected !== null && st.selected !== undefined;
    var v = st.versions[hasPick ? st.selected : st.versions.length - 1];
    $('#np-e2-pf-approve').disabled = !hasPick;
    var pick = $('#np-e2-pf-pick');
    if (pick) pick.hidden = !(st.versions.length > 1 && !hasPick);
    var pfShown = v.alpha || v.dataUrl || v.hosted;
    /* the compare shows THE PREVIEW WINDOW (composed shape+colors) vs the
       AI proof — the raw upload is only the fallback */
    var cmpUpload = !v.fallbackUpload && pfShown ? (sensei.composedLocal || sensei.composedCleanUrl || applyToggleParams(cleanUrl(artworkUrl()) || '') || '') : '';
    $('#np-e2-pf-stage').innerHTML = pfShown
      ? '<div class="np-e2-stage-note"><i>i</i><div><b>This is an AI-rendered proof</b> <span class="np-e2-note-long">' + (v.fallbackUpload
          ? 'Our AI renderer is taking longer than usual, so we\u2019re showing your uploaded design. You can continue to checkout \u2014 a patch specialist will prepare and email your proof by hand.'
          : 'This step is just your design and colors. You\u2019ll pick your size and quantity next. A patch specialist reviews every order by hand before anything is created.') + '</span><span class="np-e2-note-short">' + (v.fallbackUpload ? 'Showing your upload \u2014 a specialist will email your proof.' : 'Size &amp; quantity come next.') + '</span></div></div>' +
        '<i class="np-e2-pf-under" aria-hidden="true"></i><img src="' + pfShown + '" alt="AI proof">' +
        '<span class="np-e2-cmp__tag np-e2-cmp__tag--r">AI PROOF</span>' +
        (cmpUpload
          ? '<div class="np-e2-cmp__before" id="np-e2-cmp-before" style="clip-path:inset(0 91% 0 0);-webkit-clip-path:inset(0 91% 0 0)"><img src="' + cmpUpload + '" alt="Your preview"><span class="np-e2-cmp__tag np-e2-cmp__tag--l">YOUR PREVIEW</span></div>' +
            '<button type="button" class="np-e2-cmp__handle" id="np-e2-cmp-handle" style="left:9%" aria-label="Drag to compare"><svg viewBox="0 0 24 24" fill="none" stroke="#0f172a" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="10 8 6 12 10 16"/><polyline points="14 8 18 12 14 16"/></svg></button>'
          : '') +
        '<button type="button" class="np-e2-pf-zoombtn" aria-label="Zoom proof"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg></button>' +
        (pdpPricingOn() && !v.fallbackUpload
          /* on-page-pricing flow (Justin 2026-08-24): size is ALREADY picked
             in Step 3 before proofing, so the proof carries the measuring
             arrows too — positionDims sizes them to the measured patch */
          ? '<div class="np-e2-dim np-e2-dim--w"><i class="np-e2-dim__line"></i><b class="np-e2-dim__chip"></b></div><div class="np-e2-dim np-e2-dim--h"><i class="np-e2-dim__line"></i><b class="np-e2-dim__chip"></b></div>'
          : '')
      : ''; /* elsewhere no dimension arrows — size isn't picked until the sizing phase */
    $('#np-e2-pf-stage').classList.toggle('is-alpha', isAlphaSrc(pfShown || v.hosted || ''));
    var cmpCap = document.getElementById('np-e2-pf-cmpcap');
    if (cmpCap) cmpCap.hidden = !cmpUpload;
    try {
      var stgSet = $('#np-e2-pf-stage');
      if (stgSet && cmpUpload) {
        stgSet.classList.add('is-settling');
        npTick(function () { try { stgSet.classList.remove('is-settling'); } catch (eSr) {} }, 1500); /* never hide longer than this */
      }
    } catch (eSt) {}
    cmpSweep = !!cmpUpload && !v.__swept && !v.fallbackUpload;
    if (cmpSweep) v.__swept = true;
    wireCompare();
    var pfImg = $('#np-e2-pf-stage > img');
    if (pfImg) pfImg.addEventListener('load', function () { positionDims(); });
    positionDims();
    try { matchCompareScale($('#np-e2-pf-stage')); } catch (eMS) {}
    $('#np-e2-pf-cap').textContent = (v.fullColor ? 'Full Color Printed Patch · ' : (v.fallbackUpload ? 'Your uploaded design · ' : (v.fallback ? 'Instant preview · ' : ''))) + [v.w.toFixed(2) + '" × ' + v.h.toFixed(2) + '"', v.shape, v.backing && v.backing.label].filter(Boolean).join(' · ');
    var headNotice = document.getElementById('np-e2-pf-headnotice');
    if (headNotice) headNotice.hidden = true; /* the notice lives INSIDE the preview square now */
    var left = regensLeft();
    $('#np-e2-pf-versions').innerHTML = st.versions.map(function (x, i) {
      var on = hasPick && i === st.selected;
      return '<span class="np-e2-pf-version' + (on ? ' is-on' : '') + (x.fullColor ? ' is-fc' : '') + '" data-e2-v="' + i + '"><i>' + ((x.alpha || x.dataUrl) ? '<img src="' + (x.alpha || x.dataUrl) + '">' : '') + '</i><b>' + (x.fullColor ? 'FC' : 'V' + (i + 1)) + '</b></span>';
    }).join('');
    /* full-color recommendation: photo-real art stitches poorly */
    var reco = $('#np-e2-fc-reco');
    var forcedN = $('#np-e2-fc-forced');
    var forcedTxt = null;
    if (st.fdChoice === 'woven') forcedTxt = '<b>\ud83e\uddf5 Converted to Woven</b><span>The fine detail in your design can\u2019t be stitched in embroidery thread \u2014 ultra-fine woven threads keep it crisp, so your proof was generated as a <em>Woven Patch</em>.</span>';
    else if (st.fdChoice === 'ps') forcedTxt = '<b>\ud83e\udea1 Print &amp; Stitch production</b><span>The fine detail in your design will be PRINTED and the larger areas embroidered. A patch specialist finalizes the split by hand before production.</span>';
    else if (st.fcForced && st.fcForcedReason === 'detail') forcedTxt = '<b>\ud83d\udd0e Converted to Full Color Printed</b><span>Small text and thin lines can\u2019t be stitched in embroidery thread \u2014 full color print reproduces every detail exactly, so your proof was generated as a <em>Full Color Printed Patch</em>.</span>';
    else if (st.fcForced) forcedTxt = '<b>\ud83d\udcf8 Converted to Full Color Printed</b><span>Photographs can\u2019t be stitched in embroidery thread \u2014 full color print is the only way to produce this image, so your proof was generated as a <em>Full Color Printed Patch</em>.</span>';
    if (forcedTxt) {
      if (reco) reco.hidden = true;
      if (forcedN) { forcedN.innerHTML = forcedTxt; forcedN.hidden = false; }
    } else {
      if (forcedN) forcedN.hidden = true;
      if (reco) reco.hidden = !(PTYPE.name !== 'Printed' && fullColorLikely(v.line) && !st.fcOffered && !v.fullColor && !st.proofApproved);
    }
    var approveBtn = $('#np-e2-pf-approve');
    var pkV = hasPick && st.versions[st.selected];
    var revNow = formProp('_Revision Notes') || '';
    approveBtn.textContent = revNow ? (pdpPricingOn() ? 'Submit with Revisions & Finalize Order' : 'Submit with Revisions and go to pricing')
      : (pkV && pkV.fullColor && !onTargetProduct(pkV))
      ? (pkV.altKind === 'woven' ? 'Continue with Woven patch' : 'Continue with Full Color patch')
      : ((st.fdChoice === 'ps' && !onTargetProduct({ altKind: 'ps' })) ? 'Continue with Print & Stitch patch' : (pdpPricingOn() ? 'Approve & Finalize Order' : 'Approve and go to size and pricing'));
    $$('#np-e2-pf-versions [data-e2-v]').forEach(function (el) {
      el.addEventListener('click', function () { st.selected = parseInt(el.getAttribute('data-e2-v'), 10); renderProofReady(); });
    });
    var changeTxt = $('#np-e2-change-text').value.trim();
    var usedRows = [];
    if (PTYPE.textLines) {
      /* the typed order IS the design — every lettering decision belongs here */
      var linesU = ttLines();
      linesU.forEach(function (lU, iU) {
        usedRows.push(['Line ' + (iU + 1), lU + '  ·  ' + (st['ttLay' + (iU + 1)] || 'Straight') +
          (iU > 0 && st['ttHalf' + (iU + 1)] ? '  ·  \u00bd size' : '')]);
      });
      if (stepEnabled('font')) usedRows.push(['Font style', st.font ? st.font.label : '\u2014']);
      var layU = st['opt' + (PTYPE.layersOpt || 2)];
      if (layU) usedRows.push(['Layers', layU.label]);
      if (ttSwooshOn()) {
        usedRows.push(['Tail', ttSwooshDef(st.swooshStyle).name]);
        if (String(st.swooshText || '').trim()) {
          usedRows.push(['Text on tail', String(st.swooshText).trim().toUpperCase() +
            (st.swooshTextColor ? '  ·  ' + st.swooshTextColor.label : '')]);
        }
      }
    }
    if (stepEnabled('shape')) usedRows.push(['Shape', displayShapeLabel(v.shape) || '\u2014']);
    if (stepEnabled('border')) usedRows.push(['Border style', st.border ? st.border.label : '\u2014']);
    if (stepEnabled('bg')) usedRows.push([PTYPE.bgLabel || 'Patch background', v.bg ? v.bg.label : '\u2014']);
    if (stepEnabled('thread')) usedRows.push([PTYPE.threadLabel || 'Border thread', v.thread ? v.thread.label : '\u2014']);
    if (PTYPE.borderThick) usedRows.push(['Border thickness', Math.max(1, Math.min(10, st.lbThick || 3)) + ' of 10']);
    if (stepEnabled('texture')) usedRows.push(['Background texture', st.texture ? st.texture.label : '\u2014']);
    if (PTYPE.stitches) usedRows.push(['Border stitch', st.ttStitch || 'Zig Zag']);
    usedRows.push(['Backing', v.backing ? v.backing.label : '\u2014']);
    usedRows.push(['Size', v.w.toFixed(2) + '" × ' + v.h.toFixed(2) + '"']);
    usedRows.push(['Quantity', st.qty + ' pcs']); /* no pricing before approval — it reveals in the sizing phase */
    /* AI edit request row removed — it is noise in the selections list */
    var revSaved = formProp('_Revision Notes') || '';
    var revBox = document.getElementById('np-e2-pf-revsaved');
    if (revBox) {
      revBox.hidden = !revSaved;
      var revTxt = document.getElementById('np-e2-pf-revsaved-txt');
      if (revTxt) revTxt.textContent = revSaved;
    }
    $('#np-e2-pf-used').innerHTML = usedRows.map(function (r) { return '<div class="np-e2-pf-used-row"><span>' + r[0] + '</span><b>' + r[1] + '</b></div>'; }).join('');
    var regen = $('#np-e2-pf-regen');
    regen.disabled = false;
    var changedNow = specsChangedSince(st.versions[st.versions.length - 1]);
    regen.textContent = changedNow ? 'Regenerate with updated selections' : 'Submit Revisions';
    regen.classList.toggle('is-updated', changedNow);
    /* revisions already filed: the saved panel's "Edit notes" is the way back,
       so the footer button would just be a second door to the same room. It
       returns the moment selections change, since that is a regenerate. */
    regen.hidden = !!revSaved && !changedNow;
  }
  function onTargetProduct(v) {
    /* already ON the converted product — approve behaves normally there */
    var h = v && v.altKind === 'woven' ? 'woven-patches' : (v && v.altKind === 'ps' ? 'print-stitch-patches' : 'sublimated-patches');
    return location.pathname.indexOf(h) !== -1;
  }
  var fdChoiceEl = null;
  function openFineDetailChoice() {
    /* recommendation depends on HOW MUCH of the design is fine detail:
       nearly all thin (or a photo, which never reaches here) -> Full Color;
       a MIX of chunky areas + fine detail -> Print & Stitch leads */
    var allFine = (st.artThinInkFrac || 0) > 0.7;
    /* molded PVC can't stitch OR mold fine detail — Full Color leads, woven
       is not a sane conversion from rubber (Justin 2026-08-24) */
    var molded = /^(rubber-pvc-2-0|keychains-2-0|silicone-2-0)$/.test(TYPE_KEY);
    var OPT = {
      fc: '<button type="button" class="np-e2-fdopt' + (allFine || molded ? ' np-e2-fdopt--rec' : '') + '" data-fd="fc"><b>Full Color Printed</b><i>Every detail reproduced exactly \u2014 the sharpest result for fine detail.</i></button>',
      ps: '<button type="button" class="np-e2-fdopt' + (allFine || molded ? '' : ' np-e2-fdopt--rec') + '" data-fd="ps"><b>Print &amp; Stitch combo</b><i>Large areas embroidered, fine details printed \u2014 a patch specialist finalizes the split by hand.</i></button>',
      woven: '<button type="button" class="np-e2-fdopt" data-fd="woven"><b>Woven Patch</b><i>Ultra-fine woven threads keep tiny detail crisp with a true fabric look.</i></button>'
    };
    var intro = molded
      ? 'Your image is packed with fine detail. Molded PVC has a physical minimum line width, so detail that small would blur or fill in. Choose how you\u2019d like us to produce it:'
      : allFine
      ? 'Your image is made almost entirely of small text or very thin lines. Embroidery thread has a physical minimum stitch width, so that fine detail would blur or fill in. Choose how you\u2019d like us to produce it:'
      : 'Parts of your design have small text or thin lines that embroidery thread can\u2019t stitch cleanly \u2014 the rest stitches beautifully. Choose how you\u2019d like us to produce it:';
    if (!fdChoiceEl) {
      fdChoiceEl = document.createElement('div');
      fdChoiceEl.className = 'np-e2-ov np-e2-ov--fd';
      (document.getElementById('np-e2') || document.body).appendChild(fdChoiceEl);
    }
    fdChoiceEl.__kind = null;
    fdChoiceEl.innerHTML = '<div class="np-e2-modal">' +
      '<header class="np-e2-modal__head"><div><span class="np-e2-modal__eyebrow np-e2-fcc-eyebrow">FINE DETAIL DETECTED</span>' +
      '<h3 class="np-e2-modal__title">' + (molded ? 'This design is too detailed for molded PVC' : allFine ? 'This design is too detailed for embroidery thread' : 'Part of this design is too detailed for embroidery thread') + '</h3></div></header>' +
      '<div class="np-e2-modal__body">' +
      '<p class="np-e2-fd-txt">' + intro + '</p>' +
      (molded ? OPT.fc + OPT.ps : allFine ? OPT.fc + OPT.woven + OPT.ps : OPT.ps + OPT.fc + OPT.woven) +
      '</div>' +
      '<footer class="np-e2-modal__foot"><button type="button" class="np-e2-btn np-e2-btn--outline" data-fd-back>Go back</button><div class="np-e2-modal__footright"><button type="button" class="np-e2-btn np-e2-btn--green" data-fd-go disabled>Continue</button></div></footer></div>';
    fdChoiceEl.querySelector('[data-fd-back]').addEventListener('click', function () { fdChoiceEl.hidden = true; });
    var fdGo = fdChoiceEl.querySelector('[data-fd-go]');
    $$('[data-fd]', fdChoiceEl).forEach(function (btnF) {
      btnF.addEventListener('click', function () {
        /* select only — Continue confirms, so a stray click can't convert */
        $$('[data-fd]', fdChoiceEl).forEach(function (b2) { b2.classList.toggle('is-on', b2 === btnF); });
        fdChoiceEl.__kind = btnF.getAttribute('data-fd');
        fdGo.disabled = false;
      });
    });
    fdGo.addEventListener('click', function () {
      var kind = fdChoiceEl.__kind;
      if (!kind) return;
      fdChoiceEl.hidden = true;
      st.fdChoice = kind;
      var digIntent = (st.pendingProofKind === 'digital' || st.pendingProofKind === 'stitch');
      if (digIntent) st.proofMode = st.pendingProofKind;
      if (kind === 'fc') {
        st.fcForced = true; st.fcForcedReason = 'detail'; st.fcOffered = true;
        if (digIntent) { st.fcConfirmed = true; digitalConvert('fc'); } else generateFullColor();
      }
      else if (kind === 'woven') {
        st.fcConfirmed = true; st.fcOffered = true;
        if (digIntent) digitalConvert('woven'); else generateFullColor('woven');
      }
      else {
        if (molded) {
          /* PVC can't split print/embroider on itself — Print & Stitch means
             the print-stitch PRODUCT, artwork riding along */
          var artM = cleanUrl(artworkUrl()) || '';
          window.location.href = '/products/print-stitch-patches?np_mode=ai' + (artM && isUploadLineage(artM) ? '&file=' + encodeURIComponent(artM) : '');
          return;
        }
        st.fcConfirmed = true;
        setProp('_Production Method', 'PRINT & STITCH - fine detail printed, remainder embroidered');
        if (digIntent) digitalConvert('ps'); else openProof();
      }
    });
    fdChoiceEl.hidden = false;
  }
  var leaveConfirmEl = null;
  function openLeaveConfirm() {
    /* X in Size & Pricing: leaving throws the whole session away — make
       sure that's what they want, then restart the page clean */
    if (!leaveConfirmEl) {
      leaveConfirmEl = document.createElement('div');
      leaveConfirmEl.className = 'np-e2-ov np-e2-ov--fcc';
      leaveConfirmEl.innerHTML = '<div class="np-e2-modal np-e2-modal--fcc">' +
        '<header class="np-e2-modal__head"><div><span class="np-e2-modal__eyebrow np-e2-fcc-eyebrow">ARE YOU SURE?</span>' +
        '<h3 class="np-e2-modal__title">Leave size and pricing?</h3></div></header>' +
        '<div class="np-e2-modal__body">' +
        '<p class="np-e2-fcc-txt">If you leave now, <b>everything will be lost</b> \u2014 your proof, your selections, and your sizing. You\u2019ll start over from a fresh upload.</p>' +
        '</div>' +
        '<footer class="np-e2-modal__foot"><button type="button" class="np-e2-btn np-e2-btn--outline" data-lv-stay>Stay here</button><div class="np-e2-modal__footright"><button type="button" class="np-e2-btn np-e2-btn--green" data-lv-go>Continue \u2014 start over</button></div></footer></div>';
      (document.getElementById('np-e2') || document.body).appendChild(leaveConfirmEl);
      leaveConfirmEl.querySelector('[data-lv-stay]').addEventListener('click', function () { leaveConfirmEl.hidden = true; });
      leaveConfirmEl.querySelector('[data-lv-go]').addEventListener('click', function () {
        /* clean product URL: no file=/np_* params — lands on the upload box */
        window.location.href = window.location.pathname + (window.location.search.indexOf('view=') > -1 ? '?view=' + new URLSearchParams(window.location.search).get('view') : '');
      });
    }
    leaveConfirmEl.hidden = false;
  }
  var photoConfirmEl = null;
  function openPhotoConfirm() {
    if (!photoConfirmEl) {
      photoConfirmEl = document.createElement('div');
      photoConfirmEl.className = 'np-e2-ov np-e2-ov--fcc';
      photoConfirmEl.innerHTML = '<div class="np-e2-modal np-e2-modal--fcc">' +
        '<header class="np-e2-modal__head"><div><span class="np-e2-modal__eyebrow np-e2-fcc-eyebrow">PHOTO OR HIGH-DETAIL IMAGE DETECTED</span>' +
        '<h3 class="np-e2-modal__title">Full Color will make this image look its best</h3></div></header>' +
        '<div class="np-e2-modal__body">' +
        '<p class="np-e2-fcc-txt">Good news \u2014 your image is packed with rich detail. To keep every bit of it crisp and true to the original, we\u2019ll create your proof as a <b>Full Color Printed Patch</b>. Embroidery thread would soften the fine details that make this image great \u2014 Full Color captures all of them beautifully.</p>' +
        '<p class="np-e2-fcc-txt" data-fcc-l2>By continuing, your order switches from Embroidered to Full Color Printed.</p>' +
        '</div>' +
        '<footer class="np-e2-modal__foot"><button type="button" class="np-e2-btn np-e2-btn--outline" data-pc-keep>Keep this patch type</button><div class="np-e2-modal__footright"><button type="button" class="np-e2-btn np-e2-btn--green" data-pc-ok>Continue with Full Color</button></div></footer></div>';
      (document.getElementById('np-e2') || document.body).appendChild(photoConfirmEl);
      /* KEEP THIS PATCH TYPE (Justin 2026-08-24, replaces the re-upload
         escape): the customer overrides the detector and continues building
         on the current type. Mark the check cleared so neither the upload
         gate nor the generate backstop re-interrupts this session. */
      photoConfirmEl.querySelector('[data-pc-keep]').addEventListener('click', function () {
        st.__photoCleared = true;
        st.__photoNudged = true;
        st.__keepArtBase = (cleanUrl(artworkUrl()) || '').split('?')[0];
        photoConfirmEl.hidden = true;
        if (!photoConfirmEl.__upload) pf.hidden = true;
      });
      photoConfirmEl.querySelector('[data-pc-ok]').addEventListener('click', function () {
        photoConfirmEl.hidden = true;
        if (photoConfirmEl.__upload) {
          /* UPLOAD-TIME path: hand the customer to the Full Color builder
             FRESH so every option is chosen on the right patch type — no
             carried selections, no auto-generate. */
          var artU2 = cleanUrl(artworkUrl()) || '';
          window.location.href = '/products/sublimated-patches?np_mode=ai' + (artU2 && isUploadLineage(artU2) ? '&file=' + encodeURIComponent(artU2) : '');
          return;
        }
        st.fcConfirmed = true;
        st.fcForced = true; st.fcForcedReason = 'photo'; st.fcOffered = true;
        if (st.pendingProofKind === 'digital' || st.pendingProofKind === 'stitch') {
          st.proofMode = st.pendingProofKind;
          digitalConvert('fc');
        } else generateFullColor();
      });
    }
    photoConfirmEl.__upload = (arguments[0] === 'upload');
    var l2P = photoConfirmEl.querySelector('[data-fcc-l2]');
    if (l2P) l2P.textContent = photoConfirmEl.__upload
      ? 'We\u2019ll bring your image right along to the Full Color builder \u2014 nothing to re-upload \u2014 so you can pick your options and see it looking its best.'
      : 'By continuing, your order switches from Embroidered to Full Color Printed \u2014 so your patch looks exactly like the image you love.';
    photoConfirmEl.hidden = false;
  }
  var uploadRecoEl = null;
  function openFdReco(modeF) {
    /* material-aware at-upload fine-detail recommendation — rubber PVC molds,
       it doesn't stitch, and Full Color is the preferred escape (Justin
       2026-08-24) */
    if (/^(rubber-pvc-2-0|keychains-2-0|silicone-2-0)$/.test(TYPE_KEY)) openUploadReco(
      'FINE DETAIL DETECTED',
      'This design is too detailed for molded PVC',
      'Patch Sensei checked your image: it\u2019s full of fine detail, and molded PVC has a physical minimum line width \u2014 detail that small would blur or fill in. A <b>Full Color Printed Patch</b> reproduces every detail exactly, crisp and true to your design.',
      'Continue with Full Color',
      '/products/sublimated-patches',
      modeF
    );
    else openUploadReco(
      'FINE DETAIL DETECTED',
      'Small text and thin lines can\u2019t be stitched in embroidery thread',
      'Patch Sensei checked your image: it has fine detail that embroidery thread physically can\u2019t reproduce. A Print & Stitch patch PRINTS the fine detail and embroiders the rest \u2014 the best of both.',
      'Continue with Print & Stitch',
      '/products/print-stitch-patches',
      modeF
    );
  }
  function openUploadReco(eyebrow, title, body, cta, handle, modeR) {
    /* at-upload recommendation: warn BEFORE options are chosen and reset the
       customer onto the RIGHT product with their image in the URL */
    if (uploadRecoEl && uploadRecoEl.parentNode) uploadRecoEl.parentNode.removeChild(uploadRecoEl);
    uploadRecoEl = document.createElement('div');
    uploadRecoEl.className = 'np-e2-ov np-e2-ov--fcc';
    uploadRecoEl.innerHTML = '<div class="np-e2-modal np-e2-modal--fcc">' +
      '<header class="np-e2-modal__head"><div><span class="np-e2-modal__eyebrow np-e2-fcc-eyebrow">' + eyebrow + '</span>' +
      '<h3 class="np-e2-modal__title">' + title + '</h3></div></header>' +
      '<div class="np-e2-modal__body"><p class="np-e2-fcc-txt">' + body + '</p>' +
      '<p class="np-e2-fcc-txt">By continuing, we\u2019ll take you to the right builder so you can pick your options for that patch type.</p></div>' +
      '<footer class="np-e2-modal__foot"><button type="button" class="np-e2-btn np-e2-btn--outline" data-ur-keep>Keep this patch type</button>' +
      '<div class="np-e2-modal__footright"><button type="button" class="np-e2-btn np-e2-btn--green" data-ur-ok>' + cta + '</button></div></footer></div>';
    /* BODY, always: on classic pages #np-e2 is hidden, which made the modal
       invisible while its overlay froze the page */
    document.body.appendChild(uploadRecoEl);
    var urKeep = uploadRecoEl.querySelector('[data-ur-keep]');
    if (urKeep) urKeep.addEventListener('click', function () {
      /* KEEP THIS PATCH TYPE (Justin 2026-08-24): the customer overrides the
         recommendation and continues on the current type — stand the detector
         down so neither the upload gate nor the generate-time gates re-nag
         this session. */
      st.__photoCleared = true;
      st.__photoNudged = true;
      st.__keepArtBase = (cleanUrl(artworkUrl()) || '').split('?')[0];
      uploadRecoEl.hidden = true;
    });
    uploadRecoEl.querySelector('[data-ur-ok]').addEventListener('click', function () {
      uploadRecoEl.hidden = true;
      var artU3 = cleanUrl(artworkUrl()) || '';
      window.location.href = handle + '?np_mode=' + (modeR || 'ai') + (artU3 && isUploadLineage(artU3) ? '&file=' + encodeURIComponent(artU3) : '');
    });
    uploadRecoEl.hidden = false;
  }
  var fcConfirmEl = null;
  function openFcConfirm(picked) {
    /* forced conversions need an explicit sign-off: the customer must
       acknowledge the Embroidered -> Full Color switch before continuing */
    if (!fcConfirmEl) {
      fcConfirmEl = document.createElement('div');
      fcConfirmEl.className = 'np-e2-ov np-e2-ov--fcc';
      fcConfirmEl.innerHTML = '<div class="np-e2-modal np-e2-modal--fcc">' +
        '<header class="np-e2-modal__head"><div><span class="np-e2-modal__eyebrow np-e2-fcc-eyebrow">PLEASE CONFIRM</span>' +
        '<h3 class="np-e2-modal__title">We converted your patch to Full Color</h3></div></header>' +
        '<div class="np-e2-modal__body">' +
        '<p class="np-e2-fcc-txt">Your image is a photograph or highly detailed image, and that level of detail can\u2019t be stitched in embroidery thread. We generated your proof as a <b>Full Color Printed Patch</b> \u2014 the only way to produce this image.</p>' +
        '<p class="np-e2-fcc-txt">By continuing, you approve this proof and the switch from Embroidered to Full Color Printed.</p>' +
        '</div>' +
        '<footer class="np-e2-modal__foot"><button type="button" class="np-e2-btn np-e2-btn--outline" data-fcc-cancel>Go back</button>' +
        '<div class="np-e2-modal__footright"><button type="button" class="np-e2-btn np-e2-btn--green" data-fcc-ok>I understand \u2014 Continue with Full Color</button></div></footer></div>';
      (document.getElementById('np-e2') || document.body).appendChild(fcConfirmEl);
      fcConfirmEl.querySelector('[data-fcc-cancel]').addEventListener('click', function () { fcConfirmEl.hidden = true; });
      fcConfirmEl.querySelector('[data-fcc-ok]').addEventListener('click', function () {
        fcConfirmEl.hidden = true;
        st.fcConfirmed = true; /* signed off — don't ask again this session */
        if (fcConfirmEl.__pick) switchToFullColor(fcConfirmEl.__pick);
      });
    }
    fcConfirmEl.__pick = picked;
    fcConfirmEl.hidden = false;
  }
  function switchToFullColor(v) {
    /* they chose the Full Color proof: drop the embroidered line from the
       cart and hand off to the Full Color PDP with the approved proof */
    var notes = formProp('_Revision Notes') || '';
    var go = function () {
      /* the PROOF travels as the working file (file=) so the FC page shows
         and sells the approved render; the ORIGINAL upload rides separately
         (np_art) and is restored into _Original Image on arrival */
      var tgtView = v.altKind === 'woven' ? 'woven-2-0' : (v.altKind === 'ps' ? 'print-and-stitch-2-0' : 'fullcolor-2-0');
      /* LINEAGE GUARD (PATCH-2106464/68): artworkUrl() can be clobbered by
         legacy timers mid-session — an np_art that doesn't share the proof's
         original-upload suffix is NOT this customer's artwork. Send nothing
         rather than someone else's image. */
      var npArtV = cleanUrl(artworkUrl());
      if (!sameLineage(npArtV, v.hosted)) npArtV = '';
      var qs = '?view=' + tgtView + '&np_proof=' + encodeURIComponent(v.hosted || '') +
        '&np_art=' + encodeURIComponent(npArtV) +
        '&np_w=' + st.w.toFixed(2) + '&np_h=' + st.h.toFixed(2) + '&np_qty=' + st.qty +
        (notes ? '&np_notes=' + encodeURIComponent(notes.slice(0, 400)) : '') +
        '&np_conv=' + encodeURIComponent(st.fdChoice || st.fcForcedReason || (st.fcForced ? 'photo' : '')) +
        '&np_pp=' + encodeURIComponent((st.proofMode === 'digital' || st.proofMode === 'stitch') ? st.proofMode : '') +
        '&np_shape=' + encodeURIComponent(st.shape || '') +
        '&np_corners=' + encodeURIComponent(st.corners || '') +
        '&np_bgl=' + encodeURIComponent(st.bg ? st.bg.label : '') +
        '&np_thl=' + encodeURIComponent(st.thread ? st.thread.label : '') +
        '&np_txl=' + encodeURIComponent(st.text ? st.text.label : '') +
        '&np_bsl=' + encodeURIComponent(st.border ? st.border.label : '') +
        '&np_bkl=' + encodeURIComponent(st.backing ? st.backing.label : '') +
        '&file=' + encodeURIComponent(v.hosted || cleanUrl(artworkUrl()));
      window.location.href = '/products/' + (v.altKind === 'woven' ? 'woven-patches' : (v.altKind === 'ps' ? 'print-stitch-patches' : 'sublimated-patches')) + qs;
    };
    if (sensei.added && sensei.lineItemId) {
      cartJson().then(function (cart) {
        var line = ourCartLine(cart); /* the key drifts after every props change — refresh before zeroing */
        if (!line) return;
        return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ id: line.key, quantity: 0 }) });
      }).then(go).catch(go);
    } else go();
  }
  function renderSizing() {
    /* Phase 3 — Size and pricing, inside the same modal after approval.
       The approved proof is the product image; steppers/tiers/checkout all
       live here (no pricing anywhere on the page). */
    hidePageLoader(); /* any path landing here clears the skip-path loader */
    st.proofPhase = 'sizing';
    if (pdpPricingOn()) {
      /* STAGING: pricing IS on the page — the modal never shows a sizing
         phase. A skip-path arrival goes straight to checkout (size and qty
         were already chosen on the page). */
      if (st.__skipCheckout) {
        /* skip lands on the FINAL REVIEW: approved digital summary with the
           stitchout add-on and Add to Cart — never an auto-checkout (it was
           holding the customer on the adding-veil, Justin 2026-08-24) */
        st.__skipCheckout = false;
        var apSk = $('#np-e2-approved');
        if (apSk) apSk.hidden = false;
        var srSk = document.getElementById('np-e2-stitchrow');
        if (srSk) { try { srSk.hidden = !stitchAddonEligible(); } catch (eSk) {} }
        if (apSk) {
          var landSk = function () {
            var yS = apSk.getBoundingClientRect().top + window.pageYOffset - npScrollPad();
            window.scrollTo({ top: Math.max(0, yS), behavior: 'smooth' });
          };
          setTimeout(landSk, 150); setTimeout(landSk, 650); setTimeout(landSk, 1300);
        }
      }
      var wasModalG = !pf.hidden;
      pf.hidden = true;
      /* on the FINAL STEP the review page stands alone — step 3 (pricing)
         and everything below it leave the page (Justin 2026-08-24) */
      document.body.classList.toggle('np-e2-final', !!st.proofApproved);
      var szG0 = $('#np-e2-pf-sizing'); if (szG0) szG0.hidden = false;
      if (st.proofApproved) {
        var apG0 = $('#np-e2-approved');
        if (apG0) apG0.hidden = false;
        var srG0 = document.getElementById('np-e2-stitchrow');
        if (srG0) { try { srG0.hidden = !stitchAddonEligible(); } catch (eSg) {} }
        /* an approval just closed the modal — land the customer ON the
           final step (Review and Submit), not wherever they were */
        if (wasModalG && apG0) {
          /* the final-step class COLLAPSES step-3 + the tier rail above this
             card — a single early scroll gets stranded at the page bottom
             when the layout shifts. Land, then re-land as it settles. */
          var landTop = function () {
            var yF = apG0.getBoundingClientRect().top + window.pageYOffset - npScrollPad();
            window.scrollTo({ top: Math.max(0, yF), behavior: 'smooth' });
          };
          setTimeout(landTop, 150); setTimeout(landTop, 650); setTimeout(landTop, 1300);
        }
      }
    } else {
      pf.hidden = false;
      $('#np-e2-pf-loading').hidden = true;
      $('#np-e2-pf-ready').hidden = true;
      var er = $('#np-e2-pf-error'); if (er) er.hidden = true;
      var hn = $('#np-e2-pf-headnotice'); if (hn) hn.hidden = true;
      var sz = $('#np-e2-pf-sizing'); if (sz) sz.hidden = false;
      var eb = $('#np-e2-pf-eyebrow'); if (eb) eb.textContent = 'STEP 3 OF 3';
      $('#np-e2-pf-title').textContent = 'Size and pricing';
      var panel = pf.querySelector('.np-e2-modal'); if (panel) panel.classList.add('is-sizing');
    }
    var idx = (st.selected === null || st.selected === undefined) ? st.versions.length - 1 : st.selected;
    var v = st.versions[idx];
    var img = $('#np-e2-sz-img');
    /* digital proofs fill their canvas edge-to-edge — shrink the display so
       the rulers get breathing room instead of hugging the stage */
    var szStageD = document.getElementById('np-e2-sz-stage');
    if (szStageD) szStageD.classList.toggle('is-digital', !!(v && v.digital));
    var centerSz = function () {
      var szImgD = document.getElementById('np-e2-sz-img');
      if (szImgD) centerPatchInBox(szImgD, szImgD.currentSrc || szImgD.src);
    };
    setTimeout(centerSz, 120);
    setTimeout(centerSz, 700);
    var szSrc = (v && (v.alpha || v.dataUrl || v.hosted)) || cleanUrl(artworkUrl()) || '';
    if (pdpPricingOn() && !st.proofApproved && !st.versions.length) {
      var pvM = document.querySelector('.np-e2-maskprev img');
      if (pvM && pvM.src) szSrc = pvM.src; /* the live digital preview */
    }
    if (img) {
      if (!img.__npDimWired) { img.__npDimWired = true; img.addEventListener('load', function () { positionDims(); }); }
      img.src = szSrc;
    }
    var szStage = $('#np-e2-sz-stage');
    if (szStage) szStage.classList.toggle('is-alpha', isAlphaSrc(szSrc));
    var cap = $('#np-e2-sz-cap');
    if (cap) cap.textContent = (v && v.fallbackUpload)
      ? 'Your uploaded design · specialist proof to follow'
      : (v && v.digital ? ('Approved proof · digital-proof.png' + (st.proofMode === 'stitch' ? ' · real stitchout to follow' : '')) : 'Approved proof · ai-proof-v' + (idx + 1) + '.png');
    var szRev = document.getElementById('np-e2-sz-review');
    if (szRev) szRev.hidden = !!(v && v.digital); /* nothing to regenerate on digital/stitchout */
    if (pdpPricingOn() && !st.proofApproved && !st.versions.length) {
      if (cap) cap.textContent = 'Your digital preview \u2014 updates live as you build';
      if (szRev) szRev.hidden = true;
    }
    renderPricing();
  }

  function approveProof() {
    if (st.selected === null || st.selected === undefined) return;
    var picked = st.versions[st.selected];
    if (picked && st.fdChoice === 'ps' && !onTargetProduct({ altKind: 'ps' })) {
      /* Print & Stitch is its OWN product — approving hands off to it */
      picked.altKind = 'ps';
      switchToFullColor(picked);
      return;
    }
    if (picked && picked.fullColor && !onTargetProduct(picked)) {
      if (st.fcForced && !st.fcConfirmed) { openFcConfirm(picked); return; }
      switchToFullColor(picked);
      return;
    }
    var notes = formProp('_Revision Notes') || '';
    var v = st.versions[st.selected];
    st.proofApproved = true; try { prewarmAlphaForCart(); } catch (ePW2) {}
    /* record the approval in patch-sensei (same as the proof-preview page) */
    if (sensei.sessionId) {
      var approvedNote = (notes ? notes + ' ' : '') + '(approved AI render v' + (st.selected + 1) + ')';
      var keepRender = sensei.renderLineId;
      sensei.renderLineId = sensei.lineItemId; /* decision targets the real cart line */
      try { senseiDecide('approved', approvedNote); } catch (e) {}
      sensei.renderLineId = keepRender;
    }
    /* cart contract: proof + original both on the line; proof is the thumbnail.
       The line is ALREADY in the cart (added at generate time), so write the
       proof properties + current qty onto the LINE via /cart/change.js —
       form-level setProp only affects future adds. */
    /* _AI Proof = the production mockup; _cartImg = the TRANSPARENT imgix
       copy so the cart shows just the patch on the checkerboard */
    if (v.hosted) { setProp('_AI Proof', v.frozenProof || v.hosted); setProp('_cartImg', digitalCartUrl(v.alpha || v.hosted)); }
    if (v.hosted && !v.frozenProof) {
      freezeProofCopy(v.hosted, (TYPE_KEY || 'patch') + '--v' + (st.selected + 1), function (uF) {
        if (!uF) return;
        v.frozenProof = uF;
        setProp('_AI Proof', uF);
        if (sensei.added) lineSync({ '_AI Proof': uF });
      });
    }
    setProp('_Proof Version', 'v' + (st.selected + 1));
    if (v.fallbackUpload) setProp('_AI Proof Status', 'AI GENERATION FAILED - specialist proof required');
    if (notes) setProp('_Revision Notes', notes);
    /* arm the background pre-add + sheet stamper the moment approval lands —
       the sheets must be ON the line well before any Add to Cart click */
    try { coMark('approved'); } catch (eAb) {}
    try { commitSizeQty(); } catch (eShA) {}
    if (sensei.added) cartJson().then(function (cart) {
      /* legacy path: only when a line already exists (e.g. Add another) —
         normally the props above ride the final Add to Cart */
      var line = ourCartLine(cart);
      if (!line) return;
      var props = {};
      Object.keys(line.properties || {}).forEach(function (k) { if (k.indexOf('_Border Style') !== 0) props[k] = line.properties[k]; });
      /* current option values win (customer may have edited selections since the add) */
      if (stepEnabled('shape')) props['_Shape'] = st.shape || '';
      if (stepEnabled('border') && st.shape && st.border) props['_Border Style'] = normalizeBorder(st.border.label);
      if (stepEnabled('bg')) props[PTYPE.bgProp || PTYPE.bgLabel || '_Background Color'] = st.bg ? st.bg.label : '';
      if (stepEnabled('thread')) props[PTYPE.threadProp || PTYPE.threadLabel || '_Border Color'] = st.thread ? st.thread.label : '';
      if (stepEnabled('text')) props[PTYPE.textProp || '_Text Color'] = st.text ? st.text.label : '';
      props['_Select Your Backing'] = st.backing ? st.backing.label : '';
      if (stepEnabled('texture')) props['_Background Texture'] = st.texture ? st.texture.label : '';
      props['_Width (in)'] = st.w.toFixed(2);
      props['_Height (in)'] = st.h.toFixed(2);
      if (v.hosted) { if (v.digital) { if (v.frozenProof) props['_Mockup Catalog'] = v.frozenProof; } else props['_AI Proof'] = v.frozenProof || v.hosted; props['_cartImg'] = digitalCartUrl(v.alpha || v.hosted); }
      if (v.fallbackUpload) props['_AI Proof Status'] = 'AI GENERATION FAILED - specialist proof required';
      props['_Proof Version'] = 'v' + (st.selected + 1);
      if (notes) props['_Revision Notes'] = notes;
      ['Design Notes', '_Revision Notes'].forEach(function (k) { var fv = formProp(k); if (fv) props[k] = fv; });
      delete props['AI Edit']; /* the edited artwork is the record, not the prompt */
      stripBlockedProps(props); /* order admin never receives the blocked set */
      props = orderPropsObj(props);
      sensei.__lineSnap = { line: (cart.items || []).indexOf(line) + 1, props: props };
      try { fireSheetStamp(); } catch (eFa) {}
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: line.key, quantity: st.qty, properties: props })
      }).then(function (r) { return r.json(); }).then(function (c2) { ourCartLine(c2); }); /* property change re-keys the line */
    }).catch(function (e) { console.warn('[np-emb2] cart line update failed', e); });
    /* approved UI */
    $('#np-e2-approved').hidden = false;
    $('#np-e2-cart-thumb').src = v.alpha || v.dataUrl || artworkUrl();
    var thumbBox = document.querySelector('.np-e2-cartrow__thumb');
    if (thumbBox) thumbBox.classList.toggle('is-alpha', !!(v.alpha || isAlphaSrc(v.dataUrl || '')));
    $('#np-e2-cart-line').textContent = [
      v.shape,
      st.border ? st.border.label + ' border' : null,
      v.bg ? v.bg.label + (isLeather() ? '' : ' background') : null,
      v.thread ? v.thread.label + ' thread' : null,
      v.backing ? v.backing.label : null
    ].filter(Boolean).join(' \u00b7 ');
    var pfl2 = $('#np-e2-prooffile'); if (pfl2) pfl2.textContent = v.fallbackUpload ? 'specialist proof to follow' : ('ai-proof-v' + (st.selected + 1) + '.png');
    renderOptions();
    renderApprovedCanvas(); /* the page behind: proof + compare slider in the preview */
    /* the modal stays open: approval leads straight into size & pricing */
    renderSizing();
  }

  /* ---- checkout & add-another ---- */
  function syncCartLine() {
    try { setProp('_Proof Approval', proofApprovalLabel()); } catch (ePA2) {}
    /* v2 flow: sizing happens AFTER the line is in the cart (it was added at
       generate time with the seeded size and default qty). The final size can
       cross a variant/price boundary — /cart/change.js can't swap variants,
       so on a variant change the line is re-added with its properties. */
    commitOptions(); commitSizeQty();
    coMark('sync-read');
    return cartJson().then(function (cart) {
      coMark('sync-got');
      var line = ourCartLine(cart);
      if (!line) return cart;
      var v = nearestVariant();
      var props = {};
      Object.keys(line.properties || {}).forEach(function (k) { props[k] = line.properties[k]; });
      props['_Width (in)'] = st.w.toFixed(2);
      props['_Height (in)'] = st.h.toFixed(2);
      props['_Proof Approval'] = proofApprovalLabel();
      /* current option values win (B43) — same contract as the approval
         branch: a post-approval edit must reach the LINE */
      var optDrift = false;
      try {
        var optMap = {};
        if (stepEnabled('shape')) optMap['_Shape'] = st.shape || '';
        if (stepEnabled('border') && st.shape && st.border) optMap['_Border Style'] = normalizeBorder(st.border.label);
        if (stepEnabled('bg')) optMap[PTYPE.bgProp || PTYPE.bgLabel || '_Background Color'] = st.bg ? st.bg.label : '';
        if (stepEnabled('thread')) optMap[PTYPE.threadProp || PTYPE.threadLabel || '_Border Color'] = st.thread ? st.thread.label : '';
        if (stepEnabled('text')) optMap[PTYPE.textProp || '_Text Color'] = st.text ? st.text.label : '';
        optMap['_Select Your Backing'] = st.backing ? st.backing.label : '';
        if (stepEnabled('texture')) optMap['_Background Texture'] = st.texture ? st.texture.label : '';
        Object.keys(optMap).forEach(function (kO) {
          if (optMap[kO] && String(props[kO] || '') !== String(optMap[kO])) { props[kO] = optMap[kO]; optDrift = true; }
        });
      } catch (eOD) {}
      if (digitalNoRender()) delete props['_AI Proof'];
      var avs = (st.proofApproved && st.selected !== null && st.selected !== undefined) ? st.versions[st.selected] : null;
      if (avs && avs.alpha) props['_cartImg'] = digitalCartUrl(avs.alpha); /* flattened imgix copy always wins */
      props = orderPropsObj(props);
      if (v && v.id !== line.variant_id) {
        /* ADD the replacement line FIRST, only then zero the old one — a
           failed re-add must never delete the customer's patch */
        var fd = new FormData();
        fd.set('id', String(v.id));
        fd.set('quantity', String(st.qty));
        Object.keys(props).forEach(function (k) { fd.set('properties[' + k + ']', props[k] == null ? '' : props[k]); });
        rememberMode('ai'); /* mode memory follows the last ADD TO CART */
        coMark('sync-readd');
        return cleanFetch()('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin' })
          .then(function (r) {
            if (!r.ok) throw new Error('variant re-add failed ' + r.status);
            return cleanFetch()('/cart/change.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
              body: JSON.stringify({ id: line.key, quantity: 0 })
            });
          })
          .then(function () { return cartJson(); }).then(function (c2) {
            var mine = (c2.items || []).filter(function (it) {
              return it.variant_id === v.id && (it.properties || {})['_Width (in)'] === st.w.toFixed(2);
            })[0];
            if (mine) sensei.lineItemId = mine.key || String(mine.id);
            try { sensei.__lineVariant = String(v.id); } catch (eLV2) {}
            try { sensei.__lineState = curLineState(); } catch (eLS2) {}
            return c2;
          });
      }
      if (optDrift || line.quantity !== st.qty ||
          (line.properties || {})['_Width (in)'] !== props['_Width (in)'] ||
          (line.properties || {})['_Height (in)'] !== props['_Height (in)']) {
        coMark('sync-change');
        sensei.__lineSnap = { line: (cart.items || []).indexOf(line) + 1, props: props };
        return cleanFetch()('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
          body: JSON.stringify({ id: line.key, quantity: st.qty, properties: props })
        }).then(function (r) { return r.json(); }).then(function (c2) { ourCartLine(c2); try { sensei.__lineState = curLineState(); } catch (eLS3) {} return c2; });
      }
      try { sensei.__lineState = curLineState(); } catch (eLS4) {}
      return cart;
    }).catch(function (e) { console.warn('[np-emb2] cart sync failed', e); });
  }
  /* B79 (2026-08-25) — PRE-WARM the transparent copy. Hosting it is the single
     most expensive thing the add click used to do, so start it the moment the
     customer approves a proof: by the time they finish size and quantity it is
     cached on the version and ensureAlphaForCart resolves on its v.alpha guard.
     Fire-and-forget by design — never blocks, never surfaces an error. */
  /* B84 (2026-08-25) — THE TRANSPARENT CART IMAGE IS OFF.
     hostMockup() does a LOCAL pixel cut (flood fill / shape mask / geometry
     pass) over a full-size canvas, entirely synchronous on the main thread.
     Measured on Justin's add: 17,868ms with plain timers ticking 0 times out of
     an expected 179, worker callbacks 1, zero network traffic, tab visible the
     whole time — the signature of a jammed thread, not a slow request. The POST
     was never slow (627-932ms in every isolated test); its .then() simply could
     not run. Moving the cut off the click just moved the jam into the add.
     Justin, verbatim: "the cart image having background is NOT IMPORTANT if
     that is whats stalling this." So it is switched off. The cart thumbnail
     keeps its studio backdrop; the ORDER is unaffected (the line still carries
     _AI Proof, _Upload and _Original Image). Flip this to true to restore it —
     but move the cut into a Worker or an OffscreenCanvas first, or it will
     jam the thread again. */
  function prewarmAlphaForCart() {
    if (!NP_ALPHA_CUT) return;
    try {
      var v = (st.selected !== null && st.selected !== undefined) ? st.versions[st.selected] : null;
      if (!v || v.alpha || v.fallbackUpload || !v.hosted || isAlphaSrc(v.hosted)) return;
      if (v.__alphaWarming) return;
      v.__alphaWarming = true;
      hostMockup(v.dataUrl || v.hosted, function (u) {
        v.__alphaWarming = false;
        if (u) { v.alpha = u; try { setProp('_cartImg', digitalCartUrl(u)); } catch (eSP) {} }
      });
    } catch (ePW) {}
  }
  function ensureAlphaForCart() {
    /* the cart image must be the TRANSPARENT IMGIX copy, never the raw S3
       mockup — wait (bounded) for the re-host before the line is created */
    return new Promise(function (resolve) {
      if (!NP_ALPHA_CUT) { resolve(); return; } /* B84: never block the add on a pixel cut */
      var v = (st.proofApproved && st.selected !== null && st.selected !== undefined) ? st.versions[st.selected] : null;
      if (!v || v.alpha || v.fallbackUpload || !v.hosted || isAlphaSrc(v.hosted)) { resolve(); return; }
      /* B79 (2026-08-25): this used to hold the ADD CLICK for up to 12 SECONDS
         waiting on an image upload. Measured on Justin's session: 12,356ms of a
         17.8s add, versus 71ms for all the rest of our code. The transparent
         cart image is COSMETIC — the order line still carries _AI Proof,
         _Upload and _Original Image either way — so it is never worth making a
         customer wait. Cap the click at 900ms; if the host has not landed by
         then, let it finish in the BACKGROUND and stamp _cartImg if it arrives.
         prewarmAlphaForCart() (fired at proof approval) means it is normally
         already done and this resolves instantly on the v.alpha guard above. */
      /* B80 (2026-08-25) — Justin, verbatim: "the cart image having background is
         NOT IMPORTANT if that is whats stalling this". So the click NEVER waits
         on it. Kick the host off in the background and resolve immediately: zero
         click cost, and prewarmAlphaForCart() (fired at approval) means the
         transparent copy is usually already cached on the version anyway, in
         which case the v.alpha guard above returns before we ever get here. */
      hostMockup(v.dataUrl || v.hosted, function (u) {
        if (u) { v.alpha = u; try { setProp('_cartImg', digitalCartUrl(u)); } catch (eSP3) {} }
      });
      resolve();
    });
  }
  /* ═══ NAMES ROSTER (custom-names) — the patches ARE the names, so the
     roster drives the quantity, and Add to Cart stays locked until the
     product's piece minimum is genuinely typed in. Writes the EXISTING
     line-item property the live product already collects. ═══ */
  function namesMin() { return PTYPE.namesMin || QTY_MIN; }
  function namesList() {
    var ta = document.getElementById('np-e2-names-ta');
    if (!ta) return [];
    /* commas OR newlines — customers paste both */
    return ta.value.split(/[\n,]+/).map(function (x) { return x.trim(); }).filter(function (x) { return !!x; });
  }
  function renderNames() {
    var card = document.getElementById('np-e2-names');
    if (!card) return;
    var list = namesList(), min = namesMin(), ok = list.length >= min;
    var cnt = document.getElementById('np-e2-names-count');
    if (cnt) {
      /* short: red with the minimum spelled out; met: green, suffix dropped.
         Dip back under and the suffix returns with the red. */
      cnt.textContent = list.length + ' of ' + min + ' names' + (ok ? '' : ' (' + min + 'pc minimum)');
      cnt.classList.toggle('is-ok', ok);
    }
    var entN = document.getElementById('np-e2-nr-entries');
    if (entN) entN.textContent = list.length + (list.length === 1 ? ' entry' : ' entries');
    /* the countdown carries the minimum message now — no separate banner */
    var btnN = document.getElementById('np-e2-names-atc');
    if (btnN) btnN.disabled = !ok;
    /* one patch per name */
    st.qty = Math.max(min, list.length);
    setProp(PTYPE.namesProp || 'List of Names (Separate by Comma)', list.join(', '));
    var pN = pricing();
    var totN = document.getElementById('np-e2-names-total');
    if (totN) totN.textContent = money(pN.unit * st.qty);
    var subN = document.getElementById('np-e2-names-sub');
    if (subN) subN.textContent = st.qty + ' pcs \u00b7 ' + money(pN.unit) + ' ea';
    commitSizeQty();
  }
  function revealNames() {
    var card = document.getElementById('np-e2-names');
    if (!card) return;
    card.hidden = false;
    renderNames();
    try { nrRenderRows(); } catch (eNR) {} /* the grid tab opens ready to type */
    setTimeout(function () {
      var yN = card.getBoundingClientRect().top + window.pageYOffset - npScrollPad();
      window.scrollTo({ top: Math.max(0, yN), behavior: 'smooth' });
    }, 60);
  }

  var coBusy = false;
  function doCheckout() {
    /* "Add to Cart": the ONE cart mutation in the flow — the line lands with
       its final variant, qty, and every property (proof, original, options,
       notes), then the customer reviews it on /cart. Locked + instant button
       feedback: the alpha wait made double-clicks double-add. */
    if (coBusy) return;
    coBusy = true;
    var btn = document.getElementById(PTYPE.names ? 'np-e2-names-atc' : 'np-e2-checkout');
    var oldLabel = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding to cart…'; }
    showPageLoader('Finalizing Order & Adding to Cart\u2026');
    /* stage beacons (911 debug 2026-08-24): window.__npCoStage names the last
       stage reached — read it when an add hangs */
    var coStage = function (n) { try { var tMs = Math.round(performance.now()); window.__npCoStage = n + ' @' + Math.round(tMs / 1000); if (n.indexOf('start') === 0) localStorage.setItem('np_co_log', ''); localStorage.setItem('np_co_log', (localStorage.getItem('np_co_log') || '') + n + '@' + tMs + 'ms | '); console.log('[np-e2] checkout stage', n, tMs + 'ms'); } catch (eCs) {} };
    /* nothing may compose during the click — a pending background sheet
       stamp would race the add and jam the thread */
    commitSizeQty.__sheetGen = (commitSizeQty.__sheetGen || 0) + 1; /* cancels any pending background fire */
    commitSizeQty.__sheetPend = false; commitSizeQty.__armTok = null;
    /* C02 (2026-08-25) — SETTLE THE SPEC BEFORE COMPOSING.
       The sheet is fingerprinted (specDkToken) against the form's spec fields,
       and the cart-line gate re-computes that fingerprint at write time. Those
       fields are finalised inside ensureInCartNow() — which runs AFTER this —
       so the sheet was composed from pre-final values and was CORRECTLY judged
       stale every time. Measured: sheetgate[pre:y|dkMatch:n|ai:y|up:y] with
       dkdrift[Width (in), Upload, Original Image, cartImg, AI Model]. Both
       sheets composed fine in 566-850ms and were thrown away, which is why
       Justin saw specs on NEITHER property.
       Write the same values ensureInCartNow will write, THEN compose, so both
       sides fingerprint identically. Width matters most: composing early meant
       the sheet literally carried a stale size. */
    try { commitOptions(); commitSizeQty(); } catch (eCS2) {}
    try { setProp('_AI Model', genActive() ? 'Nano 2' : 'Open AI'); } catch (eAM3) {}
    try { setProp('_Proof Approval', proofApprovalLabel()); } catch (ePA2) {}
    try {
      var artD = artOfRecord();
      var rawD = (artD || '').split('?')[0].split('&')[0];
      if (rawD) setProp('_Original Image', rawD); /* specDkToken keys off this input */
    } catch (eOI2) {}
    /* B97 (2026-08-25) — COMPOSE THE SHEETS NOW, don't just cancel the timer.
       The background stamper waits 1200ms before composing and this click
       cancels it. That was invisible while adds took 15s (the sheets finished
       inside that window anyway), but the add now completes in 433ms, so the
       sheets were never ready and the line shipped the RAW render — measured
       `sheets:not-ready`, _AI Proof 1536x1024 instead of a composed sheet.
       Kick the compose immediately, then wait a bounded moment for it below. */
    try {
      preComposeSheets();
      /* C04 (2026-08-25) — TRUST THE SHEET WE JUST BUILT.
         The dk fingerprint exists to stop a STALE pre-composed sheet being
         attached. It does not apply here: the spec is settled immediately
         above, then the sheet is composed from it, then we wait for it. Four
         rounds of chasing dkMatch:n were spent guarding against staleness that
         cannot exist on this path. Record the token this click composed with;
         the cart-line gate accepts that one as well as an exact match.
         Justin, verbatim: "when add to cart is clicked simply write these items
         onto the proof and the _upload for it to get into the shopify admin." */
      sensei.__clickDk = specDkToken(specLines(specFormProps()));
    } catch (ePCC) {}
    coStage('start:C18'); /* build tag — bump on every np-emb2 push */
    /* TIME-BOXED CHECKOUT + redirect (2026-08-24 final): add the line, give
       the build sheets ONE short bounded window, then land on /cart — target
       feel ~3s. specForAI() is GONE from the chain: nothing consumed its
       result (applySpecToLine composes its own sheets from the LINE), so it
       was a guaranteed dead wait in front of every single add. */
    var timebox = function (p, ms) {
      /* worker clock: a hidden tab froze the plain-setTimeout cap for 35s.
         B79 (2026-08-25): race BOTH clocks. Racing npTick alone meant a stalled
         worker left the cap unenforced — measured on Justin's 12,356ms add,
         where a 1200ms box lost to ensureAlphaForCart's own 12s timeout. */
      return Promise.race([
        Promise.resolve(p).catch(function () {}),
        new Promise(function (res) { npTick(res, ms); setTimeout(res, ms + 150); })
      ]);
    };
    /* ═══ B70 (2026-08-25, Justin): ADD TO CART IS A SIMPLE FINAL BUTTON ═══
       "add to cart should be a simple final button not a waiting period for
       our customers" — hard target 3 seconds.
       The click now does exactly three things: make sure the cart image is the
       transparent copy (usually already done, ~20ms measured), POST the line
       to /cart/add.js (0.48s and 0.89s measured on live), and navigate.
       EVERYTHING to do with build sheets is gone from this path — the compose,
       the upload, the freshness-token comparison, the poll loop, the
       applySpecToLine re-stamp and the __specBusy grace. Those were the entire
       14.5s / 16.1s measured on live and the cause of the "Finalizing Order &
       Adding to Cart" hang. Sheet generation itself is switched off at
       NP_SPEC_SHEETS. Order lines still carry _AI Proof (the approved render),
       _Upload (the composed preview) and _Original Image — only the drawn
       spec panel is gone. */
    /* B97: bounded wait for the composed sheets. specDkToken must match the
       FINAL size/qty, which is why these cannot simply be composed at approval
       — the customer picks size AFTER approving. Cap it so a stuck compose can
       never hold a customer: we ship the raw proof rather than hang, and the
       post-add lineSync still upgrades the line if the sheet lands late. */
    var waitSheets = function (ms) {
      return new Promise(function (res) {
        var t0 = Date.now(), want = null;
        try { want = specDkToken(specLines(specFormProps())); } catch (eW) { want = null; }
        if (!want || !NP_SPEC_SHEETS) { res(null); return; }
        var chk = function () {
          var pre = sensei.__preSheets;
          /* B99 (2026-08-25) — WAIT FOR BOTH SHEETS, not either. This read
             `(pre.ai || pre.up)`, so the first sheet to finish released the
             wait and the second landed after the add had already read the
             properties. Measured on Justin's run: pre:up-ok@78723,
             sheets-ready@78730, the add read at 78763, pre:ai-ok@78790 — the
             AI sheet missed by 60ms, which is exactly why _Upload carried its
             specs and _AI Proof did not. Wait for each sheet that was actually
             REQUESTED (aiBase/upBase say which), so neither is left behind.
             Cost of the fix on that run would have been 67ms. */
          var okAi = !pre || !pre.aiBase || !!pre.ai;
          var okUp = !pre || !pre.upBase || !!pre.up;
          if (pre && pre.dk === want && okAi && okUp && (pre.ai || pre.up)) {
            coMark('sheets-ready:' + (Date.now() - t0) + 'ms:ai' + (pre.ai ? 'y' : 'n') + 'up' + (pre.up ? 'y' : 'n'));
            res(null); return;
          }
          if (Date.now() - t0 > ms) { coMark('sheets-timeout:' + (Date.now() - t0) + 'ms'); res(null); return; }
          setTimeout(chk, 100);
        };
        chk();
      });
    };
    timebox(ensureAlphaForCart(), 1200).then(function () {
      coStage('alpha-done');
      return waitSheets(2500);
    }).then(function () {
      /* B74 (2026-08-25): a real click measured 15,928ms on /cart/add.js while
         a bare fetch to the same endpoint from the same browser took 645ms.
         So the time is NOT Shopify serving — it is spent BEFORE the request is
         sent. Record the browser's own resource timing for the add so the next
         slow click says which phase ate it (queueing vs DNS/TLS vs server). */
      try {
        window.__npAddTiming = function () {
          try {
            /* B76: cleanFetch issues the add from a hidden IFRAME, and
               PerformanceResourceTiming is per-realm — so the entry lives in
               the iframe's timeline, not this one. Check both. */
            var perfs = [performance];
            try { if (cleanFetch.__ifr && cleanFetch.__ifr.contentWindow && cleanFetch.__ifr.contentWindow.performance) perfs.push(cleanFetch.__ifr.contentWindow.performance); } catch (eR) {}
            var es = [];
            perfs.forEach(function (pf) {
              try { es = es.concat(pf.getEntriesByType('resource').filter(function (e) { return /\/cart\/add\.js/.test(e.name); })); } catch (eE) {}
            });
            var e = es[es.length - 1];
            if (!e) return;
            coMark('addTiming:queue' + Math.round(e.requestStart - e.fetchStart) +
                   ':dns' + Math.round(e.domainLookupEnd - e.domainLookupStart) +
                   ':tcp' + Math.round(e.connectEnd - e.connectStart) +
                   ':ttfb' + Math.round(e.responseStart - e.requestStart) +
                   ':dl' + Math.round(e.responseEnd - e.responseStart) +
                   ':total' + Math.round(e.duration));
          } catch (eT) {}
        };
      } catch (eT0) {}
    }).then(function () {
      if (false) {
        /* THE normal path (line pre-added at generation/skip): one read-free
           fire with everything final; sheets ride it when ready */
        coStage('incart-done');
        try { if (window.__npAddTiming) window.__npAddTiming(); } catch (eTm) {}
        if (finalSyncFire()) { coMark('go+sheets'); return 'fired'; }
        /* sheets stale or still uploading — RE-KICK the composer for the
           final specs (1.3s measured per sheet) and fire as soon as they
           land; bounded either way (B48) */
        try { preComposeSheets(); } catch (ePK) {}
        return new Promise(function (resW) {
          var t0W = Date.now();
          (function wsh() {
            var preW = sensei.__preSheets, dkW = null;
            try { dkW = specDkToken(specLines(specFormProps())); } catch (eW) {}
            var catOk = true;
            try {
              if (digitalNoRender()) {
                var mp = mergedOrderProps();
                catOk = !!mp['_Mockup Catalog'];
              }
            } catch (eC) {}
            var allW = preW && (preW.aiBase ? preW.ai : true) && (preW.upBase ? preW.up : true) && (preW.ai || preW.up);
            if (preW && dkW && preW.dk === dkW && allW && catOk) { finalSyncFire(); resW('fired'); return; }
            /* B64: was 10,000ms — a hard floor on every click that reached
               here, measured at 14.5s and 16.1s on live because the jobs it
               waited for could never settle (see mk's HARD CAP). With those
               bounded, 4,000ms comfortably covers a real compose (~2.3-2.7s
               measured end to end) while capping the customer's worst case at
               ~5.5s including the 1,500ms alpha timebox above. A sheet that
               misses this window is simply not attached — the line NEVER
               carries a mismatched one (PATCH-2106492: production builds from
               the sheet). */
            if (Date.now() - t0W > 4000) { coMark('sheets-timeout'); finalSyncFire(); resW('fired'); return; }
            npTick(wsh, 300);
          })();
        });
      }
      /* no snapshot (fresh session, or the background read still in flight):
         the classic bounded path — the fresh ADD carries sheets atomically */
      /* B68 (2026-08-25): ensureInCart() had NO bound here. That was survivable
         while a background pre-add meant this branch almost never ran — but
         with the pre-add removed (B66) EVERY click comes through here, so a
         stalled /cart/add.js pinned the customer on "Finalizing Order & Adding
         to Cart…" forever. Bound it, and if the line genuinely did not land,
         say so and give the button back instead of spinning. */
      return timebox(ensureInCart(), 20000).then(function (r3) {
        coStage('incart-done');
        if (!sensei.added) {
          coMark('incart-TIMEOUT');
          throw new Error('the cart did not respond in time — please try again');
        }
        /* B71 (2026-08-25): the follow-up syncCartLine is REDUNDANT on the
           fresh-add path and it is expensive — measured 4,782ms on live for a
           /cart/change.js that changed nothing. ensureInCartNow() already runs
           commitOptions() + commitSizeQty() and builds the add FormData from
           the final form, so the line lands complete. The old skip-guard was
           gated on __sheetsFiredDk, which is never set now that build sheets
           are off, so it never fired and every click paid the extra call. */
        coMark('sync-skip:fresh-add');
        return null;
      });
    }).then(function () {
      /* B70: the entire sheet-stamping stage is gone from the click. */
      return null;
    }).then(function () {
      /* a variant swap must fully land (add + zero) before we leave, or the
         old, wrongly-priced line stays in the cart (B62) */
      if (sensei.__swapBusy) { coMark('await-swap'); return timebox(sensei.__swapBusy, 6000); }
      return null;
    }).then(function () {
      coStage('done');
      window.location.href = '/cart';
    })
      .catch(function (err) {
        coStage('CATCH: ' + String(err && err.message || err).slice(0, 120));
        coBusy = false;
        hidePageLoader();
        if (btn) { btn.disabled = false; btn.textContent = oldLabel; }
        alert('Could not add to cart: ' + (err && err.message || 'try again'));
      });
  }
  function npToast(msg) {
    var t = document.createElement('div');
    t.className = 'np-e2-toast';
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.classList.add('is-in'); }, 20);
    setTimeout(function () { t.classList.remove('is-in'); setTimeout(function () { t.remove(); }, 400); }, 3600);
  }
  function addAnother() {
    /* file picker FIRST (must stay inside the click gesture). Picking a file
       banks the CURRENT patch in the cart (toast confirms it), hosts the new
       image, and reloads THIS product + ?view= with the new design. */
    if (coBusy) return; /* shares the add lock with Add to Cart */
    var fi = document.createElement('input');
    fi.type = 'file';
    fi.accept = 'image/*';
    fi.style.display = 'none';
    document.body.appendChild(fi);
    fi.addEventListener('change', function () {
      var f = fi.files && fi.files[0];
      try { document.body.removeChild(fi); } catch (eRm) {}
      if (!f || coBusy) return;
      coBusy = true;
      npToast('\u2713 This patch was added to your cart');
      showPageLoader('Adding this patch to your cart\u2026');
      var qs = window.location.search
        .replace(/[?&]file=[^&]*/g, '')
        .replace(/[?&]np_added=[^&]*/g, '')
        .replace(/^&/, '?');
      if (qs && qs[0] !== '?') qs = '?' + qs;
      var go = function (fileUrl) {
        var q2 = qs || '';
        if (fileUrl) q2 += (q2 ? '&' : '?') + 'file=' + encodeURIComponent(fileUrl); /* file LAST */
        window.location.href = window.location.pathname + q2;
      };
      /* host the NEXT design while the current patch banks */
      var upP = new Promise(function (res) {
        try {
          if (typeof window.getPresignedUploadUrl !== 'function') { res(''); return; }
          /* C16 (2026-08-25, Justin: "add another patch ... reloads the product
             page but it does not start the new upload") — NAME THE FILE WITH
             THE UPLOAD LINEAGE PATTERN. theme.liquid's ARRIVAL LINEAGE GUARD
             (PATCH-2106464/68/82) deletes ?file= unless the URL looks like a
             real customer upload (image_<ts>_<rand>) or a proof (ai-proof-*).
             This flow named its object 'next_<ts>_<filename>', which matches
             neither, so the guard stripped ?file= from the reload we had just
             built — the current patch banked, the page reloaded, and the next
             design was gone. It IS a real customer upload, so name it like one
             (same convention as custom-uploader.js) instead of widening the
             guard. Covers AI and Classic: both use this one addAnother(). */
          var fnRaw = String(f.name || 'image.png');
          var fnExt = fnRaw.indexOf('.') > -1
            ? ((fnRaw.split('.').pop() || 'png').replace(/[^a-zA-Z0-9]/g, '') || 'png')
            : (((f.type || '').split('/')[1] || 'png').replace(/[^a-zA-Z0-9]/g, '') || 'png');
          var fnBase = (fnRaw.split('.').slice(0, -1).join('.') || 'image')
            .replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-') || 'image';
          var nm = fnBase + '____image_' + Date.now() + '_' + Math.floor(Math.random() * 1000) + '.' + fnExt;
          window.getPresignedUploadUrl(nm, f.type || 'image/png').then(function (p) {
            if (!p || !p.url) { res(''); return; }
            return npPut(p.url, f, { 'Content-Type': f.type || 'image/png' })
              .then(function () { res(toImgixHost(p.sourceUrl || '')); });
          }).catch(function () { res(''); });
        } catch (eU) { res(''); }
      });
      var bank = ensureAlphaForCart().then(ensureInCart).then(syncCartLine).catch(function () {});
      Promise.all([bank, upP]).then(function (r) {
        showPageLoader('Added to cart. Loading your next design\u2026');
        go(r[1] || '');
      }, function () { go(''); });
    });
    fi.click();
  }

  /* ---- activation: hide legacy post-upload UI, show builder ---- */
  function hideLegacy() {
    /* the builder REPLACES the legacy post-upload UI entirely: hide every
       rendered child of the main product section's container (the form and
       its hidden inputs stay in the DOM and still submit). */
    var ua = document.getElementById('uploadArea');
    var mainSec = ua ? ua.closest('.shopify-section') : null;
    if (!mainSec) {
      var ppL = document.querySelector('product-page, .product-actions, .product-text');
      if (ppL && ppL.closest) mainSec = ppL.closest('.shopify-section');
    }
    if (mainSec) {
      $$('.container > *, .container--large > *', mainSec).forEach(function (el) {
        if (el.closest('#np-e2')) return;
        el.classList.add('np-e2-legacy-hidden');
      });
    }
    /* post-upload the builder IS the page: hide every other template section
       below it (this also kills the huge empty scroll region that read as a
       "blank screen" when legacy code scrolled to a clipped element) */
    var builderSec = root.closest('.shopify-section');
    if (builderSec && builderSec.parentElement) {
      var seen = false;
      $$(':scope > .shopify-section', builderSec.parentElement).forEach(function (sec) {
        if (sec === builderSec) { seen = true; return; }
        if (seen || sec === mainSec) return;
        sec.classList.add('np-e2-legacy-hidden');
      });
      var after = builderSec.nextElementSibling;
      while (after) { after.classList.add('np-e2-legacy-hidden'); after = after.nextElementSibling; }
    }
    [
      '.product-gallery',                       /* image carousel */
      '.product__media-gallery',
      '.bcpo',                                  /* app option widgets */
      '.selector-wrapper.bcpo-buttons',
      '.customTabel',                           /* legacy size/qty table */
      '.customTabelPopup__openBtn',
      '.buymoresave', '.customTabelPlace',      /* legacy buy-more panel (kept in DOM for discount props) */
      'file-preview',                           /* legacy preview box */
      '.np-upload-toolbar', '.design-notes',
      '.fileupload_bg_options',
      '.disabled-cta.second-upload-cta',        /* legacy second box (we proxy to it) */
      '.customTabelPopup__overlay-2',           /* post-upload size popup */
      '.customTabelPopup__overlay',
      '.widthHeight', '.customQtyFile',         /* legacy steppers (hidden, still driven) */
      '.cta-wrapper-box'                        /* legacy CTA (clicked programmatically) */
    ].forEach(function (sel) {
      $$(sel).forEach(function (el) { el.classList.add('np-e2-legacy-hidden'); });
    });
    var style = document.getElementById('np-e2-hidestyle');
    if (!style) {
      style = document.createElement('style');
      style.id = 'np-e2-hidestyle';
      style.textContent = '.np-e2-legacy-hidden { position: absolute !important; width: 1px !important; height: 1px !important; overflow: hidden !important; clip: rect(0 0 0 0) !important; margin: 0 !important; padding: 0 !important; opacity: 0 !important; pointer-events: none !important; }';
      document.head.appendChild(style);
    }
  }

  function waitForArt(cb, maxMs) {
    var start = Date.now();
    (function attempt() {
      var cands = artworkCandidates().map(applyToggleParams);
      var i = 0;
      (function tryNext() {
        if (i >= cands.length) {
          if (Date.now() - start > (maxMs || 60000)) { cb(null); return; }
          setTimeout(attempt, 1200);
          return;
        }
        var url = cands[i++];
        var probe = new Image();
        probe.onload = function () { cb(url); };
        probe.onerror = tryNext;
        probe.src = url;
      })();
    })();
  }

  var lastDetected = '';
  function readDetectedSize() {
    /* the upload pipeline renders "Detected size: W" x H"" into [d-size]
       — the TRUE image inches at 300dpi, and it changes when Remove
       Background / Crop+Trim re-render the artwork */
    var el = document.querySelector('.widthHeight__option-detectedSize [d-size], [d-size]');
    var txt = el ? el.textContent : '';
    var m2 = txt.match(/([\d.]+)"?\s*x\s*([\d.]+)/i);
    if (!m2) return null;
    var w = parseFloat(m2[1]), h = parseFloat(m2[2]);
    if (!(w > 0) || !(h > 0)) return null;
    return { w: w, h: h, raw: txt.trim() };
  }
  function measureArt(cb) {
    /* true inches = rendered pixels / 300dpi, measured from the SAME imgix
       render the canvas shows (trim / bg-remove included). The legacy
       [d-size] element doesn't exist on every lineage — this never lies
       about the artwork's dimensions or orientation. */
    var url = applyToggleParams(cleanUrl(artworkUrl()) || '');
    if (!url || url.indexOf('http') !== 0) { cb(null); return; }
    var probe = new Image();
    probe.onload = function () {
      var w = probe.naturalWidth / 300, h = probe.naturalHeight / 300;
      if (w > 0 && h > 0) {
        cb({ w: Math.round(w * 100) / 100, h: Math.round(h * 100) / 100,
             raw: 'm:' + probe.naturalWidth + 'x' + probe.naturalHeight + ':' + (st.crop ? 1 : 0) + (st.removeBg ? 1 : 0) });
      } else cb(null);
    };
    probe.onerror = function () { cb(null); };
    probe.src = url;
  }
  function adoptDetected(d) {
    /* orientation must follow the artwork — a landscape design can never
       seed portrait numbers (or vice versa) */
    var img = document.getElementById('np-e2-artimg');
    if (img && img.naturalWidth && img.naturalHeight) {
      var artLand = img.naturalWidth >= img.naturalHeight, dLand = d.w >= d.h;
      if (artLand !== dLand) { var t = d.w; d.w = d.h; d.h = t; }
    }
    lastDetected = d.raw;
    st.ratio = d.h / d.w;
    var gD = shapeGeom();
    if (gD && gD !== 'custom' && !heightLocked()) {
      /* a chosen standard shape owns the aspect — the artwork only sets scale */
      var dD = shapeDims(gD);
      st.ratio = dD[1] / dD[0];
    }
    st.w = clampSize(Math.round(d.w * 100) / 100, true);
    st.h = heightLocked() ? st.w : clampSize(Math.round(st.w * st.ratio * 100) / 100, true);
    st.sizeSeeded = true;
    commitSizeQty();
  }
  function seedSizeFromLegacy() {
    var tries = 0;
    (function poll() {
      if (st.sizeSeeded) return;
      var d = readDetectedSize();
      if (d) { adoptDetected(d); return; }
      if (tries === 2) {
        /* no [d-size] on this lineage — measure the artwork render itself */
        measureArt(function (m) { if (!st.sizeSeeded && m) adoptDetected(m); });
      }
      /* fallback: the legacy inputs (2" default + proportional height) */
      var wi = legacyInput('width__value'), hi = legacyInput('height__value');
      var w = wi ? parseFloat(wi.value) : 0, h = hi ? parseFloat(hi.value) : 0;
      if (tries > 12 && w > 0 && h > 0) {
        st.sizeSeeded = true;
        st.w = clampSize(Math.round(w * 100) / 100, true);
        st.h = clampSize(Math.round(h * 100) / 100, true);
        st.ratio = st.h / st.w;
        commitSizeQty();
        return;
      }
      if (++tries < 25) setTimeout(poll, 700);
      else { st.sizeSeeded = true; commitSizeQty(); } /* never leave the $0.00 placeholders */
    })();
  }
  function reseedAfterToggle() {
    /* toggles re-render the artwork -> measure the new render directly and
       adopt its TRUE dimensions; the legacy [d-size] poll is the backup */
    var start = Date.now();
    measureArt(function (m) {
      if (m && m.raw !== lastDetected) { adoptDetected(m); return; }
      (function poll() {
        var d = readDetectedSize();
        if (d && d.raw !== lastDetected) { adoptDetected(d); return; }
        if (Date.now() - start < 20000) setTimeout(poll, 800);
        else renderPricing();
      })();
    });
  }
  function mountMobileSticky() {
    /* MOBILE: the preview rides in its own sticky card pinned to the top.
       Mounted whenever the viewport IS mobile — at activation OR when a
       desktop window is later narrowed (the mount used to be a one-shot
       inside activate(), so resizing after upload lost the sticky). */
    if (!(window.matchMedia && matchMedia('(max-width: 1366px)').matches)) return;
    if (!document.body.classList.contains('np-e2-active')) return;
    if (document.getElementById('np-e2-msticky')) return;
    var mMain = document.querySelector('.np-e2__main');
    var mCanvas = document.getElementById('np-e2-canvas');
    var mZrow = document.getElementById('np-e2-zoomrow');
    if (mMain && mCanvas) {
      var mWrap = document.createElement('div');
      mWrap.id = 'np-e2-msticky';
      mWrap.className = 'np-e2-card np-e2-msticky';
      mMain.insertBefore(mWrap, mMain.firstChild);
      mWrap.appendChild(mCanvas);
      if (mZrow) mWrap.appendChild(mZrow);
      var mS1 = document.getElementById('np-e2-step1');
      if (mS1) mS1.style.display = 'none'; /* just an orphaned title once the canvas leaves */
    }
    /* the switch was placed before this card existed — seat it again now
       that the preview has a new home, so the tabs stay above the image */
    try { paintModeSwitch(); } catch (ePM2) {}
  }
  (function () {
    if (!window.matchMedia) return;
    var mqS = matchMedia('(max-width: 1366px)');
    var onMqS = function () { try { mountMobileSticky(); } catch (eMS) {} };
    if (mqS.addEventListener) mqS.addEventListener('change', onMqS);
    else if (mqS.addListener) mqS.addListener(onMqS);
    window.addEventListener('resize', function () { setTimeout(onMqS, 150); });
  })();
  function activate() {
    /* permanent diagnostics: how long the customer saw the legacy page before
       the builder took over. Read with performance.getEntriesByName('np-e2-activate'). */
    try { performance.mark('np-e2-activate'); } catch (ePM) {}
    /* the boot gate held the page blank until we were ready — release it */
    document.documentElement.classList.remove('np-e2-boot');
    /* the moment the upload signal fires, the builder IS the page — no
       legacy loading UI (running ninja). Our spinner sits over the canvas
       until the artwork actually renders. */
    if (document.body.classList.contains('np-e2-active')) return;
    document.body.classList.add('np-e2-active');
    try { paintModeSwitch(); } catch (ePM) {}
    /* PHOTO CHECK AT UPLOAD (not at the Generate button): the customer learns
       "this is a photo -> Full Color" BEFORE spending time on options for the
       wrong patch type — the same early identification the mockup-generator
       page does. The generate-time gate below stays as the backstop. */
    if (photoGateOn() && !st.versions.length && !st.proofApproved) {
      var pcTries = 0;
      /* NEW ART = NEW VERDICT: a delete-and-reupload (or AI edit) in the same
         session must re-run the analysis — the flags otherwise freeze the
         FIRST upload's verdict for the whole tab (Justin 2026-08-22) */
      (function () {
        var artW = document.getElementById('np-e2-artimg');
        if (!artW || artW.__npPcRearm) return;
        artW.__npPcRearm = true;
        artW.addEventListener('load', function () {
          if (!this.src || !st.__analyzedSrc || this.src === st.__analyzedSrc) return;
          st.__artAnalyzed = false; st.__photoCleared = false; st.__photoNudged = false;
          /* "Keep this patch type" is final for this artwork — a toggle that
             only changed the src params must not resurrect the stop */
          if (keepTypeActive()) { st.__photoCleared = true; st.__photoNudged = true; return; }
          pcTries = 0;
          setTimeout(pcTick, 250);
        });
      })();
      function pcTick() {
        if (st.fcConfirmed || st.versions.length || st.__photoNudged) return;
        var artIP = document.getElementById('np-e2-artimg');
        if (!(artIP && artIP.naturalWidth > 0)) { if (pcTries++ < 120) setTimeout(pcTick, 350); return; }
        if (!st.__artAnalyzed) {
          try { analyzeArtwork(); } catch (ePA) { st.__artAnalyzed = true; }
          if (pcTries++ < 130) setTimeout(pcTick, 300);
          return;
        }
        if (fullColorLikely()) { st.__photoNudged = true; openPhotoConfirm('upload'); return; }
        st.__photoCleared = true; /* checked at upload, not a photo — never re-interrupt at Generate */
        st.__pcDone = true;
        if (typeof fineDetailLikely === 'function' && fineDetailLikely() && PTYPE.fdGate) {
          st.__photoNudged = true;
          openFdReco();
        }
      }
      pcTick();
    }
    /* a type whose size is a PRODUCT fact rather than a typed number hides the
       width/height steppers and the mean-size line. Unlike the names roster it
       keeps the qty stepper and the volume table — quantity is still a choice. */
    if (PTYPE.fixedSize) document.body.classList.add('np-e2-nosize');
    hideLegacy();
    /* the legacy size popup fades in ~after upload; keep it suppressed */
    setInterval(function () {
      var pop = document.querySelector('.customTabelPopup__overlay-2, .customTabelPopup__overlay.pricing-table');
      if (pop && !pop.classList.contains('np-e2-legacy-hidden')) pop.classList.add('np-e2-legacy-hidden');
    }, 800);
    root.hidden = false;
    /* the tabs were seated while the builder was display:none — every rect
       measured 0, so the options-column offset came out 0 and the band hugged
       the left edge. The grid takes several frames (zoom + webfonts + images)
       to reach its real geometry, so keep re-seating until the two columns
       actually read as two columns (or the layout is genuinely one-column). */
    (function reseat(n) {
      try { paintModeSwitch(); } catch (eP1) {}
      if (n >= 10) return;
      var colR = document.querySelector('.np-e2-rightcol');
      var mainR = document.querySelector('.np-e2__main');
      var twoCol = colR && mainR && (colR.getBoundingClientRect().left - mainR.getBoundingClientRect().left) > 40;
      var oneColMQ = window.matchMedia && window.matchMedia('(max-width: 1120px)').matches;
      if (twoCol || oneColMQ) { try { paintModeSwitch(); } catch (eP2) {} if (twoCol) return; }
      setTimeout(function () { reseat(n + 1); }, n < 3 ? 150 : 400);
    })(0);
    /* MOBILE: the preview rides in its own sticky card pinned to the top so
       it stays visible while the customer scrolls through the options */
    mountMobileSticky();
    /* NO-UPLOAD TYPES (custom names): there is no artwork to load, crop,
       background-remove, analyze or observe — the preview composes text. The
       artwork half of activate() is skipped wholesale rather than being fed
       an empty URL, which is what made loadArt() retry forever. */
    if (PTYPE.noArt) {
      document.body.classList.add('np-e2-noart');
      /* warm the lettering faces NOW (they used to start downloading only when
         the font row opened -> visible fallback-then-swap on the tiles) and
         repaint the open row when they land */
      ensureNameFonts(function () { try { if (accOpen !== null && accOpen !== undefined) renderAccordion(); } catch (eWF) {} });
      if (PTYPE.names) document.body.classList.add('np-e2-names-mode');
      /* loader stays ON until the first composed NAME frame lands — the
         preview used to sit as a blank white card while fonts resolved */
      artLoader(true);
      var artWrapN = document.querySelector('#np-e2-canvas .np-e2-art');
      if (artWrapN) artWrapN.hidden = true;
      var cusN = document.getElementById('np-e2-step-customize');
      if (cusN) cusN.hidden = true;
      var ebN = document.querySelector('#np-e2-step-options .np-e2-eyebrow');
      if (ebN) ebN.textContent = 'STEP 1 OF 2';
      var ebN2 = document.querySelector('#np-e2-names .np-e2-eyebrow');
      if (ebN2) ebN2.textContent = 'STEP 2 OF 2';
      var pvN = document.getElementById('np-e2-prevtitle');
      if (pvN) pvN.textContent = PTYPE.textLines ? 'Your Tackle Twill Preview' : 'Your Name Patch Preview';
      if (PTYPE.textLines) {
        var ttC = document.getElementById('np-e2-tt');
        if (ttC) ttC.hidden = false;
        /* open on the most popular size (11" x 4") so the preview, the rulers
           and the price are all true from the first frame */
        if (PTYPE.sizeFromOpt && !st['opt' + PTYPE.sizeFromOpt]) {
          var v0 = optValues(PTYPE.sizeFromOpt)[0];
          if (v0) {
            st['opt' + PTYPE.sizeFromOpt] = v0;
            if (st.draft) st.draft['opt' + PTYPE.sizeFromOpt] = v0;
            var wh0 = optSizeWH(v0.label);
            if (wh0) { st.w = wh0[0]; st.h = wh0[1]; st.ratio = st.h / st.w; st.sizeSeeded = true; }
          }
        }
        /* the product's own photos ride along: the legacy page showed this work
           after upload and the builder used to drop it entirely */
        /* the font is the first decision — its row moves ABOVE the text inputs
           (handlers are delegated, and stepSeq reads DOM order, so moving the
           node reorders the flow too) */
        var fontSlotT = document.getElementById('np-e2-tt-fontslot');
        if (fontSlotT) {
          /* font first, then 1-or-2 layers — both before any text is typed */
          ['6', String(6 + (PTYPE.layersOpt || 2))].forEach(function (nT) {
            var rowT = document.querySelector('.np-e2-accrow[data-e2-acc="' + nT + '"]');
            if (rowT && !fontSlotT.contains(rowT)) fontSlotT.appendChild(rowT);
          });
          fontSlotT.hidden = false;
        }
        /* the stitch is a finishing question: it lives in its own collapsed
           row after the colours, opened when the flow reaches it */
        var stGrp = document.getElementById('np-e2-tt-stitchgrp');
        var stSlot = document.getElementById('np-e2-tt-stitchslot');
        if (stGrp && stSlot && !stSlot.contains(stGrp)) stSlot.appendChild(stGrp);
        var stRow = document.getElementById('np-e2-tt-stitchrow');
        if (stRow && PTYPE.stitches) stRow.hidden = false;
        var galW = document.getElementById('np-e2-ttgal');
        var galS = document.getElementById('np-e2-ttgal-strip');
        var galL = (CFG.gallery || []).filter(Boolean);
        if (galW && galS && galL.length) {
          galS.innerHTML = galL.map(function (uG) {
            return '<img src="' + uG + '" alt="" loading="lazy">';
          }).join('');
          /* its own SECTION: full width under all the options, above whatever
             the theme renders next (the carbon-neutral bar) */
          var gridG = document.querySelector('#np-e2 .np-e2__grid');
          if (gridG && gridG.parentNode && galW.parentNode !== gridG.parentNode) {
            galW.classList.add('np-e2-ttgal--sec');
            gridG.parentNode.insertBefore(galW, gridG.nextSibling);
          }
          galW.hidden = false;
        }
        if (ebN) ebN.textContent = 'STEP 2 OF 2';
        var ttE = document.getElementById('np-e2-tt-eyebrow');
        if (ttE) ttE.textContent = 'STEP 1 OF 2';
        ttSync();
      }
      var minN = document.getElementById('np-e2-names-min');
      if (minN) minN.textContent = namesMin() + ' name minimum';
      var taN = document.getElementById('np-e2-names-ta');
      if (taN) taN.placeholder = 'Alex\nJordan\nSam\n\u2026or paste a comma separated list';
    } else {
    artLoader(true);
    var img = document.getElementById('np-e2-artimg');
    if (img && !img.__npAnalyzeWired) {
      img.__npAnalyzeWired = true;
      var analyzed = false;
      img.addEventListener('load', function () {
        if (!analyzed) { analyzed = true; analyzeArtwork(); }
        /* the accordion opened before the art resolved — refresh the open
           row so shape tiles show the CUSTOMER's art, not the CMS samples */
        if (accOpen !== null) renderAccordion();
      });
    }
    loadArt(); /* retries internally until a candidate resolves */
    /* crop+trim is no longer a customer choice — keep the legacy checkbox in
       sync so detected sizes and the print file reflect the trimmed art */
    var cropTries = 0;
    (function syncCrop() {
      var cc = document.getElementById('option_checkbox');
      if (cc) { if (!cc.checked) cc.click(); return; }
      if (++cropTries < 10) setTimeout(syncCrop, 800);
    })();
    /* remove-background defaults OFF — keep the legacy toggle aligned with
       st.removeBg for a few ticks (the uploader may initialize it checked,
       and the ml handoff can flip the preference mid-activation) */
    var bgTries = 0;
    (function syncBgRemove() {
      var cbg = document.getElementById('option_checkbox_upscale');
      if (cbg && !!cbg.checked !== !!st.removeBg) cbg.click();
      if (++bgTries < 10) setTimeout(syncBgRemove, 800);
    })();
    var hero = document.getElementById('fileupload_hero');
    if (hero) new MutationObserver(function () { loadArt(); }).observe(hero, { attributes: true, attributeFilter: ['src'] });
    }
    /* renderMaskPreview sizes the composed patch in PIXELS off the canvas
       box, so any reflow AFTER that first measure leaves it the wrong size —
       the mobile sticky card re-parents the canvas, late assets change the
       column width, and the customer can just resize the window. A 2.6:1
       name patch overflowed its stage that way. Re-fit whenever the box
       actually changes (debounced: each re-fit is a full re-compose). */
    (function () {
      var cvO = document.getElementById('np-e2-canvas');
      if (!cvO || cvO.__npRO || typeof ResizeObserver === 'undefined') return;
      var tO = null;
      cvO.__npRO = new ResizeObserver(function () {
        clearTimeout(tO);
        tO = setTimeout(function () { try { renderMaskPreview(); } catch (eRO) {} }, 150);
      });
      cvO.__npRO.observe(cvO);
    })();
    seedSizeFromLegacy();
    if (NP_PDP_PRICING) { try { mountPdpPricing(); } catch (eMP) {} }
    handleProofHandoff();
    renderOptions();
    renderPricing(); /* real prices immediately — the markup ships $0.00 placeholders */
    openAcc(firstUnsetStep()); /* on-page options: first unset row starts open */
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function handleProofHandoff() {
    /* arriving from another builder with an approved proof (np_proof):
       attach it, seed size/qty, and land in the approved state — the
       customer just confirms and checks out. */
    var params = new URLSearchParams(window.location.search);
    var proof = params.get('np_proof');
    if (!proof || proof.indexOf('http') !== 0) {
      document.documentElement.classList.remove('np-e2-ml-arrive');
      if (params.get('np_src') === 'ml') pf.hidden = true; /* the boot loading pane has nothing to wait for */
      return;
    }
    /* ── Mockup Lab pass-through (np_src=ml): the lab's mockup IS the proof.
       Selections ride localStorage; land straight in Size & Pricing. ── */
    if (params.get('np_src') === 'ml') {
      var mlArt = params.get('np_art');
      var h = null;
      try { h = JSON.parse(localStorage.getItem('np_ml_handoff') || 'null'); } catch (e0) {}
      /* kept in storage so a RELOAD of the arrival URL still carries the
         options — only expiry clears it */
      if (h && (!h.t || (Date.now() - h.t) >= 1800000)) { h = null; try { localStorage.removeItem('np_ml_handoff'); } catch (e1) {} }
      if (h) {
        if (typeof h.removeBg === 'boolean') {
          st.removeBg = h.removeBg;
          var tgl = document.querySelector('[data-e2-toggle="removeBg"] .np-e2-switch');
          if (tgl) tgl.classList.toggle('is-on', st.removeBg);
        }
        if (h.shape) st.shape = h.shape;
        if (h.border) st.border = (CFG.borders || []).filter(function (b) { return b.label === h.border; })[0] || { label: h.border };
        if (h.bg && h.bg.hex) st.bg = { label: h.bg.label, hex: h.bg.hex };
        if (h.thread && h.thread.hex) st.thread = { label: h.thread.label, hex: h.thread.hex };
        if (h.backing) st.backing = (CFG.backings || []).filter(function (b) { return b.label === h.backing; })[0] || { label: h.backing };
        if (h.lbThick) st.lbThick = h.lbThick;
        if (h.etchInvert) st.etchInvert = true;
        if (h.artZoom) st.artZoom = h.artZoom;
      }
      /* a missing/partial handoff must never null-crash the review pane —
         default the gaps (the order is already flagged for specialist confirm) */
      if (!st.shape) st.shape = 'Custom Shape';
      if (!st.border) st.border = (CFG.borders || [])[0] || { label: 'Embroidered / Hot Cut' };
      if (!st.bg) st.bg = { label: 'Not Sure', hex: '' };
      if (!st.thread) st.thread = { label: 'Not Sure', hex: '' };
      if (!st.backing) st.backing = (CFG.backings || [])[0] || { label: 'Heat Applied' };
      /* sizes are set in the sizing pane — stop the async seeder from mutating
         them AFTER the version meta is captured (that drift flipped the
         revisions modal into 'updated' mode and buried Edit selections) */
      st.sizeSeeded = true;
      var vml = newVersionMeta();
      vml.dataUrl = proof; vml.hosted = proof; vml.rev = 0;
      vml.w = null; vml.h = null; /* the handoff version makes no size claim */
      var mlAlpha = params.get('np_alpha') || '';
      if (mlAlpha.indexOf('http') !== 0) mlAlpha = '';
      if (mlAlpha) vml.alpha = mlAlpha; /* the lab's edge-cut transparent copy — no white studio box */
      st.versions = [vml];
      st.selected = 0;
      st.proofApproved = true; try { prewarmAlphaForCart(); } catch (ePW2) {}
      if (params.get('np_reorder')) { vml.frozenProof = proof; vml.__frozeStart = true; } /* a reorder IS the catalog entry — never re-catalog it */
      upgradeVersionAlpha(vml); /* reorders arrive with the OPAQUE frozen copy — cut the studio white */
      setProp('_AI Proof', proof);
      setProp('_cartImg', digitalCartUrl(vml.alpha || mlAlpha || proof));
      freezeProofCopy(proof, (TYPE_KEY || 'patch') + '--ml', function (uF) {
        if (!uF) return;
        vml.frozenProof = uF;
        setProp('_AI Proof', uF);
      });
      setProp('_Proof Version', 'v1');
      setProp('_AI Proof Status', h ? 'Approved in Mockup Lab' : 'Approved in Mockup Lab - options did not carry over, specialist must confirm');
      if (mlArt && mlArt.indexOf('http') === 0) setProp('_Original Image', mlArt.split('?')[0]);
      commitOptions();
      /* compose OUR digital patch preview (shape + colors + fake merrow) so
         the compare slider's YOUR PREVIEW side shows the patch, not the raw
         upload — re-draw the approved canvas once it lands */
      composeAndHost().then(function () {
        if (st.proofApproved) { try { renderApprovedCanvas(); } catch (eRc2) {} }
      });
      /* the approved-summary elements are normally filled by approveProof —
         this path skips it, so fill them here (dead cart thumb otherwise) */
      var mlThumb = $('#np-e2-cart-thumb'); if (mlThumb) mlThumb.src = mlAlpha || proof;
      var mlLine = $('#np-e2-cart-line');
      if (mlLine) mlLine.textContent = (st.shape || 'Patch') + (st.border ? ' · ' + st.border.label + ' border' : '') + (st.bg ? ' · ' + st.bg.label + ' background' : '') + (st.thread ? ' · ' + st.thread.label + ' thread' : '') + (st.backing ? ' · ' + st.backing.label : '');
      var mlPfl = $('#np-e2-prooffile'); if (mlPfl) mlPfl.textContent = 'ai-proof-v1.png';
      /* the page BEHIND the modal is the approved summary (proof canvas +
         rulers, options collapsed) — same end-state as a normal approval, so
         sizing-Continue lands on the finished view */
      var mlAp = $('#np-e2-approved'); if (mlAp) mlAp.hidden = false;
      try { renderApprovedCanvas(); } catch (eac) {}
      upgradeVersionAlpha(vml); /* fallback transparent copy when np_alpha is absent */
      /* straight to Size & Pricing — but NEVER flash a not-ready image: hold
         the loading phase until the final transparent proof has fully loaded */
      showProofLoading('Preparing your approved proof\u2026');
      var mlTtl = document.getElementById('np-e2-pf-title'); if (mlTtl) mlTtl.textContent = 'Preparing your approved proof';
      var mlT0 = Date.now();
      function mlProbe(u, cb2) { var im = new Image(); im.onload = function () { cb2(true); }; im.onerror = function () { cb2(false); }; im.src = u; }
      (function mlReveal() {
        var timedOut = Date.now() - mlT0 > 12000;
        var src = vml.alpha || vml.dataUrl || vml.hosted || '';
        if (!src) { setTimeout(mlReveal, 300); return; }
        mlProbe(src, function (ok) {
          if (!ok && vml.alpha === src) {
            /* dead transparent copy — drop it, fall back to the real proof
               and let the local cut rebuild the alpha in the background */
            vml.alpha = null;
            setProp('_cartImg', digitalCartUrl(proof));
            upgradeVersionAlpha(vml);
            if (!timedOut) { setTimeout(mlReveal, 300); return; }
          }
          document.documentElement.classList.remove('np-e2-ml-arrive'); /* drop the first-paint cover */
          renderSizing();
        });
      })();
      return;
    }
    var pw = parseFloat(params.get('np_w')), ph = parseFloat(params.get('np_h')), pq = parseInt(params.get('np_qty'), 10);
    if (pw > 0 && ph > 0) {
      st.w = clampSize(Math.round(pw * 100) / 100, true);
      st.h = clampSize(Math.round(ph * 100) / 100, true);
      st.ratio = st.h / st.w;
      st.sizeSeeded = true;
    }
    if (pq > 0) st.qty = Math.max(QTY_MIN, Math.min(QTY_MAX, pq));
    var art = params.get('np_art');
    /* the conversion carries the options — the cart line must still show
       Patch Background Color / Border Thread Color etc. on the new product */
    if (params.get('np_shape')) st.shape = params.get('np_shape');
    if (params.get('np_corners')) st.corners = params.get('np_corners');
    if (params.get('np_lbt')) st.lbThick = parseInt(params.get('np_lbt'), 10) || 3;
    if (params.get('np_inv')) st.etchInvert = true;
    if (params.get('np_tex')) {
      var texL = params.get('np_tex');
      st.texture = { label: texL, img: '' };
      (PTYPE.texture || []).forEach(function (tR) { if (tR.label === texL) st.texture = tR; });
    }
    if (params.get('np_bgl')) { st.bg = { label: params.get('np_bgl'), hex: '' }; if (FOLLOW_RE.test(st.bg.label)) st.bg.follow = true; }
    if (params.get('np_thl')) { st.thread = { label: params.get('np_thl'), hex: '' }; if (FOLLOW_RE.test(st.thread.label)) st.thread.follow = true; }
    if (params.get('np_txl')) {
      var txL = params.get('np_txl');
      st.text = { label: txL, hex: '' };
      (CFG.threads || []).forEach(function (cT) { if (cT.label === txL) st.text = cT; });
    }
    if (params.get('np_bsl')) st.border = { label: params.get('np_bsl') };
    if (params.get('np_bkl')) st.backing = { label: params.get('np_bkl') };
    try { commitOptions(); } catch (eCo) {}
    /* keep the conversion reminder alive on the converted product — the
       customer must never lose sight of WHY they're on this product */
    var conv = params.get('np_conv') || '';
    if (conv === 'woven' || conv === 'ps') { st.fdChoice = conv; st.fcConfirmed = true; st.fcOffered = true; }
    else if (conv) { st.fcForced = true; st.fcForcedReason = conv; st.fcConfirmed = true; st.fcOffered = true; }
    var ppA = params.get('np_pp') || '';
    if (ppA === 'digital' || ppA === 'stitch') {
      st.proofMode = ppA;
      setProp('_Proof Preference', ppA === 'stitch' ? 'REAL STITCHOUT REQUESTED ($19.99)' : 'DIGITAL PROOF (no AI render)');
      st.proof = { label: ppA === 'stitch' ? 'Real stitchout ($19.99)' : 'Digital proof', kind: ppA };
    }
    var v = newVersionMeta();
    v.dataUrl = proof; v.hosted = proof; v.rev = 0;
    v.fullColor = conv !== 'ps';
    v.digital = (ppA === 'digital' || ppA === 'stitch');
    v.altKind = conv === 'woven' ? 'woven' : (conv === 'ps' ? 'ps' : 'fc');
    st.versions = [v];
    st.selected = 0;
    st.proofApproved = true; try { prewarmAlphaForCart(); } catch (ePW2) {}
    st.fcOffered = true;
    if (params.get('np_reorder')) { v.frozenProof = proof; v.__frozeStart = true; } /* a reorder IS the catalog entry — never re-catalog it */
    if (!v.digital) upgradeVersionAlpha(v); /* reorders arrive with the OPAQUE frozen copy — cut the studio white */
    if (!v.digital) setProp('_AI Proof', proof);
    else setProp('_Mockup Catalog', proof);
    setProp('_cartImg', digitalCartUrl(v.alpha || proof));
    setProp('_AI Proof Status', conv === 'ps'
      ? 'Approved in Embroidered builder - converted to PRINT & STITCH (fine detail)'
      : (conv === 'woven'
        ? 'Approved in Embroidered builder - converted to WOVEN (fine detail)'
        : 'Approved in Embroidered builder - converted to FULL COLOR' + (conv === 'detail' ? ' (fine detail)' : (conv === 'photo' ? ' (photograph)' : ''))));
    var pn = params.get('np_notes');
    if (pn) setProp('_Revision Notes', pn);
    var dnA = params.get('np_dnotes');
    if (dnA) { setProp('Design Notes', dnA); var taDn = $('#np-e2-change-text'); if (taDn && !taDn.value) taDn.value = dnA; }
    /* lab handoff with revisions: the order carries the requested-revisions
       status exactly as if the note had been saved on this page */
    if (params.get('np_revreq')) setProp('_AI Proof Status', 'REVISIONS REQUESTED - specialist to apply notes');
    if (art && art.indexOf('http') === 0 && sameLineage(art, proof)) setProp('_Original Image', art);
    if (params.get('np_reorder')) setProp('_AI Proof Status', 'Reordered from My Proofs - AI proof attached');
    commitSizeQty();
    $('#np-e2-approved').hidden = false;
    $('#np-e2-cart-thumb').src = proof;
    $('#np-e2-cart-line').textContent = (CFG.productTitle || 'Patch') + (v.digital ? ' \u00b7 digital proof attached' : ' \u00b7 approved AI proof attached');
    var pfl3 = $('#np-e2-prooffile'); if (pfl3) pfl3.textContent = v.digital ? 'digital-proof.png' : 'ai-proof-fc.png';
    if (v.digital) {
      var crIA = document.querySelector('.np-e2-cartrow__mid i');
      if (crIA) crIA.textContent = 'Your original upload and your digital preview both attach to this order.';
      var coIA = document.querySelector('.np-e2-checkoutrow i');
      if (coIA) coIA.textContent = st.proofMode === 'stitch' ? 'A real stitched sample is produced and photographed for your approval first (adds 2-4 business days).' : 'Your digital preview is your proof above.';
    }
    renderApprovedCanvas();
    /* conversions land STRAIGHT in Size & Pricing — the approved summary
       waits behind the modal for when they close it */
    try { renderSizing(); } catch (eSz2) {}
  }

  /* ---- events ---- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var acccont = t.closest && t.closest('[data-e2-acccont]');
    if (acccont) {
      if (acccont.disabled) return;
      var ci2 = parseInt(acccont.getAttribute('data-e2-acccont'), 10);
      var nxA = stepAfter(ci2);
      if (nxA !== -1 && PTYPE.stitches && WZ_STEPS[nxA] === 'backing' && document.getElementById('np-e2-tt-stitchrow')) {
        accOpen = null;
        renderAccordion();
        ttStitchOpen(true);
        var rowSt = document.getElementById('np-e2-tt-stitchrow');
        setTimeout(function () {
          var ySt = rowSt.getBoundingClientRect().top + window.pageYOffset - npScrollPad();
          window.scrollTo({ top: Math.max(0, ySt), behavior: 'smooth' });
        }, 60);
        return;
      }
      if (nxA === -1) {
        accOpen = null;
        renderAccordion();
        if (committed()) {
          if (PTYPE.names) { revealNames(); return; }
          if (!st.versions.length) openProof(); else reopenProof();
        }
      } else {
        openAcc(nxA);
        /* bring the newly opened section's top into view */
        var rowN = document.querySelector('.np-e2-accrow[data-e2-acc="' + nxA + '"]');
        if (rowN) setTimeout(function () {
          var yR = rowN.getBoundingClientRect().top + window.pageYOffset - npScrollPad();
          window.scrollTo({ top: Math.max(0, yR), behavior: 'smooth' });
        }, 60);
      }
      return;
    }
    var acctext = t.closest && t.closest('[data-e2-acctext]');
    if (acctext) {
      accOpen = null;
      renderAccordion();
      ttLetterOpen(true);
      var l1T = document.getElementById('np-e2-tt-l1');
      if (l1T) {
        var yT = l1T.getBoundingClientRect().top + window.pageYOffset - npScrollPad();
        window.scrollTo({ top: Math.max(0, yT), behavior: 'smooth' });
        setTimeout(function () { try { l1T.focus(); } catch (eF) {} }, 320);
      }
      return;
    }
    var accdone = t.closest && t.closest('[data-e2-accdone]');
    if (accdone) {
      if (accdone.disabled) return;
      st.ctaRevealed = true;
      accOpen = null;
      renderAccordion();
      if (PTYPE.names) { revealNames(); return; }
      var fBD = document.getElementById('np-e2-proofbtn');
      if (fBD && !fBD.hidden) setTimeout(function () {
        var yD = fBD.getBoundingClientRect().top + window.pageYOffset - Math.round(window.innerHeight * 0.55);
        window.scrollTo({ top: Math.max(0, yD), behavior: 'smooth' });
      }, 60);
      return;
    }
    var acchead = t.closest && t.closest('[data-e2-acchead]');
    if (acchead) {
      var ai = parseInt(acchead.getAttribute('data-e2-acchead'), 10);
      if (accOpen === ai) { accOpen = null; renderAccordion(); } else openAcc(ai);
      return;
    }
    var row = t.closest && t.closest('[data-e2-row]');
    if (row) { openWizard(parseInt(row.getAttribute('data-e2-row'), 10)); return; }
    var seg = t.closest && t.closest('[data-e2-toggle]');
    if (seg) {
      var key = seg.getAttribute('data-e2-toggle');
      st[key === 'removeBg' ? 'removeBg' : 'crop'] = !st[key === 'removeBg' ? 'removeBg' : 'crop'];
      seg.querySelector('.np-e2-switch').classList.toggle('is-on');
      /* proxy into the legacy toggles so the imgix render + properties update */
      var legacy = key === 'removeBg' ? document.getElementById('option_checkbox_upscale') : document.getElementById('option_checkbox');
      if (legacy) legacy.click();
      loadArt(); /* re-render the canvas with the new imgix params */
      reseedAfterToggle();
      /* the palette belongs to the CURRENT render: re-read it and repaint the
         open colour step so "Colors from your artwork" follows the toggle */
      try {
        st.__artAnalyzed = false;
        analyzeArtwork();
        setTimeout(function () { try { renderAccordion(); } catch (eRA) {} }, 260);
      } catch (eAT) {}
      return;
    }
    var guideRow = t.closest && t.closest('[data-e2-guide]');
    if (guideRow) {
      /* apply the placement's preferred size: hit the CHARGED size exactly
         while keeping the aspect as close as possible */
      var gt = parseFloat(guideRow.getAttribute('data-e2-guide'));
      /* 2026-08-25 (Justin): Apply sets the WIDTH to the stated number and lets
         the height follow the artwork's aspect. It used to scale BOTH dimensions
         so the MEAN equalled the guide number — which kept the charged size
         exact but meant tapping "4 inches" never put 4 in the Width box.
         NOTE the trade-off: the charged size is still the mean rounded UP to a
         variant, so a 4.00 x 2.86 patch prices at 3.5", not 4". The guide now
         reads as "make it this wide", not "charge me this size". */
      if (heightLocked()) { st.w = clampSize(gt); st.h = st.w; }
      else {
        st.w = clampSize(gt, true);
        st.h = clampSize(Math.max(SIZE_MIN, Math.round(st.w * st.ratio * 100) / 100), true);
      }
      commitSizeQty();
      renderSizeGuide();
      return;
    }
    if (t.closest && t.closest('[data-e2-close="guide"]')) { var gm = document.getElementById('np-e2-sizeguide-m'); if (gm) gm.hidden = true; return; }
    if (t.closest && t.closest('[data-e2-close="wizard"]')) { closeWizard(); return; }
    if (t.closest && t.closest('[data-e2-close="proof"]')) {
      if (st.proofPhase === 'sizing') { openLeaveConfirm(); return; }
      pf.hidden = true;
      return;
    }
    if (t === wz) { closeWizard(); return; }
    /* the proof modal only closes via its X — a stray backdrop click must
       never kill an in-flight render or an unsaved proof review */
  });

  $$('.np-e2-stepper button').forEach(function (b) {
    b.addEventListener('click', function () {
      var kind = b.closest('[data-e2-step]').getAttribute('data-e2-step');
      var d = parseInt(b.getAttribute('data-d'), 10);
      if (kind === 'w') {
        st.w = clampSize(Math.round((st.w + d * SIZE_STEP) * 100) / 100);
        st.h = heightLocked() ? st.w : clampSize(Math.round(st.w * st.ratio * 100) / 100, true);
      }
      else if (kind === 'h') {
        if (heightLocked()) return;
        st.h = clampSize(Math.round((st.h + d * SIZE_STEP) * 100) / 100);
        st.w = clampSize(Math.round(st.h / st.ratio * 100) / 100, true);
      }
      else { setQty(st.qty + d * QTY_STEP); return; }
      commitSizeQty();
    });
  });

  function wireSizeInput(id, key) {
    var el = document.getElementById(id);
    if (!el) return;
    el.addEventListener('focus', function () { var s = this; setTimeout(function () { s.select(); }, 0); });
    el.addEventListener('click', function () { this.select(); });
    el.addEventListener('change', function () {
      var v = parseFloat(el.value);
      if (!v) v = SIZE_MIN;
      v = clampSize(Math.round(v * 100) / 100);
      if (key === 'w') {
        st.w = v;
        st.h = heightLocked() ? v : clampSize(Math.round(v * st.ratio * 100) / 100, true);
      } else {
        if (heightLocked()) { renderPricing(); return; }
        st.h = v;
        st.w = clampSize(Math.round(v / st.ratio * 100) / 100, true);
      }
      commitSizeQty();
    });
    el.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); el.blur(); } });
  }
  wireSizeInput('np-e2-winput', 'w');
  wireSizeInput('np-e2-hinput', 'h');

  var qtyInput = document.getElementById('np-e2-qtyinput');
  if (qtyInput) {
    qtyInput.addEventListener('focus', function () { var el = this; setTimeout(function () { el.select(); }, 0); });
    qtyInput.addEventListener('click', function () { this.select(); });
    qtyInput.addEventListener('change', function () {
      var v = parseInt(qtyInput.value, 10);
      if (!v || v < QTY_MIN) {
        var cap = document.getElementById('np-e2-qtycap');
        cap.classList.add('is-error');
        setTimeout(function () { cap.classList.remove('is-error'); }, 2000);
        v = QTY_MIN;
      }
      setQty(v || QTY_MIN);
    });
    qtyInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); qtyInput.blur(); } });
  }

  $('#np-e2-wz-prev').addEventListener('click', function () { if (st.step > 0) { st.step--; renderWizard(); } });
  $('#np-e2-wz-next').addEventListener('click', function () {
    if ($('#np-e2-wz-next').disabled) return;
    if (st.step < 4) { st.step++; renderWizard(); } else applyDraft();
  });
  $('#np-e2-wz-save').addEventListener('click', applyDraft);

  $('#np-e2-change-toggle').addEventListener('click', function () {
    st.expanded = !st.expanded;
    $('.np-e2-change__body').hidden = !st.expanded;
    this.textContent = st.expanded ? 'Close' : 'Add a change';
    $('#np-e2-change-sub').textContent = st.expanded ? (st.isAI ? 'Edit with AI' : 'Design Notes') : 'AI edits or design notes for our art team';
    if (st.expanded) {
      var ctxt = $('#np-e2-change-text');
      if (ctxt) setTimeout(function () { try { ctxt.focus({ preventScroll: false }); } catch (eF) { ctxt.focus(); } }, 30);
    }
  });
  $$('.np-e2-pill').forEach(function (p) {
    p.addEventListener('click', function () {
      st.isAI = p.getAttribute('data-e2-mode') === 'ai';
      $$('.np-e2-pill').forEach(function (x) { x.classList.toggle('is-on', x === p); });
      $('#np-e2-change-sub').textContent = st.isAI ? 'Edit with AI' : 'Design Notes';
      $('#np-e2-mode-help').textContent = st.isAI ? 'Describe it and our AI applies it now' : 'Our art team handles it before printing';
      $('#np-e2-change-text').placeholder = st.isAI ? 'i.e. Make the outline thicker and center the text.' : 'i.e. Keep the white inside of the text. Change the border of the logo to blue.';
      $('#np-e2-mode-foot').textContent = st.isAI ? 'Free · Unlimited edits' : 'Free · Reviewed before printing';
      $('#np-e2-change-cta').textContent = st.isAI ? 'Generate edit' : 'Save notes';
      $('#np-e2-change-cta').classList.toggle('np-e2-btn--ai', st.isAI);
    });
  });
  (function () { var c0 = $('#np-e2-change-cta'); if (c0) c0.classList.toggle('np-e2-btn--ai', !!st.isAI); })();
  function aiEditModal(on) {
    /* Edit-with-AI takes over the page: a white square holds the wand ninja
       front and center and the backdrop blocks every control until the new
       artwork lands — picking options mid-generate left half the session
       derived from the OLD image. */
    var m = document.getElementById('np-e2-aimodal');
    if (!m && on) {
      m = document.createElement('div');
      m.id = 'np-e2-aimodal';
      m.className = 'np-e2-ov np-e2-ov--aimodal';
      m.innerHTML = '<div class="np-e2-aimodal__panel" role="alert" aria-busy="true">' +
        '<img src="https://cdn.shopify.com/s/files/1/0819/2170/4255/files/AI_Wizard_Patches.gif?v=1768923627" alt="">' +
        '<b>Transforming your image<br>with AI magic</b>' +
        '<i>Hang tight \u2014 just a few seconds</i></div>';
      document.body.appendChild(m);
    }
    if (m) m.hidden = !on;
  }
  $('#np-e2-change-cta').addEventListener('click', function () {
    var txt = $('#np-e2-change-text').value.trim();
    if (!txt) { $('#np-e2-change-text').focus(); return; }
    if (st.isAI && typeof window.nanoBananaEditRequest === 'function') {
      var cta = this; cta.textContent = 'Generating…'; cta.disabled = true;
      /* ONE indicator: the blocking white modal. The old in-canvas ninja
         stays retired — two wands at once read as a glitch. */
      aiEditModal(true);
      window.nanoBananaEditRequest(artworkUrl(), txt).then(function (url) {
        aiEditModal(false);
        if (/imgix/.test(url || '') && url.indexOf('cs=strip') === -1) url += (url.indexOf('?') === -1 ? '?' : '&') + 'cs=strip';
        var artElA = $('#np-e2-artimg');
        artElA.src = url;
        var hero = document.getElementById('fileupload_hero');
        if (hero) hero.setAttribute('src', url);
        analyzeArtwork();
        /* The artwork just CHANGED, so everything derived from it is stale: the
           composed reference we send the renderer, and the live patch preview.
           Without this the customer edits their art with AI on a fully
           configured patch and the preview keeps showing the OLD artwork. */
        sensei.composedUrl = null; sensei.composedLocal = null; sensei.composedCleanUrl = null; sensei.composedCleanDone = false;
        var repaintA = function () {
          try { renderMaskPreview(); } catch (eR1) {}
          try { renderOptions(); } catch (eR2) {}
          try { if (accOpen !== null && accOpen !== undefined) renderAccordion(); } catch (eR3) {}
        };
        /* ALWAYS wait for the load event: right after assigning .src the element
           can still report complete/naturalWidth for the PREVIOUS image, so the
           earlier "repaint if complete" version recomposed the old artwork. */
        artElA.addEventListener('load', repaintA, { once: true });
        setTimeout(repaintA, 1200); /* belt and braces if the load event is missed */
        setProp('AI Edit', txt); /* session-only: stripped at add time, never synced to the line */
        cta.textContent = 'Generate edit'; cta.disabled = false;
        /* done populating — fold the change panel back up */
        st.expanded = false;
        $('.np-e2-change__body').hidden = true;
        var tglC = $('#np-e2-change-toggle');
        if (tglC) tglC.textContent = 'Add a change';
        var subC = $('#np-e2-change-sub');
        if (subC) subC.textContent = 'AI edits or design notes for our art team';
        /* the request is spent — clear it so the next edit starts empty */
        $('#np-e2-change-text').value = '';
        npToast('\u2713 AI edit applied');
      }).catch(function (err) {
        aiEditModal(false);
        alert('AI edit failed: ' + (err && err.message || 'try again'));
        cta.textContent = 'Generate edit'; cta.disabled = false;
      });
    } else {
      setProp('Design Notes', txt);
      lineSync({ 'Design Notes': txt });
      var el = this; el.textContent = 'Saved ✓';
      setTimeout(function () {
        el.textContent = 'Save notes';
        /* the note is filed — fold the panel back up */
        st.expanded = false;
        $('.np-e2-change__body').hidden = true;
        var tglN = $('#np-e2-change-toggle');
        if (tglN) tglN.textContent = 'Add a change';
        var subN = $('#np-e2-change-sub');
        if (subN) subN.textContent = 'AI edits or design notes for our art team';
      }, 1100);
    }
  });

  function reopenProof() {
    /* back into the proof modal (they approved but haven't checked out, or
       closed it) — NEVER burns a regeneration. Approved -> straight to the
       size & pricing phase; unapproved -> the review phase. */
    if (!st.versions.length) { openProof(); return; }
    if (st.proofApproved) {
      if (pdpPricingOn()) { pf.hidden = false; st.proofPhase = 'ready'; renderProofReady(); return; }
      renderSizing(); return;
    }
    pf.hidden = false;
    st.proofPhase = 'ready';
    renderProofReady();
  }
  function npScrollPad() {
    /* the mobile sticky preview overlays the top of the page — scrolled-to
       rows must land BELOW it, not underneath it */
    var stk = document.getElementById('np-e2-msticky');
    if (stk && window.innerWidth < 1367) {
      var rS = stk.getBoundingClientRect();
      if (rS.height > 40) return Math.round(rS.bottom + 14);
    }
    return 120;
  }
  function firstUnsetStep() {
    var sq = stepSeq();
    for (var i = 0; i < sq.length; i++) { if (!st[WZ_STEPS[sq[i]]]) return sq[i]; }
    return sq.length ? sq[sq.length - 1] : 0;
  }
  var skipBtnE = document.getElementById('np-e2-skipproof');
  if (skipBtnE) skipBtnE.addEventListener('click', function () {
    if (st.versions.length || st.proofApproved) return;
    if (!committed()) { openAcc(firstUnsetStep()); return; }
    if (pdpPricingOn()) st.__skipCheckout = true; /* size/qty already picked on the page */
    startDigitalPath(false);
  });
  $('#np-e2-proofbtn').addEventListener('click', function () {
    if (this.disabled || this.hidden) return;
    if (!committed()) { openAcc(firstUnsetStep()); return; }
    if (!st.versions.length) { st.pendingProofKind = 'ai'; setProp('_Proof Preference', 'AI PROOF (free)'); }
    if (st.versions.length) {
      /* selections changed since the last render \u2014 straight back to the
         generation phase with the updated specs */
      if (!st.proofApproved && regensLeft() > 0 && specsChangedSince(st.versions[st.versions.length - 1])) { regenerateWithNotes(''); return; }
      reopenProof();
    } else openProof();
  });
  function paintSlider(el) {
    var p = (el.value - el.min) / (el.max - el.min) * 100;
    el.style.background = 'linear-gradient(to right, #1AA86C ' + p + '%, #d4f1e0 ' + p + '%)';
  }
  var zoomSlider = document.getElementById('np-e2-artzoom');
  if (zoomSlider) paintSlider(zoomSlider);
  if (zoomSlider) zoomSlider.addEventListener('input', function () {
    paintSlider(zoomSlider);
    st.artZoom = parseInt(zoomSlider.value, 10) / 100;
    var lv = document.getElementById('np-e2-artzoom-val');
    if (lv) lv.textContent = zoomSlider.value + '%';
    /* the preview img is the WHOLE composed patch — never transform it;
       re-compose instead so only the ART inside the shape scales */
    if (!zoomSlider.__npRaf) {
      zoomSlider.__npRaf = true;
      requestAnimationFrame(function () { zoomSlider.__npRaf = false; renderMaskPreview(); });
    }
    setProp('_Art Fill', zoomSlider.value + '%');
  });
  var reopenLink = document.getElementById('np-e2-pf-reopen');
  if (reopenLink) reopenLink.addEventListener('click', function (e) { e.preventDefault(); reopenProof(); });

  var zb = $('#np-e2-zoombox');
  var zbIdx = 0;
  function zbShow(i) {
    var n = st.versions.length;
    if (!n) return;
    zbIdx = ((i % n) + n) % n;
    var v = st.versions[zbIdx];
    var src = v.dataUrl || v.hosted || v.alpha;
    if (!src) return;
    $('#np-e2-zoombox-img').src = src;
    var multi = n > 1;
    $('#np-e2-zoomprev').hidden = !multi;
    $('#np-e2-zoomnext').hidden = !multi;
    var cap = $('#np-e2-zoomcap');
    cap.hidden = !multi;
    cap.textContent = (v.fullColor ? 'FC' : 'V' + (zbIdx + 1)) + ' of ' + n;
    zb.hidden = false;
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.np-e2-pf-zoombtn')) {
      zbShow((st.selected === null || st.selected === undefined) ? st.versions.length - 1 : st.selected);
    } else if (e.target.closest && e.target.closest('#np-e2-zoomprev')) {
      zbShow(zbIdx - 1);
    } else if (e.target.closest && e.target.closest('#np-e2-zoomnext')) {
      zbShow(zbIdx + 1);
    } else if (e.target.closest && e.target.closest('#np-e2-zoomx')) {
      zb.hidden = true;
    } else if (!zb.hidden && (e.target === zb || e.target.id === 'np-e2-zoombox-img')) {
      zb.hidden = true;
    }
  });
  document.addEventListener('keydown', function (e) {
    if (zb.hidden) return;
    if (e.key === 'ArrowLeft') { e.preventDefault(); zbShow(zbIdx - 1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); zbShow(zbIdx + 1); }
    else if (e.key === 'Escape') { zb.hidden = true; }
  });

  /* self-heal: if anything ever re-renders the section markup, the fresh copy
     shows the raw $0.00 placeholders — repaint it (all renderers query the
     document, not stale node references) */
  /* B81 (2026-08-25) — BOUND THE $0.00 SELF-HEAL. This was an UNBOUNDED repair
     loop: every 3s, forever, a $0.00 price triggered a FULL renderPricing() +
     renderOptions() rebuild. Sitting in any section where the price is not set
     yet (e.g. stepping BACK before size) put the builder in that state
     permanently — a complete options rebuild every 3 seconds, each one
     re-attaching listeners (151 addEventListener vs 2 removeEventListener in
     this file), so it compounded the longer you stayed. Justin, on Safari:
     "once you slow down and start going backwards into other sections thats
     when it tightens up and starts to lag."
     A repair that has not worked in 3 tries is not going to work on the 400th;
     the counter resets as soon as a real price renders, so a genuine later
     $0.00 still gets its own bounded set of retries. */
  var npZeroHealN = 0;
  setInterval(function () {
    if (!document.body.classList.contains('np-e2-active')) return;
    var each = document.getElementById('np-e2-each');
    if (!each) return;
    if (each.textContent === '$0.00') {
      if (npZeroHealN >= 3) return;
      npZeroHealN++;
      try { renderPricing(); renderOptions(); } catch (e) {}
    } else if (npZeroHealN) npZeroHealN = 0;
  }, 3000);
  $('#np-e2-fc-go').addEventListener('click', function () { generateFullColor(); });
  $('#np-e2-fc-no').addEventListener('click', function () { st.fcOffered = true; $('#np-e2-fc-reco').hidden = true; });
  $('#np-e2-pf-retry').addEventListener('click', function () { openProof(); });
  function editSelections() {
    /* selections are edited ON THE PAGE (accordion) — close the proof,
       open the options card; the way back is the "View your proof" button,
       where the revisions CTA flips to "Regenerate with updated selections". */
    pf.hidden = true;
    var rm = $('#np-e2-regenm'); if (rm) rm.hidden = true;
    if (document.body.classList.contains('np-e2-approved-view')) {
      /* the approved summary hides the options card — restore the editing
         surface (approval itself stands until a new render supersedes it) */
      document.body.classList.remove('np-e2-approved-view');
      try { clearApprovedCanvas(); } catch (eAc) {}
      renderOptions();
      renderMaskPreview();
    }
    openAcc(0);
    var oc = document.getElementById('np-e2-step-options');
    if (oc) oc.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  var revEditBtn = $('#np-e2-rev-edit');
  if (revEditBtn) revEditBtn.addEventListener('click', editSelections);
  var regenM = $('#np-e2-regenm');
  var regenMode = 'notes';
  var regenHadNotes = false;
  function openRegenModal(mode) {
    regenMode = mode;
    var updated = mode === 'updated';
    regenM.querySelector('.np-e2-modal__title').textContent = updated ? 'Regenerate with updated selections' : 'Submit Revisions';
    regenM.querySelector('.np-e2-wz-help').textContent = updated
      ? 'We\u2019ll re-render your patch with the new selections. Add a note if there\u2019s anything else you\u2019d like changed (optional).'
      : 'Tell us what to change and a patch specialist will apply it by hand before production \u2014 this does NOT re-generate the proof. Want a brand new proof instead? Use Edit selections above, which regenerates your patch with the changes applied.';
    $('#np-e2-regen-go').textContent = updated ? 'Regenerate proof' : 'Save';
    var rc = $('#np-e2-revchoice'); if (rc) rc.hidden = false; /* Edit selections stays available in every mode */
    $('#np-e2-regen-notes').value = '';
    /* opened onto an existing note? then an EMPTY box is a valid save — it
       clears the revisions and returns the flow to a plain approval */
    regenHadNotes = !updated && !!(formProp('_Revision Notes') || '');
    $('#np-e2-regen-go').disabled = !updated && !regenHadNotes;
    regenM.hidden = false;
  }
  $('#np-e2-pf-regen').addEventListener('click', function () {
    if (this.disabled) return;
    openRegenModal(specsChangedSince(st.versions[st.versions.length - 1]) ? 'updated' : 'notes');
  });
  $('#np-e2-regen-notes').addEventListener('input', function () {
    $('#np-e2-regen-go').disabled = regenMode === 'updated' ? false : (!this.value.trim() && !regenHadNotes);
    if (regenHadNotes) $('#np-e2-regen-go').textContent = this.value.trim() ? 'Save' : 'Clear revisions';
  });
  $('#np-e2-regen-go').addEventListener('click', function () {
    var note = $('#np-e2-regen-notes').value.trim();
    if (regenMode !== 'updated' && !note && !regenHadNotes) return;
    regenM.hidden = true;
    if (regenMode !== 'updated' && !note && regenHadNotes) {
      /* cleared: drop the notes and the requested-revisions status so the
         footer goes back to a straight approval */
      setProp('_Revision Notes', '');
      lineSync({ '_Revision Notes': '' });
      setProp('_AI Proof Status', '');
      npToast('\u2713 Revisions cleared');
      renderProofReady();
      return;
    }
    if (regenMode === 'updated') {
      /* they changed their selections — that DOES warrant a fresh render */
      if (note) applyNoteSelections(note);
      regenerateWithNotes(note);
      return;
    }
    /* Notes-only revisions do NOT re-render. The note is filed as Revision
       Notes and a patch specialist applies it by hand; regenerating here was
       the source of the revision problems. Editing selections is the explicit
       path to a new proof. */
    setProp('_Revision Notes', (formProp('_Revision Notes') ? formProp('_Revision Notes') + ' | ' : '') + note);
    setProp('_AI Proof Status', 'REVISIONS REQUESTED - specialist to apply notes');
    setProp('_Proof Approval', proofApprovalLabel());
    lineSync({
      '_Revision Notes': formProp('_Revision Notes') || note,
      '_AI Proof Status': 'REVISIONS REQUESTED - specialist to apply notes',
      '_Proof Approval': proofApprovalLabel()
    });
    npToast('\u2713 Revision notes saved');
    renderProofReady();
    var svEl = document.getElementById('np-e2-pf-revsaved');
    if (svEl) svEl.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-e2-close="regen"]')) regenM.hidden = true;
    else if (e.target === regenM) regenM.hidden = true;
  });
  var revEditBtn = document.getElementById('np-e2-pf-reveditbtn');
  if (revEditBtn) revEditBtn.addEventListener('click', function () {
    openRegenModal('notes');
    var box = $('#np-e2-regen-notes');
    if (box) { box.value = formProp('_Revision Notes') || ''; box.dispatchEvent(new Event('input', { bubbles: true })); }
  });
  $('#np-e2-pf-approve').addEventListener('click', approveProof);
  /* B90 (2026-08-25) — STOP THE NATIVE FORM SUBMIT.
     This was `addEventListener('click', doCheckout)` and doCheckout takes NO
     event, so nothing ever called preventDefault(). A <button> inside the
     product <form> defaults to type="submit", so each click ALSO fired a native
     submit — a full page navigation. The browser then freezes the outgoing
     document, which is the exact fingerprint we measured on Justin's adds:
     timers 0 ticks of an expected 135, worker 0, longest task 153ms (thread
     IDLE, not busy), zero network entries, tab awake and never hidden. The wait
     was the server answering the form navigation, and /cart takes 5-7s to serve.
     PROOF from Justin: adding from the mockup shelf is "almost instant" — that
     path calls doCheckout() PROGRAMMATICALLY (see reorder flow), with no click
     event and therefore no form submit. Same add code, no freeze.
     Belt and braces: force type="button" AND preventDefault on the click. */
  (function () {
    var coBtn = $('#np-e2-checkout');
    if (!coBtn) return;
    try { coBtn.setAttribute('type', 'button'); } catch (eT) {}
    coBtn.addEventListener('click', function (evCo) {
      try { if (evCo && evCo.preventDefault) { evCo.preventDefault(); evCo.stopPropagation(); } } catch (eP) {}
      doCheckout();
    });
  })();
  /* detector: if anything still submits the product form during an add, say so
     in the log rather than leaving it to be re-diagnosed from symptoms. */
  try {
    document.addEventListener('submit', function (evS) {
      try {
        coMark('FORM-SUBMIT' + (window.__npAdding ? ':DURING-ADD-BLOCKED' : ''));
        if (window.__npAdding) { evS.preventDefault(); evS.stopImmediatePropagation(); }
      } catch (eS2) {}
    }, true);
  } catch (eS) {}
  function parseNamesCsv(text) {
    /* proper quoted-cell parse so "Smith, John" stays one cell */
    var rows = [], row = [], cell = '', q = false;
    for (var i = 0; i < text.length; i++) {
      var ch = text[i];
      if (q) {
        if (ch === '"') { if (text[i + 1] === '"') { cell += '"'; i++; } else q = false; }
        else cell += ch;
      } else if (ch === '"') q = true;
      else if (ch === ',') { row.push(cell); cell = ''; }
      else if (ch === '\n' || ch === '\r') {
        if (ch === '\r' && text[i + 1] === '\n') i++;
        row.push(cell); cell = '';
        rows.push(row); row = [];
      } else cell += ch;
    }
    row.push(cell);
    rows.push(row);
    rows = rows.map(function (r) {
      return r.map(function (c) { return c.replace(/\s+/g, ' ').trim(); }).filter(function (c) { return !!c; });
    }).filter(function (r) { return r.length; });
    if (!rows.length) return [];
    /* a header row ("Name", "First Name"...) is metadata, not a customer */
    var HDR = /^(names?|first|last|middle|first ?name|last ?name|full ?name|employees?|players?|members?|staff|roster|title|#|no\.?|number|id)$/i;
    if (rows.length > 1 && rows[0].every(function (c) { return HDR.test(c); })) rows.shift();
    /* one row of many cells = a comma list of names; many rows = one name per
       row, with multi-column rows (First,Last) joined into the full name */
    var out = (rows.length === 1 && rows[0].length > 1) ? rows[0] : rows.map(function (r) { return r.join(' '); });
    /* the roster textarea treats commas as SEPARATORS — a comma inside a
       quoted cell ("Smith, Jr.") would split into two names downstream */
    return out.map(function (nm) { return nm.replace(/\s*,\s*/g, ' ').replace(/\s+/g, ' ').trim(); });
  }
  /* the preview shows the name being TYPED: the roster row under the caret,
     else the last row they were on, else (right after a CSV) the first name */
  var namePrevTimer = null;
  function namePreviewFromCaret() {
    var taP = document.getElementById('np-e2-names-ta');
    if (!taP || !PTYPE.names) return;
    var V = taP.value, P = taP.selectionStart || 0;
    /* the active segment is bounded by newlines OR commas, same as the split */
    var a = Math.max(V.lastIndexOf('\n', P - 1), V.lastIndexOf(',', P - 1)) + 1;
    var nl = V.indexOf('\n', P), cm = V.indexOf(',', P);
    var b = Math.min(nl === -1 ? V.length : nl, cm === -1 ? V.length : cm);
    var seg = V.slice(a, b).trim();
    if (!seg || seg === st.namePreview) return; /* empty row: keep the last one */
    st.namePreview = seg;
    if (namePrevTimer) clearTimeout(namePrevTimer);
    /* a breath of throttle so fast typing doesn't queue a compose per key */
    namePrevTimer = setTimeout(function () { namePrevTimer = null; try { renderMaskPreview(); } catch (eNP) {} }, 120);
  }
  (function () {
    var taP = document.getElementById('np-e2-names-ta');
    if (!taP) return;
    ['input', 'keyup', 'click', 'focus'].forEach(function (evN) {
      taP.addEventListener(evN, namePreviewFromCaret);
    });
  })();
  /* ═══ ROSTER TABS (custom names): Grid table / Bulk paste / Upload CSV.
     All three write through the ONE textarea (#np-e2-names-ta) — namesList(),
     pricing, minimums and the order property never learn a second source. ═══ */
  function nrPane(which) {
    ['grid', 'paste', 'csv'].forEach(function (k) {
      var pane = document.getElementById('np-e2-nr-' + k);
      if (pane) pane.hidden = k !== which;
    });
    $$('.np-e2-nr-tab').forEach(function (t) {
      var on = t.getAttribute('data-nr-tab') === which;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    if (which === 'grid') nrRenderRows();
  }
  /* clicking into a roster QTY selects the whole value — typing replaces
     instead of appending (a tapped "1" becoming "110" was a support call) */
  document.addEventListener('focusin', function (evQ) {
    var q = evQ.target;
    if (q && q.classList && q.classList.contains('np-e2-nr-qn')) {
      q.__npSelArm = 1;
      try { q.select(); } catch (eQ0) {}
      setTimeout(function () { try { q.select(); } catch (eQS) {} }, 0);
      requestAnimationFrame(function () { try { q.select(); } catch (eQR) {} });
    }
  });
  /* the mouseup that follows the focusing click would collapse the selection */
  document.addEventListener('mouseup', function (evM) {
    var q = evM.target;
    if (q && q.classList && q.classList.contains('np-e2-nr-qn') && q.__npSelArm) {
      q.__npSelArm = 0;
      evM.preventDefault();
    }
  });
  function nrRowHTML(val, qty) {
    var q = Math.max(1, parseInt(qty, 10) || 1);
    return '<div class="np-e2-nr-row' + (String(val || '').trim() ? '' : ' is-blank') + '">' +
      '<input type="text" class="np-e2-nr-name" value="' + String(val || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;') + '" placeholder="Name" spellcheck="false" autocomplete="off">' +
      '<span class="np-e2-nr-qty"><button type="button" class="np-e2-nr-qbtn" data-nr-q="-1" aria-label="One fewer">\u2212</button>' +
      '<input type="number" class="np-e2-nr-qn" value="' + q + '" min="1" inputmode="numeric" aria-label="Quantity of this name">' +
      '<button type="button" class="np-e2-nr-qbtn" data-nr-q="1" aria-label="One more">+</button></span>' +
      '<button type="button" class="np-e2-nr-del" aria-label="Remove name">\u00d7</button></div>';
  }
  function nrRenderRows() {
    /* the roster is one name per patch; the grid shows CONSECUTIVE repeats of
       a name as one row with a quantity, so a team of 12 "Smith"s is one row */
    var box = document.getElementById('np-e2-nr-rows');
    if (!box) return;
    var list = namesList(), grouped = [];
    list.forEach(function (nm) {
      var lastG = grouped[grouped.length - 1];
      if (lastG && lastG.name === nm) lastG.qty++;
      else grouped.push({ name: nm, qty: 1 });
    });
    /* no phantom spare row: "+ Add row" (or Enter) mints new ones — a
       permanent empty row with a live-looking qty read as a counted entry */
    box.innerHTML = grouped.length ? grouped.map(function (g) { return nrRowHTML(g.name, g.qty); }).join('') : nrRowHTML('', 1);
    nrWireRows(box);
  }
  function nrSync() {
    /* rows -> textarea -> everything else: each row expands to (qty) roster
       lines, so one patch per name stays literally true downstream. Empty
       rows stay OUT of the roster but their inputs stay on screen. */
    var box = document.getElementById('np-e2-nr-rows');
    var ta = document.getElementById('np-e2-names-ta');
    if (!box || !ta) return;
    var out = [];
    [].slice.call(box.querySelectorAll('.np-e2-nr-row')).forEach(function (row) {
      var nm = row.querySelector('.np-e2-nr-name').value.replace(/[\n,]+/g, ' ').trim();
      if (!nm) return;
      var qEl = row.querySelector('.np-e2-nr-qn');
      var q = Math.max(1, parseInt(qEl && qEl.value, 10) || 1);
      for (var i3 = 0; i3 < q; i3++) out.push(nm);
    });
    ta.value = out.join('\n');
    renderNames();
  }
  function nrWireRows(box) {
    $$('.np-e2-nr-name', box).forEach(function (inp) {
      inp.addEventListener('input', function () {
        this.closest('.np-e2-nr-row').classList.toggle('is-blank', !this.value.trim());
        nrSync();
        /* the live preview follows the row being typed, like the caret does */
        var v2 = this.value.trim();
        if (v2) { st.namePreview = v2; try { renderMaskPreview(); } catch (eGP) {} }
      });
      inp.addEventListener('focus', function () {
        var v3 = this.value.trim();
        if (v3) { st.namePreview = v3; try { renderMaskPreview(); } catch (eGF) {} }
      });
      inp.addEventListener('keydown', function (ev2) {
        /* Enter walks down the roster, minting a fresh row from the last one */
        if (ev2.key !== 'Enter') return;
        ev2.preventDefault();
        var rows2 = [].slice.call(box.querySelectorAll('.np-e2-nr-name'));
        var at = rows2.indexOf(this);
        if (at === rows2.length - 1) { nrAddRow(); }
        else rows2[at + 1].focus();
      });
    });
    $$('.np-e2-nr-qbtn', box).forEach(function (qb) {
      qb.addEventListener('click', function () {
        var qn = this.parentElement.querySelector('.np-e2-nr-qn');
        var v4 = Math.max(1, (parseInt(qn.value, 10) || 1) + parseInt(this.getAttribute('data-nr-q'), 10));
        qn.value = v4;
        nrSync();
        var nmQ = this.closest('.np-e2-nr-row').querySelector('.np-e2-nr-name').value.trim();
        if (nmQ) { st.namePreview = nmQ; try { renderMaskPreview(); } catch (eQP) {} }
      });
    });
    $$('.np-e2-nr-qn', box).forEach(function (qn) {
      ['input', 'change'].forEach(function (evQ) {
        qn.addEventListener(evQ, function () {
          if (this.value !== '' && (parseInt(this.value, 10) || 0) < 1) this.value = 1;
          nrSync();
        });
      });
      qn.addEventListener('blur', function () { if (!this.value) { this.value = 1; nrSync(); } });
    });
    $$('.np-e2-nr-del', box).forEach(function (del) {
      del.addEventListener('click', function () {
        var row = this.closest('.np-e2-nr-row');
        var only = box.querySelectorAll('.np-e2-nr-row').length === 1;
        if (only) {
          /* the grid never goes empty — the last row clears instead */
          row.querySelector('.np-e2-nr-name').value = '';
          var qq = row.querySelector('.np-e2-nr-qn'); if (qq) qq.value = 1;
          row.classList.add('is-blank');
          nrSync();
          return;
        }
        row.remove(); /* filled or empty alike */
        nrSync();
        nrRenderRows(); /* neighbours that now touch regroup into one row */
      });
    });
  }
  function nrAddRow() {
    var box = document.getElementById('np-e2-nr-rows');
    if (!box) return;
    box.insertAdjacentHTML('beforeend', nrRowHTML(''));
    nrWireRows(box);
    var all = box.querySelectorAll('.np-e2-nr-name');
    all[all.length - 1].focus();
  }
  (function () {
    var addB = document.getElementById('np-e2-nr-add');
    if (addB) addB.addEventListener('click', nrAddRow);
    $$('.np-e2-nr-tab').forEach(function (t) {
      t.addEventListener('click', function () { nrPane(this.getAttribute('data-nr-tab')); });
    });
  })();
  var namesCsvBtn = document.getElementById('np-e2-names-csv');
  var namesCsvFile = document.getElementById('np-e2-names-csvfile');
  if (namesCsvBtn && namesCsvFile) {
    namesCsvBtn.addEventListener('click', function (evD) {
      /* the template link inside the dropzone downloads — it never opens the picker */
      if (evD.target && evD.target.closest && evD.target.closest('.np-e2-nr-tpl')) return;
      namesCsvFile.click();
    });
    namesCsvBtn.addEventListener('dragover', function (evO) { evO.preventDefault(); this.classList.add('is-drag'); });
    namesCsvBtn.addEventListener('dragleave', function () { this.classList.remove('is-drag'); });
    namesCsvBtn.addEventListener('drop', function (evP) {
      evP.preventDefault();
      this.classList.remove('is-drag');
      try {
        if (evP.dataTransfer && evP.dataTransfer.files && evP.dataTransfer.files.length) {
          namesCsvFile.files = evP.dataTransfer.files;
          namesCsvFile.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } catch (eDD) {}
    });
    namesCsvFile.addEventListener('change', function () {
      var fC = this.files && this.files[0];
      if (!fC) return;
      var noteC = document.getElementById('np-e2-names-csvnote');
      var rd = new FileReader();
      rd.onload = function () {
        var names = parseNamesCsv(String(rd.result || ''));
        var taC = document.getElementById('np-e2-names-ta');
        if (!names.length) {
          if (noteC) { noteC.textContent = 'No names found in ' + fC.name; noteC.classList.remove('is-ok'); }
          return;
        }
        if (taC) {
          var curC = taC.value.trim();
          /* appended, never replaced — typed names survive the upload */
          taC.value = (curC ? curC + '\n' : '') + names.join('\n');
          taC.dispatchEvent(new Event('input', { bubbles: true }));
        }
        if (noteC) {
          noteC.textContent = names.length + ' name' + (names.length === 1 ? '' : 's') + ' added from ' + fC.name;
          noteC.classList.add('is-ok');
        }
        var firstN = namesList()[0];
        if (firstN) { st.namePreview = firstN; try { renderMaskPreview(); } catch (eNP2) {} }
        /* the customer should SEE what the file became — flip to the grid */
        try { nrPane('grid'); } catch (eNG) {}
      };
      rd.onerror = function () { if (noteC) { noteC.textContent = 'Could not read ' + fC.name; noteC.classList.remove('is-ok'); } };
      rd.readAsText(fC);
      this.value = ''; /* same file can be picked again */
    });
  }
  var namesTaE = document.getElementById('np-e2-names-ta');
  if (namesTaE) {
    namesTaE.addEventListener('input', renderNames);
    namesTaE.addEventListener('change', renderNames);
  }
  for (var iTT = 1; iTT <= 3; iTT++) {
    (function (elTT) {
      if (!elTT) return;
      elTT.addEventListener('input', function () { ttSync(); });
      elTT.addEventListener('change', function () { ttSync(); });
    })(document.getElementById('np-e2-tt-l' + iTT));
  }
  $$('[data-tt-seg]').forEach(function (segB) {
    segB.addEventListener('click', function () {
      var grp = this.getAttribute('data-tt-seg');
      var val = this.getAttribute('data-tt-val');
      if (grp === 'fmt') st.ttFormat = val; else { st.ttStitch = val; st.ttStitchSeen = true; }
      $$('[data-tt-seg="' + grp + '"]').forEach(function (b2) {
        b2.classList.toggle('is-on', b2 === segB);
      });
      ttSync();
    });
  });
  $$('[data-tt-lay]').forEach(function (selL) {
    selL.addEventListener('change', function () {
      var vL = this.value;
      var wasSlant = false;
      $$('[data-tt-lay]').forEach(function (s2) { if (/slant/i.test(s2.value)) wasSlant = true; });
      st['ttLay' + this.getAttribute('data-tt-lay')] = vL;
      /* a slant is a property of the whole BLOCK, not one line: the lines
         have to stay parallel, so they all tilt (or un-tilt) together */
      if (/slant/i.test(vL) || wasSlant) {
        $$('[data-tt-lay]').forEach(function (s3) {
          s3.value = vL;
          st['ttLay' + s3.getAttribute('data-tt-lay')] = vL;
        });
      }
      ttSync();
    });
  });
  [2, 3].forEach(function (nH) {
    var bH = document.getElementById('np-e2-tt-half' + nH);
    if (!bH) return;
    bH.addEventListener('click', function () {
      st['ttHalf' + nH] = !st['ttHalf' + nH];
      this.classList.toggle('is-on', !!st['ttHalf' + nH]);
      this.setAttribute('aria-pressed', st['ttHalf' + nH] ? 'true' : 'false');
      ttSync();
    });
  });
  var stitchHeadE = document.getElementById('np-e2-tt-stitchhead');
  if (stitchHeadE) stitchHeadE.addEventListener('click', function () {
    var bodyS = document.getElementById('np-e2-tt-stitchbody');
    ttStitchOpen(bodyS ? bodyS.hidden : true);
  });
  var stitchContE = document.getElementById('np-e2-tt-stitchcont');
  if (stitchContE) stitchContE.addEventListener('click', function () {
    st.ttStitchSeen = true;
    ttStitchOpen(false);
    var headB = document.querySelector('.np-e2-accrow[data-e2-acc="5"] [data-e2-acchead]');
    if (headB) {
      headB.click();
      setTimeout(function () {
        var rowB = headB.closest('.np-e2-accrow');
        var yB = rowB.getBoundingClientRect().top + window.pageYOffset - npScrollPad();
        window.scrollTo({ top: Math.max(0, yB), behavior: 'smooth' });
      }, 120);
    }
  });
  var letterContE = document.getElementById('np-e2-tt-lettercont');
  if (letterContE) letterContE.addEventListener('click', function () {
    ttLetterOpen(false);
    try { ttSync(false); } catch (eLC) {}
    var firstHead = document.querySelector('#np-e2-step-options .np-e2-accrow:not([hidden]) [data-e2-acchead]');
    if (firstHead) {
      firstHead.click();
      var rowF = firstHead.closest('.np-e2-accrow');
      setTimeout(function () {
        var yF = rowF.getBoundingClientRect().top + window.pageYOffset - npScrollPad();
        window.scrollTo({ top: Math.max(0, yF), behavior: 'smooth' });
      }, 120);
    }
  });
  function doModeSwitch(m) {
    /* NOTE: switching tabs does NOT write the mode memory — only ADDING TO
       CART does (see armClassicAddMemory + the builder's cart POSTs) */
    if (m === 'classic') {
      /* hand off to the legacy flow WITH the artwork: its reuse path reads
         everything after "file=", so that param must stay LAST */
      var artC = cleanUrl(artworkUrl() || '');
      var baseC = location.pathname + '?np_mode=classic' + (artC ? '&file=' + encodeURIComponent(artC) : '');
      markModeJump('Switching to Classic Order Mode');
      showPageLoader('Switching to Classic Order Mode');
      location.href = baseC;
      return;
    }
    var artA = cleanUrl(artworkUrl() || '') || legacyArtworkUrl();
    if (document.body.classList.contains('np-e2-classic')) {
      /* the builder never booted on this page load — come back through a
         clean AI arrival carrying the artwork */
      markModeJump('Switching to AI Order Mode');
      showPageLoader('Switching to AI Order Mode');
      location.href = location.pathname + '?np_mode=ai' + (artA ? '&file=' + encodeURIComponent(artA) : '');
      return;
    }
    activate();
    paintModeSwitch();
  }
  var modeConfirmEl = null;
  function openModeConfirm(m) {
    /* our own dialog, in the builder's voice — never window.confirm — and it
       shows EVERY time: switching always restarts the design on the other
       flow, whether or not anything has been chosen yet */
    if (!modeConfirmEl) {
      modeConfirmEl = document.createElement('div');
      modeConfirmEl.className = 'np-e2-ov np-e2-ov--fcc';
      modeConfirmEl.innerHTML = '<div class="np-e2-modal np-e2-modal--fcc">' +
        '<header class="np-e2-modal__head"><div><span class="np-e2-modal__eyebrow np-e2-fcc-eyebrow">SWITCH ORDER MODE?</span>' +
        '<h3 class="np-e2-modal__title" data-mc-title></h3></div></header>' +
        '<div class="np-e2-modal__body"><p class="np-e2-fcc-txt" data-mc-txt></p></div>' +
        '<footer class="np-e2-modal__foot"><button type="button" class="np-e2-btn np-e2-btn--outline" data-mc-stay>Stay here</button>' +
        '<div class="np-e2-modal__footright"><button type="button" class="np-e2-btn np-e2-btn--green" data-mc-go></button></div></footer></div>';
      /* NOT inside #np-e2 — that whole tree is display:none in classic mode,
         and this dialog has to open from both sides of the switch */
      document.body.appendChild(modeConfirmEl);
      modeConfirmEl.querySelector('[data-mc-stay]').addEventListener('click', function () { modeConfirmEl.hidden = true; });
      modeConfirmEl.addEventListener('click', function (ev) { if (ev.target === modeConfirmEl) modeConfirmEl.hidden = true; });
      modeConfirmEl.querySelector('[data-mc-go]').addEventListener('click', function () {
        modeConfirmEl.hidden = true;
        doModeSwitch(modeConfirmEl.getAttribute('data-mc-mode') || 'ai');
      });
    }
    modeConfirmEl.setAttribute('data-mc-mode', m);
    var toClassic = m === 'classic';
    modeConfirmEl.querySelector('[data-mc-title]').textContent = toClassic
      ? 'Switch to Classic Order Mode?' : 'Switch to AI Order Mode?';
    modeConfirmEl.querySelector('[data-mc-txt]').innerHTML = toClassic
      ? 'Your uploaded image comes with you, but <b>any selections made here will be cleared</b> \u2014 you\u2019ll start fresh in the classic order form.'
      : 'Your uploaded image comes with you, but <b>any selections made in the classic form will be cleared</b> \u2014 you\u2019ll start fresh in the AI designer.';
    modeConfirmEl.querySelector('[data-mc-go]').textContent = toClassic
      ? 'Switch to Classic' : 'Switch to AI Mode';
    modeConfirmEl.hidden = false;
  }
  $$('#np-e2-modeswitch .np-e2-modebtn[data-e2-mode]').forEach(function (bM) {
    bM.addEventListener('click', function () {
      var m = this.getAttribute('data-e2-mode');
      if (m !== 'ai' && m !== 'classic') return;
      /* compare against the PAGE's actual mode, not the stored preference */
      var curM = document.body.classList.contains('np-e2-classic') ? 'classic' : 'ai';
      if (m === curM) return;
      openModeConfirm(m);
    });
  });
  if (window.matchMedia) {
    /* the tabs sit in a different place in one column than in two, so they
       have to be re-placed when the layout flips (rotate / resize) */
    var mqCol = window.matchMedia('(max-width: 1120px)');
    var onCol = function () { try { paintModeSwitch(); } catch (eC) {} };
    if (mqCol.addEventListener) mqCol.addEventListener('change', onCol);
    else if (mqCol.addListener) mqCol.addListener(onCol);
  }
  var mswRsz = null;
  window.addEventListener('resize', function () {
    /* classic alignment is measured, not styled — re-measure when settled */
    clearTimeout(mswRsz);
    mswRsz = setTimeout(function () { try { paintModeSwitch(); } catch (eR) {} }, 180);
  });
  var letterHeadE = document.getElementById('np-e2-tt-letterhead');
  if (letterHeadE) letterHeadE.addEventListener('click', function () {
    var bodyL = document.getElementById('np-e2-tt-letterbody');
    ttLetterOpen(bodyL ? bodyL.hidden : true);
    try { ttSync(false); } catch (eL) {}
  });
  var swSelE = document.getElementById('np-e2-tt-swstyle');
  if (swSelE) {
    TT_SWOOSHES.forEach(function (sw) {
      var o = document.createElement('option');
      o.value = String(sw.n); o.textContent = '#' + sw.n + ' \u2014 ' + sw.name;
      swSelE.appendChild(o);
    });
    swSelE.value = '1'; /* Classic Tail */
    swSelE.addEventListener('change', function () { st.swooshStyle = this.value; ttSync(); });
  }
  var swColE = document.getElementById('np-e2-tt-swtxtcolor');
  if (swColE) swColE.addEventListener('change', function () { ttSync(); });
  var swTxtE = document.getElementById('np-e2-tt-swtxt');
  if (swTxtE) {
    swTxtE.addEventListener('input', function () { ttSync(); });
    swTxtE.addEventListener('change', function () { ttSync(); });
  }
  var swTT = document.getElementById('np-e2-tt-swoosh');
  if (swTT) swTT.addEventListener('click', function () {
    st.swoosh = !st.swoosh;
    var swEl = this.querySelector('.np-e2-switch');
    if (swEl) swEl.classList.toggle('is-on', st.swoosh);
    this.setAttribute('aria-pressed', st.swoosh ? 'true' : 'false');
    ttSync();
  });
  var namesAtcE = document.getElementById('np-e2-names-atc');
  if (namesAtcE) namesAtcE.addEventListener('click', function () {
    /* the button is disabled under the minimum, but re-check here: paste +
       submit can outrun the input event on some mobile keyboards */
    renderNames();
    if (namesList().length < namesMin()) {
      var errB = document.getElementById('np-e2-names-err');
      if (errB) { errB.hidden = false; errB.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      return;
    }
    doCheckout();
  });
  var stitchTgl = document.getElementById('np-e2-stitch-toggle');
  if (stitchTgl) stitchTgl.addEventListener('click', function () {
    st.stitchAddon = !st.stitchAddon;
    st.proofMode = st.stitchAddon ? 'stitch' : 'digital';
    var prefS = st.stitchAddon ? 'REAL STITCHOUT REQUESTED ($19.99)' : 'DIGITAL PROOF (no AI render)';
    setProp('_Proof Preference', prefS);
    var swS = this.querySelector('.np-e2-switch');
    if (swS) swS.classList.toggle('is-on', st.stitchAddon);
    this.setAttribute('aria-pressed', st.stitchAddon ? 'true' : 'false');
    setProp('_Proof Approval', proofApprovalLabel());
    if (sensei.added) {
      lineSync({ '_Proof Preference': prefS, '_Proof Approval': proofApprovalLabel() });
      if (st.stitchAddon && !st.__stitchCharged) { st.__stitchCharged = true; adjustStitchLine(1); }
      else if (!st.stitchAddon && st.__stitchCharged) { st.__stitchCharged = false; adjustStitchLine(-1); }
    }
    npToast(st.stitchAddon ? '\u2713 Real stitchout added ($19.99 in cart)' : 'Real stitchout removed');
  });
  $$('[data-e2-stitchtip]').forEach(function (tipS) {
    tipS.addEventListener('click', function (e) { e.stopPropagation(); e.preventDefault(); tipS.classList.toggle('is-open'); });
  });
  $('#np-e2-another').addEventListener('click', addAnother);
  var szCoBtn = $('#np-e2-sz-checkout');
  if (szCoBtn) szCoBtn.addEventListener('click', function () {
    if (pdpPricingOn() && !st.proofApproved) {
      /* on-page step 3: Continue hands off to the proof choice below */
      var poF = document.getElementById('np-e2-proof-options');
      if (poF) {
        poF.scrollIntoView({ behavior: 'smooth', block: 'center' });
        poF.classList.add('np-e2-flash');
        setTimeout(function () { poF.classList.remove('np-e2-flash'); }, 1200);
      }
      return;
    }
    /* Continue: back to the page — the approved summary owns Add to Cart
       and Add-another */
    pf.hidden = true;
    try { renderApprovedCanvas(); } catch (eRc) {}
    var ap = document.getElementById('np-e2-approved');
    if (ap) { ap.hidden = false; ap.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  });
  var szAnother = $('#np-e2-sz-another'); if (szAnother) szAnother.addEventListener('click', addAnother);
  var szReview = $('#np-e2-sz-review');
  if (szReview) szReview.addEventListener('click', function (e) {
    /* back to the review phase — swap versions or regenerate, then approve
       again to return to sizing */
    e.preventDefault();
    pf.hidden = false;
    st.proofPhase = 'ready';
    renderProofReady();
  });
  var delM = $('#np-e2-delconfirm');
  $('#np-e2-delete').addEventListener('click', function () { delM.hidden = false; });
  $('#np-e2-del-go').addEventListener('click', function () {
    var qs = window.location.search
      .replace(/[?&]file=[^&]*/g, '')
      .replace(/[?&]np_added=[^&]*/g, '')
      .replace(/^&/, '?');
    if (qs && qs[0] !== '?') qs = '?' + qs;
    window.location.href = window.location.pathname + qs;
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-e2-close="del"]')) delM.hidden = true;
    else if (e.target === delM) delM.hidden = true;
  });
  $('#np-e2-zoom').addEventListener('click', function () {
    /* zoom = the SAME preview they're looking at, in the lightbox */
    function showInBox(src) {
      if (!src) return;
      $('#np-e2-zoombox-img').src = src;
      var pv = $('#np-e2-zoomprev'), nx = $('#np-e2-zoomnext'), cap = $('#np-e2-zoomcap');
      if (pv) pv.hidden = true;
      if (nx) nx.hidden = true;
      if (cap) cap.hidden = true;
      zb.hidden = false;
    }
    if (st.proofApproved && st.versions.length) {
      zbShow((st.selected === null || st.selected === undefined) ? st.versions.length - 1 : st.selected);
      return;
    }
    var g = shapeGeom();
    /* typed products (names, tackle twill) have no artwork URL — their preview
       IS the composition, so the lightbox always shows the composed frame */
    if ((st.shape && g !== 'custom') || PTYPE.textPreview || PTYPE.textLines) {
      composePatchImage(function (cv) {
        showInBox(cv ? cv.toDataURL('image/png') : (applyToggleParams(cleanUrl(artworkUrl()) || '') || ''));
      });
    } else {
      showInBox(applyToggleParams(cleanUrl(artworkUrl()) || '') || '');
    }
  });
  /* ---- Patch Size Guide modal: preferred sizes by placement, tap to apply ---- */
  var GUIDE_SIZES = [
    ['Hat Square/Circle Patch', 2],
    ['Hat Rectangle Patch', 4],
    ['Front Left Chest Shirt', 4],
    ['Sleeve', 3],
    ['Back Neckline', 3]
  ];
  function renderSizeGuide() {
    var rows = document.getElementById('np-e2-guide-rows');
    if (!rows) return;
    var pv = nearestVariant();
    /* match on WIDTH: Apply sets the width, so the badge must compare width or
       the row you just applied would never read as Current. */
    var cur = Math.round(st.w * 100) / 100;
    rows.innerHTML = GUIDE_SIZES.map(function (r) {
      var on = Math.abs(cur - r[1]) < 0.01;
      return '<div class="np-e2-guide__row" data-e2-guide="' + r[1] + '"><span>' + r[0] + '</span>' +
        '<span class="np-e2-guide__size"><b>' + r[1] + ' inches</b><em class="' + (on ? 'is-cur' : '') + '">' + (on ? 'Current' : 'Apply') + '</em></span></div>';
    }).join('');
  }
  var sg = $('#np-e2-sizeguide');
  if (sg) sg.addEventListener('click', function (e) {
    e.preventDefault();
    renderSizeGuide();
    var m = document.getElementById('np-e2-sizeguide-m');
    if (m) m.hidden = false;
  });

  /* any open builder overlay locks background scroll */
  (function () {
    function sync() {
      var anyOpen = $$('.np-e2-ov').some(function (ov) { return !ov.hidden; });
      document.body.classList.toggle('np-e2-modal-open', anyOpen);
    }
    /* B92 (2026-08-25) — COALESCE THE BODY OBSERVER. This is a childList +
       subtree observer on document.body, so it fired on EVERY DOM change
       anywhere on the page and ran a querySelectorAll each time. During an add
       (which mutates a lot of DOM) that is a storm of short callbacks — none
       over 50ms, so longtask never reports them, while the event loop starves.
       Measured symptom: a 250ms interval degrading 743,1311,2051,3112,5587,
       8458,13690,27496ms while longestTask stayed at 148ms and the thread
       looked "idle". Collapse every burst into ONE sync per animation frame;
       behaviour is identical, the work is bounded. */
    var moPend = false;
    var moSched = function () {
      if (moPend) return;
      moPend = true;
      var run = function () { moPend = false; sync(); };
      if (window.requestAnimationFrame) requestAnimationFrame(run); else setTimeout(run, 16);
    };
    var mo = new MutationObserver(moSched);
    /* subtree: dynamically created overlays (photo/FC/fine-detail popups)
       must lock background scroll too */
    mo.observe(document.body, { attributes: true, attributeFilter: ['hidden'], subtree: true, childList: true });
    sync();
  })();

  /* ---- boot: wait for the legacy upload signal.
     body.image-uploaded fires only on real dropzone events; the ?file=
     reuse path (second uploads, My Designs, ordering modal) never adds
     it. #uploadArea gaining .hidden is the reliable post-upload marker
     on BOTH paths (see np-upload-signal notes), so watch both. ---- */
  function classicHasFile() {
    /* the upload box ships with its own artwork illustration, so "is there an
       image in there" is not the question — only the flow's own state says
       whether a customer file has landed. The hidden property field counts
       ONLY during a ?file= handoff: the legacy uploader RESTORES the previous
       session's upload into that input on a fresh visit, which was showing
       the mode tabs under the carousel before any upload happened. */
    /* while the upload/review card is open (mid-upload progress included)
       the flow is not settled — no tabs yet */
    if (document.querySelector('.uploaded-file.uploaded-file--open')) return false;
    if (uploadedNow()) return true;
    if (!/[?&]file=/.test(location.search)) return false;
    var f = document.querySelector('input[name="properties[_Upload]"], input[name="properties[_cartImg]"]');
    return !!(f && f.value);
  }
  function classicReady() {
    return document.body.classList.contains('np-e2-classic') && classicHasFile();
  }
  function uploadedNow() {
    if (document.body.classList.contains('image-uploaded')) return true;
    var ua = document.getElementById('uploadArea');
    return !!(ua && ua.classList.contains('hidden'));
  }
  /* ═══ ORDER MODE ══════════════════════════════════════════════════════
     Uploading products offer the customer a choice BEFORE they upload: the new
     AI flow (default) or the classic one. Nothing changes until a file lands —
     at that moment AI activates this builder and Classic simply stands down
     and lets the legacy post-upload UI run untouched. Typed products (custom
     names, tackle twill) have no upload, so they never show the switch. */
  function modeEligible() { return !PTYPE.noArt; }
  /* The choice sticks: whichever mode they used last is the one the next
     product opens in. Safe now that BOTH modes carry the tabs — an accidental
     Classic click is one click to undo, on any product. */
  var MODE_PREF = 'np_order_mode';
  function storedMode() {
    try {
      var v = (localStorage.getItem(MODE_PREF) || '').toLowerCase();
      return (v === 'classic' || v === 'ai') ? v : '';
    } catch (e) { return ''; }
  }
  function rememberMode(m) {
    try { localStorage.setItem(MODE_PREF, m === 'classic' ? 'classic' : 'ai'); } catch (e) {}
  }
  function orderMode() {
    if (!modeEligible()) return 'ai';
    if (NP_FORCE_CLASSIC) return 'classic'; /* live kill-switch: see flag */
    var pM = new URLSearchParams(location.search);
    var q = (pM.get('np_mode') || '').toLowerCase();
    if (q === 'classic' || q === 'ai') return q;           /* this page said so */
    /* a link INTO the builder — an approved proof, a Mockup Lab handoff, a
       reorder, a 2.0 template by name — outranks a stored classic preference */
    if (pM.get('np_proof') || pM.get('np_src') === 'ml' || pM.get('np_reorder')) return 'ai';
    if (/2-0$/.test(pM.get('view') || '')) return 'ai';
    return storedMode() || 'ai';
  }
  /* ── mode handoff ───────────────────────────────────────────────────
     Changing mode is a full page load (the legacy flow only picks the
     artwork up on arrival), which by default dumps the customer at the top
     of a page that then rearranges itself under them. Instead the tabs'
     on-screen position rides across in sessionStorage and the new page is
     held behind the loader until it has been seated back there. */
  var MODE_JUMP = 'np_mode_jump';
  function markModeJump(msg) {
    try {
      var w = document.getElementById('np-e2-modeswitch');
      var vy = w && !w.hidden ? Math.round(w.getBoundingClientRect().top) : 140;
      sessionStorage.setItem(MODE_JUMP, String(Math.max(60, Math.min(vy, 320))) + '|' + (msg || ''));
    } catch (e) {}
  }
  function settleModeJump() {
    var raw = null;
    try { raw = sessionStorage.getItem(MODE_JUMP); sessionStorage.removeItem(MODE_JUMP); } catch (e) { return; }
    if (raw === null) return;
    var vy = parseInt(raw, 10); if (isNaN(vy)) vy = 140;
    var msgJ = String(raw).split('|').slice(1).join('|');
    try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e2) {}
    /* the OLD page's message stays up while the new page settles — one
       continuous "Switching…" from click to landing, not a bare spinner */
    showPageLoader(msgJ || 'Loading your design\u2026');
    /* the head-level veil OWNS the whole transition now (one loader style
       start to finish) — it removes itself when every loader below is done,
       so it is NOT removed here */
    var ovJ = document.getElementById('np-e2-pageloader');
    if (ovJ) ovJ.setAttribute('data-jump', '1');
    function release() {
      /* only ever take down the veil we raised — another flow may have put
         its own loader up in the meantime */
      var o = document.getElementById('np-e2-pageloader');
      if (o && o.getAttribute('data-jump') === '1') { o.removeAttribute('data-jump'); o.hidden = true; }
    }
    /* the loader may only come down when the DESTINATION flow is actually on
       screen — the legacy uploader shows its own textless spinner while it
       consumes ?file=, and releasing on scroll-stability alone left the
       customer staring at that bare ring with no words under it */
    var hasFileP = /[?&]file=/.test(location.search);
    function destinationReady() {
      if (document.body.classList.contains('np-e2-classic')) return !hasFileP || classicHasFile();
      return !hasFileP || document.body.classList.contains('np-e2-active');
    }
    var tries = 0, landed = 0, lastY = -1, stable = 0;
    function anchorEl() {
      /* the tabs are the anchor once they are on the page; until then (classic
         is still consuming file=, AI is still booting) the flow's own top edge
         stands in for them, so the page never sits at scroll 0 waiting */
      var w = document.getElementById('np-e2-modeswitch');
      if (w && !w.hidden) return w;
      return document.querySelector('.shopify-section[id$="__main"] .np-upload-tabs')
        || document.getElementById('uploadArea')
        || document.getElementById('np-e2-step-customize')
        || document.querySelector('.shopify-section[id$="__main"] .product-actions');
    }
    function land() {
      var w = anchorEl();
      if (w) {
        landed++;
        var want = Math.max(0, Math.round(w.getBoundingClientRect().top + window.pageYOffset - vy));
        window.scrollTo(0, want);
        var after = w.getBoundingClientRect().top;
        /* whatever grew above them, the customer has to land looking AT the
           tabs — never off the top of the screen */
        if (after < 8) { window.scrollBy(0, Math.round(after - 12)); want = Math.round(window.pageYOffset); }
        stable = Math.abs(want - lastY) <= 4 ? stable + 1 : 0;
        lastY = want;
      }
      tries++;
      /* artwork and the legacy step boxes arrive late and shove everything
         below them — re-seat until the position stops moving AND the flow is
         genuinely up (classic has its file / the builder is active) */
      if (((landed && stable >= 2) || tries >= 12) && destinationReady()) { release(); return; }
      if (tries >= 90) { release(); return; } /* ~25s hard cap — never trap */
      setTimeout(land, landed ? 250 : 150);
    }
    requestAnimationFrame(land);
    setTimeout(release, 26000); /* absolute failsafe behind the in-loop cap */
  }
  function paintModeSwitch() {
    var wrap = document.getElementById('np-e2-modeswitch');
    if (!wrap) return;
    if (NP_FORCE_CLASSIC) { wrap.hidden = true; return; } /* no AI option shown on live */
    var classicOn = document.body.classList.contains('np-e2-classic');
    var aiOn = document.body.classList.contains('np-e2-active');
    /* the choice belongs AFTER the upload — before one there is nothing to
       switch between. In CLASSIC the switch has to live outside the (hidden)
       builder, above the legacy flow, or they could never come back. AI
       requires REAL artwork in the builder (st.versions) — np-e2-active alone
       fires pre-upload on 2.0 templates where the legacy #uploadArea is
       hidden by design, which painted the tabs under the carousel before any
       upload. While hidden, keep re-checking so the tabs appear the moment
       a file lands. */
    var aiHasArt = false;
    try { aiHasArt = (st.versions || []).some(function (vA) { return !!(vA && (vA.hosted || vA.dataUrl || vA.alpha)); }); } catch (eHA) {}
    if (!aiHasArt) {
      /* fresh uploads live in the preview canvas before any version exists */
      var aImg = document.getElementById('np-e2-artimg');
      var aR = aImg ? aImg.getBoundingClientRect() : null;
      aiHasArt = !!(aImg && aImg.src && aImg.naturalWidth > 0 && aR && aR.width > 0);
      if (!aiHasArt && aImg && aImg.src && aImg.naturalWidth > 0) {
        /* LEATHER (Circle default) composes immediately, hiding the raw art
           img behind the composed preview — the visible canvas counts as
           artwork or the tabs never appear (2026-08-21 regression) */
        var cvV = document.getElementById('np-e2-canvas');
        aiHasArt = !!(cvV && cvV.getBoundingClientRect().width > 0);
      }
    }
    /* belt AND suspenders: beyond having artwork, the builder's DESIGN UI must
       be visibly on screen — while the upload panel is what the customer sees
       (pre-upload, any flow, any restored state) the tabs stay gone */
    var designUi = document.querySelector('.np-e2__main')
      || document.getElementById('np-e2-step-customize')
      || document.getElementById('np-e2-step-options');
    var dRect = designUi ? designUi.getBoundingClientRect() : null;
    var designUp = !!(dRect && dRect.width > 0 && dRect.height > 80);
    var aiReady = aiOn && aiHasArt && designUp;
    if (!modeEligible() || (!aiReady && !classicReady())) {
      wrap.hidden = true;
      if (modeEligible() && !paintModeSwitch.__rearm) {
        paintModeSwitch.__rearm = setTimeout(function () {
          paintModeSwitch.__rearm = null;
          try { paintModeSwitch(); } catch (eRA) {}
        }, 900);
      }
      return;
    }
    /* the tabs are a design-page control: once the customer is at Size &
       Pricing / the approved review page, switching flows would throw that
       work away — the choice is over, so the tabs leave with it. They return
       only if Edit selections brings the design page back. */
    if (aiOn && (st.proofApproved || st.proofPhase === 'sizing'
        || document.body.classList.contains('np-e2-approved-view'))) { wrap.hidden = true; return; }
    var host = classicOn
      ? (document.querySelector('.shopify-section[id$="__main"] .np-upload-tabs')
         || document.getElementById('uploadArea')
         || document.querySelector('.shopify-section[id$="__main"] .product-text'))
      : (document.querySelector('.np-e2__main')
         || document.getElementById('np-e2-step-customize') || document.getElementById('np-e2-step-options'));
    if (classicOn) {
      /* the tabs leave the ordering column entirely and sit ABOVE the product
         grid, so the carousel and the ordering flow start on the same line —
         then they are shoved right to line up with the ordering column */
      var gridC = document.querySelector('.shopify-section[id$="__main"] .grid--layout');
      var colC = document.querySelector('.shopify-section[id$="__main"] .product-text');
      if (gridC && gridC.parentNode && colC) {
        if (wrap.nextElementSibling !== gridC) gridC.parentNode.insertBefore(wrap, gridC);
        var dxC = Math.max(0, Math.round(colC.getBoundingClientRect().left - gridC.getBoundingClientRect().left));
        wrap.style.marginLeft = dxC ? dxC + 'px' : '';
        wrap.style.maxWidth = dxC ? Math.round(colC.getBoundingClientRect().width) + 'px' : '';
      } else if (host && host.parentNode) {
        var targetC = host.closest('.np-upload-tabs') || host;
        if (wrap.nextElementSibling !== targetC) targetC.parentNode.insertBefore(wrap, targetC);
      }
    } else {
      if (host && host.parentNode && wrap.nextElementSibling !== host) host.parentNode.insertBefore(wrap, host);
      /* same treatment as classic: the tabs fill the dead strip above the
         grid, starting where the options column starts; the two cards below
         keep one shared top line. (The grid is zoomed, so the measured visual
         offset converts back to local px before it becomes a margin.) */
      var colA = document.querySelector('.np-e2-rightcol');
      var mainA = document.querySelector('.np-e2__main');
      var dxA = 0, zA = 1;
      if (colA && mainA) {
        try { zA = parseFloat(getComputedStyle(document.querySelector('.np-e2__grid')).zoom) || 1; } catch (eZ) {}
        dxA = Math.max(0, Math.round((colA.getBoundingClientRect().left - mainA.getBoundingClientRect().left) / zA));
      }
      wrap.style.marginLeft = dxA ? dxA + 'px' : '';
      wrap.style.maxWidth = dxA && colA ? Math.round(colA.getBoundingClientRect().width / zA) + 'px' : '';
    }
    wrap.classList.toggle('np-e2-modeswitch--classic', classicOn);
    wrap.hidden = false;
    var cur = classicOn ? 'classic' : 'ai';
    $$('[data-e2-mode]', wrap).forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-e2-mode') === cur);
      b.setAttribute('aria-pressed', b.getAttribute('data-e2-mode') === cur ? 'true' : 'false');
    });
  }
  function classicStitchOffer() {
    /* CLASSIC MODE proof choice, above "Upload another patch" — ONLY where a
       physical stitchout exists (embroidery family, full color, leather,
       faux leather); every other patch type gets NO proof section in classic.
       Clicking a card SELECTS it (click again to unselect — never disables,
       never navigates); the cart action happens on the page's own Add to
       Cart: stitch = Stitchout: Yes property + the $19.99 line added first,
       none = straight through, no selection = blocked with a nudge. */
    var CST_STITCH_TYPES = ['embroidery-2-0', '3demb-2-0', 'fullcolor-2-0', 'leather-2-0', 'fauxleather-2-0',
      'print-and-stitch-2-0'];  /* 2026-08-25 Justin: P&S is embroidery + print, a real stitchout exists */
    if (CST_STITCH_TYPES.indexOf(TYPE_KEY) === -1 || !CFG.stitchVid) return;
    var host = document.querySelector('.shopify-section[id$="__main"] .second-upload-cta');
    if (!host || !host.parentNode || document.getElementById('np-cst')) return;
    /* the upload box sits inside a FLEX ROW (.flex-buttons) — the card goes
       ABOVE the whole row, full width, never beside the box */
    if (host.parentElement && /flex-buttons/.test(host.parentElement.className || '')) host = host.parentElement;
    var card = document.createElement('div');
    card.id = 'np-cst';
    card.className = 'np-cst';
    card.innerHTML = '<b class="np-cst__title">Select Your Proof Option</b>' +
      '<p class="np-cst__sub">Choose how you\u2019d like to approve your design before it goes into production.</p>' +
      '<div class="np-cst__btns">' +
      '<button type="button" class="np-cst__opt" data-cst="none"><span class="np-cst__opt-top"><b>No Proof</b><em class="np-cst__badge np-cst__badge--free">FREE</em><em class="np-cst__badge np-cst__badge--pop">Most Popular</em></span><i>Go straight to production</i></button>' +
      '<button type="button" class="np-cst__opt" data-cst="stitch"><span class="np-cst__opt-top"><b>Physical Stitchout</b><em class="np-cst__badge">$19.99</em></span><i>A real sample patch, emailed for your approval \u2014 adds 2\u20134 business days</i></button>' +
      '</div>';
    host.parentNode.insertBefore(card, host);
    /* the legacy uploader re-renders this area (size/qty edits) and REPLACES
       the card — restore the customer's previous choice on the new copy.
       First render PRESELECTS No Proof (FREE · Most Popular). */
    if (!classicStitchOffer.__pick) classicStitchOffer.__pick = 'none';
    var rP = card.querySelector('[data-cst="' + classicStitchOffer.__pick + '"]');
    if (rP) rP.classList.add('is-on');
    function setLineProp(nameP, valP) {
      var form = document.querySelector('.shopify-section[id$="__main"] form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      var inp = form.querySelector('input[name="properties[' + nameP + ']"]');
      if (valP == null) { if (inp && inp.parentNode) inp.parentNode.removeChild(inp); return; }
      if (!inp) {
        inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = 'properties[' + nameP + ']';
        form.appendChild(inp);
      }
      inp.value = valP;
    }
    function picked() {
      /* ALWAYS resolve the live card — a stale closure over a replaced card
         froze the checkout lock on "greyed out" even with everything chosen */
      var cNow = document.getElementById('np-cst');
      var on = cNow && cNow.querySelector('[data-cst].is-on');
      return on ? on.getAttribute('data-cst') : '';
    }
    /* the Add to Cart greys out until a proof option is chosen — the capture
       gate below still hard-blocks, this is the visual cue */
    function paintAtcGate() {
      var lock = !picked() || (typeof window.NP_CO_MISSING === 'function' && window.NP_CO_MISSING() > 0);
      ['button.add-to-cart', '.second-upload-cta'].forEach(function (selG) {
        var elG = document.querySelector('.shopify-section[id$="__main"] ' + selG) || document.querySelector(selG);
        if (elG) elG.classList.toggle('np-e2-atc-locked', lock);
      });
    }
    /* classic ALWAYS ships a _Proof Approval — one or the other */
    if (classicStitchOffer.__pick === 'stitch') setLineProp('_Proof Approval', 'Stitchout Needed');
    else if (classicStitchOffer.__pick === 'none') setLineProp('_Proof Approval', 'Digital Proof Approved');
    paintAtcGate();
    if (!classicStitchOffer.__tick) {
      classicStitchOffer.__tick = setInterval(function () {
        if (document.getElementById('np-cst')) paintAtcGate();
      }, 1200);
    }
    card.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('[data-cst]');
      if (!b) return;
      var was = b.classList.contains('is-on');
      $$('[data-cst]', card).forEach(function (x) { x.classList.remove('is-on'); });
      if (!was) b.classList.add('is-on');
      card.classList.remove('np-cst--nudge');
      if (picked() === 'stitch') {
        setLineProp('_Proof Approval', 'Stitchout Needed'); /* same property AI mode writes */
        npToast('Physical stitchout will be added with your patch ($19.99)');
      } else if (picked() === 'none') {
        setLineProp('_Proof Approval', 'Digital Proof Approved'); /* No Proof = the digital preview IS the approval */
      } else {
        setLineProp('_Proof Approval', null); /* deselected — the gate forces a re-pick */
      }
      classicStitchOffer.__pick = picked();
      paintAtcGate();
    });
    /* gate the page's Add to Cart (capture, before the theme handler):
       no choice = nudge; stitch = add the $19.99 line, THEN let it through */
    var cstBusy = false;
    if (classicStitchOffer.__gate) return;
    classicStitchOffer.__gate = 1;
    document.addEventListener('click', function (ev) {
      var go = ev.target.closest && ev.target.closest('.shopify-section[id$="__main"] button.add-to-cart, .second-upload-cta');
      if (!go || !document.getElementById('np-cst')) return;
      if (go.getAttribute('data-np-cst-ok') === '1') { go.removeAttribute('data-np-cst-ok'); return; }
      var isSecondUp = !(go.matches && go.matches('button.add-to-cart'));
      var pick = picked();
      if (!ev.isTrusted) {
        /* programmatic clicks are the theme's own pipelines (the second-upload
           flow adds the current design via $('.anotherTransfer').click()).
           NEVER block or defer those — swallowing that click ate the add and
           bounced the customer back to the product page with an empty cart.
           If a stitchout is selected, add its line in parallel instead. */
        if (pick === 'stitch') { try { adjustStitchLine(1); } catch (eBG) {} }
        return;
      }
      if (!pick) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        var cN = document.getElementById('np-cst') || card;
        cN.classList.add('np-cst--nudge');
        try { cN.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (eSV) { cN.scrollIntoView(); }
        npToast('Please select a proof option first');
        return;
      }
      /* "Upload another patch" with a proof chosen proceeds untouched — the
         pipeline's own programmatic add picks the stitch line up in parallel */
      if (isSecondUp) return;
      /* a REAL checkout click: disarm any leftover second-upload machinery —
         a zombie cart-count poll from an earlier "upload another" watches for
         ANY count change and yanks the customer back to the product page
         (?np_added reload = "white screen then right back to the options") */
      try { window.__npLastUploadedFilePath = null; window.__npSecondUploadRedirect = false; } catch (eZP) {}
      if (pick === 'stitch') {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        if (cstBusy) return;
        cstBusy = true;
        setLineProp('_Proof Approval', 'Stitchout Needed');
        var passed = false;
        var pass = function () {
          if (passed) return;
          passed = true;
          cstBusy = false;
          /* the legacy uploader may have REPLACED the button while the stitch
             line was being added — a click on a detached node goes nowhere */
          var goNow = (go && go.isConnected) ? go : (document.querySelector('.shopify-section[id$="__main"] button.add-to-cart') || go);
          goNow.setAttribute('data-np-cst-ok', '1');
          goNow.click();
        };
        var pr = null;
        try { pr = adjustStitchLine(1); } catch (eAS) {}
        if (pr && pr.then) pr.then(pass, pass); else pass();
        /* a hung cart call must never strand the customer — proceed anyway */
        setTimeout(pass, 7000);
      }
      /* pick === 'none' -> fall through untouched */
    }, true);
  }
  /* ═══ SPEC SHEET ═══════════════════════════════════════════════════════
     The proof image production opens should BE the build sheet: the patch
     render on the left, every attribute used to build it on the right.
     Composed in-browser at order time from the line's own properties, so it
     adapts to whatever options each patch type carries, and uploaded through
     the same pipeline as frozen proofs (dk-token naming keeps the portal's
     purchased-matching intact). Rides as _AI Proof in BOTH modes. */
  var SPEC_EXCLUDE = { '_Upload': 1, 'upload': 1, '_upload': 1, '_Original Image': 1, '_cartImg': 1,
    '_AI Proof': 1, '_Preview Image': 1, '_Order Mode': 1, '_Proof Approval': 1, '_AI Proof Status': 1,
    '_AI Proof Revisions': 1, '_Revision Notes': 1, '_Remove Background': 1, '_Crop & Trim': 1,
    '_discount_input': 1, '_discount_name': 1, '_upsell': 1, 'Design Notes': 1, '_Design Notes': 1,
    'reorder': 1, 'design re-used': 1, 'AI Edit': 1,
    /* C05 (2026-08-25, Justin): keep _AI Model OFF the printed sheet. It stays
       on the ORDER for the A/B engine attribution — this only stops it being
       drawn in the spec panel, which is customer/production facing. */
    '_AI Model': 1, 'AI Model': 1 };
  function specFormProps() {
    var out = {};
    var form = document.querySelector('product-form.product-form form') || document.querySelector('form[action*="/cart/add"]');
    if (!form) return out;
    [].slice.call(form.querySelectorAll('input[name^="properties["], textarea[name^="properties["]')).forEach(function (el) {
      if (el.disabled) return;
      if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) return;
      var m = /^properties\[(.+)\]$/.exec(el.name || '');
      if (!m) return;
      var v = (el.value || '').trim();
      if (v) out[m[1]] = v;
    });
    return out;
  }
  function specLines(props) {
    var lines = [];
    /* the sheet leads with WHAT the patch is — the patch type from the
       product itself (Embroidered, Printed, Leather, ...) */
    var ptN = (PTYPE && PTYPE.name) || '';
    if (!ptN && TYPE_KEY) ptN = String(TYPE_KEY).replace(/-2-0$/, '').replace(/-/g, ' ').replace(/\b[a-z]/g, function (mC) { return mC.toUpperCase(); });
    if (ptN) lines.push(['Patch Type', ptN]);
    var wV = props['_Width (in)'] || props['Width (in)'] || '';
    var hV = props['_Height (in)'] || props['Height (in)'] || '';
    if (wV) lines.push(['Width (in)', wV]);
    if (hV) lines.push(['Height (in)', hV]);
    Object.keys(props).forEach(function (k) {
      if (SPEC_EXCLUDE[k]) return;
      if (/width \(in\)|height \(in\)/i.test(k)) return;
      var v = String(props[k]);
      if (!v || v.indexOf('://') > -1 || v.length > 48) return;
      lines.push([k.replace(/^_+/, '').replace(/\s+$/, ''), v]);
    });
    return lines;
  }
  function specNotes(props) {
    /* revision notes ride onto the sheet as their own wrapped block */
    return String(props['_AI Proof Revisions'] || props['_Revision Notes'] || '').trim();
  }
  function composeSpec(imgUrl, lines, notes, cb) {
    if (typeof notes === 'function') { cb = notes; notes = ''; }
    notes = String(notes || '').trim();
    /* vector uploads (PDF/AI/EPS) can't load into an <img> — rasterize
       through imgix for the SHEET ONLY; the order keeps the true file
       (PATCH-2106506: a PDF upload shipped with no build sheet) */
    if (/\.(pdf|ai|eps)$/i.test(String(imgUrl || '').split('?')[0])) {
      var vU = toImgixHost(imgUrl);
      imgUrl = vU + (vU.indexOf('?') > -1 ? '&' : '?') + 'fm=png&w=1200';
    }
    /* the sheet draws the patch at <=720px — decoding the FULL multi-MB
       render just to downscale it blocked the main thread for seconds
       (B40). imgix serves a 1440px rendition instead. */
    if (/imgix/.test(String(imgUrl)) && !/[?&]w=/.test(String(imgUrl))) {
      imgUrl += (String(imgUrl).indexOf('?') > -1 ? '&' : '?') + 'w=1440';
    }
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var LH = 92, W = 1640;
        /* pre-wrap the notes so the canvas is tall enough for them */
        var probeN = document.createElement('canvas').getContext('2d');
        probeN.font = '400 34px -apple-system, "Segoe UI", sans-serif';
        var noteW = W - 870 - 40, noteLines = [];
        if (notes) {
          notes.split(/\n+/).forEach(function (para) {
            var words = para.split(/\s+/), cur = '';
            words.forEach(function (wd) {
              var t2 = cur ? cur + ' ' + wd : wd;
              if (probeN.measureText(t2).width > noteW && cur) { noteLines.push(cur); cur = wd; }
              else cur = t2;
            });
            if (cur) noteLines.push(cur);
          });
          if (noteLines.length > 10) { noteLines = noteLines.slice(0, 10); noteLines[9] += '\u2026'; }
        }
        var notesH = noteLines.length ? (90 + noteLines.length * 48) : 0;
        var H = Math.max(880, 200 + lines.length * LH + notesH);
        var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
        var x = cv.getContext('2d');
        x.fillStyle = '#ffffff'; x.fillRect(0, 0, W, H);
        /* C15 (2026-08-25, Justin: "make sure the rulers dont override the
           images") — the LEFT GUTTER has to hold the height ruler AND its
           chip. It was 70px; the chip alone is ~100px wide and is centred on
           the ruler line, so its right half landed on top of the render (and
           its left half ran off the canvas). Reserve 150px and take it out of
           the render box so the art still clears the spec column at x=870. */
        var box = 650, bx = 150, by = (H - box) / 2;
        var sc = Math.min(box / im.naturalWidth, box / im.naturalHeight);
        var dw = im.naturalWidth * sc, dh = im.naturalHeight * sc;
        x.drawImage(im, bx + (box - dw) / 2, by + (box - dh) / 2, dw, dh);
        /* measuring rulers hug the DRAWN patch on the sheet itself (Justin
           2026-08-24): bounds scanned from the composed pixels by distance
           from the white backdrop (soft shadows stay excluded), chips carry
           the order's true Width/Height. Applies to AI and digital sheets. */
        try {
          var wVal = '', hVal = '';
          lines.forEach(function (lnV) {
            if (/^width/i.test(String(lnV[0]))) wVal = String(lnV[1]);
            if (/^height/i.test(String(lnV[0]))) hVal = String(lnV[1]);
          });
          if (!wVal && typeof st !== 'undefined' && st && st.w) wVal = st.w.toFixed(2);
          if (!hVal && typeof st !== 'undefined' && st && st.h) hVal = st.h.toFixed(2);
          if (wVal || hVal) {
            var ix0 = Math.round(bx + (box - dw) / 2), iy0 = Math.round(by + (box - dh) / 2);
            var IW = Math.max(2, Math.round(dw)), IH = Math.max(2, Math.round(dh));
            var dd = x.getImageData(ix0, iy0, IW, IH).data;
            var cI = [0, (IW - 1) * 4, ((IH - 1) * IW) * 4, ((IH - 1) * IW + (IW - 1)) * 4];
            var rB = 0, gB = 0, bB2 = 0;
            cI.forEach(function (ci) { rB += dd[ci]; gB += dd[ci + 1]; bB2 += dd[ci + 2]; });
            rB /= 4; gB /= 4; bB2 /= 4;
            var mnX = IW, mxX = -1, mnY = IH, mxY = -1;
            var stp = Math.max(1, Math.round(IW / 360));
            for (var yy2 = 0; yy2 < IH; yy2 += stp) {
              for (var xx2 = 0; xx2 < IW; xx2 += stp) {
                var i5 = (yy2 * IW + xx2) * 4;
                if ((Math.abs(dd[i5] - rB) + Math.abs(dd[i5 + 1] - gB) + Math.abs(dd[i5 + 2] - bB2)) > 90) {
                  if (xx2 < mnX) mnX = xx2; if (xx2 > mxX) mxX = xx2;
                  if (yy2 < mnY) mnY = yy2; if (yy2 > mxY) mxY = yy2;
                }
              }
            }
            if (mxX > mnX && mxY > mnY) {
              x.save();
              var pX0 = ix0 + mnX, pX1 = ix0 + mxX + stp, pY0 = iy0 + mnY, pY1 = iy0 + mxY + stp;
              x.font = '700 30px -apple-system, "Segoe UI", sans-serif';
              x.textAlign = 'center'; x.textBaseline = 'middle';
              var tick = function (x1, y1, x2, y2) { x.beginPath(); x.moveTo(x1, y1); x.lineTo(x2, y2); x.stroke(); };
              var chip = function (cx2, cy2, txt) {
                var tw = x.measureText(txt).width + 26;
                x.fillStyle = '#ffffff'; x.lineWidth = 2;
                x.beginPath();
                if (x.roundRect) x.roundRect(cx2 - tw / 2, cy2 - 22, tw, 44, 8); else x.rect(cx2 - tw / 2, cy2 - 22, tw, 44);
                x.fill(); x.stroke();
                x.fillStyle = '#131715';
                x.fillText(txt, cx2, cy2 + 1);
              };
              x.strokeStyle = '#131715';
              if (wVal) {
                /* C15 — 24 keeps the chip's top (wy-22) on the canvas */
                var wy = Math.max(24, pY0 - 42);
                x.lineWidth = 3;
                tick(pX0, wy, pX1, wy); tick(pX0, wy - 12, pX0, wy + 12); tick(pX1, wy - 12, pX1, wy + 12);
                chip((pX0 + pX1) / 2, wy, wVal + '"');
              }
              if (hVal) {
                /* C15 — the chip is centred ON the line, so half of it sticks
                   out sideways. Park the line so the chip's RIGHT edge stops
                   short of the render instead of covering it. The line itself
                   still spans pY0..pY1 exactly — the standing rule that a
                   ruler must hug the patch is about the SPAN, not the offset. */
                var hTxt = hVal + '"';
                var hTw = x.measureText(hTxt).width + 26;
                var hx = pX0 - (hTw / 2 + 14);
                if (hx - hTw / 2 < 10) hx = hTw / 2 + 10; /* never off the left edge */
                x.lineWidth = 3;
                tick(hx, pY0, hx, pY1); tick(hx - 12, pY0, hx + 12, pY0); tick(hx - 12, pY1, hx + 12, pY1);
                /* unreachable with the 150px gutter, but never draw a chip over
                   the art: an unlabelled ruler beats a covered render */
                if (hx + hTw / 2 < pX0 - 4) chip(hx, (pY0 + pY1) / 2, hTxt);
              }
              x.restore();
            }
          }
        } catch (eRul) {}
        x.fillStyle = '#131715';
        x.textBaseline = 'middle';
        /* shrink to fit the LONGEST line inside the text column */
        var avail = W - 870 - 40, fs = 44;
        x.font = '700 44px -apple-system, "Segoe UI", sans-serif';
        var widest = 0;
        lines.forEach(function (ln) { widest = Math.max(widest, x.measureText(ln[0] + ':  ' + ln[1]).width); });
        if (widest > avail) fs = Math.max(26, Math.floor(44 * avail / widest));
        x.font = '700 ' + fs + 'px -apple-system, "Segoe UI", sans-serif';
        var blockH = (lines.length - 1) * LH + notesH;
        var ty = H / 2 - blockH / 2;
        lines.forEach(function (ln, i) { x.fillText(ln[0] + ':  ' + ln[1], 870, ty + i * LH); });
        if (noteLines.length) {
          var ny = ty + (lines.length - 1) * LH + 110;
          x.font = '700 36px -apple-system, "Segoe UI", sans-serif';
          x.fillText('Revision Notes:', 870, ny);
          x.font = '400 34px -apple-system, "Segoe UI", sans-serif';
          noteLines.forEach(function (nl, i2) { x.fillText(nl, 870, ny + 60 + i2 * 48); });
        }
        cb(cv);
      } catch (eC) { cb(null); }
    };
    im.onerror = function () { cb(null); };
    im.src = imgUrl;
  }
  /* the freshness token baked into sheet filenames: art + size + the sheet's
     own content. If the customer changes ANY spec after the sheets were
     stamped (re-opening sizing, new border color...), the recomputed token
     stops matching and applySpecToLine recomposes — the PATCH-2106492 lesson:
     a stale sheet shipped 3.00" stats on a 4.00" line. */
  function specDkToken(lines) {
    /* B61: key off the ORIGINAL upload — stable for the whole session. It
       used to key off artworkUrl(), which the checkout's own _AI Proof write
       changes, so the token drifted at click time and every ready sheet was
       judged stale (beacon-proven: click dk != composer dk). */
    var artU = '';
    try {
      var oI = document.querySelector('input[name="properties[_Original Image]"]');
      artU = oI ? String(oI.value || '').split('?')[0] : '';
    } catch (eO) {}
    if (!artU) { try { artU = (cleanUrl(artworkUrl()) || '').split('?')[0]; } catch (eA) {} }
    if (!artU) {
      var upI = document.querySelector('input[name="properties[_Upload]"]');
      artU = upI ? (upI.value || '').split('?')[0] : '';
    }
    var wI = document.querySelector('input[name="properties[_Width (in)]"]');
    var hI = document.querySelector('input[name="properties[_Height (in)]"]');
    var dkSrc = artU + '|' + ((st && st.w) || (wI && wI.value) || 0) + 'x' + ((st && st.h) || (hI && hI.value) || 0) +
      '|' + (lines && lines.length ? lines.map(function (l) { return l.join(':'); }).join(';') : '');
    var dkH = 5381;
    for (var iH = 0; iH < dkSrc.length; iH++) dkH = ((dkH << 5) + dkH + dkSrc.charCodeAt(iH)) >>> 0;
    return dkH.toString(36);
  }
  function uploadSpec(cv, cb, lines) {
    try {
      cv.toBlob(function (blob) {
        if (!blob || typeof window.getPresignedUploadUrl !== 'function') { cb(null); return; }
        var name = 'ai-proof-' + (TYPE_KEY || 'patch') + '--spec-dk' + specDkToken(lines) + '-' + Date.now() + '-' + Math.floor(Math.random() * 10000) + '.png';
        window.getPresignedUploadUrl(name, 'image/png').then(function (p) {
          if (!p || !p.url) { cb(null); return; }
          npPut(p.url, blob).then(function (r2) {
            var uOut = r2 && r2.ok ? toImgixHost(p.sourceUrl || '') : null;
            if (uOut) uOut = uOut.replace(/([^:])\/\//g, '$1/');
            cb(uOut);
          }).catch(function () { cb(null); });
        }).catch(function () { cb(null); });
      }, 'image/png');
    } catch (eU) { cb(null); }
  }
  function makeSpecSheet(imgUrl, cb) {
    var fp = specFormProps();
    var lines = specLines(fp);
    if (!imgUrl || !lines.length) { cb(null); return; }
    composeSpec(imgUrl, lines, specNotes(fp), function (cv) {
      if (!cv) { cb(null); return; }
      uploadSpec(cv, cb, lines);
    });
  }
  function specForAI() {
    /* AI checkout: swap _AI Proof for the composed build sheet, then proceed.
       Any failure (image blocked, upload hiccup) falls back to the plain
       proof after 9s — checkout is never held hostage. */
    return new Promise(function (resolve) {
      var done = false;
      var fin = function () { if (!done) { done = true; resolve(); } };
      setTimeout(fin, 9000);
      try {
        var src = formProp('_AI Proof') || formProp('_cartImg') || formProp('_Preview Image') || formProp('_Upload') || '';
        if (!src) { fin(); return; }
        makeSpecSheet(src, function (u) {
          if (u) {
            specForAI.__url = u; /* applied to the LINE by applySpecToLine.
              NO form-level writes: stamping the form made artworkUrl()
              return the sheet, which leaked it into _Original Image */
          }
          fin();
        });
      } catch (eAll) { fin(); }
    });
  }
  function fireSheetStamp() {
    if (!NP_SPEC_SHEETS) return;  /* B70: build sheets disabled */

    /* B45 (the live-flow fix): the sheet stamp FIRES the instant both sheets
       are uploaded — no cart read before it, no response wait after it.
       Mutations commit server-side immediately on this store even when the
       response takes 30s, so firing IS finishing. Addressed by line INDEX
       (stable across Shopify's property re-keying), with the full property
       snapshot cached at the last authoritative write. */
    try {
      var pre = sensei.__preSheets, snap = sensei.__lineSnap;
      if (!pre || !snap || !sensei.added) return;
      if (!pre.ai && !pre.up) return;
      if ((pre.aiBase && !pre.ai) || (pre.upBase && !pre.up)) return; /* B53: fire only when complete */
      var fp = specFormProps();
      var linesF = specLines(fp);
      if (!linesF.length) return;
      var dkF = specDkToken(linesF);
      if (pre.dk !== dkF) return; /* sheets are stale for the current specs */
      if (sensei.__sheetsFiredDk === dkF) return; /* already fired */
      var props = mergedOrderProps();
      props['_Width (in)'] = st.w.toFixed(2);
      props['_Height (in)'] = st.h.toFixed(2);
      if (pre.ai) props['_AI Proof'] = pre.ai;
      var upSheet = pre.up || pre.ai;
      if (upSheet) props['_Upload'] = upSheet;
      if (digitalNoRender()) delete props['_AI Proof'];
      sensei.__sheetsFiredDk = dkF;
      try { coMark('sheet-fired'); } catch (eSf) {}
      cleanFetch()('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
        body: JSON.stringify({ line: snap.line, quantity: st.qty, properties: props })
      }).then(function (r) { return r.json(); }).then(function (c2) {
        try {
          var mine = ourCartLine(c2);
          if (mine) sensei.__lineSnap = { line: (c2.items || []).indexOf(mine) + 1, props: mine.properties || {} };
          coMark('sheet-landed');
        } catch (eSn) {}
      }).catch(function () { sensei.__sheetsFiredDk = null; /* retry-able */ });
    } catch (eFS) {}
  }
  function preComposeSheets() {
    if (!NP_SPEC_SHEETS) return;  /* B70: build sheets disabled */

    /* build sheets composed AHEAD of need (at approval and on every size
       settle) from CURRENT state — applySpecToLine then only stamps the
       ready URLs onto the line, so the Add-to-Cart grace covers one cart
       write instead of a canvas+upload race (Justin 2026-08-24: orders were
       still shipping plain proofs when the click beat the compose). */
    try {
      var fp = specFormProps();
      var lines = specLines(fp);
      if (!lines.length) { coMark('pre:no-lines'); return; }
      var wantDk = specDkToken(lines);
      var avSp = (st.selected !== null && st.selected !== undefined) ? st.versions[st.selected] : (st.versions.length ? st.versions[st.versions.length - 1] : null);
      var aiBase = (avSp && !avSp.digital) ? String(avSp.alpha || avSp.frozenProof || avSp.hosted || '') : '';
      /* DIGITAL lane (B41): the LOCAL compose data URL is a legitimate sheet
         base when the hosted clean copy has not landed yet. */
      var upBase = String(sensei.composedCleanUrl || '') || ((avSp && avSp.digital && /^data:|^blob:/.test(String(avSp.dataUrl || '')) ? String(avSp.dataUrl) : '')) || aiBase;
      if (/--spec-dk/.test(aiBase)) aiBase = '';
      if (/--spec-dk/.test(upBase)) upBase = '';
      if (!aiBase && !upBase) { coMark('pre:no-base' + (avSp ? (avSp.digital ? ':dig' : ':ai') : ':nover')); return; }
      var pre = sensei.__preSheets;
      /* B64: `&& !pre.__capped` — a run whose jobs were capped (see mk below)
         left this object in place with ai/up still null. Without this clause
         every later attempt for the same token short-circuits here as "fresh"
         and that configuration can NEVER obtain a sheet again for the rest of
         the session. */
      if (pre && pre.dk === wantDk && pre.aiBase === aiBase && pre.upBase === upBase && !pre.__capped) return; /* already fresh */
      var notes = specNotes(fp);
      var mine = (sensei.__preSheets = { dk: wantDk, aiBase: aiBase, upBase: upBase, ai: null, up: null, wh: st.w.toFixed(2) + 'x' + st.h.toFixed(2) });
      coMark('pre:composing' + (aiBase ? '+ai' : '') + (upBase ? '+up' : '') + ':dk' + wantDk);
      /* C01 (2026-08-25): keep the exact props this sheet was composed from, so
         a later dkMatch:n can name WHICH field drifted instead of leaving us to
         guess. Both sheets compose fine (ai:y up:y) and are still rejected. */
      try {
        mine.snap = fp;
        /* C03 (2026-08-25): the fingerprint is artU | WxH | specLines, where
           artU is read from the DOM and W/H come from st.*, NOT from the form.
           A form-level diff therefore cannot see the real cause — C02 narrowed
           the drift to two URL fields that specLines already excludes, yet
           dkMatch stayed 'n'. Capture the ACTUAL components. */
        var oId = document.querySelector('input[name="properties[_Original Image]"]');
        mine.dbg = {
          a: oId ? String(oId.value || '').split('?')[0].slice(-28) : '(none)',
          w: String((st && st.w) || ''),
          h: String((st && st.h) || ''),
          l: lines.map(function (l) { return l.join(':'); }).join(';')
        };
      } catch (eSn) {}
      var mk = function (base, key) {
        /* HARD CAP (B64, 2026-08-25). composeSpec + uploadSpec sit behind FOUR
           unbounded awaits — the sheet base image load (no timer on im.src),
           cv.toBlob, getPresignedUploadUrl and the PUT. With none of them
           bounded, mine.ai / mine.up could stay null FOREVER, and the
           Add-to-Cart wait loop (doCheckout) has no state that could ever
           satisfy it: it then burns its whole cap and ships with no sheet.
           Live proof — two clicks of 14,544ms and 16,142ms in which NOT ONE of
           pre:ai-ok / pre:up-ok / pre:cv-null / pre:upload-fail was emitted,
           i.e. the jobs never reached any terminal state at all.
           Every job now settles exactly once, always leaves a mark, and a
           capped attempt is flagged so preComposeSheets may compose it again
           instead of short-circuiting on "already fresh". */
        var settled = false;
        var fin = function (u, mark) {
          if (settled) return;
          settled = true;
          try { coMark(mark); } catch (eM) {}
          if (u && sensei.__preSheets === mine) {
            mine[key] = u;
            try { fireSheetStamp(); } catch (eFk) {}
          } else if (!u && sensei.__preSheets === mine) {
            mine.__capped = true; /* allow a later attempt to retry this token */
          }
        };
        npTick(function () { fin(null, 'pre:cap:' + key); }, 6000);
        composeSpec(base, lines, notes, function (cv) {
          if (!cv) { fin(null, 'pre:cv-null:' + key); return; }
          uploadSpec(cv, function (u) {
            fin(u || null, u ? ('pre:' + key + '-ok') : ('pre:upload-fail:' + key));
          }, lines);
        });
      };
      if (aiBase) mk(aiBase, 'ai');
      if (upBase && upBase !== aiBase) mk(upBase, 'up');
    } catch (ePS) { try { coMark('pre:threw'); } catch (eT) {} }
  }
  function applySpecToLine() {
    if (!NP_SPEC_SHEETS) return Promise.resolve(null);  /* B70: build sheets disabled */

    /* tracked: doCheckout gives an IN-FLIGHT stamp a short bounded grace so
       orders never ship without their build sheets (Justin 2026-08-24) */
    var pSp = applySpecToLineInner();
    var reg = Promise.resolve(pSp).catch(function () {}).then(function () { if (sensei.__specBusy === reg) sensei.__specBusy = null; });
    sensei.__specBusy = reg;
    return pSp;
  }
  function applySpecToLineInner() {
    /* FINAL step of checkout: TWO build sheets composed from the LINE's own
       final properties — _AI Proof = the AI render + stats, _Upload = the
       customer's digital preview + stats (they are DIFFERENT base images).
       A line with only one base image (classic-style) rides one sheet on
       both. Verify-and-retry beats any late builder write. Capped so
       checkout is never held hostage. */
    return cartJson().then(function (cart) {
      var line = ourCartLine(cart);
      if (!line) return;
      var props = {};
      Object.keys(line.properties || {}).forEach(function (k) { props[k] = line.properties[k]; });
      var lines = specLines(props);
      var notes = specNotes(props);
      if (!lines.length) return;
      /* SESSION-OWNED bases ONLY (2026-08-21 PATCH-2106464 incident): the
         legacy uploader's restore can clobber the LINE's image props with a
         DIFFERENT session's artwork on converted-product arrivals — a real
         customer's build sheet composed with someone else's photo. st.versions
         and sensei.composedCleanUrl belong to THIS tab alone; when they are
         missing we skip the sheet rather than ever risk foreign art. */
      var avSp = (st.selected !== null && st.selected !== undefined) ? st.versions[st.selected] : (st.versions.length ? st.versions[st.versions.length - 1] : null);
      var aiBase = (avSp && !avSp.digital) ? String(avSp.alpha || avSp.frozenProof || avSp.hosted || '') : '';
      /* DIGITAL lane (B41): until the hosted clean copy lands there was NO
         base to compose the _Upload sheet from — fast checkouts shipped a
         plain preview forever. The LOCAL compose data URL is canvas-safe and
         identical in content, so it is the fallback base. */
      var upBase = String(sensei.composedCleanUrl || '') || ((avSp && avSp.digital && /^data:|^blob:/.test(String(avSp.dataUrl || '')) ? String(avSp.dataUrl) : '')) || aiBase;
      if (/--spec-dk/.test(aiBase)) aiBase = '';
      if (/--spec-dk/.test(upBase)) upBase = '';
      /* a sheet is only "done" when its dk token matches the CURRENT specs —
         a stale token (customer re-sized / re-colored after the first stamp)
         recomposes instead of shipping outdated stats (PATCH-2106492) */
      var wantDk = specDkToken(lines);
      var freshSheet = function (v) {
        var m = /--spec-dk([a-z0-9]+)-/.exec(String(v || ''));
        return !!m && m[1] === wantDk;
      };
      var needA = !!aiBase && !freshSheet(props['_AI Proof']);
      var needB = !!upBase && !freshSheet(props['_Upload']);
      if (!needA && !needB) { sensei.__sheetsDk = wantDk; return; }
      function sheet(base) {
        return new Promise(function (res) {
          var done = false;
          var fin = function (u) { if (!done) { done = true; res(u || null); } };
          setTimeout(function () { fin(null); }, 12000);
          composeSpec(base, lines, notes, function (cv) {
            if (!cv) { fin(null); return; }
            uploadSpec(cv, fin, lines);
          });
        });
      }
      var preS = sensei.__preSheets && sensei.__preSheets.dk === wantDk ? sensei.__preSheets : null;
      var preAi = preS && preS.ai && preS.aiBase === aiBase ? preS.ai : null;
      var preUp = preS && ((preS.up && preS.upBase === upBase) ? preS.up : (preS.ai && preS.aiBase === upBase ? preS.ai : null));
      var jobs = [
        needA ? (preAi ? Promise.resolve(preAi) : sheet(aiBase)) : Promise.resolve(null),
        needB ? (preUp ? Promise.resolve(preUp) : sheet(upBase)) : Promise.resolve(null)
      ];
      return Promise.all(jobs).then(function (r) {
        var uA = r[0], uB = r[1];
        if (!uA && !uB) return;
        function stamp(pObj) {
          var changed = false;
          if (uA && !freshSheet(pObj['_AI Proof'])) { pObj['_AI Proof'] = uA; changed = true; }
          var upSheet = uB || (!upBase ? uA : null); /* never the AI sheet when a digital base existed */
          if (upSheet && !freshSheet(pObj['_Upload'])) { pObj['_Upload'] = upSheet; changed = true; }
          return changed;
        }
        function write(l2, pObj) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ id: l2.key, quantity: l2.quantity, properties: pObj })
          });
        }
        var stChanged = stamp(props);
        sensei.__sheetsDk = wantDk;
        if (!stChanged) return;
        return write(line, props).then(function () {
          /* verify after the dust settles; one retry wins over late racers */
          return new Promise(function (res) { setTimeout(res, 1500); });
        }).then(function () { return cartJson(); }).then(function (c2) {
          var l2 = ourCartLine(c2);
          if (!l2) return;
          var p2 = {};
          Object.keys(l2.properties || {}).forEach(function (k) { p2[k] = l2.properties[k]; });
          if (stamp(p2)) return write(l2, p2);
        });
      });
    }).catch(function () {});
  }
  function classicVectorUpload() {
    /* vector uploads (PDF/AI/EPS): _Upload becomes the imgix RASTER (Justin
       2026-08-21 — production no longer needs the vector there); the true
       source file rides in _Original Image. Also lets the build sheet and
       the cart thumbnail actually render. */
    var upI = document.querySelector('input[name="properties[_Upload]"]');
    if (!upI || !upI.value || upI.value.indexOf('fm=png') > -1) return;
    var base = upI.value.split('?')[0];
    if (!/\.(pdf|ai|eps)$/i.test(base)) return;
    var form = upI.form || document.querySelector('form[action*="/cart/add"]');
    var oI = document.querySelector('input[name="properties[_Original Image]"]');
    if (form && (!oI || !oI.value)) {
      if (!oI) { oI = document.createElement('input'); oI.type = 'hidden'; oI.name = 'properties[_Original Image]'; form.appendChild(oI); }
      oI.value = base;
    }
    var vU = toImgixHost(upI.value);
    upI.value = vU + (vU.indexOf('?') > -1 ? '&' : '?') + 'fm=png';
  }
  function classicPhotoWatch() {
    /* CLASSIC photo gate (Justin 2026-08-21): a photograph uploaded on a
       stitched type gets the same at-upload warning as AI mode and moves to
       Full Color IN CLASSIC MODE, image riding in the URL. */
    if (classicPhotoWatch.__on) return;
    classicPhotoWatch.__on = 1;
    if (!photoGateOn()) return;
    var cpTries = 0;
    (function cpTick() {
      if (st.__photoNudged) return;
      var upIc = document.querySelector('input[name="properties[_Upload]"]');
      if (!(upIc && upIc.value && isUploadLineage(upIc.value))) { if (cpTries++ < 240) setTimeout(cpTick, 500); return; }
      /* WAIT FOR THE VISIBLE PREVIEW (Justin 2026-08-24): the _Upload property
         lands seconds before the hero image finishes loading, so the modal was
         popping over a still-blank page. Interrupt only once the customer can
         SEE their image (capped — a broken hero must not silence the gate). */
      var heroCp = document.getElementById('fileupload_hero');
      var heroReady = heroCp && heroCp.complete && heroCp.naturalWidth > 0 && heroCp.offsetParent !== null;
      if (!heroReady && cpTries < 230) { cpTries++; setTimeout(cpTick, 400); return; }
      if (!st.__artAnalyzed) {
        try { analyzeArtwork(); } catch (ePA2) { st.__artAnalyzed = true; }
        if (cpTries++ < 250) setTimeout(cpTick, 300);
        return;
      }
      if (fullColorLikely()) {
        st.__photoNudged = true;
        openUploadReco(
          'PHOTO OR HIGH-DETAIL IMAGE DETECTED',
          'Full Color will make this image look its best',
          'Good news \u2014 your image is packed with rich detail. Embroidery thread would soften the fine details that make it great, so a <b>Full Color Printed Patch</b> is the perfect fit \u2014 it captures every bit of your image, crisp and true to the original.',
          'Continue with Full Color',
          '/products/sublimated-patches',
          'classic'
        );
        return;
      }
      if (typeof fineDetailLikely === 'function' && fineDetailLikely() && PTYPE.fdGate) {
        /* same recommendation contract as AI mode, staying in classic */
        st.__photoNudged = true;
        openFdReco('classic');
      }
    })();
  }
  function classicRulers() {
    /* W/H arrow rulers on the classic preview — spanning EXACTLY the image
       box (classic prints the image as-is, border included), values live
       from the _Width/_Height inputs */
    var hero = document.getElementById('fileupload_hero');
    var host = hero && hero.closest('.easyzoom');
    var wrap = document.getElementById('np-cl-rulers');
    function hideR() { if (wrap) wrap.style.display = 'none'; }
    if (!hero || !host || !hero.complete || !hero.naturalWidth) { hideR(); return; }
    var iR = hero.getBoundingClientRect();
    if (iR.width < 40 || iR.height < 20) { hideR(); return; }
    var wV = (document.querySelector('input[name="properties[_Width (in)]"]') || {}).value || '';
    var hV = (document.querySelector('input[name="properties[_Height (in)]"]') || {}).value || '';
    if (!wV || !hV) { hideR(); return; }
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.id = 'np-cl-rulers';
      wrap.innerHTML = '<div class="np-cl-dim np-cl-dim--w"><b class="np-cl-dim__chip"></b></div>' +
                       '<div class="np-cl-dim np-cl-dim--h"><b class="np-cl-dim__chip"></b></div>';
    }
    if (wrap.parentElement !== host) { host.appendChild(wrap); }
    host.classList.add('np-cl-hasrulers');
    wrap.style.display = '';
    var hR = host.getBoundingClientRect();
    var x = iR.left - hR.left, y = iR.top - hR.top;
    var wd = wrap.children[0], hd = wrap.children[1];
    wd.style.left = Math.round(x) + 'px';
    wd.style.top = Math.round(y - 18) + 'px';
    wd.style.width = Math.round(iR.width) + 'px';
    hd.style.left = Math.round(x - 18) + 'px';
    hd.style.top = Math.round(y) + 'px';
    hd.style.height = Math.round(iR.height) + 'px';
    wd.querySelector('.np-cl-dim__chip').textContent = wV + '"';
    hd.querySelector('.np-cl-dim__chip').textContent = hV + '"';
  }
  setInterval(function () {
    if (document.body.classList.contains('np-e2-classic')) {
      try { classicPhotoWatch(); } catch (eCW2) {}
    }
  }, 1500); /* tab switches and np_mode reloads arm the photo gate too */

  function armClassicSpecSheet() {
    if (!NP_SPEC_SHEETS) return;  /* B70: build sheets disabled */

    if (armClassicSpecSheet.__on) return;
    armClassicSpecSheet.__on = 1;
    var upSig = '', busySp = false, lastSpecUrl = '';
    function upLineageOk(u) {
      /* the _Upload input must belong to THIS session: it matches the file
         we uploaded here, the file= arrival, or an attached proof's lineage.
         Foreign values (legacy-restore clobber) compose NO sheet at all. */
      u = String(u || '');
      if (!isUploadLineage(u)) return false; /* catalog/style asset — never */
      var own = String(window.__npLastUploadedFilePath || '');
      if (own && (u.indexOf(own.split('/').pop().split('?')[0]) > -1 || sameLineage(u, own))) return true;
      var fp = '';
      try { fp = new URLSearchParams(location.search).get('file') || ''; } catch (eF) {}
      if (fp && isUploadLineage(fp) && (u.split('?')[0].split('/').pop() === fp.split('?')[0].split('/').pop() || sameLineage(u, fp) || sameLineage(fp, u))) return true;
      var prI = document.querySelector('input[name="properties[_AI Proof]"]');
      if (prI && prI.value && /--spec-dk|____/.test(prI.value) && (sameLineage(u, prI.value) || sameLineage(prI.value, u))) return true;
      return !own && !fp; /* nothing to compare against — allow (plain classic upload flow) */
    }
    function currentSig() {
      var upI = document.querySelector('input[name="properties[_Upload]"]');
      if (!upI || !upI.value) return '';
      if (!upLineageOk(upI.value)) return '';
      if (typeof window.NP_CO_MISSING === 'function' && window.NP_CO_MISSING() > 0) return '';
      var cN = document.getElementById('np-cst');
      if (cN && !cN.querySelector('[data-cst].is-on')) return '';
      var lines = specLines(specFormProps());
      if (!lines.length) return '';
      return (upI.value || '').split('?')[0] + '|' + JSON.stringify(lines);
    }
    function refresh(cb) {
      var sig = currentSig();
      if (!sig || sig === upSig || busySp) { if (cb) cb(); return; }
      busySp = true;
      var upI = document.querySelector('input[name="properties[_Upload]"]');
      makeSpecSheet(upI.value, function (u) {
        busySp = false;
        if (u) {
          upSig = sig;
          lastSpecUrl = u; /* swapped into _Upload at the final trusted click */
        }
        /* CONTRACT (Justin 2026-08-21): _AI Proof means AN AI PROOF WAS
           GENERATED — classic mode has no such option, so classic must never
           submit one. The sheet rides on _Upload alone. Remove any stray
           _AI Proof input a prior build seeded in this session. */
        var strayAI = document.querySelector('form input[name="properties[_AI Proof]"]');
        if (strayAI && strayAI.parentNode) strayAI.parentNode.removeChild(strayAI);
        if (cb) cb();
      });
    }
    setInterval(function () { try { classicVectorUpload(); } catch (eCV) {} refresh(); }, 2500);
    try { classicVectorUpload(); } catch (eCV0) {}
    /* checkout guarantee: choices changed within the last moments → hold the
       click, refresh the sheet, then continue (marker bypasses the re-click) */
    document.addEventListener('click', function (ev) {
      if (!document.body.classList.contains('np-e2-classic')) return;
      var go = ev.target.closest && ev.target.closest('button.add-to-cart');
      if (!go) return;
      if (go.getAttribute('data-np-spec-ok') === '1') { go.removeAttribute('data-np-spec-ok'); return; }
      if (!ev.isTrusted) return;
      function swapUpload() {
        /* the FINAL trusted checkout also points _Upload at the sheet — done
           only now so nothing mid-flow (upload-another, reorders, artwork
           restores) ever reads the sheet as artwork */
        if (!lastSpecUrl) return;
        var uI = document.querySelector('input[name="properties[_Upload]"]');
        if (uI) uI.value = lastSpecUrl;
      }
      var sig = currentSig();
      if (!sig) return; /* gates will block this click anyway */
      if (sig === upSig) { swapUpload(); return; } /* sheet fresh — pass through */
      ev.preventDefault();
      ev.stopImmediatePropagation();
      var passed2 = false;
      var go2 = function () {
        if (passed2) return;
        passed2 = true;
        swapUpload();
        var goNow = go.isConnected ? go : document.querySelector('.shopify-section[id$="__main"] button.add-to-cart');
        if (goNow) { goNow.setAttribute('data-np-spec-ok', '1'); goNow.click(); }
      };
      setTimeout(go2, 9000);
      refresh(go2);
    }, true);
  }
  function armClassicAddMemory() {
    /* the mode PREFERENCE follows the last add-to-cart: any classic-mode
       Add to Cart / Proceed to Checkout click stamps 'classic' */
    if (armClassicAddMemory.__on) return;
    armClassicAddMemory.__on = 1;
    document.addEventListener('click', function (ev) {
      if (!document.body.classList.contains('np-e2-classic')) return;
      if (!(ev.target.closest && ev.target.closest('button.add-to-cart'))) return;
      rememberMode('classic');
      /* the same white "Adding your patch to the cart…" cover AI mode shows —
         raised only AFTER dispatch, so a validation block (preventDefault)
         never flashes it; it rides until the cart page navigation lands */
      setTimeout(function () {
        if (ev.defaultPrevented) return;
        if (document.getElementById('np-atc-veil')) return;
        var v = document.createElement('div');
        v.id = 'np-atc-veil';
        v.innerHTML = '<style>#np-atc-veil{position:fixed;inset:0;background:rgba(255,255,255,.97);z-index:2147483300;display:flex;align-items:center;justify-content:center}#np-atc-veil .in{display:flex;flex-direction:column;align-items:center;gap:14px}#np-atc-veil .sp{width:46px;height:46px;border-radius:50%;border:4px solid #d4f1e0;border-top-color:#1AA86C;animation:npATC .8s linear infinite}@keyframes npATC{to{transform:rotate(360deg)}}#np-atc-veil b{font:700 16px/1.4 -apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;color:#0f172a}</style>' +
          '<span class="in"><span class="sp"></span><b>Adding your patch to the cart\u2026</b></span>';
        document.body.appendChild(v);
        setTimeout(function () {
          var e2 = document.getElementById('np-atc-veil');
          if (e2 && e2.parentNode) e2.parentNode.removeChild(e2);
        }, 15000); /* failsafe if no navigation follows */
      }, 0);
    }, true);
  }
  function classicStepReveal() {
    /* THE ?file= ARRIVAL BUG: the legacy uploader consumes the handed-over
       file but never calls goToNextStep(), so the ENTIRE buy area (options,
       proof, upload-another, Proceed to checkout) stays inside .step__2.hidden
       — a hidden dead checkout and a scrambled-looking page. Once the file has
       genuinely landed and step 2 is still hidden, run the reveal ourselves. */
    if (classicStepReveal.__armed) return;
    classicStepReveal.__armed = 1;
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      var upI = document.querySelector('input[name="properties[_Upload]"]');
      var s2 = document.querySelector('.step__2.hidden');
      if (!s2) { clearInterval(iv); return; } /* already revealed */
      if (upI && upI.value && uploadedNow() && typeof window.goToNextStep === 'function') {
        clearInterval(iv);
        try { window.goToNextStep(); } catch (eGS) {}
      } else if (tries > 240) { clearInterval(iv); } /* ~2min cap */
    }, 500);
  }
  function stampOrderMode() {
    /* every patch order carries a hidden _Order Mode: AI | Classic property,
       seated directly ABOVE properties[_Upload] so it lands in that spot on
       the order. One input covers both flows: the classic submit posts the
       form natively and the AI checkout builds FormData from the same form. */
    var form = document.querySelector('product-form.product-form form') ||
      document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var upI = form.querySelector('input[name="properties[_Upload]"]');
    /* typed products (Custom Names, Tackle Twill) have no upload input but
       are ALWAYS AI — the builder root marks the patch flow */
    if (!upI && !document.getElementById('np-e2')) return;
    var inp = form.querySelector('input[name="properties[_Order Mode]"]');
    if (!inp) {
      inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = 'properties[_Order Mode]';
    }
    if (upI) { if (inp.nextElementSibling !== upI) upI.parentNode.insertBefore(inp, upI); }
    else if (!inp.parentNode) form.appendChild(inp);
    inp.value = document.body.classList.contains('np-e2-classic') ? 'Classic' : 'AI';
  }
  function bootWatch() {
    try { settleModeJump(); } catch (eJ) {}
    try { stampOrderMode(); } catch (eOM) {}
    if (!bootWatch.__omTick) {
      /* the legacy uploader re-renders the form area — keep the stamp seated,
         and re-seat at the exact moment of submission so the property always
         lands ABOVE _Upload regardless of late re-renders */
      bootWatch.__omTick = setInterval(function () { try { stampOrderMode(); } catch (eOM2) {} }, 1500);
      document.addEventListener('submit', function () { try { stampOrderMode(); } catch (eOM3) {} }, true);
      document.addEventListener('click', function (evOM) {
        if (evOM.target.closest && evOM.target.closest('button.add-to-cart, .anotherTransfer')) {
          try { stampOrderMode(); } catch (eOM4) {}
        }
      }, true);
    }
    /* CLASSIC arrival: the customer chose the old flow and we handed the page
       over with ?np_mode=classic…&file=<artwork>. Stand down before any of the
       arrival handling below, so the legacy reuse path consumes that file. */
    if (orderMode() === 'classic' && modeEligible()) {
      document.body.classList.add('np-e2-classic');
      paintModeSwitch();
      armClassicAddMemory();
      armClassicSpecSheet();
      try { classicPhotoWatch(); } catch (eCPW) {}
      try { classicStitchOffer(); } catch (eCS) {}
      if (/[?&]file=/.test(location.search)) classicStepReveal();
      /* arriving on classic by remembered preference means there may be no
         upload yet — the tabs stay off the page until the legacy flow has a
         file, exactly as they do on the AI side */
      if (!uploadedNow()) {
        var obsC = new MutationObserver(function () {
          if (!classicHasFile()) return;
          try { paintModeSwitch(); } catch (eO) {}
          obsC.disconnect();
        });
        obsC.observe(document.body, { attributes: true, attributeFilter: ['class'], subtree: true });
      }
      return;
    }
    /* Mockup Lab arrivals never see the upload screen: the proof modal's
       loading pane covers the page from first paint until the builder
       activates and the handoff opens Size & Pricing */
    try {
      var mlq = new URLSearchParams(window.location.search);
      if (mlq.get('np_src') === 'ml') {
        showProofLoading('Preparing your approved proof\u2026');
        var mlTtl0 = document.getElementById('np-e2-pf-title'); if (mlTtl0) mlTtl0.textContent = 'Preparing your approved proof';
        setTimeout(function () {
          /* safety valve: if the builder never activated (artwork failed to
             load), release the page instead of holding a dead overlay */
          document.documentElement.classList.remove('np-e2-ml-arrive');
          if (!document.body.classList.contains('np-e2-active')) pf.hidden = true;
        }, 30000);
      }
    } catch (eml) {}
    if (PTYPE.cta) {
      /* nothing is ever uploaded on this type, so the upload watcher below
         would never fire — the builder opens from its own call to action */
      var scB = document.getElementById('np-e2-startcta');
      var sbB = document.getElementById('np-e2-startbtn');
      if (sbB) sbB.textContent = PTYPE.cta;
      var stT = document.querySelector('#np-e2-startcta .np-e2-startcta__title');
      if (stT && PTYPE.ctaTitle) stT.textContent = PTYPE.ctaTitle;
      var stS = document.querySelector('#np-e2-startcta .np-e2-startcta__sub');
      if (stS && PTYPE.ctaSub) stS.textContent = PTYPE.ctaSub;
      if (scB) scB.hidden = false;
      if (sbB) sbB.addEventListener('click', function () {
        if (scB) scB.hidden = true;
        activate();
      });
      return;
    }
    /* CLASSIC: stand down completely — the legacy flow owns the page. The
       arrival paths above (file= reuse, np_proof) already returned, so our own
       links still open the builder regardless of the stored preference. */
    if (orderMode() === 'classic') {
      document.body.classList.add('np-e2-classic');
      paintModeSwitch();
      armClassicAddMemory();
      armClassicSpecSheet();
      try { classicPhotoWatch(); } catch (eCPW) {}
      try { classicStitchOffer(); } catch (eCS2) {}
      /* tabs + the AI-rendering card wait for the upload, same as the
         np_mode=classic arrival above */
      if (!uploadedNow()) {
        var obsC2 = new MutationObserver(function () {
          if (!classicHasFile()) return;
          try { paintModeSwitch(); } catch (eO2) {}
          try { classicStitchOffer(); } catch (eO3) {}
          obsC2.disconnect();
        });
        obsC2.observe(document.body, { attributes: true, attributeFilter: ['class'], subtree: true });
      }
      return;
    }
    /* np_proof arrival WITHOUT file= (the dashboard portal's My Mockups
       links omit it): the proof IS the session, so boot the builder directly
       instead of waiting on an upload signal that will never fire — the
       reorder branch in handleProofHandoff builds the version from np_proof
       alone (Justin 2026-08-24, PDP arrived dead from portal reorder links) */
    var bwQ = new URLSearchParams(location.search);
    if ((bwQ.get('np_proof') || '').indexOf('http') === 0 && !uploadedNow()) { activate(); return; }
    if (uploadedNow()) { activate(); return; }
    new MutationObserver(function (_m, obs) {
      if (uploadedNow()) { obs.disconnect(); activate(); }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'], subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootWatch);
  else bootWatch();

  /* Recover the UI after tab switches: background tabs throttle timers and
     some flows can leave the page in a half-rendered state. On return,
     re-assert the builder and never allow a visible proof overlay with
     neither of its states shown (= blank screen). */
  function npRecoverUI(why) {
    /* MOBILE RETURN RECOVERY (B65, 2026-08-25 — Justin: "on mobile I fill
       everything out, leave the browser, come back and it's frozen, then the
       whole screen goes blank").
       TWO defects fixed here.
       (1) EVERY step used to share ONE try block with the blank-screen guard
           LAST. A phone reclaims canvas memory while the tab is away, so
           renderOptions()/loadArt() can throw on return — and when they did,
           the guard that repairs a visible-but-empty proof overlay never ran.
           That is the blank screen. Each step is now isolated: no single
           failure can skip the repair.
       (2) It was bound to visibilitychange ONLY. Returning to a backgrounded
           mobile browser usually restores the page from the back/forward
           cache, where `pageshow` is the reliable signal and visibilitychange
           is often not delivered at all — so on mobile NONE of this ran. */
    try {
      /* CLASSIC MODE OWNS THE PAGE: the legacy flow has consumed the upload,
         so uploadedNow() is true — activating here layered the AI builder
         (which classic keeps display:none) over hideLegacy()'s hidden page,
         i.e. a tab-switch away and back BLANKED the whole product section. */
      if (document.body.classList.contains('np-e2-classic')) return;
      if (!document.body.classList.contains('np-e2-active')) { if (uploadedNow()) activate(); return; }
      root.hidden = false;
    } catch (eG) { console.error('[np-emb2] recover gate', eG); }
    /* a compose that froze mid-flight leaves __busy latched, and every later
       repaint is gated on it — clear it unconditionally on return (the 4s
       threshold in the other handler let a quick tab-switch stay stuck) */
    try {
      if (renderMaskPreview.__busy) {
        renderMaskPreview.__busy = false;
        renderMaskPreview.__again = false;
        maskPrevSeq++;
      }
    } catch (eB) {}
    try { renderPricing(); } catch (eP) { console.error('[np-emb2] recover pricing', eP); }
    try { renderOptions(); } catch (eO) { console.error('[np-emb2] recover options', eO); }
    try { loadArt(); } catch (eA) { console.error('[np-emb2] recover art', eA); }
    try {
      if (!pf.hidden) {
        var loadingShown = !$('#np-e2-pf-loading').hidden;
        var readyShown = !$('#np-e2-pf-ready').hidden;
        var szShown = $('#np-e2-pf-sizing') ? !$('#np-e2-pf-sizing').hidden : false;
        if (!loadingShown && !readyShown && !szShown) {
          if (st.proofPhase === 'sizing' && st.versions.length) { renderSizing(); }
          else if (st.versions.length) { st.proofPhase = 'ready'; renderProofReady(); }
          else if (st.proofPhase === 'loading') { $('#np-e2-pf-loading').hidden = false; }
          else pf.hidden = true;
        }
      }
    } catch (eV) { console.error('[np-emb2] recover overlay', eV); }
    /* last line of defence: an active builder must never come back hidden */
    try { if (document.body.classList.contains('np-e2-active') && root && root.hidden) root.hidden = false; } catch (eR) {}
    /* ANTI-BLANK WATCHDOG (B66, 2026-08-25 — Justin: "every time I leave Safari
       to go to another app and come back the whole screen is blank and wiped
       out on my iPhone").
       Leaving Safari for ANOTHER APP is not a tab switch: iOS suspends the page
       and, under memory pressure, throws away its rendering state. We can come
       back with hideLegacy()'s `np-e2-legacy-hidden` still applied to the whole
       product section while the builder itself has no laid-out height — which
       is a white void with no way out. If the builder is not actually painting,
       give the customer the real page back rather than nothing. Re-checked on a
       short delay too, because iOS restores layout asynchronously. */
    var npAntiBlank = function (tag) {
      try {
        var rb = root ? root.getBoundingClientRect() : null;
        var painting = !!(rb && rb.height > 40 && !root.hidden);
        if (painting) return;
        var hid = document.querySelectorAll('.np-e2-legacy-hidden');
        if (!hid.length) return;
        [].slice.call(hid).forEach(function (el) { el.classList.remove('np-e2-legacy-hidden'); });
        try { document.body.classList.remove('np-e2-active'); } catch (eC) {}
        console.warn('[np-e2] ANTI-BLANK(' + tag + '): builder not painting on return — restored ' + hid.length + ' hidden elements');
      } catch (eW) {}
    };
    npAntiBlank('now');
    setTimeout(function () { npAntiBlank('t600'); }, 600);
    setTimeout(function () { npAntiBlank('t2500'); }, 2500);
    try { console.log('[np-e2] UI recovered via', why); } catch (eL) {}
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    npRecoverUI('visibilitychange');
  });
  /* PROOF-REVEAL WATCHDOG (B67, 2026-08-25 — Justin: "render status comes back
     but it never takes me to the AI proof").
     A finished render pushes a version, but the reveal is gated on image
     preloads that can stall indefinitely on iOS. If a version EXISTS while the
     loading panel is still up, the render is done and the customer is simply
     being held behind a gate that will never open — so open it. */
  /* ON-DEVICE DIAGNOSTICS (B68, 2026-08-25). iOS Safari cannot be reproduced
     from the dev machine — the same flow passes in Chrome at 606px (inside the
     ≤767px mobile branch) but fails on a real iPhone. Add ?npdiag=1 to the PDP
     URL and this paints the live internal state over the loading panel so a
     screenshot from the phone shows exactly where the flow stops. Gated on the
     query param, so customers never see it. */
  try {
    if (/[?&]npdiag=1/.test(location.search)) {
      var dg = document.createElement('div');
      dg.style.cssText = 'position:fixed;left:0;right:0;bottom:0;z-index:2147483647;background:rgba(0,0,0,.88);color:#0f0;font:11px/1.35 ui-monospace,Menlo,monospace;padding:8px 10px;white-space:pre-wrap;max-height:44vh;overflow:auto;';
      document.addEventListener('DOMContentLoaded', function () { document.body.appendChild(dg); });
      if (document.body) document.body.appendChild(dg);
      setInterval(function () {
        try {
          var v = (st.versions || []).length;
          var lines = [
            'phase=' + String(st.proofPhase) + '  versions=' + v + '  approved=' + !!st.proofApproved,
            'session=' + (sensei.sessionId ? String(sensei.sessionId).slice(-10) : 'NONE') +
              '  cartTok=' + (sensei.cartToken ? 'yes' : 'NONE') +
              '  lineId=' + (sensei.lineItemId ? String(sensei.lineItemId).slice(-8) : 'none'),
            'composed=' + (sensei.composedUrl ? 'hosted' : (sensei.composedLocal ? 'localOnly' : 'NONE')) +
              '  busy=' + !!sensei.busy + '  added=' + !!sensei.added,
            'loading=' + (document.getElementById('np-e2-pf-loading') ? !document.getElementById('np-e2-pf-loading').hidden : '-') +
              '  ready=' + (document.getElementById('np-e2-pf-ready') ? !document.getElementById('np-e2-pf-ready').hidden : '-'),
            'errs=' + ((window.__npErrs || []).length ? (window.__npErrs || []).slice(-2).join(' ; ') : '0')
          ];
          dg.textContent = lines.join('\n');
        } catch (eD) { try { dg.textContent = 'diag error: ' + eD.message; } catch (eD2) {} }
      }, 1000);
      window.__npErrs = window.__npErrs || [];
      /* B73: "Script error." alone is useless — capture file/line and the real
         stack so a phone screenshot names the failing call. */
      window.addEventListener('error', function (e) {
        try {
          var f = String(e.filename || '').split('/').pop().split('?')[0];
          var st = (e.error && e.error.stack) ? String(e.error.stack).replace(/https?:\/\/[^ )]+\//g, '').replace(/\s+/g, ' ').slice(0, 150) : '';
          window.__npErrs.push('ERR ' + String(e.message).slice(0, 60) + ' @' + f + ':' + e.lineno + (st ? ' | ' + st : ''));
        } catch (x) {}
      });
      window.addEventListener('unhandledrejection', function (e) {
        try {
          var r = e.reason;
          var st = (r && r.stack) ? String(r.stack).replace(/https?:\/\/[^ )]+\//g, '').replace(/\s+/g, ' ').slice(0, 150) : '';
          window.__npErrs.push('REJ ' + String((r && r.message) || r).slice(0, 70) + (st ? ' | ' + st : ''));
        } catch (x) {}
      });
    }
  } catch (eDG) {}
  var pfHeldSince = 0;
  setInterval(function () {
    try {
      if (!pf || pf.hidden) { pfHeldSince = 0; return; }
      var ld = document.getElementById('np-e2-pf-loading');
      if (!ld || ld.hidden) { pfHeldSince = 0; return; }
      if (!st.versions || !st.versions.length) { pfHeldSince = 0; return; }
      if (!pfHeldSince) { pfHeldSince = Date.now(); return; }
      if (Date.now() - pfHeldSince < 3000) return;
      pfHeldSince = 0;
      console.warn('[np-e2] REVEAL WATCHDOG: version ready but still on loading — forcing proof view');
      try { coMark('reveal-watchdog'); } catch (eM) {}
      st.proofPhase = 'ready';
      renderProofReady();
    } catch (eW) {}
  }, 1500);
  /* B67 REVERTED (2026-08-25): a `pageshow` binding here re-ran renderOptions()
     on a bfcache restore, i.e. exactly when iOS has discarded canvas/layout
     state. If that render throws part-way it leaves the builder shell painted
     but EMPTY — a grey void, which is what Justin hit. Until the iOS restore
     path can be reproduced and stepped through, do not re-render on restore;
     visibilitychange alone is the pre-existing, better-understood path. */
  window.addEventListener('pageshow', function (ev) {
    if (!(ev && ev.persisted)) return;
    /* observability only — no DOM work on the restore path */
    try { console.warn('[np-e2] bfcache restore (no re-render performed)'); } catch (eL) {}
  });
})();
